const Wc = Function("return this")();
function Gc() {
  const e = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis, t = typeof window == "object" && window && window.Object === Object && window, n = typeof global == "object" && global && global.Object === Object && global, r = typeof self == "object" && self && self.Object === Object && self;
  return e || t || n || r || this || Wc;
}
const _ = Gc(), cn = {
  env: {
    NODE_ENV: "",
    // production development test
    terminal: ""
  },
  argv: [],
  execPath: "",
  // process.execPath || process.argv[0] || ''
  platform: "",
  // macos windows darwin linux wsl
  versions: {
    node: void 0,
    bun: void 0
  },
  ...typeof process == "object" && process ? process : {}
}, Tg = {
  // 私密配置: {}.*
  ...cn.env,
  BASE_URL: "/",
  MODE: "production",
  DEV: !1,
  PROD: !0,
  SSR: !1,
  YZ_PUBLIC_PATH: "/public",
  YZ_IMAGE_PATH: "/public/images"
}, mo = "@YZ/";
function Vc(e, t = mo) {
  return e.startsWith(t);
}
function Kc(e, t = mo) {
  return Vc(e, t) ? e : `${t}${e}`;
}
function Qc(e) {
  return typeof e == "string" && e.startsWith("Symbol(") && e.endsWith(")");
}
function Jc(e) {
  return Qc(e) && (e = e.slice(7, -1)), e;
}
function Hc(e) {
  return e = Jc(e), e = Kc(e), typeof Symbol == "function" ? Symbol(e) : `Symbol(${e})`;
}
const Dt = Hc("META");
class Xc {
}
function Qr(e) {
  e || (e = _), Object.prototype.hasOwnProperty.call(e, Dt) === !1 && Object.defineProperty(e, Dt, {
    value: new Xc()
  });
  const t = {
    set: (n, r) => e[Dt][n] = r,
    get: (n, r) => {
      const i = e[Dt][n];
      return i === void 0 && r !== void 0 ? (t.set(n, r), r) : i;
    },
    delete: (n) => {
      delete e[Dt][n];
    }
  };
  return t;
}
const Jr = NaN, Er = Symbol("NO_VALUE"), Rg = 16, xg = 5, ln = {
  immediate: 0,
  // 建议全局只有一个
  high: 100,
  normal: 200,
  low: 300,
  idle: 400
};
function kg(e, t) {
  return { type: e, payload: t ?? {} };
}
function Ng(e) {
  return "dispatch" in e;
}
const Ig = {
  UNKNOWN: "UNKNOWN",
  // 未知
  // ** 扫码 **
  SCAN_QR_LOT: "SCAN_QR_LOT",
  // 扫「车位二维码 /l?n=${lottag}」而来
  SCAN_QR_PARK: "SCAN_QR_PARK",
  // 扫「停车场二维码 /l?p=${pktag} 或 /p?t=${pktag}」而来
  SCAN_QR_TICKET: "SCAN_QR_TICKET",
  // 扫「小票码 /h?o=${ordersn}」而来
  SCAN_QR_NEED_PAY: "SCAN_QR_NEED_PAY",
  // 扫「支付码 /h?o=${ordersn} & uo.ctype!==L 」而来
  SCAN_QR_OWED_ORDER: "SCAN_QR_OWED_ORDER",
  // 扫「原补缴订单码/包月支付码 /l?o=${ordersn} 」而来
  SCAN_QR_GATE: "SCAN_QR_GATE",
  // 扫「道闸码 /o?d=${doorid} 」而来
  SCAN_QR_COUPON: "SCAN_QR_COUPON",
  // 扫「领取优惠券 /c?c=${couponid} 」而来
  SCAN_QR_CHARGE: "SCAN_QR_CHARGE",
  // 扫「充电枪码 /e?n=${chargeconnsn} 」而来
  // ** 点击 **
  TAP_SUBSCRIPTION_CHARGE_END: "TAP_SUBSCRIPTION_CHARGE_END",
  // 点击「结束充电提醒-订阅消息链接」而来
  TAP_SUBSCRIPTION_NONSENSE_END: "TAP_SUBSCRIPTION_NONSENSE_END",
  // 点击「信用停-停车缴费通知-订阅消息链接」而来
  TAP_SUBSCRIPTION_BOARD_RAISED: "TAP_SUBSCRIPTION_BOARD_RAISED",
  // 点击「车位翻板升起提醒-订阅消息链接」而来
  // ** 成功支付 **
  PAID_INPROGRESS_ORDER: "PAID_INPROGRESS_ORDER",
  // 成功支付「仅当前在停订单」而来
  PAID_OWED_ORDER: "PAID_OWED_ORDER",
  // 成功支付「仅单个历史欠费订单」而来
  PAID_OWED_ORDER_NONSENSE: "PAID_OWED_ORDER_NONSENSE",
  // 成功支付「信用停-历史欠费订单（单个）」而来
  PAID_OWED_ORDERS_ONLY: "PAID_OWED_ORDERS_ONLY",
  // 成功支付「仅历史欠费订单列表（可能多个历史欠费）」而来
  PAID_OWED_ORDERS_MERGE_INPROGRESS_ORDER: "PAID_OWED_ORDERS_MERGE_INPROGRESS_ORDER",
  // 成功支付「历史欠费订单列表（可能多个历史欠费）+ 当前在停订单」而来
  PAID_MONTH: "PAID_MONTH",
  // 成功支付「包月」而来
  PAID_MONTH_CLEAR_OWED_ORDERS_BEFORE: "PAID_MONTH_CLEAR_OWED_ORDERS_BEFORE"
  // 成功支付「包月清缴」而来
}, Pg = {
  CRLF: "CRLF",
  // \r\n
  LF: "LF"
  // \n
};
var be = /* @__PURE__ */ ((e) => (e[e["text/plain"] = 0] = "text/plain", e[e["text/html"] = 1] = "text/html", e[e["text/xml"] = 2] = "text/xml", e[e["text/css"] = 3] = "text/css", e[e["image/jpeg"] = 4] = "image/jpeg", e[e["image/png"] = 5] = "image/png", e[e["image/gif"] = 6] = "image/gif", e[e["image/bmp"] = 7] = "image/bmp", e[e["image/webp"] = 8] = "image/webp", e[e["image/svg+xml"] = 9] = "image/svg+xml", e[e["image/x-icon"] = 10] = "image/x-icon", e[e["image/vnd.microsoft.icon"] = 11] = "image/vnd.microsoft.icon", e[e["image/octet-stream"] = 12] = "image/octet-stream", e[e["audio/mpeg"] = 13] = "audio/mpeg", e[e["video/mp4"] = 14] = "video/mp4", e[e["audio/ogg"] = 15] = "audio/ogg", e[e["audio/wav"] = 16] = "audio/wav", e[e["audio/midi"] = 17] = "audio/midi", e[e["video/webm"] = 18] = "video/webm", e[e["video/ogg"] = 19] = "video/ogg", e[e["application/octet-stream"] = 20] = "application/octet-stream", e[e["application/javascript"] = 21] = "application/javascript", e[e["application/ecmascript"] = 22] = "application/ecmascript", e[e["application/json"] = 23] = "application/json", e[e["application/xml"] = 24] = "application/xml", e[e["application/xhtml+xml"] = 25] = "application/xhtml+xml", e[e["application/x-www-form-urlencoded"] = 26] = "application/x-www-form-urlencoded", e[e["application/msword"] = 27] = "application/msword", e[e["application/x-csv"] = 28] = "application/x-csv", e[e["application/vnb.ms-excel"] = 29] = "application/vnb.ms-excel", e[e["application/vnb.mspowerpoint"] = 30] = "application/vnb.mspowerpoint", e[e["application/pdf"] = 31] = "application/pdf", e[e["application/zip"] = 32] = "application/zip", e[e["application/x-gtar"] = 33] = "application/x-gtar", e[e["application/x-gzip"] = 34] = "application/x-gzip", e[e["appliaction/vnd.ms-fontobject"] = 35] = "appliaction/vnd.ms-fontobject", e[e["aplication/font-sfnt"] = 36] = "aplication/font-sfnt", e[e["aplication/pkcs12"] = 37] = "aplication/pkcs12", e))(be || {}), Yc = /* @__PURE__ */ ((e) => (e[e.text = 0] = "text", e[e.dataURL = 1] = "dataURL", e[e.binaryString = 2] = "binaryString", e[e.arraybuffer = 3] = "arraybuffer", e))(Yc || {});
const gt = {
  arraybuffer: "arraybuffer",
  text: "text",
  json: "json",
  blob: "blob",
  stream: "stream",
  formdata: "formdata",
  document: "document"
}, tt = {
  ascii: "ascii",
  /**
   * UTF-8 是一种可变长度的 Unicode 编码格式，使用一至四个字节为每个字符编码
   *
   * 000000 - 00007F(128个代码)      0zzzzzzz(00-7F)                             一个字节
   * 000080 - 0007FF(1920个代码)     110yyyyy(C0-DF) 10zzzzzz(80-BF)             两个字节
   * 000800 - 00D7FF
   * 00E000 - 00FFFF(61440个代码)    1110xxxx(E0-EF) 10yyyyyy 10zzzzzz           三个字节
   * 010000 - 10FFFF(1048576个代码)  11110www(F0-F7) 10xxxxxx 10yyyyyy 10zzzzzz  四个字节
   *
   * 注: Unicode在范围 D800-DFFF 中不存在任何字符
   * http://zh.wikipedia.org/wiki/UTF-8
   */
  utf8: "utf8",
  "utf-8": "utf-8",
  /**
   * UTF-16 大部分使用两个字节编码，编码超出 65535 的使用四个字节
   * 000000 - 00FFFF  两个字节
   * 010000 - 10FFFF  四个字节
   *
   * http://zh.wikipedia.org/wiki/UTF-16
   *
   * 小字节序编码的 Unicode 字符，支持代理（U+10000至 U+10FFFF）
   */
  utf16le: "utf16le",
  "utf-16le": "utf-16le",
  ucs2: "ucs2",
  //  utf16le 的别名
  "ucs-2": "ucs-2",
  base64: "base64",
  base64url: "base64url",
  latin1: "latin1",
  // 编码成一字节编码的字符串的方式
  binary: "binary",
  // latin1 的别名
  hex: "hex"
  // 将一个字节编码为两个十六进制字符
  // ansi: "ansi"
}, zn = {
  md5: "md5",
  sha1: "sha1",
  sha256: "sha256",
  "SHA-256": "SHA-256",
  sha512: "sha512",
  "SHA-512": "SHA-512",
  "AES-GCM": "AES-GCM",
  ECDSA: "ECDSA"
}, zg = {
  "aes-128-cbc": "aes-128-cbc",
  "aes-128-ecb": "aes-128-ecb",
  "aes-192-cbc": "aes-192-cbc",
  "aes-192-ecb": "aes-192-ecb",
  "aes-256-cbc": "aes-256-cbc",
  "aes-256-ecb": "aes-256-ecb",
  base64: "base64"
}, Bg = [
  "jelly",
  "bounce",
  "flash",
  "pulse",
  "rubberBand",
  "shakeX",
  "shakeY",
  "headShake",
  "swing",
  "tada",
  "wobble",
  "jello",
  "heartBeat",
  "backInLeft",
  "backInRight",
  "backInUp",
  "backInDown",
  "backOutLeft",
  "backOutRight",
  "backOutUp",
  "backOutDown",
  "bounceIn",
  "bounceInLeft",
  "bounceInRight",
  "bounceInUp",
  "bounceInDown",
  "bounceOut",
  "bounceOutLeft",
  "bounceOutRight",
  "bounceOutUp",
  "bounceOutDown",
  "fadeIn",
  "fadeInLeft",
  "fadeInLeftBig",
  "fadeInRight",
  "fadeInRightBig",
  "fadeInUp",
  "fadeInUpBig",
  "fadeInDown",
  "fadeInDownBig",
  "fadeInTopLeft",
  "fadeInTopRight",
  "fadeInBottomLeft",
  "fadeInBottomRight",
  "fadeOut",
  "fadeOutLeft",
  "fadeOutLeftBig",
  "fadeOutRight",
  "fadeOutRightBig",
  "fadeOutUp",
  "fadeOutUpBig",
  "fadeOutDown",
  "fadeOutDownBig",
  "fadeOutTopLeft",
  "fadeOutTopRight",
  "fadeOutBottomRight",
  "fadeOutBottomLeft",
  "flip",
  "flipInX",
  "flipInY",
  "flipOutX",
  "flipOutY",
  "flipOutRight",
  "flipInLeft",
  "flipOutLeft",
  "flipInRight",
  "flipOutTop",
  "flipInBottom",
  "flipOutBottom",
  "flipInTop",
  "lightSpeedInLeft",
  "lightSpeedInRight",
  "lightSpeedOutLeft",
  "lightSpeedOutRight",
  "rotateIn",
  "rotateInUpLeft",
  "rotateInUpRight",
  "rotateInDownLeft",
  "rotateInDownRight",
  "rotateOut",
  "rotateOutUpLeft",
  "rotateOutUpRight",
  "rotateOutDownLeft",
  "rotateOutDownRight",
  "hinge",
  "rotateFall",
  "rotateOutNewspaper",
  "rotateInNewspaper",
  "jackInTheBox",
  "rollIn",
  "rollOut",
  "zoomIn",
  "zoomInLeft",
  "zoomInRight",
  "zoomInUp",
  "zoomInDown",
  "zoomOut",
  "zoomOutLeft",
  "zoomOutRight",
  "zoomOutUp",
  "zoomOutDown",
  "fade",
  "moveFromLeft",
  "moveToLeft",
  "moveFromRight",
  "moveToRight",
  "moveFromTop",
  "moveToTop",
  "moveFromBottom",
  "moveToBottom",
  "moveFromLeftFade",
  "moveToLeftFade",
  "moveFromRightFade",
  "moveToRightFade",
  "moveFromTopFade",
  "moveToTopFade",
  "moveFromBottomFade",
  "moveToBottomFade",
  "scaleFromSmall",
  "scaleToSmall",
  "scaleFromLarge",
  "scaleToLarge",
  "scaleFromSmallCenter",
  "scaleToSmallCenter",
  "slideInLeft",
  "slideInRight",
  "slideInUp",
  "slideInDown",
  "slideOutLeft",
  "slideOutRight",
  "slideOutUp",
  "slideOutDown",
  "rotateRightSideFirst",
  "rotateLeftSideFirst",
  "rotateTopSideFirst",
  "rotateBottomSideFirst",
  "rotatePushLeft",
  "rotatePushRight",
  "rotatePushTop",
  "rotatePushBottom",
  "rotatePullRight",
  "rotatePullLeft",
  "rotatePullTop",
  "rotatePullBottom",
  "rotateFoldRight",
  "rotateFoldLeft",
  "rotateFoldTop",
  "rotateFoldBottom",
  "rotateUnfoldLeft",
  "rotateUnfoldRight",
  "rotateUnfoldTop",
  "rotateUnfoldBottom",
  "rotateRoomLeftOut",
  "rotateRoomLeftIn",
  "rotateRoomRightOut",
  "rotateRoomRightIn",
  "rotateRoomTopOut",
  "rotateRoomTopIn",
  "rotateRoomBottomOut",
  "rotateRoomBottomIn",
  "rotateCubeLeftOut",
  "rotateCubeLeftIn",
  "rotateCubeRightOut",
  "rotateCubeRightIn",
  "rotateCubeTopOut",
  "rotateCubeTopIn",
  "rotateCubeBottomOut",
  "rotateCubeBottomIn",
  "rotateCarouselLeftOut",
  "rotateCarouselLeftIn",
  "rotateCarouselRightOut",
  "rotateCarouselRightIn",
  "rotateCarouselTopOut",
  "rotateCarouselTopIn",
  "rotateCarouselBottomOut",
  "rotateCarouselBottomIn",
  "rotateSidesOut",
  "rotateSidesIn",
  "rotateSlideOut",
  "rotateSlideIn",
  "superRainbow",
  "statusProcessing"
];
var e0 = /* @__PURE__ */ ((e) => (e[e.Continue = 100] = "Continue", e[e.SwitchingProtocols = 101] = "SwitchingProtocols", e[e.Processing = 102] = "Processing", e[e.EarlyHints = 103] = "EarlyHints", e[e.Ok = 200] = "Ok", e[e.Created = 201] = "Created", e[e.Accepted = 202] = "Accepted", e[e.NonAuthoritativeInformation = 203] = "NonAuthoritativeInformation", e[e.NoContent = 204] = "NoContent", e[e.ResetContent = 205] = "ResetContent", e[e.PartialContent = 206] = "PartialContent", e[e.MultiStatus = 207] = "MultiStatus", e[e.AlreadyReported = 208] = "AlreadyReported", e[e.ImUsed = 226] = "ImUsed", e[e.MultipleChoices = 300] = "MultipleChoices", e[e.MovedPermanently = 301] = "MovedPermanently", e[e.Found = 302] = "Found", e[e.SeeOther = 303] = "SeeOther", e[e.NotModified = 304] = "NotModified", e[e.UseProxy = 305] = "UseProxy", e[e.Unused = 306] = "Unused", e[e.TemporaryRedirect = 307] = "TemporaryRedirect", e[e.PermanentRedirect = 308] = "PermanentRedirect", e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.PaymentRequired = 402] = "PaymentRequired", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.MethodNotAllowed = 405] = "MethodNotAllowed", e[e.NotAcceptable = 406] = "NotAcceptable", e[e.ProxyAuthenticationRequired = 407] = "ProxyAuthenticationRequired", e[e.RequestTimeout = 408] = "RequestTimeout", e[e.Conflict = 409] = "Conflict", e[e.Gone = 410] = "Gone", e[e.LengthRequired = 411] = "LengthRequired", e[e.PreconditionFailed = 412] = "PreconditionFailed", e[e.PayloadTooLarge = 413] = "PayloadTooLarge", e[e.UriTooLong = 414] = "UriTooLong", e[e.UnsupportedMediaType = 415] = "UnsupportedMediaType", e[e.RangeNotSatisfiable = 416] = "RangeNotSatisfiable", e[e.ExpectationFailed = 417] = "ExpectationFailed", e[e.ImATeapot = 418] = "ImATeapot", e[e.MisdirectedRequest = 421] = "MisdirectedRequest", e[e.UnprocessableEntity = 422] = "UnprocessableEntity", e[e.Locked = 423] = "Locked", e[e.FailedDependency = 424] = "FailedDependency", e[e.TooEarly = 425] = "TooEarly", e[e.UpgradeRequired = 426] = "UpgradeRequired", e[e.PreconditionRequired = 428] = "PreconditionRequired", e[e.TooManyRequests = 429] = "TooManyRequests", e[e.RequestHeaderFieldsTooLarge = 431] = "RequestHeaderFieldsTooLarge", e[e.UnavailableForLegalReasons = 451] = "UnavailableForLegalReasons", e[e.InternalServerError = 500] = "InternalServerError", e[e.NotImplemented = 501] = "NotImplemented", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable", e[e.GatewayTimeout = 504] = "GatewayTimeout", e[e.HttpVersionNotSupported = 505] = "HttpVersionNotSupported", e[e.VariantAlsoNegotiates = 506] = "VariantAlsoNegotiates", e[e.InsufficientStorage = 507] = "InsufficientStorage", e[e.LoopDetected = 508] = "LoopDetected", e[e.NotExtended = 510] = "NotExtended", e[e.NetworkAuthenticationRequired = 511] = "NetworkAuthenticationRequired", e))(e0 || {});
const We = (e) => {
  let t = null;
  switch (e) {
    case "any-character":
      t = /[^]/;
      break;
    case "bin":
      t = /^(0b)?[0-1]+$/i;
      break;
    case "oct":
      t = /^(0o)?[0-7]+$/i;
      break;
    case "hex":
      t = /^(0x)?[0-9a-fA-F]+$/i;
      break;
    case "ascii":
      t = /^[\x00-\xFF]+$/i;
      break;
    case "int":
      t = /^[-+]?[0-9]+$/;
      break;
    case "number":
      t = /[-+]?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
      break;
    case "number-single":
      t = /[-+]?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/i;
      break;
    case "split":
      t = /\s*,\s*/gi;
      break;
    case "trim":
      t = /^\s+|\s+$/g;
      break;
    case "regexp":
      t = /[\\^$.*+?()[\]{}|]/g;
      break;
    case "regexp-flags":
      t = /\w*$/;
      break;
    case "native-method":
      t = RegExp(
        "^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(We("regexp"), "\\$&").replace(
          /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
          "$1.*?"
        ) + "$"
      );
      break;
    case "svg-segment":
      t = /([mlhvzaqtcs])([^mlhvzaqtcs]*)/gi;
      break;
    case "mobile-china":
      t = /^[1]{1}[0-9]{10}$/;
      break;
    case "email":
      t = /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+\@[A-Za-z0-9._-]+\.[A-Za-z0-9]+$/gm;
      break;
    case "ip":
      t = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      break;
    case "url":
      t = /^http[s]?:\/\/([\w-]+\.)+[\w-]+([\w-./?%&=]*)?$/;
      break;
    case "element-url":
      t = /^url\(['"]?(.+?)['"]?\)$/i;
      break;
    case "date":
      t = /^\d{4}(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2})$/;
      break;
    case "time":
      t = /^(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
      break;
    case "datetime":
      t = /^\d{4}(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2})\s+(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
      break;
    case "base64-data":
      t = /^\s*data:(?:[a-z]+\/[a-z0-9-+.]+(?:;[a-z-]+=[a-z0-9-]+)?)?(?:;base64)?,([a-z0-9!$&',()*+;=\-._~:@/?%\s]*?)\s*$/i;
      break;
    case "hex-color":
      t = /^#([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
      break;
    case "color":
      t = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i;
      break;
    case "whitespace":
      t = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]/g;
      break;
    case "commaSpaces":
      t = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/;
      break;
    case "var-name":
      t = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/;
      break;
    case "bezier":
      t = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/;
      break;
    case "chinese-name":
      t = /^(?:[\u4e00-\u9fa5·]{2,16})$/;
      break;
    case "chinese":
      t = new RegExp(
        String.raw`
          [\u{FA0E}\u{FA0F}\u{FA11}\u{FA13}\u{FA14}\u{FA1F}\u{FA21}\u{FA23}\u{FA24}\u{FA27}-\u{FA29}]
          |[\u{4E00}-\u{9FCC}]
          |[\u{3400}-\u{4DB5}]
          |[\u{20000}-\u{2A6D6}]
          |[\u{2A700}-\u{2B734}]
          |[\u{2B740}-\u{2B81D}]
          |[\u{2B820}-\u{2CEAF}]
          |[\u{2CEB0}-\u{2EBEF}]
        `.replace(/\s+/g, ""),
        "u"
      );
      break;
    case "mime-image":
      t = /^image\//;
      break;
    case "mime-video":
      t = /^video\//;
      break;
    case "mime-audio":
      t = /^audio\//;
      break;
    case "mime-document-word":
      t = /^application\/(?:vnd\.openxmlformats-officedocument\.wordprocessingml\.document|msword|vnd\.ms-word\.document\.macroenabled\.12|vnd\.openxmlformats-officedocument\.wordprocessingml\.template|vnd\.ms-word\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-excel":
      t = /^application\/(?:vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|vnd\.ms-excel|vnd\.ms-excel\.sheet\.macroenabled\.12|vnd\.openxmlformats-officedocument\.spreadsheetml\.template|vnd\.ms-excel\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-ppt":
      t = /^application\/(?:vnd\.ms-powerpoint|vnd\.openxmlformats-officedocument\.presentationml\.presentation|vnd\.ms-powerpoint\.presentation\.macroenabled\.12|vnd\.openxmlformats-officedocument\.presentationml\.template|vnd\.ms-powerpoint\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-json":
      t = /^application\/json$/;
      break;
    case "mime-document-xml":
      t = /^(?:application|text)\/(?:xml|xhtml\+xml)$/;
      break;
  }
  return t;
};
function t0(e) {
  if (e.flags)
    return e.flags;
  const t = [];
  return e.global && t.push("g"), e.ignoreCase && t.push("i"), e.multiline && t.push("m"), e.sticky && t.push("y"), e.unicode && t.push("u"), t.join("");
}
function n0(e) {
  const t = new RegExp(e.source, t0(e));
  return t.lastIndex = e.lastIndex, t;
}
const Nt = (e, t) => (typeof e == "string" && (e = We(e) || new RegExp(e)), e.test(t)), $g = (e, t) => (typeof e == "string" && (e = We(e) || new RegExp(e)), t.search(e)), Lg = (e, t) => (typeof e == "string" && (e = We(e) || new RegExp(e)), t.split(e)), Hr = (e, t) => {
  typeof e == "string" && (e = We(e) || new RegExp(e));
  const n = t.match(e);
  return n ? e.flags.toLowerCase().indexOf("g") >= 0 ? n.map(
    (r) => ({
      matchIndex: -1,
      fullMatch: r,
      groupMatchs: []
    })
  ) : {
    matchIndex: typeof n.index == "number" ? n.index : -1,
    fullMatch: n[0],
    groupMatchs: n.slice(1)
  } : null;
}, Mg = (e, t) => {
  typeof e == "string" && (e = We(e) || new RegExp(e));
  const n = [], r = t.matchAll(e);
  for (const i of r)
    n.push({
      matchIndex: typeof i.index == "number" ? i.index : -1,
      fullMatch: i[0],
      groupMatchs: i.slice(1)
    });
  return n;
}, jg = (e, t) => {
  if (typeof e == "string" && (e = We(e) || new RegExp(e)), e.flags.toLowerCase().indexOf("g") < 0)
    return Hr(e, t);
  const n = [];
  let r;
  for (; r = e.exec(t); )
    n.push({
      matchIndex: typeof r.index == "number" ? r.index : -1,
      fullMatch: r[0],
      groupMatchs: r.slice(1)
    });
  return n;
};
function at(e) {
  const t = e.match(/[\s\S]/gu);
  return t ? t.length : 0;
}
function Ug(e) {
  return [...e].length;
}
function Zg(e) {
  return Array.from(e).length;
}
function qg(e) {
  const t = e.length;
  let n = 0, r = 0;
  for (; n < t; ) {
    const i = e.charCodeAt(n);
    if (i >= 55296 && i <= 56319) {
      const s = e.charCodeAt(n + 1);
      s >= 56320 && s <= 57343 && n++;
    }
    r++, n++;
  }
  return r;
}
function Wg(e, t) {
  return Array.from(e).slice(0, t).join("");
}
function Gg(e, t) {
  const n = e.codePointAt(t);
  return n ? String.fromCodePoint(n) : void 0;
}
function Vg(e) {
  if (!/^\s*[0-9A-Z]+\s*$/i.test(e))
    throw new Error("纳税人识别号只能由数字和大写字母组成");
  const t = e.trim().toUpperCase(), n = at(t);
  if (n !== 15 && n !== 17 && n !== 18 && n !== 20)
    throw new Error("税号应为15/17/18/20位数字或大写字母组合，请检查。");
  return t;
}
function Kg(e) {
  if (!/^\s*[0-9A-Z（）\u{FA0E}\u{FA0F}\u{FA11}\u{FA13}\u{FA14}\u{FA1F}\u{FA21}\u{FA23}\u{FA24}\u{FA27}-\u{FA29}\u{4E00}-\u{9FCC}\u{3400}-\u{4DB5}\u{20000}-\u{2A6D6}\u{2A700}-\u{2B734}\u{2B740}-\u{2B81D}\u{2B820}-\u{2CEAF}\u{2CEB0}-\u{2EBEF}]+\s*$/iu.test(
    e
  ))
    throw new Error("名称只能包含：中文+英文+数字+全角括号");
  const t = e.trim(), n = at(t);
  if (n == 0)
    throw new Error("请输入名称");
  if (n > 100)
    throw new Error("名称过长，请修改 (不超过100个字符)");
  return t;
}
function Qg(e) {
  if (!/^\s*([a-z0-9A-Z]+[-|_|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}\s*$/i.test(
    e
  ))
    throw new Error("请输入正确的邮箱");
  return e.trim();
}
const r0 = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghijklmnopqrstuvwxyz0123456789", i0 = "0123456789";
function Do(e = 12, t = r0) {
  let n = "";
  for (let r = 0; r < e; r++)
    n += t[Math.floor(Math.random() * t.length)];
  return n;
}
function Jg(e = 12) {
  return Do(e, i0);
}
const Hg = () => String.fromCharCode(
  Math.random() * ("z".charCodeAt(0) - "a".charCodeAt(0)) + "a".charCodeAt(0)
);
function Xg(e, t) {
  const n = Object.keys(t);
  for (let r = 0, i = n.length; r < i; r++)
    e = e.replace(new RegExp("{" + n[r] + "}", "gi"), t[n[r]]);
  return e;
}
function Yg(e, ...t) {
  let n = "", r;
  for (r = 0; r < t.length; r++)
    n += e.raw[r] + t[r];
  return n += e.raw[r] || "", n;
}
function ey(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function s0(e) {
  return e.replace(/(^\w)/g, (t) => t.toLowerCase());
}
const ty = (e, t = "-") => {
  let n = e.replace(new RegExp("[_-]?([A-Z])", "g"), t + "$1").toLowerCase();
  const r = new RegExp(`^${t}`);
  return r.test(e) || (n = n.replace(r, "")), n;
};
function o0(e) {
  return e.replace(/(^\w|[_-]\w)/g, (t) => t.slice(-1).toUpperCase());
}
function ny(e) {
  return s0(o0(e));
}
function ry(e) {
  return e ? e.replaceAll(/^\s+|\s+$/g, "").replaceAll(/\r?\n/g, "") : "";
}
function iy(e = "") {
  const t = /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
  return e.replaceAll(t, "");
}
function sy(e, t = "", n = /\[data-v-[0-9a-zA-Z]*\]/g) {
  return e = e.replaceAll(n, t), e;
}
function oy(e, t, n = "0", r = "left") {
  const i = at(e);
  if (t > i) {
    const s = t - i;
    let o, u;
    switch (r) {
      case "left":
        e = Array(s + 1).join(n) + e;
        break;
      case "right":
        e = e + Array(s + 1).join(n);
        break;
      default:
        o = Math.ceil(s / 2), u = s - o, e = Array(u + 1).join(n) + e + Array(o + 1).join(n);
        break;
    }
  }
  return e;
}
const uy = (e, t) => e.repeat(t), ay = (e, t, n = "...") => at(e) < t ? e : `${e.slice(0, t - 3)}${n}`, cy = (e, t, n, r = "...") => {
  const i = at(e);
  return i < t || n - t >= i ? e : `${e.slice(0, t)}${r}${e.slice(i - n)}`;
}, ly = (e) => e.split("").reverse().join("");
function hy(e) {
  const t = e.codePointAt(0);
  return typeof t < "u" && t > 65535;
}
function fy(e) {
  let t = "";
  for (let n = 0, r = e.length; n < r; n++) {
    const i = e.charCodeAt(n);
    i >= 1 && i <= 127 ? t += e.charAt(n) : i > 2047 ? (t += String.fromCharCode(224 | i >> 12 & 15), t += String.fromCharCode(128 | i >> 6 & 63), t += String.fromCharCode(128 | i >> 0 & 63)) : (t += String.fromCharCode(192 | i >> 6 & 31), t += String.fromCharCode(128 | i >> 0 & 63));
  }
  return t;
}
function dy(e) {
  const t = e.length;
  let n = "", r = 0, i, s;
  for (; r < t; ) {
    const o = e.charCodeAt(r++);
    switch (o >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        n += e.charAt(r - 1);
        break;
      case 12:
      case 13:
        i = e.charCodeAt(r++), n += String.fromCharCode((o & 31) << 6 | i & 63);
        break;
      case 14:
        i = e.charCodeAt(r++), s = e.charCodeAt(r++), n += String.fromCharCode(
          (o & 15) << 12 | (i & 63) << 6 | (s & 63) << 0
        );
        break;
    }
  }
  return n;
}
function py(e, t = "utf-8") {
  t = t.toLowerCase();
  let n = 0;
  if (t === "utf-16" || t === "utf16")
    for (let r = 0, i = e.length; r < i; r++)
      e.charCodeAt(r) <= 65535 ? n += 2 : n += 4;
  else
    for (let r = 0, i = e.length; r < i; r++) {
      const s = e.charCodeAt(r);
      s <= 127 ? n += 1 : s <= 2047 ? n += 2 : s <= 65535 ? n += 3 : n += 4;
    }
  return n;
}
function my(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function u0(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Dy(e) {
  return u0(e).replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function gy(e, t, n = t + "s") {
  return e === 1 ? t : n;
}
function yy(e) {
  const t = e.indexOf(`
`);
  return t === -1 ? e : e.slice(0, t);
}
function by(e, t, n = 0) {
  let r = 0, i = e.indexOf(t, n);
  for (; i !== -1; )
    r++, i = e.indexOf(t, i + 1);
  return r;
}
function wy(e) {
  return e.replace(
    /[０-９]/g,
    (t) => String.fromCharCode(t.charCodeAt(0) - 65248)
  );
}
function Fy(e) {
  return e.replace(/\u3000/g, " ");
}
const go = 2 ** 25;
function Ey(e, t = ",", n = go) {
  const r = "...[truncated]";
  let i = "";
  for (const s of e) {
    const o = i ? t : "", u = o + s;
    if (i.length + u.length <= n)
      i += u;
    else {
      const a = n - i.length - o.length - r.length;
      return a > 0 ? i += o + s.slice(0, a) + r : i += r, i;
    }
  }
  return i;
}
function vy(e, t) {
  const n = e.split(`
`);
  return n.length <= t ? e : n.slice(0, t).join(`
`) + "…";
}
class _y {
  /**
   * Creates a new EndTruncatingAccumulator
   * @param maxSize Maximum size in characters before truncation occurs
   */
  constructor(t = go) {
    this.maxSize = t;
  }
  content = "";
  isTruncated = !1;
  totalBytesReceived = 0;
  /**
   * Appends data to the accumulator. If the total size exceeds maxSize,
   * the end is truncated to maintain the size limit.
   * @param data The string data to append
   */
  append(t) {
    const n = typeof t == "string" ? t : t.toString();
    if (this.totalBytesReceived += n.length, !(this.isTruncated && this.content.length >= this.maxSize))
      if (this.content.length + n.length > this.maxSize) {
        const r = this.maxSize - this.content.length;
        r > 0 && (this.content += n.slice(0, r)), this.isTruncated = !0;
      } else
        this.content += n;
  }
  /**
   * Returns the accumulated string, with truncation marker if truncated
   */
  toString() {
    if (!this.isTruncated)
      return this.content;
    const t = this.totalBytesReceived - this.maxSize, n = Math.round(t / 1024);
    return this.content + `
... [output truncated - ${n}KB removed]`;
  }
  /**
   * Clears all accumulated data
   */
  clear() {
    this.content = "", this.isTruncated = !1, this.totalBytesReceived = 0;
  }
  /**
   * Returns the current size of accumulated data
   */
  get length() {
    return this.content.length;
  }
  /**
   * Returns whether truncation has occurred
   */
  get truncated() {
    return this.isTruncated;
  }
  /**
   * Returns total bytes received (before truncation)
   */
  get totalBytes() {
    return this.totalBytesReceived;
  }
}
function Sy(e) {
  let t = 0, n = 0;
  for (let r = 0, i = e.length; r < i; r++)
    e[r] === `
` && (r > 0 && e[r - 1] === "\r" ? t++ : n++);
  return t > n ? "CRLF" : "LF";
}
function Ay(e) {
  return e.includes("	") ? e.replace(/^\t+/gm, (t) => "  ".repeat(t.length)) : e;
}
function a0(e) {
  const t = new ArrayBuffer(e.length), n = new Uint8Array(t);
  for (let r = 0, i = e.length; r < i; r++)
    n[r] = e[r];
  return t;
}
function c0(e) {
  return ArrayBuffer.isView(e);
}
function l0(e) {
  return c0(e) && !(e instanceof DataView);
}
function Oy(e) {
  return l0(e) ? e.constructor.name : "";
}
function Cy(e) {
  return new DataView(e);
}
function Ty(e, t) {
  return new t(e);
}
function Ry(e, ...t) {
  let n = 0;
  for (const s of t)
    n += s.length;
  const r = new e(n);
  let i = 0;
  for (const s of t)
    r.set(s, i), i += s.length;
  return r;
}
function Xr(e) {
  return e.slice(0);
}
function xy(e, t = !0) {
  const n = t ? Xr(e.buffer) : e.buffer;
  return new DataView(n, e.byteOffset, e.byteLength);
}
function h0(e, t = !0) {
  const n = t ? Xr(e.buffer) : e.buffer;
  return new e.constructor(
    n,
    e.byteOffset,
    e.length
  );
}
function Yr() {
  const e = Uint32Array.of(305419896), t = new Uint8Array(e.buffer);
  switch (t[0] * 16777216 + t[1] * 65536 + t[2] * 256 + t[3]) {
    case 305419896:
      return !1;
    case 2018915346:
    default:
      return !0;
  }
}
const f0 = (e, t = 16) => e.toString(t), d0 = (e, t = 16) => {
  let n = e.toLowerCase();
  const r = n.indexOf("0b") == 0, i = n.indexOf("0o") == 0, s = n.indexOf("0x") == 0;
  (r || i || s) && (n = n.slice(2)), r && (t = 2), i && (t = 8), s && (t = 16);
  const o = parseInt(n, t);
  if (Number.isNaN(o) || n.length == 0)
    throw new Error(`radixStringToNumber(${e}, ${t}) 无法解析！`);
  return o;
};
function Y(e, t) {
  switch (t.constructor) {
    case Float32Array:
      return e;
    case Uint32Array:
      return Math.round(e * 4294967295);
    case Uint16Array:
      return Math.round(e * 65535);
    case Uint8Array:
      return Math.round(e * 255);
    case Int32Array:
      return Math.round(e * 2147483647);
    case Int16Array:
      return Math.round(e * 32767);
    case Int8Array:
      return Math.round(e * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
function yt(e, t) {
  switch (t.constructor) {
    case Float32Array:
      return e;
    case Uint32Array:
      return e / 4294967295;
    case Uint16Array:
      return e / 65535;
    case Uint8Array:
      return e / 255;
    case Int32Array:
      return Math.max(e / 2147483647, -1);
    case Int16Array:
      return Math.max(e / 32767, -1);
    case Int8Array:
      return Math.max(e / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function ky(e, t, n = Yr()) {
  const r = e.getUint32(t, n), i = e.getUint32(t + 4, n), s = n ? r + 2 ** 32 * i : 2 ** 32 * r + i;
  return Number.isSafeInteger(s) || console.warn(s, "exceeds MAX_SAFE_INTEGER. Precision may be lost"), s;
}
function Ny(e, t, n = Yr()) {
  const r = BigInt(32);
  BigInt(0);
  const i = BigInt(e.getUint32(t | 0, !!n) >>> 0), s = BigInt(
    e.getUint32((t | 0) + 4 | 0, !!n) >>> 0
  );
  return n ? s << r | i : i << r | s;
}
function p0(e) {
  return Array.from(new Uint8Array(e));
}
function Iy(e) {
  const t = [];
  for (; e > 0; ) {
    const n = e & 255;
    t.unshift(n), e = (e - n) / 256;
  }
  return t;
}
function Py(e) {
  const t = [];
  for (let n = 0, r = e.length; n < r; n += 2)
    try {
      t.push(d0(e.slice(n, n + 2), 16));
    } catch {
      continue;
    }
  return t;
}
function m0(e) {
  const t = [];
  for (let n = 0, r = e.length; n < r; n++) {
    const i = e.charCodeAt(n);
    i && t.push(i);
  }
  return t;
}
function zy(e) {
  const t = [];
  for (const n of e) {
    const r = n.codePointAt(0);
    r && t.push(r);
  }
  return t;
}
function ei(e) {
  return new TextEncoder().encode(e);
}
function By(e) {
  let t = 0;
  for (let n = 0, r = e.length; n < r; n++)
    t = t * 256 + e[n];
  return t;
}
function D0(e) {
  let t = "";
  for (let n = 0, r = e.length; n < r; n++)
    t += f0(e[n], 16).padStart(2, "0");
  return t;
}
function g0(e) {
  return String.fromCodePoint.apply(null, e);
}
function yo(e) {
  return String.fromCharCode.apply(
    null,
    new Uint16Array(e)
  );
}
function $y(e, t = tt.utf8) {
  return new TextDecoder(t).decode(e);
}
function Ly(e, t) {
  let n = t?.type;
  const r = t?.mime, i = t?.encode;
  if (!n && r)
    switch (i) {
      case tt.utf8:
      case tt["utf-8"]:
        n = `${r};charset=${i}`;
        break;
      case tt.base64:
        n = `${r};${i}`;
        break;
      default:
        n = `${r}`;
        break;
    }
  return new Blob([e], {
    type: n
  });
}
function My(e) {
  let t = be["text/plain"];
  switch (new DataView(e).getUint32(0, Yr()).toString(16).toUpperCase()) {
    case "FFD8FFDB":
      t = be["image/jpeg"];
      break;
    case "FFD8FFE0":
    case "FFD8FFE1":
    case "FFD8FFE2":
    case "FFD8FFE3":
      t = be["image/jpeg"];
      break;
    case "89504E47":
      t = be["image/png"];
      break;
    case "47494638":
      t = be["image/gif"];
      break;
    case "52494646":
      t = be["image/webp"];
      break;
    case "25504446":
      t = be["application/pdf"];
      break;
    case "504B0304":
      t = be["application/zip"];
      break;
  }
  return t;
}
function jy(e) {
  let t;
  return e instanceof File ? t = e.name : t = e, t.match(/\.([0-9a-z]+)(?:[\\?#]|$)/i)?.[1] || "";
}
class ve {
  array;
  itemSize;
  // 组成每一个的 item 在 array 中占的个数
  itemCount;
  normalized;
  updateRanges;
  version;
  _onChangeCallback() {
  }
  constructor(t, n, r = !1) {
    if (Array.isArray(t))
      throw new TypeError("BufferAttribute: array should be a Typed Array.");
    this.array = t, this.itemSize = n, this.itemCount = t.length / n, this.normalized = r, this.updateRanges = [], this.version = 0;
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  addUpdateRange(t, n) {
    this.updateRanges.push({ start: t, count: n });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(t) {
    return this.array = h0(t.array), this.itemSize = t.itemSize, this.itemCount = t.itemCount, this.normalized = t.normalized, this;
  }
  copyAt(t, n, r) {
    t *= this.itemSize, r *= n.itemSize;
    for (let i = 0, s = this.itemSize; i < s; i++)
      this.array[t + i] = n.array[r + i];
    return this;
  }
  copyArray(t) {
    return this.array.set(t), this;
  }
  set(t, n = 0) {
    return this.array.set(t, n), this;
  }
  getComponent(t, n) {
    let r = this.array[t * this.itemSize + n];
    return this.normalized && (r = yt(r, this.array)), r;
  }
  setComponent(t, n, r) {
    return this.normalized && (r = Y(r, this.array)), this.array[t * this.itemSize + n] = r, this;
  }
  getX(t) {
    let n = this.array[t * this.itemSize];
    return this.normalized && (n = yt(n, this.array)), n;
  }
  setX(t, n) {
    return this.normalized && (n = Y(n, this.array)), this.array[t * this.itemSize] = n, this;
  }
  getY(t) {
    let n = this.array[t * this.itemSize + 1];
    return this.normalized && (n = yt(n, this.array)), n;
  }
  setY(t, n) {
    return this.normalized && (n = Y(n, this.array)), this.array[t * this.itemSize + 1] = n, this;
  }
  getZ(t) {
    let n = this.array[t * this.itemSize + 2];
    return this.normalized && (n = yt(n, this.array)), n;
  }
  setZ(t, n) {
    return this.normalized && (n = Y(n, this.array)), this.array[t * this.itemSize + 2] = n, this;
  }
  getW(t) {
    let n = this.array[t * this.itemSize + 3];
    return this.normalized && (n = yt(n, this.array)), n;
  }
  setW(t, n) {
    return this.normalized && (n = Y(n, this.array)), this.array[t * this.itemSize + 3] = n, this;
  }
  setXY(t, n, r) {
    return t *= this.itemSize, this.normalized && (n = Y(n, this.array), r = Y(r, this.array)), this.array[t + 0] = n, this.array[t + 1] = r, this;
  }
  setXYZ(t, n, r, i) {
    return t *= this.itemSize, this.normalized && (n = Y(n, this.array), r = Y(r, this.array), i = Y(i, this.array)), this.array[t + 0] = n, this.array[t + 1] = r, this.array[t + 2] = i, this;
  }
  setXYZW(t, n, r, i, s) {
    return t *= this.itemSize, this.normalized && (n = Y(n, this.array), r = Y(r, this.array), i = Y(i, this.array), s = Y(s, this.array)), this.array[t + 0] = n, this.array[t + 1] = r, this.array[t + 2] = i, this.array[t + 3] = s, this;
  }
  onChange(t) {
    return this._onChangeCallback = t, this;
  }
  clone() {
    return R0(
      this,
      this.array,
      this.itemSize,
      this.normalized
    ).copy(this);
  }
  toJSON() {
    return {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
  }
}
class Uy extends ve {
  constructor(t, n, r = !1) {
    super(new Int8Array(t), n, r);
  }
}
class Zy extends ve {
  constructor(t, n, r = !1) {
    super(new Uint8Array(t), n, r);
  }
}
class qy extends ve {
  constructor(t, n, r = !1) {
    super(new Uint8ClampedArray(t), n, r);
  }
}
class Wy extends ve {
  constructor(t, n, r = !1) {
    super(new Int16Array(t), n, r);
  }
}
class Gy extends ve {
  constructor(t, n, r = !1) {
    super(new Uint16Array(t), n, r);
  }
}
class Vy extends ve {
  constructor(t, n, r = !1) {
    super(new Int32Array(t), n, r);
  }
}
class Ky extends ve {
  constructor(t, n, r = !1) {
    super(new Uint32Array(t), n, r);
  }
}
class Qy extends ve {
  isFloat16BufferAttribute = !0;
  constructor(t, n, r = !1) {
    super(new Uint16Array(t), n, r);
  }
}
class Jy extends ve {
  constructor(t, n, r = !1) {
    super(new Float32Array(t), n, r);
  }
}
const bo = "[object Undefined]", wo = "[object Null]", Fo = "[object Boolean]", y0 = "[object Number]", b0 = "[object BigInt]", Eo = "[object String]", vo = "[object Symbol]", w0 = "[object Function]", F0 = "[object GeneratorFunction]", E0 = "[object Array]", v0 = "[object Map]", _0 = "[object Set]", S0 = "[object Date]";
function ue(e) {
  return Object.prototype.toString.call(e);
}
function Hy(e, t) {
  return t != null && e instanceof t;
}
function Xy(e) {
  const t = typeof e;
  return t !== "object" ? t : ue(e).replace(/^\[object (\S+)\]$/, "$1").toLowerCase();
}
function Yy(e) {
  return ue(e) === bo;
}
function e5(e) {
  return ue(e) === wo;
}
function t5(e) {
  return ue(e) === Fo;
}
function n5(e) {
  return ue(e) === Eo;
}
function r5(e) {
  return e === e + 0;
}
function A0(e) {
  return ue(e) === vo;
}
function i5(e) {
  const t = e ? Symbol.prototype : void 0, n = t ? t.valueOf : void 0;
  return n ? Object(n.call(e)) : {};
}
function ti(e) {
  const t = ue(e);
  return t === bo || t === wo || t === Fo || t === y0 || t === Eo || t === vo || t === b0;
}
function Oe(e) {
  const t = ue(e);
  return t == w0 || t == F0;
}
function s5(e) {
  return Oe(e) && Object.prototype.hasOwnProperty.call(e, "toString");
}
function o5(e) {
  return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(
    Oo(e)
  ) != null;
}
function hn(e) {
  if (!ct(e))
    return !1;
  const t = /[\\^$.*+?()[\]{}|]/g, n = /^\[object .+?Constructor\]$/, r = RegExp(
    "^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(t, "\\$&").replace(
      /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
      "$1.*?"
    ) + "$"
  );
  return (Oe(e) ? r : n).test(Oo(e));
}
function O0(e, t) {
  return e?.[t];
}
function ni(e, t) {
  const n = O0(e, t);
  return hn(n) ? n : void 0;
}
function u5() {
  return ni(Object, "create");
}
const er = ni(_, "Map"), _o = ni(_, "WeakMap");
function Ge(e) {
  return ue(e) === E0;
}
function a5(e) {
  return e != null && typeof e.length == "number" && e.length > -1 && e.length % 1 == 0 && e.length <= Number.MAX_SAFE_INTEGER && !Oe(e);
}
function ct(e) {
  const t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function ri(e) {
  return !!e && typeof e == "object";
}
function Ee(e) {
  if (Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function c5(e) {
  const t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function l5(e) {
  const t = e && e.constructor, n = typeof t == "function" && t.prototype || Object.prototype;
  return e === n;
}
const h5 = wl(Object.getPrototypeOf, Object);
function f5(e) {
  if (!e || !e.hasOwnProperty)
    return !1;
  const t = ["value", "initializer", "get", "set"];
  for (let n = 0, r = t.length; n < r; n++)
    if (Object.hasOwnProperty.call(e, t[n]))
      return !0;
  return !1;
}
const De = (e) => {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t))
      return !1;
  return !0;
};
function So(e) {
  return typeof Promise < "u" && e instanceof Promise || ct(e) && typeof e.then == "function" && typeof e.catch == "function";
}
function C0(e) {
  return ct(e) && typeof e.next == "function";
}
function d5(e) {
  const t = e.constructor;
  return t ? (t.name || t.displayName) === "GeneratorFunction" : !1;
}
function p5(e) {
  return e && Oe(Symbol) ? Oe(e[Symbol.iterator]) : Ge(e);
}
function m5(e) {
  return ri(e) && ue(e) == v0;
}
function D5(e) {
  return ri(e) && ue(e) == _0;
}
function g5(e) {
  return ri(e) && ue(e) == S0;
}
function y5(e) {
  return e === e && !ct(e);
}
function ii(e) {
  const t = [];
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
  return t;
}
function b5(e) {
  const t = [];
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.push(e[n]);
  return t;
}
function w5(e) {
  const t = [];
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.push([n, e[n]]);
  return t;
}
function F5(e) {
  const t = {};
  return ii(e).forEach(
    (n) => t[n] = Object.getOwnPropertyDescriptor(e, n)
  ), t;
}
function E5(e, t) {
  if (A0(e)) {
    do {
      if (t === Object.prototype)
        return typeof t[e] < "u";
      if (Object.prototype.hasOwnProperty.call(t, e))
        return !0;
    } while (t = Object.getPrototypeOf(t));
    return !1;
  } else
    return e in t;
}
function At(e, t, n = !0) {
  if (Ee(e) && Ee(t))
    for (const r of ii(t))
      Ee(e[r]) && Ee(t[r]) ? At(e[r], t[r], n) : (n || typeof e[r] > "u") && (e[r] = t[r]);
  return e;
}
function T0(e) {
  Object.freeze(e), Object.keys(e).forEach((t) => {
    ct(e[t]) && T0(e[t]);
  });
}
function v5(e) {
  const t = Object.entries(e).slice(0), n = t.length;
  let r = -1;
  const i = n - 1;
  for (; ++r < n; ) {
    const s = r + Math.floor(Math.random() * (i - r + 1)), o = t[s];
    t[s] = t[r], t[r] = o;
  }
  return Object.fromEntries(t);
}
function _5(e, t = {}) {
  const n = Symbol("isa");
  function r(i) {
    for (const s of Reflect.ownKeys(e))
      Object.defineProperty(i.prototype, s, {
        value: e[s],
        writable: !0
      });
    return Object.defineProperty(i.prototype, n, { value: !0 }), i;
  }
  for (const i of Reflect.ownKeys(t))
    Object.defineProperty(r, i, {
      value: t[i],
      enumerable: Object.propertyIsEnumerable.call(t, i)
    });
  return Object.defineProperty(r, Symbol.hasInstance, {
    value: (i) => !!i[n]
  }), r;
}
function S5(...e) {
  class t {
    constructor() {
      for (const r of e)
        At(this, new r());
    }
  }
  for (const n of e)
    At(t, n), At(t.prototype, n.prototype);
  return t;
}
function A5(e) {
  try {
    postMessage(e, "*");
  } catch (t) {
    if (t?.code === 25)
      return !1;
  }
  return !0;
}
function O5(e, t) {
  return ti(e) || Oe(e) ? t = e : Ge(e) ? t = [...e] : t ? (Object.setPrototypeOf(t, e), Object.assign(t, e)) : t = Object.create(
    Object.getPrototypeOf(e),
    Object.getOwnPropertyDescriptors(e)
  ), t;
}
function R0(e, ...t) {
  return new e.constructor(...t);
}
function Ne(e, t = new _o()) {
  if (!ct(e))
    return e;
  if (t.has(e))
    return t.get(e);
  let n;
  const r = e.constructor;
  if (Oe(e) ? n = e : r === Array ? n = [] : r === er ? n = new er() : r === Set ? n = /* @__PURE__ */ new Set() : r === RegExp ? n = n0(e) : r === Date ? n = new Date(e.getTime()) : typeof ArrayBuffer < "u" && r === ArrayBuffer ? n = Xr(e) : r === Promise ? n = new Promise((i, s) => {
    e.then(
      (o) => {
        i(Ne(o, t));
      },
      (o) => {
        s(Ne(o, t));
      }
    );
  }) : r === Error ? n = Object.create(e) : n = Object.create(
    Object.getPrototypeOf(e)
    // Object.getOwnPropertyDescriptors(from)
  ), e instanceof er)
    e.forEach((i, s) => {
      n.set(Ne(s, t), Ne(i, t));
    });
  else if (e instanceof Set)
    e.forEach((i) => {
      n.add(Ne(i, t));
    });
  else
    for (const i in e)
      try {
        Object.getOwnPropertyDescriptor(e, i) && (n[i] = Ne(e[i], t));
      } catch (s) {
        if (s instanceof TypeError)
          continue;
        if (s instanceof ReferenceError)
          continue;
      }
  if (Object.getOwnPropertySymbols) {
    const i = Object.getOwnPropertySymbols(e);
    for (let s = 0, o = i.length; s < o; s++) {
      const u = i[s], a = Object.getOwnPropertyDescriptor(e, u);
      a && (n[u] = Ne(e[u], t), Object.defineProperty(n, u, a));
    }
  }
  return t.set(e, n), n;
}
function C5(e) {
  if (e === null)
    return null;
  class t {
  }
  return t.prototype = e, new t();
}
function T5(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e;
}
function R5(e, t) {
  return e.__proto__ = t, e;
}
function x0(e, t) {
  return e === t || e !== e && t !== t;
}
function Ao(e, t) {
  if (e === t)
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const i of n)
    if (!r.includes(i) || !Ao(e[i], t[i]))
      return !1;
  return !0;
}
function x5(e, t) {
  return e.bind ? e.bind(t) : function(...r) {
    return e.apply(t, r);
  };
}
function k5(e) {
  const t = new _o();
  return new Proxy(e, {
    get(n, r) {
      const i = Reflect.get(n, r);
      return typeof i != "function" ? i : (t.has(i) || t.set(i, i.bind(n)), t.get(i));
    }
  });
}
function N5(e, t, n) {
  return Object.assign({}, n, { [e]: t });
}
function I5(e, t) {
  if (!Ee(e))
    return e;
  for (const n in t)
    Object.prototype.hasOwnProperty.call(t, n) && delete e[n];
  return e;
}
function P5(e, t) {
  if (!Ee(e))
    return e;
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && !t(n, e[n]) && delete e[n];
  return e;
}
function z5(e, t) {
  const n = {};
  return Ee(e) && t.forEach((r) => {
    Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  }), n;
}
function B5(e) {
  return Ee(e) && ii(e).forEach((t) => {
    delete e[t];
  }), e;
}
function Oo(e) {
  if (e != null) {
    try {
      return Function.prototype.toString.call(e);
    } catch {
    }
    try {
      return "" + e;
    } catch {
    }
  }
  return "";
}
function k0(e, t = ["", "sign", "key"]) {
  return Ee(e) ? Object.keys(e).filter((n) => {
    for (let r = 0, i = t.length; r < i; r++)
      if (e[n] == t[r])
        return !1;
    return !0;
  }).sort().map((n) => `${n}=${e[n]}`).join("&") : String(e);
}
function N0(e, t, n = "") {
  let r = [];
  return !(typeof e == "object" && e !== null) || !(typeof t == "object" && t !== null) ? (e === t || r.push({
    path: n,
    oldValue: e,
    newValue: t
  }), r) : ((/* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)])).forEach((u) => {
    const a = n ? `${n}.${u}` : u;
    r = r.concat(N0(e[u], t[u], a));
  }), r);
}
function $5(e) {
  return e.join(".");
}
function vr(e, t) {
  let n;
  return typeof t == "string" ? n = t.split(".") : n = t, n.reduce(
    (r, i) => r != null && r != null ? r[i] : r,
    e
  );
}
function L5(e, t) {
  try {
    return vr(e, t);
  } catch {
    return;
  }
}
function M5(e, t, n) {
  if (!e || !t)
    return e;
  let r;
  typeof t == "string" ? r = t.split(".") : r = t;
  let i = e;
  for (let s = 0, o = r.length - 1; s < o; s++) {
    const u = r[s];
    (!(u in i) || typeof i[u] != "object" || i[u] === null) && (i[u] = Number.isNaN(Number(r[s + 1])) ? {} : []), i = i[u];
  }
  return i[r[r.length - 1]] = n, e;
}
function j5(e, t, n, r = !1) {
  try {
    const i = vr(e, n), s = vr(t, n);
    return r ? !Ao(i, s) : i !== s;
  } catch {
    return !0;
  }
}
function U5(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  let r = 0;
  for (const i of e) {
    const s = t(i, r++);
    n[s] === void 0 && (n[s] = []), n[s].push(i);
  }
  return n;
}
function I0(e) {
  return e != null;
}
function Co(e) {
  return I0(e) && e !== Er && e !== Jr;
}
function Ve(e) {
  return Co(e) && ti(e);
}
function P0(e, t) {
  return It(t) && t >= e;
}
function z0(e, t) {
  return It(t) && t <= e;
}
function B0(e, t) {
  return at(String(t)) == e;
}
function $0(e) {
  return Nt("email", e);
}
function L0(e) {
  return Nt("mobile-china", e);
}
function M0(e) {
  return Nt("date", e);
}
function j0(e) {
  return Nt("time", e);
}
function U0(e) {
  return Nt("datetime", e);
}
function Z5(e, t) {
  if (!$(e) || !$(t))
    throw new Error("Invalid Date");
  return t.getTime() < e.getTime();
}
function q5(e, t) {
  if (!$(e) || !$(t))
    throw new Error("Invalid Date");
  return t.getTime() > e.getTime();
}
function W5(e, t, n) {
  if (!$(e) || !$(t) || !$(n))
    throw new Error("Invalid Date");
  return e.getTime() <= n.getTime() && n.getTime() <= t.getTime();
}
function Z0(e, t) {
  return e.some((n) => n === t);
}
function Te(e, t) {
  const n = t.reduce((r, i) => {
    try {
      const { predicate: s, message: o } = i;
      s(e) || r.push(o);
    } catch (s) {
      r.push(String(s));
    }
    return r;
  }, []);
  return {
    valid: n.length === 0,
    errors: n
  };
}
function G5(e) {
  return (t) => {
    const n = Te(t, [
      {
        predicate: Ve,
        message: e?.emptyError || e?.error || "邮箱不能为空"
      },
      {
        predicate: $0,
        message: e?.error || "邮箱格式不正确"
      }
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function V5(e) {
  return (t) => {
    const n = Te(t, [
      {
        predicate: Ve,
        message: e?.emptyError || e?.error || "手机号不能为空"
      },
      {
        predicate: L0,
        message: e?.error || "手机号格式不正确"
      }
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function K5(e) {
  return (t) => {
    const n = Te(t, [
      {
        predicate: Ve,
        message: e?.emptyError || e?.error || "日期不能为空"
      },
      {
        predicate: M0,
        message: e?.error || "日期格式不正确"
      }
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function Q5(e) {
  return (t) => {
    const n = Te(t, [
      {
        predicate: Ve,
        message: e?.emptyError || e?.error || "时间不能为空"
      },
      {
        predicate: j0,
        message: e?.error || "时间格式不正确"
      }
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function J5(e) {
  return (t) => {
    const n = Te(t, [
      {
        predicate: Ve,
        message: e?.emptyError || e?.error || "时间不能为空"
      },
      {
        predicate: U0,
        message: e?.error || "时间格式不正确"
      }
    ]);
    if (!n.valid && e?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function H5(e) {
  return (t) => {
    const n = [
      {
        predicate: Ve,
        message: e?.emptyError || e?.error || `${t} 不能为空`
      }
    ];
    typeof e?.min == "number" && n.push({
      predicate: Ct(P0, e.min),
      message: e?.minError || e?.error || `${t} 应该大于等于 ${e.min}`
    }), typeof e?.max == "number" && n.push({
      predicate: Ct(z0, e.max),
      message: e?.maxError || e?.error || `${t} 应该小于等于 ${e.max}`
    });
    const r = Te(t, n);
    if (!r.valid && e?.throw)
      throw new Error(r.errors[0]);
    return r;
  };
}
function X5(e, t) {
  return (n) => {
    const r = Te(n, [
      {
        predicate: Ve,
        message: t?.emptyError || t?.error || "不能为空"
      },
      {
        predicate: Ct(B0, e),
        message: t?.error || "长度不正确"
      }
    ]);
    if (!r.valid && t?.throw)
      throw new Error(r.errors[0]);
    return r;
  };
}
function Y5(e, t) {
  return (n) => {
    const r = Te(n, [
      {
        predicate: Ct(Z0, e),
        message: t?.error || "不能为空"
      }
    ]);
    if (!r.valid && t?.throw)
      throw new Error(r.errors[0]);
    return r;
  };
}
function It(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function eb(e) {
  return It(e) && Number.isFinite(e);
}
const q0 = 2 ** 53 - 1, tb = -q0, W0 = 2 ** 31 - 1, nb = Math.pow(2, -52);
function X(e, t) {
  const n = parseFloat(e);
  return Number.isNaN(n) ? typeof t == "number" ? t : NaN : n;
}
const To = (e) => typeof e == "number" && e >= 0 && Number.isFinite(e), Ro = (e) => To(e) && e > 0, we = (e) => Ro(e) && e === Math.floor(e), rb = (e) => e === 1 / 0 || Ro(e), ib = (e) => e === 1 / 0 || To(e), tr = (e) => e === 1 / 0 || we(e), sb = (e) => e % 2 === 0;
function G0(e) {
  if (e <= 1)
    return !1;
  for (let t = 2; t <= Math.sqrt(e); t++)
    if (e % t === 0)
      return !1;
  return !0;
}
function V0(e) {
  for (; !G0(e); )
    e++;
  return e;
}
const ob = (...e) => e.reduce((t, n) => t + n) / e.length;
function ub(e, t, n) {
  return typeof e == "string" ? (e = e.trim().toLowerCase(), e.indexOf("%") > 0 ? X(e, t) / 100 * n : e.indexOf("vw") > 0 ? X(e, t) / 100 * window.innerWidth : e.indexOf("vh") > 0 ? X(e, t) / 100 * window.innerHeight : e.indexOf("vm") > 0 ? X(e, t) / 100 * Math.min(window.innerWidth, window.innerHeight) : e == "top" || e == "left" ? 0 : e == "center" || e == "middle" ? n * 0.5 : e == "bottom" || e == "right" ? n : X(e, t)) : X(e, t);
}
function K0(e = 1e-6) {
  return function(t, n) {
    return Math.abs(t - n) < e;
  };
}
function ab(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = Math.pow(10, Math.max(n, r));
  return (e * i + t * i) / i;
}
function N(e, t, n) {
  const r = Math.min(t, n), i = Math.max(t, n);
  return e < r ? r : e > i ? i : e;
}
function cb(e, t = 0) {
  const n = Math.pow(10, t);
  return Math.round(n * e) / n;
}
function Q0(e, t) {
  return (e % t + t) % t;
}
function Xt(e, t, n) {
  return typeof e == "number" && typeof t == "number" ? (1 - n) * e + n * t : typeof e == "number" ? e : typeof t == "number" ? t : 0;
}
function lb(e, t, n) {
  const r = Math.max(e.length, t.length), i = new Array(r);
  for (let s = 0; s < r; s++)
    i[s] = Xt(e[s], t[s], n);
  return i;
}
function hb(e, t, n, r) {
  return (i) => n + (r - n) * ((i - e) / (t - e));
}
function fb(e, t, n) {
  return (r) => {
    const i = N(r, e, t);
    return n == 0 ? i : t - i < n ? t : Math.round(i / n) * n;
  };
}
function db(e, t = 12) {
  return X(e, 0).toPrecision(t);
}
function xo(e, t = 2) {
  return X(e, 0).toFixed(t);
}
function Fe(e, t = 2) {
  return +xo(e, t);
}
function J0(e, t = 2) {
  return String(Fe(e, t));
}
function pb(e, t = 2) {
  const n = X(e, 0);
  let r = 1;
  for (let i = 0; i < t; i++)
    r *= 10;
  return Math.round(n * r) / r;
}
function H0(e) {
  const [t, n] = String(e).split(".");
  return Number(t);
}
function mb(e) {
  const [t, n] = String(e).split(".");
  return Number(n);
}
function Db(e, t = 4, n = ",") {
  const r = new RegExp(`\\d{1,${t}}(?=(\\d{${t}})+$)`, "g");
  return String(e).replace(r, `$&${n}`);
}
function gb(e, t = ",") {
  const [n, r] = String(e).split("."), i = n.replace(/\B(?=(\d{3})+(?!\d))/g, t);
  return r ? `${i}.${r}` : i;
}
function yb(e, t) {
  const n = Hr("number-single", String(e));
  return {
    hasNumber: !!n,
    number: n && !Array.isArray(n) && n.fullMatch ? parseFloat(n.fullMatch) : Co(t) ? t : NaN,
    prefix: n && !Array.isArray(n) && n.fullMatch ? e.substring(0, n.matchIndex) : "",
    suffix: n && !Array.isArray(n) && n.fullMatch ? e.substring(n.matchIndex + n.fullMatch.length) : ""
  };
}
function X0(e) {
  const t = Hr("number", e);
  return t ? Array.isArray(t) ? t.map((n) => Number(n.fullMatch)) : [Number(t.fullMatch)] : [];
}
function bb() {
  return Math.random() > 0.5 ? 1 : -1;
}
function Y0(e = 0, t = 100) {
  return Math.random() * (t - e) + e;
}
function wb(e = 0, t = 100) {
  return Math.floor(Y0(e, t));
}
function Fb(e = 0) {
  return () => ++e;
}
const Eb = (e) => new Array(e).fill(void 0);
function vb(e, t = void 0) {
  return Array.from({ length: e }, (n, r) => t);
}
function _b(e, t) {
  const n = new Array(e);
  let r = -1;
  for (; ++r < e; )
    n[r] = t(r);
  return n;
}
function el(e, t, n = void 0) {
  return Array.from(
    { length: e },
    () => new Array(t).fill(n)
  );
}
function Sb(e, t) {
  return [...e[t]];
}
function Ab(e, t) {
  return e.map((n) => n.filter((r, i) => i === t)[0]);
}
function Ob(e) {
  const t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Object.prototype.hasOwnProperty.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
function Cb(e) {
  return e[0].length ? el(e.length, e[0].length) : new Error("Illegal, Array must be any[][]!");
}
function tl(e, t, n) {
  [e[t], e[n]] = [e[n], e[t]];
}
function Tb(e, t) {
  return tl(e, 0, t);
}
function Rb(e, t, n) {
  e.splice(N(t, 0, e.length), 0, n);
}
function nl(e, t) {
  const n = e.findIndex((r) => r === t);
  n >= 0 && e.splice(n, 1);
}
function xb(e, t) {
  return e.includes(t) ? e.filter((n) => n !== t) : [...e, t];
}
function kb(e) {
  if (e.length)
    return e[0];
}
function Nb(e) {
  if (e.length)
    return e[e.length - 1];
}
function Ib(e) {
  const t = [...e];
  t.sort((r, i) => r - i);
  const n = Math.floor(t.length / 2);
  return t[n];
}
function Pb(e, t) {
  const n = e.length ?? 0;
  let r = -1;
  for (; ++r < n; )
    t(e[r], r, e);
}
function zb(e, t) {
  let n = 0;
  for (const r of e)
    n += +!!t(r);
  return n;
}
function Bb(e, t) {
  const n = e.length ?? 0;
  let r = -1;
  for (; ++r < n; )
    if (t(e[r], r, e) === !1)
      return !1;
  return !0;
}
function $b(e, t) {
  const n = e.length ?? 0;
  let r = -1;
  for (; ++r < n; )
    if (t(e[r], r, e) === !0)
      return !0;
  return !1;
}
function rl(e, t) {
  for (let n = 0, r = e.length; n < r; n++)
    if (e[n] == t)
      return !0;
  return !1;
}
function il(e, t = 1) {
  return e.splice(0, t);
}
function Lb(e) {
  return Array.isArray(e) && e.length > 0 && Object.keys(e).length > 0;
}
const Mb = (e, t) => e.length === t.length && e.every((n, r) => n === t[r]);
function sl(e = [], t = []) {
  const n = e.length ?? 0, r = t.length ?? 0;
  for (let s = 0; s < r; s++)
    e[s] = t[s];
  let i = Math.max(0, n - r);
  for (; i > 0; )
    e.pop(), i--;
  return e;
}
function jb(e) {
  for (; e.length; )
    e.pop();
}
const Ub = ([...e]) => e.sort(() => Math.random() - 0.5);
function Zb(e, t) {
  return e.flatMap((n, r) => r ? [t(r), n] : [n]);
}
function* ko(e) {
  for (const t of e)
    Ge(t) ? yield* ko(t) : yield t;
}
function qb(e) {
  if (Ge(e))
    return [...ko(e)];
}
function ol(e) {
  let t = [];
  return e.forEach((n) => {
    Ge(n) ? t = t.concat(ol(n)) : t.push(n);
  }), t;
}
function ul(e) {
  return e.reduce((t, n) => t.concat(Ge(n) ? ul(n) : n), []);
}
function Wb(e) {
  return e.flat(1 / 0);
}
function Gb(e) {
  let t = JSON.stringify(e);
  return t = t.replace(/(\[|\])/g, ""), t = "[" + t + "]", JSON.parse(t);
}
function Vb(e) {
  return [...new Set(e)];
}
function Kb(e, ...t) {
  return t.forEach((n) => {
    rl(e, n) || e.push(n);
  }), e;
}
function Qb(e, t) {
  return [.../* @__PURE__ */ new Set([...e, ...t])];
}
function Jb(e, t) {
  const n = /* @__PURE__ */ new Set();
  for (const r of e)
    n.add(r);
  for (const r of t)
    n.add(r);
  return n;
}
function Hb(e, t) {
  return [...new Set(e.filter((n) => t.includes(n)))];
}
function Xb(e, t) {
  const n = /* @__PURE__ */ new Map();
  e.forEach((i) => {
    n.set(i, !0);
  });
  const r = [];
  return t.forEach((i) => {
    n.has(i) && (r.push(i), n.delete(i));
  }), r;
}
function Yb(e, t) {
  return new Set([...e].filter((n) => t.has(n)));
}
function e6(e, t) {
  if (e.size === 0 || t.size === 0)
    return !1;
  for (const n of e)
    if (t.has(n))
      return !0;
  return !1;
}
function t6(e, t) {
  return [...new Set(e.filter((n) => !t.includes(n)))];
}
function n6(e, t) {
  const n = /* @__PURE__ */ new Set();
  for (const r of e)
    t.has(r) || n.add(r);
  return n;
}
function r6(e) {
  for (let t = e.length - 1; t >= 0; --t)
    if (e[t] >= 65535)
      return !0;
  return !1;
}
class Yt extends Array {
  constructor(t) {
    super(t), this.fill(0);
  }
}
const No = (e) => we(e) ? e <= Math.pow(2, 8) ? Uint8Array : e <= Math.pow(2, 16) ? Uint16Array : e <= Math.pow(2, 32) ? Uint32Array : e <= Number.MAX_SAFE_INTEGER ? Yt : null : null;
function Ut(e, t) {
  let n = e.length;
  for (; n--; )
    if (x0(e[n][0], t))
      return n;
  return -1;
}
function ji(e) {
  const t = Array(e.size);
  return e.forEach(function(n, r) {
    t.push([r, n]);
  }), t;
}
function al(e, t) {
  return e.set(t[0], t[1]), e;
}
function i6(e, t) {
  return (t ? t(ji(e), !0) : ji(e)).reduce(al, /* @__PURE__ */ new Map());
}
function Ui(e) {
  const t = Array(e.size);
  return e.forEach((n, r) => {
    t[r] = n;
  }), t;
}
function cl(e, t) {
  return e.add(t), e;
}
function s6(e, t) {
  return (t ? t(Ui(e), !0) : Ui(e)).reduce(cl, /* @__PURE__ */ new Set());
}
function o6(e, t = "Asia/Shanghai") {
  const n = (/* @__PURE__ */ new Date()).getTimezoneOffset() * 60 * 1e3;
  return new Date(e.getTime() - n);
}
function M() {
  return (typeof performance == "object" && performance && typeof performance.now == "function" ? performance : Date).now();
}
function u6(e) {
  return e.getTime() - Date.now();
}
function Zt(e = /* @__PURE__ */ new Date()) {
  return e.getTime();
}
function a6(e = /* @__PURE__ */ new Date(), t = "yyyy-mm-dd hh:ii:ss.SSS") {
  return Pt(e, t);
}
function $(e) {
  const t = e.valueOf();
  return !Number.isNaN(t);
}
const si = 864e5;
function Io(e) {
  return e > 1e12;
}
function ll(e) {
  return e > 1e9 && !Io(e);
}
function Le(e) {
  if (e == null)
    return /* @__PURE__ */ new Date(NaN);
  if (e instanceof Date)
    return new Date(e);
  if (typeof e == "string") {
    const t = e.match(
      /^(\d{4})[-/.]?(\d{1,2})?[-/.]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?[zZ]?$/
    );
    if (t && t[1]) {
      const n = parseInt(t[1]), r = t[2] ? Math.max(parseInt(t[2]) - 1, 0) : 0, i = t[3] ? parseInt(t[3]) : 1, s = t[4] ? parseInt(t[4]) : 0, o = t[5] ? parseInt(t[5]) : 0, u = t[6] ? parseInt(t[6]) : 0, a = t[7] ? parseInt(t[7].substring(0, 3)) : 0;
      return /Z$/i.test(e) ? new Date(Date.UTC(n, r, i, s, o, u, a)) : new Date(n, r, i, s, o, u, a);
    } else
      return /* @__PURE__ */ new Date(NaN);
  }
  return Array.isArray(e) ? new Date(
    e[0],
    Math.max(e[1] - 1, 0),
    e[2] || 1,
    e[3] || 0,
    e[4] || 0,
    e[5] || 0,
    e[6] || 0
  ) : ll(e) ? new Date(Io(e) ? e : e * 1e3) : /* @__PURE__ */ new Date(NaN);
}
function c6(e, t = 3, n = ":") {
  const r = Math.max(e.length, 6);
  let i = "";
  for (let o = 0; o < r - 4; o++)
    i += e[o] || "0";
  const s = [
    i,
    // 小时
    "" + (e[r - 4] || "0") + (e[r - 3] || "0"),
    // 分钟
    "" + (e[r - 2] || "0") + (e[r - 1] || "0")
    // 秒
  ];
  switch (t) {
    case 1:
      return s[0];
    case 2:
      return s[0] + n + s[1];
    case 3:
      return s[0] + n + s[1] + n + s[2];
  }
}
function hl(e, t = 3) {
  const n = Math.max(e.length, 6);
  let r = 0;
  for (let o = 0; o < n - 4; o++)
    r = r * 10 + (e[o] || 0);
  const i = [
    Math.floor(r),
    // 小时
    Math.floor((e[n - 4] || 0) * 10 + (e[n - 3] || 0)),
    // 分钟
    Math.floor((e[n - 2] || 0) * 10 + (e[n - 1] || 0))
    // 秒
  ];
  let s = "";
  switch (t) {
    case 1:
      i[0] ? s += i[0] + "小时" : (i[1] || i[2]) && (s += "1小时");
      break;
    case 2:
      i[0] && (s += i[0] + "小时"), i[1] ? s += i[1] + "分钟" : i[2] && (s += "1分钟");
      break;
    case 3:
    default:
      i[0] && (s += i[0] + "小时"), (i[1] || i[2]) && (s += i[1] + "分钟"), i[2] && (s += i[2] + "秒");
      break;
  }
  return s || "0秒";
}
function en(e) {
  const t = Math.max(e.length, 6);
  let n = 0;
  n += (e[t - 2] || 0) * 10 + (e[t - 1] || 0), n += ((e[t - 4] || 0) * 10 + (e[t - 3] || 0)) * 60;
  let r = 0;
  for (let i = 0; i < t - 4; i++)
    r = r * 10 + (e[i] || 0);
  return n += r * 60 * 60, Math.floor(Math.max(0, n));
}
function it(e, t = !1) {
  let n = 0;
  if (typeof e == "number" ? n = e : n = en(e), n <= 0)
    return [0, 0, 0, 0, 0, 0];
  const r = [], i = n % 60;
  r.unshift(i % 10), r.unshift(Math.floor(i / 10)), n = Math.floor(n / 60);
  const s = n % 60;
  if (r.unshift(s % 10), r.unshift(Math.floor(s / 10)), n = Math.floor(n / 60), t) {
    const o = n % 100;
    for (r.unshift(o % 10), r.unshift(Math.floor(o / 10)), n = Math.floor(n / 100); n; )
      r.unshift(n % 10), n = Math.floor(n / 10);
  } else {
    const o = n % 24;
    r.unshift(o % 10), r.unshift(Math.floor(o / 10));
  }
  return r;
}
function l6(e, t = !1) {
  if (e instanceof Date) {
    const o = e.getHours(), u = e.getMinutes(), a = e.getSeconds();
    return it(o * 60 * 60 + u * 60 + a, !1);
  }
  const n = X0(e);
  let r = 0, i = 0, s = 0;
  for (let o = 0, u = Math.max(n.length, 3); o < u; o++) {
    const a = Math.floor(Math.abs(n[o] || 0));
    o == 0 ? t ? r = a : r = a % 24 : o == 1 ? i = a : o == 2 && (s = a);
  }
  return it(r * 60 * 60 + i * 60 + s, t);
}
function Zi(e, t = !1) {
  const n = e[0] || 0, r = e[1] || 0, i = e[2] || 0;
  return it(n * 60 * 60 + r * 60 + i, t);
}
function fl(e, t, n = !1) {
  const r = ($(e) && $(t) ? Math.abs(t.getTime() - e.getTime()) : 0) / 1e3;
  return it(r, n);
}
function h6(e, t = 1, n = !1) {
  return e[e.length - 1] += t, it(e, n);
}
function f6(e, t = 1, n = !1) {
  return e[e.length - 1] -= t, it(e, n);
}
function d6(e, t) {
  sl(t, e);
}
function p6(e, t, n) {
  const r = en(e), i = en(t), s = en(n);
  return i >= r ? s >= r && s <= i : s >= r || s <= i;
}
function qi(e, t) {
  if (!$(e))
    throw new Error(`Date(${e}) is Invalid !`);
  if (!$(t))
    throw new Error(`Date(${t}) is Invalid !`);
  return Math.ceil((t.getTime() - e.getTime()) / si);
}
function m6(e, t, n) {
  return !(!$(e) || !$(t) || !$(n) || qi(e, n) < 0 || qi(n, t) < 0);
}
function Pt(e, t = "yyyy-mm-dd hh:ii:ss") {
  if (!$(e))
    return "";
  const n = /(y+)/.exec(t);
  if (n && n[1]) {
    const i = n[1];
    t = t.replace(
      i,
      // (date.getFullYear() + "").substring(Math.max(4 - year.length, 0))
      (e.getFullYear() + "").substring(4 - i.length)
    );
  }
  const r = {
    "m+": e.getMonth() + 1,
    //月份
    "d+": e.getDate(),
    //日
    "h+": e.getHours(),
    //小时
    "i+": e.getMinutes(),
    //分
    "s+": e.getSeconds(),
    //秒
    "q+": Math.floor((e.getMonth() + 3) / 3),
    // 季度
    "S+": e.getMilliseconds()
    //毫秒
  };
  for (const i in r) {
    const s = new RegExp("(" + i + ")").exec(t);
    if (s && s[1]) {
      const o = s[1];
      t = t.replace(
        o,
        // d.length == 1 ? "" + o[k] : ("00" + o[k]).substring(("" + o[k]).length)
        // d.length == 1
        //   ? "" + o[k]
        //   : ("00" + o[k]).substring(("" + o[k]).length - d.length + 2)
        o.length === 1 ? "" + r[i] : ("00" + r[i]).slice(-o.length)
      );
    }
  }
  return t;
}
function D6(e = "yyyy-mm-dd hh:ii:ss") {
  return (t) => Pt(t, e);
}
function g6(e, t = "-") {
  return Pt(e, `yyyy${t}mm${t}dd`);
}
function y6(e, t = ":") {
  return Pt(e, `hh${t}ii${t}ss`);
}
function b6(e) {
  return $(e) ? e.toTimeString().slice(0, 8) : "";
}
function _r(e, t = "-", n = ":") {
  return Pt(
    e,
    `yyyy${t}mm${t}dd hh${n}ii${n}ss`
  );
}
function w6(e) {
  return $(e) ? [0, 6].indexOf(e.getDay()) !== -1 : !1;
}
function F6(e) {
  return $(e) ? Math.floor(
    (e.getTime() - new Date(e.getFullYear(), 0, 0).getTime()) / si
  ) : -1;
}
function dl(e, t) {
  return new Date(e, t, 0).getDate();
}
function pl(e, t) {
  const n = new Date(e, t, 1);
  return n.setHours(0, 0, 0, 0), n.getTime() - 1;
}
function E6(e, t) {
  return pl(e, t) + 1;
}
function ml(e, t) {
  const n = new Date(e, t - 1, 1);
  return n.setHours(0, 0, 0, 0), n.getTime();
}
function v6(e, t) {
  return ml(e, t) - 1;
}
function _6(e, t = 1) {
  const n = typeof e == "string" ? Le(e) : new Date(e);
  n.setHours(0, 0, 0, 0);
  const r = new Date(n);
  return n.setMonth(n.getMonth() + t), n.getDate() < r.getDate() && n.setDate(0), new Date(n.getTime() - 1);
}
function S6(e, t = 1, n = !1) {
  const r = typeof e == "string" ? Le(e) : new Date(e);
  r.setHours(0, 0, 0, 0);
  const i = new Date(r);
  return r.setMonth(r.getMonth() + t), r.getDate() < i.getDate() ? (r.setDate(0), r) : n ? r : new Date(r.getTime() - 1);
}
function qt(e, t = 1) {
  const n = typeof e == "string" ? Le(e) : e;
  return new Date(n.getTime() + t * si);
}
function bt(e) {
  const t = e.getFullYear(), n = e.getMonth() + 1, r = e.getDate();
  let i = e.getDay();
  return i == 0 && (i = 7), {
    year: t,
    month: n,
    day: r,
    weekday: i,
    monthDays: dl(t, n),
    date: new Date(e)
  };
}
function A6(e = "") {
  const t = [], n = bt(
    typeof e == "string" ? e != "" ? Le(e) : /* @__PURE__ */ new Date() : e
  );
  function r(i, s) {
    if (i.month !== n.month)
      return;
    const o = [];
    s == "forward" ? t.unshift(o) : t.push(o), o.push(i);
    let u = i;
    for (let a = i.weekday - 1; a >= 1; a--)
      u = bt(qt(u.date, -1)), o.unshift(u);
    u = i;
    for (let a = i.weekday + 1; a <= 7; a++)
      u = bt(qt(u.date, 1)), o.push(u);
    o[0].day > 1 && (s == "both" || s == "forward") && r(bt(qt(o[0].date, -1)), "forward"), o[6].day < n.monthDays && (s == "both" || s == "backward") && r(bt(qt(o[6].date, 1)), "backward");
  }
  return r(n, "both"), t;
}
const Dl = () => {
}, O6 = (e) => e, Po = (e) => () => e, C6 = Po(!0), T6 = Po(!1), R6 = (e) => ({ value: e, done: !0 });
function x6(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function gl(e, t = 300, n) {
  const r = typeof n?.leading == "boolean" ? n.leading : !0, i = typeof n?.trailing == "boolean" ? n.trailing : !1;
  let s = !0, o;
  return function(...a) {
    if (!s) {
      o = a;
      return;
    }
    s = !1, r && e.apply(n?.thisArg || this, a), i && (o = a), setTimeout(() => {
      i && e.apply(n?.thisArg || this, o), o = void 0, s = !0;
    }, t);
  };
}
function yl(e, t = 300, n) {
  let r, i = 0;
  return function(...o) {
    i || (i = M()), r && (clearTimeout(r), r = void 0);
    let u = !1;
    n?.throttle && (u = M() - i >= t), u ? (e.apply(n?.thisArg || this, o), i = M()) : r = setTimeout(() => {
      e.apply(n?.thisArg || this, o), n?.throttle && (i = M()), r = void 0;
    }, t);
  };
}
function k6(e, t) {
  let n;
  return function(...r) {
    return n || (n = e.apply(t || this, r)), n;
  };
}
function Ct(e, ...t) {
  const n = e.length;
  return t = t || [], function(...r) {
    const i = t.concat(Array.prototype.slice.call(r));
    return i.length < n ? Ct.call(this, e, ...i) : e.apply(this, i);
  };
}
function bl(...e) {
  return e.length === 0 ? (...t) => t : e.length === 1 ? e[0] : e.reduce(
    (t, n) => (...r) => t(n(...r))
  );
}
function N6(...e) {
  return e.length === 0 ? (...t) => t : e.length === 1 ? e[0] : e.reduceRight(
    (t, n) => (...r) => t(n(...r))
  );
}
function I6(...e) {
  return e.length === 0 ? (...t) => t : e.length === 1 ? e[0] : e.reduceRight(
    (t, n) => (...r) => n(...r, t),
    Dl
  );
}
function P6(e) {
  for (; e && e instanceof Function; )
    e = e();
  return e;
}
function z6(e) {
  let t, n = !1;
  const r = [];
  return function(...s) {
    if (r.push(s), !n) {
      for (n = !0; r.length; )
        t = e.apply(this, r.shift());
      return n = !1, t;
    }
  };
}
function B6(e, t) {
  return function(...n) {
    return e.apply(t || this, n.reverse());
  };
}
function wl(e, t) {
  return function(n) {
    return e(t(n));
  };
}
function $6(e, t, n) {
  return n = Math.max(n === void 0 ? e.length - 1 : n, 0), function(...r) {
    const i = Math.max(r.length - n, 0), s = Array(i);
    let o = -1;
    for (; ++o < i; )
      s[o] = r[n + o];
    o = -1;
    const u = Array(n + 1);
    for (; ++o < n; )
      u[o] = r[o];
    return u[n] = t(s), e.apply(this, u);
  };
}
function Fl(e = 0, t) {
  const n = t?.min ?? 300, r = t?.max ?? 6e4, i = t?.exponent ?? 2, s = t?.factor ?? 0.5;
  let o = n * Math.pow(i, e);
  if (s) {
    const u = Math.random(), a = Math.floor(u * s * o);
    o = Math.floor(u * 10) & 1 ? o + a : o - a;
  }
  return Math.min(o, r) | 0;
}
function zt(e, t) {
  const n = t?.maxRetries ?? 0;
  return async function(...i) {
    const s = t?.thisArg || this;
    let o;
    for (let u = 0; u <= n; u++)
      try {
        return await e.call(s, ...i);
      } catch (a) {
        if (o = a, t?.shouldRetry && !t.shouldRetry(o))
          throw o;
        if (u === n)
          break;
        const c = typeof t?.retryDelay == "function" ? t.retryDelay(u) : t?.retryDelay ?? Fl(u);
        await new Promise((l) => setTimeout(l, c));
      }
    throw o;
  };
}
function Ke(e, t = {
  // createCache: () => new Map()
  // createCache: () => new MapCache()
  // createCache: () => new TTLCache({ max: 500 })
  // createCache: () => new TTLCache({ ttl: 60 * 1000 })
  // createCache: () =>
  //   new TTLCache({ max: 500, ttl: 60 * 1000 }, new MapCache())
  // createCache: () => new LRUCache({ max: 500 })
}) {
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  const n = function(...r) {
    const i = t?.thisArg || this, s = t?.cacheKeyResolver ? t.cacheKeyResolver.apply(i, r) : r[0], o = n.cache;
    if (o.has(s))
      return o.get(s);
    const u = e.apply(i, r);
    return u instanceof Promise && u.catch(() => o.delete(s)), n.cache = o.set(s, u) || o, u;
  };
  return n.cache = t?.createCache ? t.createCache() : /* @__PURE__ */ new Map(), n;
}
function L6(e, t) {
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  let n = null, r;
  return function(...s) {
    const o = t?.thisArg || this;
    return (!n || s.length !== n.length || s.some((a, c) => !Object.is(a, n?.[c]))) && (n = [...s], r = e.call(o, ...s), So(r) && r.catch(() => {
      n = null;
    })), r;
  };
}
function M6(e, t) {
  return e = zt(e, t), e = Ke(e, t), e;
}
function j6(e, t) {
  const { ignoreResult: n = () => !1 } = t || {};
  return async (...r) => {
    for (let i = 0, s = e.length; i < s; i++)
      try {
        const o = await e[i](...r);
        if (!n(o))
          return o;
      } catch (o) {
        t?.onError?.(o);
      }
    throw new Error("tryEach failed. No function returned a value");
  };
}
function U6(e) {
  return (t) => (console.log(e + ": " + t), t);
}
function Z6(e) {
  return (t) => t.map(e);
}
function q6(e) {
  return (t, n) => t.reduce(e, n);
}
Array.prototype.ap = function(e) {
  return this.reduce((t, n) => t.concat(e.map(n)), []);
};
function W6(e) {
  return (...t) => (
    // thunk 函数签名
    (n) => {
      let r;
      try {
        e.apply(this, [
          ...t,
          (i, ...s) => {
            r || (r = !0, n(i, ...s));
          }
        ]);
      } catch (i) {
        n(i);
      }
    }
  );
}
function G6(e) {
  return new Promise((t, n) => {
    e.call(this, (r, ...i) => r ? n(r) : t(i));
  });
}
async function* V6(e) {
  for (const t of e)
    yield t;
}
async function K6(e) {
  const t = [];
  for await (const n of e)
    t.push(n);
  return t;
}
async function Q6(e) {
  let t = Er;
  for await (const n of e)
    t = n;
  if (t === Er)
    throw new Error("No items in generator");
  return t;
}
async function J6(e) {
  let t;
  do
    t = await e.next();
  while (!t.done);
  return t.value;
}
async function H6(e, t) {
  const n = C0(e) ? e : e(), r = async (i) => {
    i.value && i.value.then ? i.value.then(async (s) => {
      await t?.(s), i.done || await r(await n.next(s));
    }).catch(async (s) => {
      if (i.done || !n.throw)
        throw new Error(s);
      await r(await n.throw(s));
    }) : typeof i.value == "function" ? i.value(async (s, o) => {
      if (s) {
        if (i.done || !n.throw)
          throw new Error(s);
        return await r(await n.throw(s));
      }
      await t?.(o), i.done || await r(await n.next(o));
    }) : (await t?.(i.value), i.done || await r(await n.next(i.value)));
  };
  await r(await n.next());
}
async function* X6(e, t = 1 / 0) {
  const n = (s) => {
    const o = s.next().then(({ done: u, value: a }) => ({
      done: u,
      value: a,
      generator: s,
      promise: o
    }));
    return o;
  }, r = [...e], i = /* @__PURE__ */ new Set();
  for (; i.size < t && r.length > 0; ) {
    const s = r.shift();
    i.add(n(s));
  }
  for (; i.size > 0; ) {
    const { done: s, value: o, generator: u, promise: a } = await Promise.race(i);
    if (i.delete(a), !s)
      i.add(n(u)), o !== void 0 && (yield o);
    else if (r.length > 0) {
      const c = r.shift();
      i.add(n(c));
    }
  }
}
function El() {
  let e, t;
  return { promise: new Promise((r, i) => {
    e = r, t = i;
  }), resolve: e, reject: t };
}
function Y6(e, t) {
  Promise.resolve().then(e).then((n) => {
    t(null, n);
  }).catch((n) => {
    t(n);
  });
}
function Sr(e, t = (n) => console.error(n)) {
  try {
    const n = e();
    return So(n) ? Promise.resolve(n).catch((r) => {
      t(r);
    }) : n;
  } catch (n) {
    t(n);
  }
}
const vl = 2147483647;
function zo(e, t, n) {
  if (typeof t != "number" || t <= 0)
    return e;
  let r;
  const i = new Promise((s, o) => {
    r = setTimeout(
      (u, a) => {
        u(new Error(a || `Timeout of ${t}ms!`));
      },
      Math.min(t, vl),
      o,
      n
    );
  });
  return Promise.race([e, i]).finally(() => {
    r !== void 0 && (clearTimeout(r), r = void 0);
  });
}
function _l(e, t, n) {
  if (!t)
    return e;
  const r = n || "Aborted!";
  return t.aborted ? Promise.reject(new Error(r)) : new Promise((i, s) => {
    const o = () => {
      s(new Error(r));
    };
    t.addEventListener("abort", o, { once: !0 }), e.finally(() => {
      t.removeEventListener("abort", o);
    }), e.then(i, s);
  });
}
async function ew(e, t, n) {
  return new Promise((r, i) => {
    const s = () => {
      n?.throwOnAbort || n?.abortError ? i(n.abortError?.() ?? new Error("aborted")) : r();
    };
    if (t?.aborted) {
      s();
      return;
    }
    const o = setTimeout(
      (a, c, l) => {
        a?.removeEventListener("abort", c), l();
      },
      e,
      t,
      u,
      r
    );
    function u() {
      t?.removeEventListener("abort", u), clearTimeout(o), s();
    }
    t?.addEventListener("abort", u, { once: !0 });
  });
}
function tw(e) {
}
async function nw(e = []) {
  return await e.reduce(async (t, n) => {
    const r = await t;
    return await n(r);
  }, Promise.resolve(void 0));
}
async function rw(e) {
  let t = null, n = Promise.resolve();
  for (const r of e)
    n = n.then((i) => (t = i, r));
  return n.catch((r) => {
    throw r;
  }).then(() => t);
}
async function iw(e) {
  return await Promise.allSettled(
    e
  );
}
async function sw(e, t, n = 1 / 0) {
  const r = new Array(e.length);
  let i = 0;
  async function s() {
    for (; i < e.length; ) {
      const a = i++, c = e[a];
      c !== void 0 && (r[a] = await t(c, a));
    }
  }
  const o = [], u = Math.min(n, e.length);
  for (let a = 0; a < u; a++)
    o.push(s());
  return await Promise.all(o), r;
}
class ow {
  constructor(t) {
    this.returned = t;
  }
  queue = [];
  readResolve;
  readReject;
  started = !1;
  isDone = !1;
  hasError;
  // subscribe
  [Symbol.asyncIterator]() {
    if (this.started)
      throw new Error("Stream can only be iterated once");
    return this.started = !0, this;
  }
  // for await (const { value } of stream) {
  //   console.log(`start`);
  //   await sleep(1000);
  //   console.log(`end`);
  // }
  // async *[Symbol.asyncIterator](): AsyncIterator<IteratorResult<T, unknown>> {
  //   if (this.started) {
  //     throw new Error("Stream can only be iterated once");
  //   }
  //   this.started = true;
  //   while (true) {
  //     const item = await this.next();
  //     if (!item || item.done) {
  //       return;
  //     }
  //     yield item;
  //   }
  // }
  next() {
    return this.queue.length > 0 ? Promise.resolve({
      done: !1,
      value: this.queue.shift()
    }) : this.isDone ? Promise.resolve({ done: !0, value: void 0 }) : this.hasError ? Promise.reject(this.hasError) : new Promise((t, n) => {
      this.readResolve = t, this.readReject = n;
    });
  }
  enqueue(t) {
    if (this.readResolve) {
      const n = this.readResolve;
      this.readResolve = void 0, this.readReject = void 0, n({ done: !1, value: t });
    } else
      this.queue.push(t);
  }
  done() {
    if (this.isDone = !0, this.readResolve) {
      const t = this.readResolve;
      this.readResolve = void 0, this.readReject = void 0, t({ done: !0, value: void 0 });
    }
  }
  error(t) {
    if (this.hasError = t, this.readReject) {
      const n = this.readReject;
      this.readResolve = void 0, this.readReject = void 0, n(t);
    }
  }
  return() {
    return this.isDone = !0, this.returned && this.returned(), Promise.resolve({ done: !0, value: void 0 });
  }
}
function uw(e, t) {
  const n = e.getReader();
  n.read().then(function r({ done: i, value: s }) {
    return t(s), i ? Promise.resolve(i) : n.read().then(r);
  });
}
class Ot {
  value;
  left;
  right;
  constructor(t, n) {
    this.value = t, this.left = n?.left, this.right = n?.right;
  }
  clone() {
    return new Ot(this.value, {
      left: this.left,
      right: this.right
    });
  }
}
class aw {
  root;
  constructor() {
  }
  add(t) {
    if (!this.root)
      this.root = new Ot(t);
    else {
      let n = this.root;
      for (; n; )
        if (t === n.value) {
          console.log("Duplicates cannot be added");
          break;
        } else if (t < n.value)
          if (n.left)
            n = n.left;
          else {
            n.left = new Ot(t);
            break;
          }
        else if (t > n.value)
          if (n.right)
            n = n.right;
          else {
            n.right = new Ot(t);
            break;
          }
    }
  }
  remove(t) {
    let n = this.root, r, i;
    for (; n; )
      if (t < n.value)
        r = n, n = n.left;
      else if (t > n.value)
        r = n, n = n.right;
      else {
        i = n;
        break;
      }
    if (!i) {
      console.log("The node was not found");
      return;
    }
    if (r) {
      const s = r.left === i;
      if (!i.left && !i.right)
        s ? r.left = void 0 : r.right = void 0;
      else if (i.left && !i.right)
        s ? r.left = i.left : r.right = i.left;
      else if (i.right && !i.left)
        s ? r.left = i.right : r.right = i.right;
      else {
        const o = i.right, u = i.left;
        s ? r.left = o : r.right = o;
        let a = o, c;
        for (; a; )
          c = a, a = a.left;
        c && (c.left = u), console.log("The node was successfully deleted");
      }
    } else if (!i.left && !i.right)
      this.root = void 0;
    else if (i.left && !i.right)
      this.root = i.left;
    else if (i.right && !i.left)
      this.root = i.right;
    else {
      const s = i.right, o = i.left;
      this.root = s;
      let u = s, a;
      for (; u; )
        a = u, u = u.left;
      a && (a.left = o), console.log("The node was successfully deleted");
    }
    return i;
  }
  // 树的高度
  // 最大深度： root 到 叶子节点
  maxDepth(t = this.root) {
    let n = 0;
    const r = (i, s = 1) => {
      i && (!i.left && !i.right && (n = Math.max(n, s)), r(i.left, s + 1), r(i.right, s + 1));
    };
    return r(t), n;
  }
  // 最小深度： root 到 叶子节点
  minDepth(t = this.root) {
    if (!t)
      return 0;
    const n = [[t, 1]];
    for (; n.length; ) {
      const [r, i] = n.shift();
      if (!r.left && !r.right)
        return i;
      r.left && n.push([r.left, i + 1]), r.right && n.push([r.right, i + 1]);
    }
  }
  // 如果某二叉树中任意节点的左右子树的深度相差不超过 1，那么它就是一棵平衡二叉树
  // 该方法最坏的情况是每个父节点都只有一个子节点，这样树的高度时间复杂度为 O(n)，即“链表”的长度。而第 d 层调用 height 函数的时间复杂度是 O(d)，所以整体的时间复杂度为 高度时间复杂度 * 调用height函数的时间复杂度，即 O(n^2)。
  isBalance(t = this.root) {
    return t ? Math.abs(this.maxDepth(t.left) - this.maxDepth(t.right)) <= 1 && this.isBalance(t.left) && this.isBalance(t.right) : !0;
  }
  // 广度优先遍历
  bfs(t = this.root, n) {
    if (!t)
      return;
    const r = [t];
    for (; r.length; ) {
      const i = r.shift();
      if (!n?.(i))
        break;
      i.left && r.push(i.left), i.right && r.push(i.right);
    }
  }
  // 深度优先遍历
  dfs(t = this.root, n) {
    t && n?.(t) && (this.dfs(t.left, n), this.dfs(t.right, n));
  }
  // 递归遍历 - 先序遍历 current, left, right
  preOrderRecursive(t = this.root, n) {
    t && n?.(t) && (this.preOrderRecursive(t.left, n), this.preOrderRecursive(t.right, n));
  }
  // 递归遍历 - 中序遍历 left, current, right
  // 中序遍历：递增序列
  // 中序遍历倒序：递减序列
  inOrderRecursive(t = this.root, n) {
    t && (this.inOrderRecursive(t.left, n), n?.(t) && this.inOrderRecursive(t.right, n));
  }
  // 递归遍历 - 后序遍历 left, right, current
  postOrderRecursive(t = this.root, n) {
    t && (this.postOrderRecursive(t.left, n), this.postOrderRecursive(t.right, n), n?.(t));
  }
  // 非递归遍历 - 先序遍历 current, left, right
  preOrder(t = this.root, n) {
    const r = [];
    for (t && r.push(t); r.length && (t = r.pop(), !!n?.(t)); )
      t.right && r.push(t.right), t.left && r.push(t.left);
  }
  // 中序遍历：递增序列
  // 非递归遍历 - 中序遍历 left, current, right
  inOrder(t = this.root, n) {
    const r = [];
    for (; r.length || t; ) {
      for (; t; )
        r.push(t), t = t.left;
      if (t = r.pop(), !n?.(t))
        break;
      t = t.right;
    }
  }
  // 中序遍历倒序：递减序列 right, current, left
  inOrderReverse(t = this.root, n) {
    const r = [];
    for (; r.length || t; ) {
      for (; t; )
        r.push(t), t = t.right;
      if (t = r.pop(), !n?.(t))
        break;
      t = t.left;
    }
  }
  // 非递归遍历 - 后序遍历 left, right, current
  postOrder(t = this.root, n) {
    const r = [], i = [];
    for (t && r.push(t); r.length; )
      t = r.pop(), i.push(t), t.left && r.push(t.left), t.right && r.push(t.right);
    n && i.reverse().map(n);
  }
  // 获得第K大的节点, K从1开始
  kthLargest(t) {
    let n = 0, r;
    return this.inOrderReverse(this.root, (i) => (n++, n == t ? (r = i.value, !1) : !0)), r;
  }
  // 反转二叉树
  // 寻找递归公式
  // 解题要采用自上而下的思考方式，那我们取前面的 1， 2，3 结点来看，对于根节点 1 来说，假设 2, 3 结点下的节点都已经翻转，那么只要翻转 2， 3 节点即满足需求
  // 对于 2， 3 结点来说，也是翻转其左右节点即可,依此类推,对每一个根节点，依次翻转其左右节点，
  // 所以我们可知问题与子问题的关系是 翻转(根节点) = 翻转(根节点的左节点) + 翻转(根节点的右节点)
  // 即 invert(root) = invert(root->left) + invert(root->right),
  // 而显然递归的终止条件是当结点为叶子结点时终止（因为叶子节点没有左右结点）
  // 时间复杂度分析: 由于会对每一个节点都去做翻转，所以时间复杂度是 O(n)
  // 空间复杂度分析: 由于每次调用 invertTree 函数都相当于一次压栈操作，
  //   那最多压了几次栈呢，从根节点出发不断对左结果调用翻转函数, 直到叶子节点，每调用一次都会压栈，左节点调用完后，出栈，再对右节点压栈 ...,
  //   可知栈的大小为3， 即树的高度，如果是完全二叉树 ，则树的高度为logn, 即空间复杂度为O(logn)
  //   最坏情况，如果此二叉树是只有左节点，没有右节点，则树的高度即结点的个数 n，此时空间复杂度为 O(n)
  //   总的来看，空间复杂度为O(n)
  invertTree(t = this.root) {
    if (!t)
      return;
    const n = this.invertTree(t.left), r = this.invertTree(t.right);
    return t.right = n, t.left = r, t;
  }
}
class oi {
  value;
  toEdges;
  constructor(t, n = []) {
    this.value = t, this.toEdges = n;
  }
  clone() {
    return new oi(this.value, this.toEdges);
  }
}
class fn {
  fromNode;
  toNode;
  // 权重
  weight;
  constructor(t, n, r = 1) {
    this.fromNode = t, this.toNode = n, this.weight = r;
  }
  clone() {
    return new fn(this.fromNode, this.toNode, this.weight);
  }
}
class cw {
  // 有无方向
  isdirected;
  nodes = [];
  visitFn;
  constructor(t = !1, n) {
    this.isdirected = t, this.visitFn = n || ((r) => console.log(r.value + ","));
  }
  addNode(t) {
    this.nodes.push(new oi(t));
  }
  removeNode(t) {
    this.nodes = this.nodes.filter((n) => n.value !== t), this.nodes.forEach((n) => {
      n.toEdges = n.toEdges.filter((r) => r.toNode.value !== t);
    });
  }
  findNode(t) {
    return this.nodes.find((n) => n.value === t);
  }
  addEdge(t, n, r = 1) {
    const i = this.findNode(t), s = this.findNode(n);
    i && s && (i.toEdges.push(new fn(i, s, r)), this.isdirected && s.toEdges.push(new fn(s, i, r)));
  }
  // 邻接矩阵
  toMatrixArray() {
    const t = this.nodes.length, n = Array.from(
      { length: t },
      () => Array(t).fill(0)
    );
    return this.nodes.forEach((r, i) => {
      r.toEdges.forEach((s) => {
        const o = this.nodes.indexOf(s.toNode);
        n[i][o] = 1;
      });
    }), n;
  }
  // 邻接表
  toLinkedArrayObject() {
    const t = this.nodes.length, n = {};
    for (let r = 0; r < t; r++) {
      const i = [];
      this.nodes[r].toEdges.forEach((s) => {
        i.push(this.nodes.indexOf(s.toNode));
      }), n[String(this.nodes[r].value)] = i;
    }
    return n;
  }
  // 深度优先遍历
  dfs(t, n = /* @__PURE__ */ new Set()) {
    this.visitFn(t), n.add(t), t.toEdges.forEach((r) => {
      n.has(r.toNode) || this.dfs(r.toNode, n);
    });
  }
  // 广度优先遍历
  wfs(t) {
    const n = /* @__PURE__ */ new Set(), r = [t];
    for (; r.length; ) {
      const i = r.shift();
      this.visitFn(i), n.add(i), i.toEdges.forEach((s) => {
        n.has(s.toNode) || r.push(s.toNode);
      });
    }
  }
}
class Bn {
  heap = [];
  compareFn;
  constructor(t, n) {
    if (this.compareFn = t, n) {
      this.heap = n;
      const r = this.size() - 1, i = this.getParentIndex(r);
      for (let s = i; s >= 0; s--)
        this.shiftDown(s);
    }
  }
  size() {
    return this.heap.length;
  }
  isEmpty() {
    return this.size() === 0;
  }
  // 获取父元素坐标
  getParentIndex(t) {
    return t - 1 >> 1;
  }
  // 获取左子节点元素坐标
  getLeftChildIndex(t) {
    const n = t * 2 + 1;
    return n < this.size() ? n : null;
  }
  // 获取右子节点元素坐标
  getRightChildIndex(t) {
    const n = t * 2 + 2;
    return n < this.size() ? n : null;
  }
  // 交换元素
  swap(t, n) {
    t >= 0 && t < this.size() && n >= 0 && n < this.size() && ([this.heap[t], this.heap[n]] = [this.heap[n], this.heap[t]]);
  }
  // 查看堆顶元素
  peek() {
    return this.heap[0];
  }
  // 尾部插入元素
  // 时间复杂度O(logN)
  push(t) {
    this.heap.push(t), this.shiftUp(this.size() - 1);
  }
  // 上移操作
  shiftUp(t) {
    if (t === 0)
      return;
    const n = this.getParentIndex(t);
    this.compareFn(this.heap[n], this.heap[t]) || (this.swap(n, t), this.shiftUp(n));
  }
  // 堆顶删除元素
  // 时间复杂度O(logN)
  pop() {
    if (this.isEmpty())
      return null;
    {
      const t = this.heap[0], n = this.heap.pop();
      return n !== void 0 && !this.isEmpty() && (this.heap[0] = n, this.shiftDown(0)), t;
    }
  }
  // 下移操作
  shiftDown(t) {
    if (t >= this.size() - 1)
      return;
    const n = this.getLeftChildIndex(t), r = this.getRightChildIndex(t);
    n && !this.compareFn(this.heap[t], this.heap[n]) && (this.swap(n, t), this.shiftDown(n)), r && !this.compareFn(this.heap[t], this.heap[r]) && (this.swap(r, t), this.shiftDown(r));
  }
}
const lw = Bn;
class hw extends Bn {
  constructor(t, n) {
    const r = (i, s) => i > s;
    super(t ?? r, n);
  }
}
class fw extends Bn {
  constructor(t, n) {
    const r = (i, s) => i < s;
    super(t ?? r, n);
  }
}
class ui {
  value;
  next;
  constructor(t, n) {
    this.value = t, this.next = n;
  }
  clone() {
    return new ui(this.value, this.next);
  }
}
class dw {
  head;
  tail;
  length = 0;
  constructor() {
  }
  size() {
    return this.length;
  }
  isEmpty() {
    return this.size() === 0;
  }
  insert(t, n) {
    const r = new ui(n);
    if (t == 0)
      return r.next = this.head, this.head = r, this.isEmpty() && (this.tail = this.head), this.length++, !0;
    {
      let i = this.head, s = this.head?.next, o = 1;
      for (; o++ < t; )
        i = s, s = s?.next;
      return i ? (i.next = r, r.next = s, s || (this.tail = r), this.length++, !0) : !1;
    }
  }
  delete(t) {
    if (!this.isEmpty())
      if (t == 0) {
        const n = this.head;
        return this.size() == 1 ? this.head = this.tail = void 0 : this.head = this.head?.next, this.length--, n;
      } else {
        let n = this.head, r = this.head?.next, i = 1;
        for (; i++ < t && r; )
          n = r, r = r?.next;
        return n ? (n.next = r?.next, (!r || !r.next) && (this.tail = n), r && this.length--, r) : void 0;
      }
  }
  deleteNode(t) {
    t.next ? (t.value = t.next.value, t.next = t.next.next, t.next || (this.tail = t), this.length--) : this.pop();
  }
  // 尾部加入
  push(t) {
    return this.insert(this.size(), t);
  }
  // 尾部删除
  pop() {
    return this.delete(this.size() - 1);
  }
  // 头部加入
  unshift(t) {
    return this.insert(0, t);
  }
  // 头部删除
  shift() {
    return this.delete(0);
  }
  // 遍历
  // visitFn 返回 true 继续遍历， 返回 false 中断遍历
  traverse(t) {
    let n = this.head, r = 0;
    for (; n && t?.(n, r++); )
      n = n.next;
  }
  at(t) {
    if (t < 0 || t >= this.size() || this.isEmpty())
      return;
    if (t === 0)
      return this.head;
    if (t === this.size() - 1)
      return this.tail;
    let n = this.head;
    for (; --t >= 0 && n; )
      n = n.next;
    return n;
  }
  getIndex(t) {
    let n = -1;
    return this.traverse((r, i) => (r.value == t && (n = i), n == -1)), n;
  }
  toArray() {
    const t = [];
    return this.traverse((n) => (t.push(n.value), !0)), t;
  }
  // 列表反转
  // 时间复杂度 O(N)
  reverse() {
    this.tail = this.head;
    let t, n;
    for (; this.head && this.head.next; )
      t = n, n = this.head, this.head = this.head.next, n.next = t;
    return this.head && (this.head.next = n), this;
  }
  // 快慢指针: 判断链表中是否有环
  hasCycle(t = this.head) {
    if (!t || !t.next)
      return !1;
    let n = t, r = t.next;
    for (; n !== r; ) {
      if (!n || !r || !r.next)
        return !1;
      n = n.next, r = r.next.next;
    }
    return !0;
  }
}
const me = {
  THROW: 1,
  DROP: 2,
  SLIDE: 3,
  EXPAND: 4
};
class Bt {
  queue;
  limit;
  overflow;
  constructor(t = 10, n = me.EXPAND) {
    this.queue = [], this.limit = t, this.overflow = n;
  }
  length() {
    return this.queue.length;
  }
  isEmpty() {
    return this.length() === 0;
  }
  findIndex(t) {
    return this.queue.findIndex(t);
  }
  deleteIndex(t) {
    return !!this.queue.splice(t, 1).length;
  }
  delete(t) {
    const n = this.findIndex(t);
    return n > -1 ? this.deleteIndex(n) : !1;
  }
  // 入队
  enqueue(t) {
    if (this.length() < this.limit) {
      this.queue.push(t);
      return;
    }
    switch (this.overflow) {
      case me.EXPAND:
        this.limit *= 2, this.queue.push(t);
        break;
      case me.SLIDE:
        this.deleteIndex(0), this.queue.push(t);
        break;
      case me.THROW:
        throw new Error(`Queue limit(${this.limit}) overflow!`);
      case me.DROP:
    }
  }
  push(t) {
    this.enqueue(t);
  }
  put(t) {
    this.enqueue(t);
  }
  // 出队
  dequeue() {
    return this.queue.shift();
  }
  pop() {
    return this.dequeue();
  }
  take() {
    return this.dequeue();
  }
  // 获取队顶对象
  peek() {
    return this.queue[0];
  }
  // 获取对象
  index(t) {
    return this.queue[t];
  }
  // 全部出队
  clear() {
    this.queue = [];
  }
  // 全部出队
  flush() {
    const t = [];
    let n;
    for (; n = this.dequeue(); )
      t.push(n);
    return t;
  }
}
const pw = () => new Bt(0, me.DROP), mw = (e) => new Bt(e, me.THROW), Dw = (e) => new Bt(e, me.DROP), gw = (e) => new Bt(e, me.SLIDE), yw = (e) => new Bt(e, me.EXPAND), Wi = {
  SLIDE: 1,
  EXPAND: 2
};
class bw {
  size;
  table;
  objectSignature;
  overflow;
  ttl;
  constructor(t) {
    this.table = new Array(t?.size || 137), this.size = this.table.length, this.objectSignature = t?.objectSignature || ((n) => String(n)), this.overflow = t?.overflow || Wi.EXPAND, this.ttl = t?.ttl || 6e4;
  }
  // 散列函数，纯函数
  hash(t) {
    if (t == null || t == null)
      throw new Error("HashTable can't put undefined or null");
    const n = this.objectSignature(t), r = 31;
    let i = 0;
    for (let s = 0, o = n.length; s < o; s++)
      i += r * i + n.charCodeAt(s);
    return i % this.size;
  }
  // 扩展散列表大小至一个更大的质数
  resize() {
    const t = this.size, n = V0(this.size * 2), r = new Array(n), i = this.table;
    this.table = r, this.size = n;
    for (let s = 0, o = t; s < o; s++)
      if (i[s] !== void 0 && !this.isOutdated(i[s])) {
        let u = this.hash(i[s].value);
        for (; r[u] !== void 0; )
          u = (u + 1) % n;
        r[u] = i[s];
      }
    i.length = 0;
  }
  put(t) {
    this.size > 200 && Math.random() < 0.1 && this.clean();
    let n = this.hash(t);
    const r = n;
    for (; this.table[n] !== void 0 && !this.isOutdated(this.table[n]); )
      if (n = (n + 1) % this.size, r == n) {
        if (this.overflow == Wi.EXPAND)
          return this.resize(), this.put(t);
        break;
      }
    return this.table[n] = { value: t, timestamp: Date.now() }, n;
  }
  // 性能瓶颈
  // visitFn : return false to break loop
  traverse(t) {
    for (let n = 0, r = this.size; n < r; n++)
      if (this.table[n] !== void 0 && !t(this.table[n].value, n))
        return n;
    return -1;
  }
  // filter : return false 删除
  update(t) {
    this.traverse((n, r) => (t(n) === !1 && this.deleteIndex(r), !0));
  }
  getIndex(t) {
    let n = this.hash(t);
    const r = n;
    for (; this.table[n]?.value !== t; )
      if (this.table[n] === void 0 || (this.isOutdated(this.table[n]) && (this.table[n] = void 0), n = (n + 1) % this.size, r == n))
        return -1;
    return this.isOutdated(this.table[n]) ? (this.table[n] = void 0, -1) : n;
  }
  has(t) {
    return this.getIndex(t) >= 0;
  }
  // 性能瓶颈
  find(t) {
    const n = this.traverse((r) => !t(r));
    return n >= 0 ? this.table[n]?.value : void 0;
  }
  deleteIndex(t) {
    return t >= 0 && t < this.size && this.table[t] !== void 0 ? (this.table[t] = void 0, !0) : !1;
  }
  delete(t) {
    return this.deleteIndex(this.getIndex(t));
  }
  clear() {
    this.table = [];
  }
  // 数据是否过期
  isOutdated(t) {
    return Date.now() - t.timestamp > this.ttl;
  }
  // 性能瓶颈
  // 供外部使用：主动清理过期数据
  clean() {
    for (let t = 0, n = this.size; t < n; t++)
      this.table[t] !== void 0 && this.isOutdated(this.table[t]) && (this.table[t] = void 0);
  }
}
class ww {
  obj = {};
  constructor() {
  }
  put(t, n) {
    this.obj[t] = this.obj[t] || [], this.obj[t].push(n);
  }
  get(t) {
    return this.obj[t] || [];
  }
  has(t) {
    let n = !1;
    return this.traverse((r) => r == t ? (n = !0, !1) : !0), n;
  }
  keys() {
    const t = [];
    for (const n in this.obj)
      t.push(n);
    return t;
  }
  // visitFn : return false to break loop
  traverse(t) {
    for (const n in this.obj)
      for (let r = 0, i = this.obj[n].length; r < i && t(this.obj[n][r]); r++)
        ;
  }
}
class Fw {
  constructor(t) {
    this.capacity = t, this.buffer = new Array(t);
  }
  buffer;
  head = 0;
  size = 0;
  /**
   * Add an item to the buffer. If the buffer is full,
   * the oldest item will be evicted.
   */
  add(t) {
    this.buffer[this.head] = t, this.head = (this.head + 1) % this.capacity, this.size < this.capacity && this.size++;
  }
  /**
   * Add multiple items to the buffer at once.
   */
  addAll(t) {
    for (const n of t)
      this.add(n);
  }
  /**
   * Get the most recent N items from the buffer.
   * Returns fewer items if the buffer contains less than N items.
   */
  getRecent(t) {
    const n = [], r = this.size < this.capacity ? 0 : this.head, i = Math.min(t, this.size);
    for (let s = 0; s < i; s++) {
      const o = (r + this.size - i + s) % this.capacity;
      n.push(this.buffer[o]);
    }
    return n;
  }
  /**
   * Get all items currently in the buffer, in order from oldest to newest.
   */
  toArray() {
    if (this.size === 0)
      return [];
    const t = [], n = this.size < this.capacity ? 0 : this.head;
    for (let r = 0; r < this.size; r++) {
      const i = (n + r) % this.capacity;
      t.push(this.buffer[i]);
    }
    return t;
  }
  /**
   * Clear all items from the buffer.
   */
  clear() {
    this.buffer.length = 0, this.head = 0, this.size = 0;
  }
  /**
   * Get the current number of items in the buffer.
   */
  length() {
    return this.size;
  }
}
function Sl(e) {
  return typeof e.set == "function";
}
function Al(e) {
  return typeof e.add == "function";
}
function Ew(e) {
  if (e && typeof e == "object") {
    if (Sl(e))
      return "map";
    if (Al(e))
      return "set";
  }
  return "unknown";
}
class vw {
  __data__ = {};
  size = 0;
  constructor(t) {
    t = t || [];
    const n = t.length;
    let r = -1;
    for (; ++r < n; ) {
      const i = t[r];
      this.set(i[0], i[1]);
    }
  }
  set(t, n) {
    const r = this.__data__;
    return this.size += this.has(t) ? 0 : 1, r[t] = n, this;
  }
  get(t) {
    const n = this.__data__;
    return this.has(t) ? n[t] : void 0;
  }
  has(t) {
    const n = this.__data__;
    return Object.prototype.hasOwnProperty.call(n, t);
  }
  delete(t) {
    const n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  clear() {
    this.__data__ = {}, this.size = 0;
  }
  *entries() {
    for (const t in this.__data__)
      yield [t, this.__data__[t]];
  }
  *keys() {
    for (const t in this.__data__)
      yield t;
  }
  *values() {
    for (const t in this.__data__)
      yield this.__data__[t];
  }
  [Symbol.iterator]() {
    return this.entries();
  }
}
class Ol {
  __data__ = [];
  size = 0;
  constructor(t) {
    t = t || [];
    const n = t.length;
    let r = -1;
    for (; ++r < n; ) {
      const i = t[r];
      this.set(i[0], i[1]);
    }
  }
  set(t, n) {
    const r = this.__data__, i = Ut(r, t);
    return i < 0 ? (++this.size, r.push([t, n])) : r[i][1] = n, this;
  }
  get(t) {
    const n = this.__data__, r = Ut(n, t);
    return r < 0 ? void 0 : n[r][1];
  }
  has(t) {
    return Ut(this.__data__, t) > -1;
  }
  delete(t) {
    const n = this.__data__, r = Ut(n, t);
    if (r < 0)
      return !1;
    const i = n.length - 1;
    return r == i ? n.pop() : Array.prototype.splice.call(n, r, 1), --this.size, !0;
  }
  clear() {
    this.__data__ = [], this.size = 0;
  }
  *entries() {
    for (const t of this.__data__)
      yield t;
  }
  *keys() {
    for (const t of this.__data__)
      yield t[0];
  }
  *values() {
    for (const t of this.__data__)
      yield t[1];
  }
  [Symbol.iterator]() {
    return this.entries();
  }
}
const Cl = typeof performance == "object" && performance && typeof performance.now == "function" ? performance : Date, Bo = /* @__PURE__ */ new Set(), Tl = (e, t, n, r) => {
  typeof cn.emitWarning == "function" ? cn.emitWarning(e, t, n, r) : console.error(`[${n}] ${t}: ${e}`);
}, Rl = (e) => !Bo.has(e);
class Xe {
  heap;
  length;
  // private constructor
  static #e = !1;
  static create(t) {
    const n = No(t);
    if (!n)
      return [];
    Xe.#e = !0;
    const r = new Xe(t, n);
    return Xe.#e = !1, r;
  }
  constructor(t, n) {
    if (!Xe.#e)
      throw new TypeError("instantiate Stack using Stack.create(n)");
    this.heap = new n(t), this.length = 0;
  }
  push(t) {
    this.heap[this.length++] = t;
  }
  pop() {
    return this.heap[--this.length];
  }
}
class ai {
  // options that cannot be changed without disaster
  /**
   * An integer greater than 0, reflecting a number of items
   */
  #e;
  /**
   * An integer greater than 0, reflecting the calculated size of items
   */
  #t;
  #n;
  #i;
  #s;
  #o;
  #g;
  #c;
  /**
   * {@link LRUCache.OptionsBase.perf}
   */
  get perf() {
    return this.#c;
  }
  /**
   * {@link LRUCache.OptionsBase.ttl}
   */
  ttl;
  /**
   * {@link LRUCache.OptionsBase.ttlResolution}
   */
  ttlResolution;
  /**
   * {@link LRUCache.OptionsBase.ttlAutopurge}
   */
  ttlAutopurge;
  /**
   * {@link LRUCache.OptionsBase.updateAgeOnGet}
   */
  updateAgeOnGet;
  /**
   * {@link LRUCache.OptionsBase.updateAgeOnHas}
   */
  updateAgeOnHas;
  /**
   * {@link LRUCache.OptionsBase.allowStale}
   */
  allowStale;
  /**
   * {@link LRUCache.OptionsBase.noDisposeOnSet}
   */
  noDisposeOnSet;
  /**
   * {@link LRUCache.OptionsBase.noUpdateTTL}
   */
  noUpdateTTL;
  /**
   * {@link LRUCache.OptionsBase.maxEntrySize}
   */
  maxEntrySize;
  /**
   * {@link LRUCache.OptionsBase.sizeCalculation}
   */
  sizeCalculation;
  /**
   * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
   */
  noDeleteOnFetchRejection;
  /**
   * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
   */
  noDeleteOnStaleGet;
  /**
   * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
   */
  allowStaleOnFetchAbort;
  /**
   * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
   */
  allowStaleOnFetchRejection;
  /**
   * {@link LRUCache.OptionsBase.ignoreFetchAbort}
   */
  ignoreFetchAbort;
  // computed properties
  #l;
  #h;
  #f;
  #u;
  #r;
  #d;
  #y;
  #p;
  #m;
  #E;
  #D;
  #v;
  #_;
  #b;
  #w;
  #S;
  #x;
  #F;
  #B;
  /**
   * Do not call this method unless you need to inspect the
   * inner workings of the cache.  If anything returned by this
   * object is modified in any way, strange breakage may occur.
   *
   * These fields are private for a reason!
   *
   * @internal
   */
  static unsafeExposeInternals(t) {
    return {
      // properties
      starts: t.#_,
      ttls: t.#b,
      autopurgeTimers: t.#w,
      sizes: t.#v,
      keyMap: t.#f,
      keyList: t.#u,
      valList: t.#r,
      next: t.#d,
      prev: t.#y,
      get head() {
        return t.#p;
      },
      get tail() {
        return t.#m;
      },
      free: t.#E,
      // methods
      isBackgroundFetch: (n) => t.#a(n),
      backgroundFetch: (n, r, i, s) => t.#M(
        n,
        r,
        i,
        s
      ),
      moveToTail: (n) => t.#z(n),
      indexes: (n) => t.#O(n),
      rindexes: (n) => t.#C(n),
      isStale: (n) => t.#A(n)
    };
  }
  // Protected read-only members
  /**
   * {@link LRUCache.OptionsBase.max} (read-only)
   */
  get max() {
    return this.#e;
  }
  /**
   * {@link LRUCache.OptionsBase.maxSize} (read-only)
   */
  get maxSize() {
    return this.#t;
  }
  /**
   * The total computed size of items in the cache (read-only)
   */
  get calculatedSize() {
    return this.#h;
  }
  /**
   * The number of items stored in the cache (read-only)
   */
  get size() {
    return this.#l;
  }
  /**
   * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
   */
  get fetchMethod() {
    return this.#o;
  }
  get memoMethod() {
    return this.#g;
  }
  /**
   * {@link LRUCache.OptionsBase.dispose} (read-only)
   */
  get dispose() {
    return this.#n;
  }
  /**
   * {@link LRUCache.OptionsBase.onInsert} (read-only)
   */
  get onInsert() {
    return this.#i;
  }
  /**
   * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
   */
  get disposeAfter() {
    return this.#s;
  }
  constructor(t) {
    const {
      max: n = 0,
      ttl: r,
      ttlResolution: i = 1,
      ttlAutopurge: s,
      updateAgeOnGet: o,
      updateAgeOnHas: u,
      allowStale: a,
      dispose: c,
      onInsert: l,
      disposeAfter: f,
      noDisposeOnSet: d,
      noUpdateTTL: h,
      maxSize: p = 0,
      maxEntrySize: m = 0,
      sizeCalculation: D,
      fetchMethod: y,
      memoMethod: F,
      noDeleteOnFetchRejection: S,
      noDeleteOnStaleGet: v,
      allowStaleOnFetchRejection: E,
      allowStaleOnFetchAbort: R,
      ignoreFetchAbort: A,
      perf: k
    } = t;
    if (k !== void 0 && typeof k?.now != "function")
      throw new TypeError(
        "perf option must have a now() method if specified"
      );
    if (this.#c = k ?? Cl, n !== 0 && !we(n))
      throw new TypeError("max option must be a nonnegative integer");
    const w = n ? No(n) : Array;
    if (!w)
      throw new Error("invalid max value: " + n);
    if (this.#e = n, this.#t = p, this.maxEntrySize = m || this.#t, this.sizeCalculation = D, this.sizeCalculation) {
      if (!this.#t && !this.maxEntrySize)
        throw new TypeError(
          "cannot set sizeCalculation without setting maxSize or maxEntrySize"
        );
      if (typeof this.sizeCalculation != "function")
        throw new TypeError("sizeCalculation set to non-function");
    }
    if (F !== void 0 && typeof F != "function")
      throw new TypeError("memoMethod must be a function if defined");
    if (this.#g = F, y !== void 0 && typeof y != "function")
      throw new TypeError("fetchMethod must be a function if specified");
    if (this.#o = y, this.#x = !!y, this.#f = /* @__PURE__ */ new Map(), this.#u = Array.from({ length: n }).fill(void 0), this.#r = Array.from({ length: n }).fill(void 0), this.#d = new w(n), this.#y = new w(n), this.#p = 0, this.#m = 0, this.#E = Xe.create(n), this.#l = 0, this.#h = 0, typeof c == "function" && (this.#n = c), typeof l == "function" && (this.#i = l), typeof f == "function" ? (this.#s = f, this.#D = []) : (this.#s = void 0, this.#D = void 0), this.#S = !!this.#n, this.#B = !!this.#i, this.#F = !!this.#s, this.noDisposeOnSet = !!d, this.noUpdateTTL = !!h, this.noDeleteOnFetchRejection = !!S, this.allowStaleOnFetchRejection = !!E, this.allowStaleOnFetchAbort = !!R, this.ignoreFetchAbort = !!A, this.maxEntrySize !== 0) {
      if (this.#t !== 0 && !we(this.#t))
        throw new TypeError(
          "maxSize must be a positive integer if specified"
        );
      if (!we(this.maxEntrySize))
        throw new TypeError(
          "maxEntrySize must be a positive integer if specified"
        );
      this.#K();
    }
    if (this.allowStale = !!a, this.noDeleteOnStaleGet = !!v, this.updateAgeOnGet = !!o, this.updateAgeOnHas = !!u, this.ttlResolution = we(i) || i === 0 ? i : 1, this.ttlAutopurge = !!s, this.ttl = r || 0, this.ttl) {
      if (!we(this.ttl))
        throw new TypeError("ttl must be a positive integer if specified");
      this.#j();
    }
    if (this.#e === 0 && this.ttl === 0 && this.#t === 0)
      throw new TypeError("At least one of max, maxSize, or ttl is required");
    if (!this.ttlAutopurge && !this.#e && !this.#t) {
      const T = "LRU_CACHE_UNBOUNDED";
      Rl(T) && (Bo.add(T), Tl("TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.", "UnboundedCacheWarning", T, ai));
    }
  }
  /**
   * Return the number of ms left in the item's TTL. If item is not in cache,
   * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
   */
  getRemainingTTL(t) {
    return this.#f.has(t) ? 1 / 0 : 0;
  }
  #j() {
    const t = new Yt(this.#e), n = new Yt(this.#e);
    this.#b = t, this.#_ = n;
    const r = this.ttlAutopurge ? Array.from({
      length: this.#e
    }) : void 0;
    this.#w = r, this.#U = (u, a, c = this.#c.now()) => {
      n[u] = a !== 0 ? c : 0, t[u] = a, i(u, a);
    }, this.#N = (u) => {
      n[u] = t[u] !== 0 ? this.#c.now() : 0, i(u, t[u]);
    };
    const i = this.ttlAutopurge ? (u, a) => {
      if (r?.[u] && (clearTimeout(r[u]), r[u] = void 0), a && a !== 0 && r) {
        const c = setTimeout(() => {
          this.#A(u) && this.#T(this.#u[u], "expire");
        }, a + 1);
        c.unref && c.unref(), r[u] = c;
      }
    } : () => {
    };
    this.#R = (u, a) => {
      if (t[a]) {
        const c = t[a], l = n[a];
        if (!c || !l)
          return;
        u.ttl = c, u.start = l, u.now = s || o();
        const f = u.now - l;
        u.remainingTTL = c - f;
      }
    };
    let s = 0;
    const o = () => {
      const u = this.#c.now();
      if (this.ttlResolution > 0) {
        s = u;
        const a = setTimeout(() => s = 0, this.ttlResolution);
        a.unref && a.unref();
      }
      return u;
    };
    this.getRemainingTTL = (u) => {
      const a = this.#f.get(u);
      if (a === void 0)
        return 0;
      const c = t[a], l = n[a];
      if (!c || !l)
        return 1 / 0;
      const f = (s || o()) - l;
      return c - f;
    }, this.#A = (u) => {
      const a = n[u], c = t[u];
      return !!c && !!a && (s || o()) - a > c;
    };
  }
  // conditionally set private methods related to TTL
  #N = () => {
  };
  #R = () => {
  };
  #U = () => {
  };
  #A = () => !1;
  #K() {
    const t = new Yt(this.#e);
    this.#h = 0, this.#v = t, this.#I = (n) => {
      this.#h -= t[n], t[n] = 0;
    }, this.#Z = (n, r, i, s) => {
      if (this.#a(r))
        return 0;
      if (!we(i))
        if (s) {
          if (typeof s != "function")
            throw new TypeError("sizeCalculation must be a function");
          if (i = s(r, n), !we(i))
            throw new TypeError(
              "sizeCalculation return invalid (expect positive integer)"
            );
        } else
          throw new TypeError(
            "invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set."
          );
      return i || 0;
    }, this.#$ = (n, r, i) => {
      if (t[n] = r, this.#t) {
        const s = this.#t - t[n];
        for (; this.#h > s; )
          this.#L(!0);
      }
      this.#h += t[n], i && (i.entrySize = r, i.totalCalculatedSize = this.#h);
    };
  }
  #I = (t) => {
  };
  #$ = (t, n, r) => {
  };
  #Z = (t, n, r, i) => {
    if (r || i)
      throw new TypeError(
        "cannot set size without setting maxSize or maxEntrySize on cache"
      );
    return 0;
  };
  *#O({ allowStale: t = this.allowStale } = {}) {
    if (this.#l)
      for (let n = this.#m; this.#q(n) && ((t || !this.#A(n)) && (yield n), n !== this.#p); )
        n = this.#y[n];
  }
  *#C({ allowStale: t = this.allowStale } = {}) {
    if (this.#l)
      for (let n = this.#p; this.#q(n) && ((t || !this.#A(n)) && (yield n), n !== this.#m); )
        n = this.#d[n];
  }
  #q(t) {
    return t !== void 0 && this.#f.get(this.#u[t]) === t;
  }
  /**
   * Return a generator yielding `[key, value]` pairs,
   * in order from most recently used to least recently used.
   */
  *entries() {
    for (const t of this.#O())
      this.#r[t] !== void 0 && this.#u[t] !== void 0 && !this.#a(this.#r[t]) && (yield [this.#u[t], this.#r[t]]);
  }
  /**
   * Inverse order version of {@link LRUCache.entries}
   *
   * Return a generator yielding `[key, value]` pairs,
   * in order from least recently used to most recently used.
   */
  *rentries() {
    for (const t of this.#C())
      this.#r[t] !== void 0 && this.#u[t] !== void 0 && !this.#a(this.#r[t]) && (yield [this.#u[t], this.#r[t]]);
  }
  /**
   * Return a generator yielding the keys in the cache,
   * in order from most recently used to least recently used.
   */
  *keys() {
    for (const t of this.#O()) {
      const n = this.#u[t];
      n !== void 0 && !this.#a(this.#r[t]) && (yield n);
    }
  }
  /**
   * Inverse order version of {@link LRUCache.keys}
   *
   * Return a generator yielding the keys in the cache,
   * in order from least recently used to most recently used.
   */
  *rkeys() {
    for (const t of this.#C()) {
      const n = this.#u[t];
      n !== void 0 && !this.#a(this.#r[t]) && (yield n);
    }
  }
  /**
   * Return a generator yielding the values in the cache,
   * in order from most recently used to least recently used.
   */
  *values() {
    for (const t of this.#O())
      this.#r[t] !== void 0 && !this.#a(this.#r[t]) && (yield this.#r[t]);
  }
  /**
   * Inverse order version of {@link LRUCache.values}
   *
   * Return a generator yielding the values in the cache,
   * in order from least recently used to most recently used.
   */
  *rvalues() {
    for (const t of this.#C())
      this.#r[t] !== void 0 && !this.#a(this.#r[t]) && (yield this.#r[t]);
  }
  /**
   * Iterating over the cache itself yields the same results as
   * {@link LRUCache.entries}
   */
  [Symbol.iterator]() {
    return this.entries();
  }
  /**
   * A String value that is used in the creation of the default string
   * description of an object. Called by the built-in method
   * `Object.prototype.toString`.
   */
  [Symbol.toStringTag] = "LRUCache";
  /**
   * Find a value for which the supplied fn method returns a truthy value,
   * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
   */
  find(t, n = {}) {
    for (const r of this.#O()) {
      const i = this.#r[r], s = this.#a(i) ? i.__staleWhileFetching : i;
      if (s !== void 0 && t(s, this.#u[r], this))
        return this.#P(this.#u[r], n);
    }
  }
  /**
   * Call the supplied function on each item in the cache, in order from most
   * recently used to least recently used.
   *
   * `fn` is called as `fn(value, key, cache)`.
   *
   * If `thisp` is provided, function will be called in the `this`-context of
   * the provided object, or the cache if no `thisp` object is provided.
   *
   * Does not update age or recenty of use, or iterate over stale values.
   */
  forEach(t, n = this) {
    for (const r of this.#O()) {
      const i = this.#r[r], s = this.#a(i) ? i.__staleWhileFetching : i;
      s !== void 0 && t.call(n, s, this.#u[r], this);
    }
  }
  /**
   * The same as {@link LRUCache.forEach} but items are iterated over in
   * reverse order.  (ie, less recently used items are iterated over first.)
   */
  rforEach(t, n = this) {
    for (const r of this.#C()) {
      const i = this.#r[r], s = this.#a(i) ? i.__staleWhileFetching : i;
      s !== void 0 && t.call(n, s, this.#u[r], this);
    }
  }
  /**
   * Delete any stale entries. Returns true if anything was removed,
   * false otherwise.
   */
  purgeStale() {
    let t = !1;
    for (const n of this.#C({ allowStale: !0 }))
      this.#A(n) && (this.#T(this.#u[n], "expire"), t = !0);
    return t;
  }
  /**
   * Get the extended info about a given entry, to get its value, size, and
   * TTL info simultaneously. Returns `undefined` if the key is not present.
   *
   * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
   * serialization, the `start` value is always the current timestamp, and the
   * `ttl` is a calculated remaining time to live (negative if expired).
   *
   * Always returns stale values, if their info is found in the cache, so be
   * sure to check for expirations (ie, a negative {@link Entry#ttl})
   * if relevant.
   */
  info(t) {
    const n = this.#f.get(t);
    if (n === void 0)
      return;
    const r = this.#r[n], i = this.#a(r) ? r.__staleWhileFetching : r;
    if (i === void 0)
      return;
    const s = { value: i };
    if (this.#b && this.#_) {
      const o = this.#b[n], u = this.#_[n];
      if (o && u) {
        const a = o - (this.#c.now() - u);
        s.ttl = a, s.start = Date.now();
      }
    }
    return this.#v && (s.size = this.#v[n]), s;
  }
  /**
   * Return an array of [key, {@link Entry}] tuples which can be
   * passed to {@link LRUCache#load}.
   *
   * The `start` fields are calculated relative to a portable `Date.now()`
   * timestamp, even if `performance.now()` is available.
   *
   * Stale entries are always included in the `dump`, even if
   * {@link LRUCache.OptionsBase.allowStale} is false.
   *
   * Note: this returns an actual array, not a generator, so it can be more
   * easily passed around.
   */
  dump() {
    const t = [];
    for (const n of this.#O({ allowStale: !0 })) {
      const r = this.#u[n], i = this.#r[n], s = this.#a(i) ? i.__staleWhileFetching : i;
      if (s === void 0 || r === void 0)
        continue;
      const o = { value: s };
      if (this.#b && this.#_) {
        o.ttl = this.#b[n];
        const u = this.#c.now() - this.#_[n];
        o.start = Math.floor(Date.now() - u);
      }
      this.#v && (o.size = this.#v[n]), t.unshift([r, o]);
    }
    return t;
  }
  /**
   * Reset the cache and load in the items in entries in the order listed.
   *
   * The shape of the resulting cache may be different if the same options are
   * not used in both caches.
   *
   * The `start` fields are assumed to be calculated relative to a portable
   * `Date.now()` timestamp, even if `performance.now()` is available.
   */
  load(t) {
    this.clear();
    for (const [n, r] of t) {
      if (r.start) {
        const i = Date.now() - r.start;
        r.start = this.#c.now() - i;
      }
      this.#k(n, r.value, r);
    }
  }
  /**
   * Add a value to the cache.
   *
   * Note: if `undefined` is specified as a value, this is an alias for
   * {@link LRUCache#delete}
   *
   * Fields on the {@link SetOptions} options param will override
   * their corresponding values in the constructor options for the scope
   * of this single `set()` operation.
   *
   * If `start` is provided, then that will set the effective start
   * time for the TTL calculation. Note that this must be a previous
   * value of `performance.now()` if supported, or a previous value of
   * `Date.now()` if not.
   *
   * Options object may also include `size`, which will prevent
   * calling the `sizeCalculation` function and just use the specified
   * number if it is a positive integer, and `noDisposeOnSet` which
   * will prevent calling a `dispose` function in the case of
   * overwrites.
   *
   * If the `size` (or return value of `sizeCalculation`) for a given
   * entry is greater than `maxEntrySize`, then the item will not be
   * added to the cache.
   *
   * Will update the recency of the entry.
   *
   * If the value is `undefined`, then this is an alias for
   * `cache.delete(key)`. `undefined` is never stored in the cache.
   */
  set(t, n, r = {}) {
    const { status: i = void 0 } = r;
    return r.status = i, i && (i.op = "set", i.key = t, n !== void 0 && (i.value = n)), this.#k(t, n, r);
  }
  #k(t, n, r = {}) {
    const {
      ttl: i = this.ttl,
      start: s,
      noDisposeOnSet: o = this.noDisposeOnSet,
      sizeCalculation: u = this.sizeCalculation,
      status: a
    } = r;
    if (n === void 0)
      return a && (a.set = "deleted"), this.delete(t), this;
    let { noUpdateTTL: c = this.noUpdateTTL } = r;
    a && !this.#a(n) && (a.value = n);
    const l = this.#Z(
      t,
      n,
      r.size || 0,
      u,
      a
    );
    if (this.maxEntrySize && l > this.maxEntrySize)
      return this.#T(t, "set"), a && (a.set = "miss", a.maxEntrySizeExceeded = !0), this;
    let f = this.#l === 0 ? void 0 : this.#f.get(t);
    if (f === void 0)
      f = this.#l === 0 ? this.#m : this.#E.length !== 0 ? this.#E.pop() : this.#l === this.#e ? this.#L(!1) : this.#l, this.#u[f] = t, this.#r[f] = n, this.#f.set(t, f), this.#d[this.#m] = f, this.#y[f] = this.#m, this.#m = f, this.#l++, this.#$(f, l, a), a && (a.set = "add"), c = !1, this.#B && this.#i?.(n, t, "add");
    else {
      this.#z(f);
      const d = this.#r[f];
      if (n !== d) {
        if (this.#x && this.#a(d)) {
          d.__abortController.abort(new Error("replaced"));
          const { __staleWhileFetching: h } = d;
          h !== void 0 && !o && (this.#S && this.#n?.(h, t, "set"), this.#F && this.#D?.push([h, t, "set"]));
        } else
          o || (this.#S && this.#n?.(d, t, "set"), this.#F && this.#D?.push([d, t, "set"]));
        if (this.#I(f), this.#$(f, l, a), this.#r[f] = n, a) {
          a.set = "replace";
          const h = d && this.#a(d) ? d.__staleWhileFetching : d;
          h !== void 0 && (a.oldValue = h);
        }
      } else
        a && (a.set = "update");
      this.#B && this.onInsert?.(n, t, n === d ? "update" : "replace");
    }
    if (i !== 0 && !this.#b && this.#j(), this.#b && (c || this.#U(f, i, s), a && this.#R(a, f)), !o && this.#F && this.#D) {
      const d = this.#D;
      let h;
      for (; h = d?.shift(); )
        this.#s?.(...h);
    }
    return this;
  }
  /**
   * Evict the least recently used item, returning its value or
   * `undefined` if cache is empty.
   */
  pop() {
    try {
      for (; this.#l; ) {
        const t = this.#r[this.#p];
        if (this.#L(!0), this.#a(t)) {
          if (t.__staleWhileFetching)
            return t.__staleWhileFetching;
        } else if (t !== void 0)
          return t;
      }
    } finally {
      if (this.#F && this.#D) {
        const t = this.#D;
        let n;
        for (; n = t?.shift(); )
          this.#s?.(...n);
      }
    }
  }
  #L(t) {
    const n = this.#p, r = this.#u[n], i = this.#r[n];
    return this.#x && this.#a(i) ? i.__abortController.abort(new Error("evicted")) : (this.#S || this.#F) && (this.#S && this.#n?.(i, r, "evict"), this.#F && this.#D?.push([i, r, "evict"])), this.#I(n), this.#w?.[n] && (clearTimeout(this.#w[n]), this.#w[n] = void 0), t && (this.#u[n] = void 0, this.#r[n] = void 0, this.#E.push(n)), this.#l === 1 ? (this.#p = this.#m = 0, this.#E.length = 0) : this.#p = this.#d[n], this.#f.delete(r), this.#l--, n;
  }
  /**
   * Check if a key is in the cache, without updating the recency of use.
   * Will return false if the item is stale, even though it is technically
   * in the cache.
   *
   * Check if a key is in the cache, without updating the recency of
   * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
   * to `true` in either the options or the constructor.
   *
   * Will return `false` if the item is stale, even though it is technically in
   * the cache. The difference can be determined (if it matters) by using a
   * `status` argument, and inspecting the `has` field.
   *
   * Will not update item age unless
   * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
   */
  has(t, n = {}) {
    const { status: r = void 0 } = n;
    return n.status = r, r && (r.op = "has", r.key = t), this.#Q(t, n);
  }
  #Q(t, n = {}) {
    const { updateAgeOnHas: r = this.updateAgeOnHas, status: i } = n, s = this.#f.get(t);
    if (s !== void 0) {
      const o = this.#r[s];
      if (this.#a(o) && o.__staleWhileFetching === void 0)
        return !1;
      if (this.#A(s))
        i && (i.has = "stale", this.#R(i, s));
      else
        return r && this.#N(s), i && (i.has = "hit", this.#R(i, s)), !0;
    } else
      i && (i.has = "miss");
    return !1;
  }
  /**
   * Like {@link LRUCache#get} but doesn't update recency or delete stale
   * items.
   *
   * Returns `undefined` if the item is stale, unless
   * {@link LRUCache.OptionsBase.allowStale} is set.
   */
  peek(t, n = {}) {
    const { status: r = void 0 } = n;
    return r && (r.op = "peek", r.key = t), n.status = r, this.#J(t, n);
  }
  #J(t, n) {
    const { status: r, allowStale: i = this.allowStale } = n, s = this.#f.get(t);
    if (s === void 0 || !i && this.#A(s)) {
      r && (r.peek = s === void 0 ? "miss" : "stale");
      return;
    }
    const o = this.#r[s], u = this.#a(o) ? o.__staleWhileFetching : o;
    return r && (u !== void 0 ? (r.peek = "hit", r.value = u) : r.peek = "miss"), u;
  }
  #M(t, n, r, i) {
    const s = n === void 0 ? void 0 : this.#r[n];
    if (this.#a(s))
      return s;
    const o = new AbortController(), { signal: u } = r;
    u?.addEventListener("abort", () => o.abort(u.reason), {
      signal: o.signal
    });
    const a = {
      signal: o.signal,
      options: r,
      context: i
    }, c = (m, D = !1) => {
      const { aborted: y } = o.signal, F = r.ignoreFetchAbort && m !== void 0, S = r.ignoreFetchAbort || !!(r.allowStaleOnFetchAbort && m !== void 0);
      if (r.status && (y && !D ? (r.status.fetchAborted = !0, r.status.fetchError = o.signal.reason, F && (r.status.fetchAbortIgnored = !0)) : r.status.fetchResolved = !0), y && !F && !D)
        return f(o.signal.reason, S);
      const v = h, E = this.#r[n];
      return (E === h || E === void 0 && F && D) && (m === void 0 ? v.__staleWhileFetching !== void 0 ? this.#r[n] = v.__staleWhileFetching : this.#T(t, "fetch") : (r.status && (r.status.fetchUpdated = !0), this.#k(t, m, a.options))), m;
    }, l = (m) => (r.status && (r.status.fetchRejected = !0, r.status.fetchError = m), f(m, !1)), f = (m, D) => {
      const { aborted: y } = o.signal, F = y && r.allowStaleOnFetchAbort, S = F || r.allowStaleOnFetchRejection, v = S || r.noDeleteOnFetchRejection, E = h;
      if (this.#r[n] === h && (!v || !D && E.__staleWhileFetching === void 0 ? this.#T(t, "fetch") : F || (this.#r[n] = E.__staleWhileFetching)), S)
        return r.status && E.__staleWhileFetching !== void 0 && (r.status.returnedStale = !0), E.__staleWhileFetching;
      if (E.__returned === E)
        throw m;
    }, d = (m, D) => {
      const y = this.#o?.(t, s, a);
      y && y instanceof Promise && y.then((F) => m(F === void 0 ? void 0 : F), D), o.signal.addEventListener("abort", () => {
        (!r.ignoreFetchAbort || r.allowStaleOnFetchAbort) && (m(void 0), r.allowStaleOnFetchAbort && (m = (F) => c(F, !0)));
      });
    };
    r.status && (r.status.fetchDispatched = !0);
    const h = new Promise(d).then(c, l), p = Object.assign(h, {
      __abortController: o,
      __staleWhileFetching: s,
      __returned: void 0
    });
    return n === void 0 ? (this.#k(t, p, { ...a.options, status: void 0 }), n = this.#f.get(t)) : this.#r[n] = p, p;
  }
  #a(t) {
    if (!this.#x)
      return !1;
    const n = t;
    return !!n && n instanceof Promise && Object.prototype.hasOwnProperty.call(n, "__staleWhileFetching") && n.__abortController instanceof AbortController;
  }
  fetch(t, n = {}) {
    const { status: r = void 0 } = n;
    return n.status = r, r && n.context && (r.context = n.context), this.#W(t, n);
  }
  async #W(t, n = {}) {
    const {
      // get options
      allowStale: r = this.allowStale,
      updateAgeOnGet: i = this.updateAgeOnGet,
      noDeleteOnStaleGet: s = this.noDeleteOnStaleGet,
      // set options
      ttl: o = this.ttl,
      noDisposeOnSet: u = this.noDisposeOnSet,
      size: a = 0,
      sizeCalculation: c = this.sizeCalculation,
      noUpdateTTL: l = this.noUpdateTTL,
      // fetch exclusive options
      noDeleteOnFetchRejection: f = this.noDeleteOnFetchRejection,
      allowStaleOnFetchRejection: d = this.allowStaleOnFetchRejection,
      ignoreFetchAbort: h = this.ignoreFetchAbort,
      allowStaleOnFetchAbort: p = this.allowStaleOnFetchAbort,
      context: m,
      forceRefresh: D = !1,
      status: y,
      signal: F
    } = n;
    if (y && (y.op = "fetch", y.key = t, D && (y.forceRefresh = !0)), !this.#x)
      return y && (y.fetch = "get"), this.#P(t, {
        allowStale: r,
        updateAgeOnGet: i,
        noDeleteOnStaleGet: s,
        status: y
      });
    const S = {
      allowStale: r,
      updateAgeOnGet: i,
      noDeleteOnStaleGet: s,
      ttl: o,
      noDisposeOnSet: u,
      size: a,
      sizeCalculation: c,
      noUpdateTTL: l,
      noDeleteOnFetchRejection: f,
      allowStaleOnFetchRejection: d,
      allowStaleOnFetchAbort: p,
      ignoreFetchAbort: h,
      status: y,
      signal: F
    }, v = this.#f.get(t);
    if (v === void 0) {
      y && (y.fetch = "miss");
      const E = this.#M(t, v, S, m);
      return E.__returned = E;
    } else {
      const E = this.#r[v];
      if (this.#a(E)) {
        const T = r && E.__staleWhileFetching !== void 0;
        return y && (y.fetch = "inflight", T && (y.returnedStale = !0)), T ? E.__staleWhileFetching : E.__returned = E;
      }
      const R = this.#A(v);
      if (!D && !R)
        return y && (y.fetch = "hit"), this.#z(v), i && this.#N(v), y && this.#R(y, v), E;
      const A = this.#M(t, v, S, m), w = A.__staleWhileFetching !== void 0 && r;
      return y && (y.fetch = R ? "stale" : "refresh", w && R && (y.returnedStale = !0)), w ? A.__staleWhileFetching : A.__returned = A;
    }
  }
  forceFetch(t, n = {}) {
    const { status: r = void 0 } = n;
    return n.status = r, r && n.context && (r.context = n.context), this.#H(t, n);
  }
  async #H(t, n = {}) {
    const r = await this.#W(
      t,
      n
    );
    if (r === void 0)
      throw new Error("fetch() returned undefined");
    return r;
  }
  memo(t, n = {}) {
    const { status: r = void 0 } = n;
    n.status = r, r && (r.op = "memo", r.key = t, n.context && (r.context = n.context));
    const i = this.#X(t, n);
    return r && (r.value = i), i;
  }
  #X(t, n = {}) {
    const r = this.#g;
    if (!r)
      throw new Error("no memoMethod provided to constructor");
    const { context: i, status: s, forceRefresh: o, ...u } = n;
    s && o && (s.forceRefresh = !0);
    const a = this.#P(t, u), c = o || a === void 0;
    if (s && (s.memo = c ? "miss" : "hit", c || (s.value = a)), !c)
      return a;
    const l = r(t, a, {
      options: u,
      context: i
    });
    return s && (s.value = l), this.#k(t, l, u), l;
  }
  /**
   * Return a value from the cache. Will update the recency of the cache
   * entry found.
   *
   * If the key is not found, get() will return `undefined`.
   */
  get(t, n = {}) {
    const { status: r = void 0 } = n;
    n.status = r, r && (r.op = "get", r.key = t);
    const i = this.#P(t, n);
    return r && i !== void 0 && (r.value = i), i;
  }
  #P(t, n = {}) {
    const {
      allowStale: r = this.allowStale,
      updateAgeOnGet: i = this.updateAgeOnGet,
      noDeleteOnStaleGet: s = this.noDeleteOnStaleGet,
      status: o
    } = n, u = this.#f.get(t);
    if (u === void 0) {
      o && (o.get = "miss");
      return;
    }
    const a = this.#r[u], c = this.#a(a);
    return o && this.#R(o, u), this.#A(u) ? c ? (o && (o.get = "stale-fetching"), r && a.__staleWhileFetching !== void 0 ? (o && (o.returnedStale = !0), a.__staleWhileFetching) : void 0) : (s || this.#T(t, "expire"), o && (o.get = "stale"), r ? (o && (o.returnedStale = !0), a) : void 0) : (o && (o.get = c ? "fetching" : "hit"), this.#z(u), i && this.#N(u), c ? a.__staleWhileFetching : a);
  }
  #G(t, n) {
    this.#y[n] = t, this.#d[t] = n;
  }
  #z(t) {
    t !== this.#m && (t === this.#p ? this.#p = this.#d[t] : this.#G(this.#y[t], this.#d[t]), this.#G(this.#m, t), this.#m = t);
  }
  /**
   * Deletes a key out of the cache.
   *
   * Returns true if the key was deleted, false otherwise.
   */
  delete(t) {
    return this.#T(t, "delete");
  }
  #T(t, n) {
    let r = !1;
    if (this.#l !== 0) {
      const i = this.#f.get(t);
      if (i !== void 0)
        if (this.#w?.[i] && (clearTimeout(this.#w?.[i]), this.#w[i] = void 0), r = !0, this.#l === 1)
          this.#V(n);
        else {
          this.#I(i);
          const s = this.#r[i];
          if (this.#a(s) ? s.__abortController.abort(new Error("deleted")) : (this.#S || this.#F) && (this.#S && this.#n?.(s, t, n), this.#F && this.#D?.push([s, t, n])), this.#f.delete(t), this.#u[i] = void 0, this.#r[i] = void 0, i === this.#m)
            this.#m = this.#y[i];
          else if (i === this.#p)
            this.#p = this.#d[i];
          else {
            const o = this.#y[i];
            this.#d[o] = this.#d[i];
            const u = this.#d[i];
            this.#y[u] = this.#y[i];
          }
          this.#l--, this.#E.push(i);
        }
    }
    if (this.#F && this.#D?.length) {
      const i = this.#D;
      let s;
      for (; s = i?.shift(); )
        this.#s?.(...s);
    }
    return r;
  }
  /**
   * Clear the cache entirely, throwing away all values.
   */
  clear() {
    return this.#V("delete");
  }
  #V(t) {
    for (const n of this.#C({ allowStale: !0 })) {
      const r = this.#r[n];
      if (this.#a(r))
        r.__abortController.abort(new Error("deleted"));
      else {
        const i = this.#u[n];
        this.#S && this.#n?.(r, i, t), this.#F && this.#D?.push([r, i, t]);
      }
    }
    if (this.#f.clear(), this.#r.fill(void 0), this.#u.fill(void 0), this.#b && this.#_) {
      this.#b.fill(0), this.#_.fill(0);
      for (const n of this.#w ?? [])
        n !== void 0 && clearTimeout(n);
      this.#w?.fill(void 0);
    }
    if (this.#v && this.#v.fill(0), this.#p = 0, this.#m = 0, this.#E.length = 0, this.#h = 0, this.#l = 0, this.#F && this.#D) {
      const n = this.#D;
      let r;
      for (; r = n?.shift(); )
        this.#s?.(...r);
    }
  }
}
class ci {
  // 内部数据库 data = expirationMap
  data;
  // <key, expiration>
  expirationMap = /* @__PURE__ */ new Map();
  // 永不过期的（ttl=Infinity） keys[]
  immortalKeys = /* @__PURE__ */ new Set();
  // <expiration, keys[]> = 默认字典序 = 默认按 expiration 过期时间 排序
  // 未进入 expirations 的 key 无法删除
  expirations = /* @__PURE__ */ Object.create(null);
  ttl;
  max;
  // private calculatedSize = 0;
  // private maxSize: number;
  // private maxEntrySize: number;
  // private sizeCalculation: SizeCalculator<K, V> | undefined;
  updateAgeOnGet;
  checkAgeOnGet;
  updateAgeOnHas;
  checkAgeOnHas;
  noUpdateTTL;
  dispose;
  noDisposeOnSet;
  timer;
  timerExpiration;
  constructor({
    ttl: t = 1 / 0,
    max: n = 1 / 0,
    // maxSize,
    // maxEntrySize,
    // sizeCalculation,
    updateAgeOnGet: r = !1,
    checkAgeOnGet: i = !1,
    updateAgeOnHas: s = !1,
    checkAgeOnHas: o = !1,
    noUpdateTTL: u = !1,
    dispose: a,
    noDisposeOnSet: c = !1
  } = {}, l = /* @__PURE__ */ new Map()) {
    if (t !== void 0 && !tr(t))
      throw new TypeError("ttl must be positive integer or Infinity if set");
    if (!tr(n))
      throw new TypeError("max must be positive integer or Infinity");
    if (this.data = l, this.ttl = t, this.max = n, this.updateAgeOnGet = !!r, this.checkAgeOnGet = !!i, this.updateAgeOnHas = !!s, this.checkAgeOnHas = !!o, this.noUpdateTTL = !!u, this.noDisposeOnSet = !!c, a !== void 0) {
      if (typeof a != "function")
        throw new TypeError("dispose must be function if set");
      this.dispose = a;
    } else
      this.dispose = (f, d, h) => {
      };
    this.timer = void 0, this.timerExpiration = void 0;
  }
  get size() {
    return this.data.size;
  }
  // 设置下一个检查时间点
  // expiration = now() + ttl
  setTimer(t, n) {
    if (this.timerExpiration && this.timerExpiration < t)
      return;
    this.timer && clearTimeout(this.timer);
    const r = setTimeout(() => {
      this.timer = void 0, this.timerExpiration = void 0, this.purgeStale();
      for (const i in this.expirations) {
        const s = Number(i);
        this.setTimer(s, s - M());
        break;
      }
    }, Math.min(W0, Math.max(0, n)));
    r.unref && r.unref(), this.timerExpiration = t, this.timer = r;
  }
  // hang onto the timer so we can clearTimeout if all items
  // are deleted.  Deno doesn't have Timer.unref(), so it
  // hangs otherwise.
  cancelTimer() {
    this.timer && (clearTimeout(this.timer), this.timerExpiration = void 0, this.timer = void 0);
  }
  clear() {
    const t = this.dispose !== ci.prototype.dispose ? [...this] : [];
    this.data.clear(), this.expirationMap.clear(), this.cancelTimer(), this.expirations = /* @__PURE__ */ Object.create(null);
    for (const [n, r] of t)
      this.dispose(r, n, "delete");
  }
  setTTL(t, n = this.ttl) {
    const r = this.expirationMap.get(t);
    if (r !== void 0) {
      const i = this.expirations[r];
      !i || i.length <= 1 ? delete this.expirations[r] : this.expirations[r] = i.filter((s) => s !== t);
    }
    if (n && n !== 1 / 0) {
      this.immortalKeys.delete(t);
      const i = Math.floor(M() + n);
      this.expirationMap.set(t, i), this.expirations[i] || (this.expirations[i] = [], this.setTimer(i, n)), this.expirations[i].push(t);
    } else
      this.immortalKeys.add(t), this.expirationMap.set(t, 1 / 0);
  }
  set(t, n, {
    ttl: r = this.ttl,
    noUpdateTTL: i = this.noUpdateTTL,
    noDisposeOnSet: s = this.noDisposeOnSet
  } = {}) {
    if (!tr(r))
      throw new TypeError("ttl must be positive integer or Infinity");
    if (this.expirationMap.has(t)) {
      i || this.setTTL(t, r);
      const o = this.data.get(t), u = !s && this.data.has(t);
      o !== n && (this.data.set(t, n), u && this.dispose(o, t, "set"));
    } else
      this.setTTL(t, r), this.data.set(t, n);
    for (; this.size > this.max; )
      this.purgeToCapacity();
    return this;
  }
  has(t, {
    checkAgeOnHas: n = this.checkAgeOnHas,
    ttl: r = this.ttl,
    updateAgeOnHas: i = this.updateAgeOnHas
  } = {}) {
    return this.data.has(t) ? n && this.getRemainingTTL(t) === 0 ? (this.delete(t), !1) : (i && this.setTTL(t, r), !0) : !1;
  }
  getRemainingTTL(t) {
    const n = this.expirationMap.get(t);
    return n === 1 / 0 ? 1 / 0 : n !== void 0 ? Math.max(0, Math.ceil(n - M())) : 0;
  }
  get(t, {
    updateAgeOnGet: n = this.updateAgeOnGet,
    ttl: r = this.ttl,
    checkAgeOnGet: i = this.checkAgeOnGet
  } = {}) {
    const s = this.data.get(t);
    if (i && this.getRemainingTTL(t) === 0) {
      this.delete(t);
      return;
    }
    return n && this.setTTL(t, r), s;
  }
  delete(t) {
    const n = this.expirationMap.get(t);
    if (n !== void 0) {
      const r = this.data.get(t);
      this.data.delete(t), this.expirationMap.delete(t), this.immortalKeys.delete(t);
      const i = this.expirations[n];
      return i && (i.length <= 1 ? delete this.expirations[n] : this.expirations[n] = i.filter(
        (s) => s !== t
      )), this.dispose(r, t, "delete"), this.size === 0 && this.cancelTimer(), !0;
    }
    return !1;
  }
  // 清除超限数据 when cache is full
  purgeToCapacity() {
    if (!(this.size <= this.max))
      for (const t in this.expirations) {
        const n = this.expirations[t];
        if (this.size - n.length >= this.max) {
          delete this.expirations[t];
          const r = [];
          for (const i of n)
            r.push([i, this.data.get(i)]), this.data.delete(i), this.expirationMap.delete(i);
          for (const [i, s] of r)
            this.dispose(s, i, "evict");
        } else {
          const r = this.size - this.max, i = [];
          for (const s of n.splice(0, r))
            i.push([s, this.data.get(s)]), this.data.delete(s), this.expirationMap.delete(s);
          for (const [s, o] of i)
            this.dispose(o, s, "evict");
        }
      }
  }
  // 清除陈旧数据
  purgeStale() {
    const t = Math.ceil(M());
    for (const n in this.expirations) {
      if (n === "Infinity" || Number(n) > t)
        return;
      const r = [...this.expirations[n] || []], i = [];
      delete this.expirations[n];
      for (const s of r)
        i.push([s, this.data.get(s)]), this.data.delete(s), this.expirationMap.delete(s);
      for (const [s, o] of i)
        this.dispose(o, s, "expire");
    }
    this.size === 0 && this.cancelTimer();
  }
  *entries() {
    for (const t in this.expirations)
      for (const n of this.expirations[t])
        yield [n, this.data.get(n)];
    for (const t of this.immortalKeys)
      yield [t, this.data.get(t)];
  }
  *keys() {
    for (const t in this.expirations)
      for (const n of this.expirations[t])
        yield n;
    for (const t of this.immortalKeys)
      yield t;
  }
  *values() {
    for (const t in this.expirations)
      for (const n of this.expirations[t])
        yield this.data.get(n);
    for (const t of this.immortalKeys)
      yield this.data.get(t);
  }
  [Symbol.iterator]() {
    return this.entries();
  }
  firstKey() {
    return this.keys().next().value;
  }
}
const xl = "__yz_set_cache_undefined__";
class _w {
  __data__;
  get size() {
    return this.__data__.size;
  }
  constructor(t, n = new Ol()) {
    this.__data__ = n, t = t || [];
    const r = t.length;
    let i = -1;
    for (; ++i < r; )
      this.add(t[i]);
  }
  add(t) {
    return this.__data__.set(t, xl), this;
  }
  has(t) {
    return this.__data__.has(t);
  }
  delete(t) {
    return this.__data__.delete(t);
  }
  clear() {
    this.__data__.clear();
  }
  *values() {
    for (const t of this.__data__.keys())
      yield { value: t };
  }
  [Symbol.iterator]() {
    return this.values();
  }
}
class kl {
  cache;
  cacheKeyResolver;
  constructor(t) {
    if (typeof AbortController > "u")
      throw new Error("AbortController not supported!");
    this.cache = t?.createCache ? t.createCache() : /* @__PURE__ */ new Map(), this.cacheKeyResolver = t?.cacheKeyResolver || ((...n) => String(n[0]));
  }
  set(...t) {
    const n = this.cacheKeyResolver(...t), r = new AbortController();
    return this.cache.set(n, r), r;
  }
  get(...t) {
    const n = this.cacheKeyResolver(...t);
    return this.cache.get(n);
  }
  delete(...t) {
    const n = this.cacheKeyResolver(...t);
    return this.cache.delete(n);
  }
  clear() {
    this.cache.clear();
  }
  abort(...t) {
    this.get(...t)?.abort(), this.delete(...t);
  }
}
const Ie = {
  branch: "├",
  lastBranch: "└",
  line: "│",
  empty: " "
};
function nr(e, t = {}) {
  const {
    showValues: n = !0,
    hideFunctions: r = !1,
    lineBreak: i = `\r
`,
    maxDeep: s
  } = t, o = [], u = /* @__PURE__ */ new WeakSet();
  function a(l, f = "", d = 0) {
    if (typeof l == "string") {
      o.push(f + '"' + l + '"');
      return;
    }
    if (typeof l != "object" || l === null) {
      n && o.push(f + String(l));
      return;
    }
    if (s && d >= s) {
      Array.isArray(e) ? o.push("[...OverMaxDeep]") : o.push("{...OverMaxDeep}");
      return;
    }
    if (u.has(l)) {
      o.push(f + "[Circular]");
      return;
    }
    u.add(l);
    const h = Object.keys(l).filter((p) => !(r && typeof l[p] == "function"));
    h.forEach((p, m) => {
      const D = l[p], y = m === h.length - 1, F = d === 0 && m === 0 ? "" : f, S = y ? Ie.lastBranch : Ie.branch, v = p.trim() === "" ? "" : p;
      let E = F + S + (v ? " " + v : "");
      const R = p.trim() !== "";
      if (D && typeof D == "object" && u.has(D))
        o.push(
          E + (R ? ": " : E ? " " : "") + "[Circular]"
        );
      else if (D && typeof D == "object" && !Array.isArray(D)) {
        o.push(E);
        const A = y ? Ie.empty : Ie.line, k = F + A + " ";
        a(D, k, d + 1);
      } else if (Array.isArray(D)) {
        o.push(
          E + (R ? ": " : E ? " " : "") + "[Array(" + D.length + ")]"
        );
        const A = y ? Ie.empty : Ie.line, k = F + A + " ";
        a(D, k, d + 1);
      } else if (n) {
        const A = typeof D == "function" ? "[Function]" : typeof D == "string" ? '"' + String(D) + '"' : String(D);
        E += (R ? ": " : E ? " " : "") + A, o.push(E);
      } else
        o.push(E);
    });
  }
  const c = Object.keys(e);
  if (c.length === 0)
    return "(empty)";
  if (c.length === 1 && c[0] !== void 0 && c[0].trim() === "" && typeof e[c[0]] == "string") {
    const l = c[0], f = Ie.lastBranch, d = e[l], h = typeof d == "function" ? "[Function]" : typeof d == "string" ? '"' + d + '"' : String(d);
    return f + " " + h;
  }
  return a(e), i + o.join(i);
}
function $o(e = "verbose") {
  let t = -1;
  switch (e) {
    case "verbose":
      t = 0;
      break;
    case "debug":
      t = 1;
      break;
    case "info":
      t = 2;
      break;
    case "warn":
      t = 3;
      break;
    case "error":
      t = 4;
      break;
  }
  return t;
}
function Sw(e = "verbose") {
  _.OPEN_LOG_LEVEL = $o(e);
}
function Nl() {
  _.OPEN_LOG_LEVEL = -1;
}
function Aw(e) {
  _.LOG_UPLOAD_FN = e;
}
Nl();
function lt(e = "verbose") {
  return _.OPEN_LOG_LEVEL <= $o(e);
}
function li(e) {
  _.LOG_UPLOAD_FN && _.LOG_UPLOAD_FN(e);
}
function $e(e, t = "") {
  try {
    if (li({ level: "info", msg: e, type: t }), !lt("info"))
      return;
    console.log(e);
  } catch {
  }
}
function _e(e, t = "") {
  try {
    if (li({ level: "warn", msg: e, type: t }), !lt("warn"))
      return;
    console.warn(e);
  } catch {
  }
}
function Il(e, t = "") {
  try {
    if (li({ level: "error", msg: e, type: t }), !lt("error"))
      return;
    console.error(e);
  } catch {
  }
}
const Gi = {
  start: (e) => {
    lt("verbose") && (!console || typeof console != "object" || // typeof console.group !== "function"
    typeof console.groupCollapsed != "function" || console.groupCollapsed(e));
  },
  end: () => {
    !console || typeof console != "object" || typeof console.groupEnd != "function" || console.groupEnd();
  }
}, dn = {
  start: (e) => {
    lt("verbose") && (!console || typeof console != "object" || typeof console.time != "function" || console.time(e));
  },
  end: (e) => {
    !console || typeof console != "object" || typeof console.timeEnd != "function" || console.timeEnd(e);
  }
}, Vi = {
  start: (e) => {
    lt("verbose") && (!console || typeof console != "object" || typeof console.profile != "function" || console.profile(e));
  },
  end: (e) => {
    !console || typeof console != "object" || typeof console.profileEnd != "function" || console.profileEnd(e);
  }
};
function Ow(e) {
  const t = /* @__PURE__ */ new WeakMap();
  return new Proxy(e, {
    construct(n, r) {
      return t.has(n) || t.set(n, new n(...r)), t.get(n);
    }
  });
}
function Cw(e) {
  return class extends e {
    constructor(...t) {
      super(...t), this.currentUser = null;
    }
    login(t) {
      $e(`User ${t.name} logged in with role ${t.role}`), this.currentUser = t;
    }
    logout() {
      $e(`User ${this.currentUser.name} logged out`), this.currentUser = null;
    }
  };
}
function Tw(e) {
  return function(t, n, r) {
    const i = r.value;
    return r.value = function(...s) {
      if (!this.currentUser)
        throw new Error("Authentication required");
      if (this.currentUser.role !== e)
        throw new Error(`Requires ${e} role`);
      return i.apply(this, s);
    }, r;
  };
}
function Rw(e) {
  return function(t, n) {
    let r;
    Object.defineProperty(t, n, {
      get() {
        return r;
      },
      set(i) {
        if (i.length < e)
          throw new Error(`${String(n)} must be at least ${e} long`);
        r = i;
      }
    });
  };
}
function xw(e) {
  return function(t, n) {
    let r;
    Object.defineProperty(t, n, {
      get() {
        return r;
      },
      set(i) {
        if (i.length < e)
          throw new Error(`${String(n)} must be at most ${e} long`);
        r = i;
      }
    });
  };
}
function kw(e) {
  return function(t, n, r) {
    const i = e || `${t.constructor.name}.${String(n)}`, s = r.value;
    if (typeof s != "function")
      throw new SyntaxError(
        `@LogExecuteResultDecorator() can only be used on functions, not: ${i}`
      );
    return {
      ...r,
      value(...o) {
        const u = s.apply(this, o);
        return $e(`${i} ( ${o} ) = ${u}`), u;
      }
    };
  };
}
function Nw(e, t, n) {
  const r = `${e.constructor.name}.${String(t)}`, i = n.value;
  if (typeof i != "function")
    throw new SyntaxError(
      `@LogExecuteTimeDecorator can only be used on functions, not: ${r}`
    );
  let s = 0;
  return {
    ...n,
    value(...o) {
      const u = `${r}-${s++}`;
      dn.start(u);
      try {
        return i.apply(this, o);
      } finally {
        dn.end(u);
      }
    }
  };
}
function Iw(e, t, n) {
  const r = `${e.constructor.name}.${String(t)}`, i = n.value;
  if (typeof i != "function")
    throw new SyntaxError(
      `@ProfileDecorator can only be used on functions, not: ${r}`
    );
  return {
    ...n,
    value(...s) {
      Vi.start(r);
      try {
        return i.apply(this, s);
      } finally {
        Vi.end(r);
      }
    }
  };
}
function Pw(e = 300, t) {
  return function(n, r, i) {
    const s = `${n.constructor.name}.${String(r)}`, o = i.value;
    if (typeof o != "function")
      throw new SyntaxError(
        `@ThrottleDecorator() can only be used on functions, not: ${s}`
      );
    return {
      ...i,
      value(...u) {
        Qr(this).get(`__@ThrottleDecorator_${s}__`, gl(o, e, t)).apply(this, u);
      }
    };
  };
}
function zw(e = 300) {
  return function(t, n, r) {
    const i = `${t.constructor.name}.${String(n)}`, s = r.value;
    if (typeof s != "function")
      throw new SyntaxError(
        `@DebounceDecorator() can only be used on functions, not: ${i}`
      );
    return {
      ...r,
      value(...o) {
        Qr(this).get(`__@DebounceDecorator_${i}__`, yl(s, e)).apply(this, o);
      }
    };
  };
}
function Bw(e = 3, t) {
  return function(n, r, i) {
    const s = `${n.constructor.name}.${String(r)}`, o = i.value;
    if (typeof o != "function")
      throw new SyntaxError(
        `@RetryDecoratorDecorator() can only be used on functions, not: ${s}`
      );
    const u = zt(o, { maxRetries: e, retryDelay: t });
    return {
      ...i,
      async value(...a) {
        return await u.apply(this, a);
      }
    };
  };
}
function $w(e = { ttl: 6e4 }) {
  return function(t, n, r) {
    const i = `${t.constructor.name}.${String(n)}`, s = r.value;
    if (typeof s != "function")
      throw new SyntaxError(
        `@MemoizeDecorator() can only be used on functions, not: ${i}`
      );
    return {
      ...r,
      async value(...o) {
        return await Qr(this).get(
          `__@MemorizeDecorator_${i}__`,
          Ke(s, {
            cacheKeyResolver: (...a) => a.join("_"),
            createCache: () => new ci(e)
          })
        ).apply(this, o);
      }
    };
  };
}
function Lw(e, t, n) {
  if (n)
    return n.writable = !1, n;
  let r;
  Object.defineProperty(e, t, {
    get() {
      return r;
    },
    set(i) {
      if (r === void 0)
        r = i;
      else
        throw new Error(`${e}.${String(t)} is Readonly!`);
    }
  });
}
function Mw(e = !0) {
  return (t, n, r) => {
    if (r)
      return r.configurable = e, r;
    Object.defineProperty(t, n, {
      configurable: e
    });
  };
}
function jw(e = !0) {
  return (t, n, r) => {
    if (r)
      return r.enumerable = e, r;
    Object.defineProperty(t, n, {
      enumerable: e
    });
  };
}
function Pl(e) {
  return typeof setImmediate < "u" && hn(setImmediate) ? (setImmediate(e), !0) : typeof queueMicrotask == "function" ? (queueMicrotask(e), !0) : typeof Promise < "u" && hn(Promise) ? (Promise.resolve().then(e), !0) : !1;
}
function $t(e) {
  if (typeof MessageChannel < "u" && (hn(MessageChannel) || MessageChannel.toString() === "[object MessageChannelConstructor]")) {
    const { port1: t, port2: n } = new MessageChannel();
    t.onmessage = () => {
      t.onmessage = null, e();
    }, n.postMessage(null);
  } else
    setTimeout(e, 0);
}
function Uw(e) {
  Pl(e) || $t(e);
}
async function zl() {
  return new Promise((e) => {
    $t(e);
  });
}
_.requestAnimationFrame = _.requestAnimationFrame || _.webkitRequestAnimationFrame || _.mozRequestAnimationFrame || _.oRequestAnimationFrame || _.msRequestAnimationFrame;
_.cancelAnimationFrame = _.cancelAnimationFrame || _.webkitCancelAnimationFrame || _.mozCancelAnimationFrame || _.oCancelAnimationFrame || _.msCancelAnimationFrame;
if (!_.requestAnimationFrame) {
  let e = M();
  _.requestAnimationFrame = (t) => {
    const n = M(), r = Math.max(0, 16 - (n - e)), i = _.setTimeout(() => {
      t(n + r);
    }, r);
    return e = n + r, i;
  };
}
_.cancelAnimationFrame || (_.cancelAnimationFrame = (e) => {
  _.clearTimeout(e);
});
const pn = _.requestAnimationFrame, Lo = _.cancelAnimationFrame;
function Bl(e) {
  let t = !0, n = pn(function r(i) {
    t && e(i) && (n = pn(r));
  });
  return () => {
    t = !1, Lo(n);
  };
}
function Ki(e, t = 0) {
  if (t <= 0) {
    const n = pn(e);
    return () => Lo(n);
  } else {
    const n = M();
    return Bl((r) => r - n >= t ? (e(r), !1) : !0);
  }
}
function Zw(e, t = 0) {
  let n = !0, r = 0;
  const i = M();
  let s = Ki(function o(u) {
    if (!n)
      return;
    r = Math.floor((u - i) / t);
    const a = u - i - r * t;
    e(u, r, t <= a), s = Ki(o, Math.max(0, t - a));
  }, t);
  return () => {
    n = !1, s();
  };
}
_.requestIdleCallback = _.requestIdleCallback || function(e, t) {
  const n = M();
  return setTimeout(() => {
    const r = M() - n, i = {
      didTimeout: typeof t?.timeout != "number" ? !1 : r > t.timeout,
      // 是否已到设置的超时时间
      // 本帧剩余可执行时间，毫秒
      // timeRemaining 最大不超过 50ms，50ms = 1000 / 20fps
      // 注意：timeRemaining 最大为 50毫秒 ，是根据研究 https://w3c.github.io/requestidlecallback/#bib-responsetime 得出的
      // 该研究表明，对用户输入的 100毫秒 以内的响应通常被认为对人类是瞬时的，就是人类不会有察觉
      // 将闲置截止期限设置为 50ms 意味着即使在闲置任务开始后立即发生用户输入，用户代理仍然有剩余的 50ms 可以在其中响应用户输入而不会产生用户可察觉的滞后
      timeRemaining: () => Math.max(0, 50 - r)
    };
    e(i);
  }, t?.timeout);
};
_.cancelIdleCallback = _.cancelIdleCallback || function(e) {
  clearTimeout(e);
};
const qw = _.requestIdleCallback, Ww = _.cancelIdleCallback;
let wt = 33, ge = 33, Wt = 0, Ft = 0, rr = !1;
function Mo(e) {
  rr || (rr = !0, pn((t) => {
    rr = !1, Wt = t, Ft === 0 && (Ft = Wt + ge);
    let n = ge + Wt - Ft;
    n < ge && wt < ge ? (n < 8 && (n = 8), ge = Math.max(
      n,
      wt
    )) : n > ge && wt > ge && (ge = Math.min(
      n,
      wt
    )), wt = n, Ft = Wt + ge, $t(() => {
      e(Ft), Mo(e);
    });
  }));
}
function jo(e) {
  const t = e?.maxIterations || 1e4, n = !!e?.tracing, r = e?.onTrace || ((h) => {
    const p = "  ".repeat(h.depth);
    console.log(
      `${p}emit#${h.id} parent=${h.parentId} source=${h.source}`
    );
  }), i = [];
  let s = 0, o = 0;
  const u = /* @__PURE__ */ new Set(), a = (h) => (u.add(h), () => {
    u.delete(h);
  });
  let c;
  function l(h, p) {
    const m = c, D = {
      id: String(++s),
      dataset: h,
      source: p,
      createdAt: M(),
      parentId: m?.id,
      depth: m ? m.depth + 1 : 0
    };
    i.push(D);
  }
  let f = !1;
  function d() {
    if (f)
      return;
    f = !0;
    let h = 0;
    try {
      for (; o < i.length; ) {
        if (++h > t)
          throw new Error("Possible infinite signal loop detected");
        const p = i[o], m = c;
        c = p, n && r(p);
        const D = Array.from(u);
        for (const y of D)
          try {
            y(...p.dataset);
          } catch (F) {
            $t(() => {
              throw F;
            });
          }
        c = m, o++;
      }
    } finally {
      f = !1, o >= i.length && (i.length = 0, o = 0);
    }
  }
  return {
    subscribe: a,
    once(h) {
      const p = a((...m) => {
        p(), h(...m);
      });
      return p;
    },
    emit(...h) {
      l(h), d();
    },
    emitFrom(h, ...p) {
      l(p, h), d();
    },
    clear() {
      u.clear();
    }
  };
}
function $l(e = {}) {
  const { concurrency: t = 1 / 0, maxWorkerRunTime: n = 6e4 } = e;
  let r = 1 / 0;
  const i = () => r === 1 / 0 || M() < r, s = (w) => {
    r = M() + w, c();
  };
  let o = i() ? 0 : 1;
  const u = () => o > 0, a = () => {
    o++;
  }, c = () => {
    o > 0 && o--, A();
  }, l = () => !u() && !i(), f = async () => {
    l() && await zl();
  };
  let d = 0, h = [];
  const p = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Set();
  let D = 0, y = [], F = [];
  const S = () => {
    D === 0 && (y.forEach((w) => w()), y = [], h.length === 0 && (F.forEach((w) => w()), F = []));
  }, v = (w) => {
    if (w.signal) {
      if (w.signal.aborted)
        return w.resultReject("Cancel by Aborted!"), w;
      w.abortHandler = () => {
        w.resultReject("Cancel by Abort!"), h = h.filter((T) => T.id !== w.id), S();
      }, w.signal.addEventListener("abort", w.abortHandler, {
        once: !0
      });
    }
    if (h.filter((T) => w.invalidates?.includes(T.id)).forEach((T) => {
      T.resultReject("Cancel by invalidates!");
    }), h = h.filter((T) => !w.invalidates?.includes(T.id)), w.fold) {
      const T = h.findIndex((P) => P.id === w.id);
      if (T !== -1) {
        const P = h[T], V = w.fold(P, w);
        return P.dataset = V.dataset, P;
      } else
        return h.push(w), w;
    } else
      return h.push(w), w;
  }, E = () => {
    if (h.length === 0)
      return;
    let w = -1, T;
    for (let P = 0, V = h.length; P < V; P++) {
      const ne = h[P];
      (!T || ne.niceness < T.niceness) && (w = P, T = ne);
    }
    return h.splice(w, 1), T;
  };
  let R = !1;
  const A = () => {
    R || u() || (R = !0, $t(() => {
      for (R = !1; h.length > 0 && m.size > 0 && D < t && !u(); ) {
        const w = E(), T = It(w.deadline) && M() >= w.deadline, P = w.niceness == ln.immediate;
        if (!i() && !T && !P) {
          v(w), A();
          break;
        }
        if (w.signal?.aborted) {
          w.resultReject("Cancel by Aborted!"), S();
          continue;
        }
        D++;
        const V = m.values().next().value;
        m.delete(V), _l(
          zo(
            Promise.resolve(V(...w.dataset)),
            // 只是调度 async，还不能抢占 sync CPU
            n
          ),
          w.signal
        ).then((ne) => {
          w.resultResolve(ne);
        }).catch((ne) => {
          w.retry > 0 ? (w.retry--, v(w)) : w.resultReject(ne);
        }).finally(async () => {
          p.has(V) && m.add(V), w.signal && w.abortHandler && w.signal.removeEventListener("abort", w.abortHandler), D--, S(), A();
        });
      }
    }));
  }, k = (w) => (p.add(w), m.add(w), A(), () => {
    p.delete(w), m.delete(w);
  });
  return {
    // dispatch
    put(...w) {
      const T = w[w.length - 1] || {};
      let P = {};
      ("niceness" in T || "deadline" in T || "retry" in T || "signal" in T || "invalidates" in T || "fold" in T) && (P = w.pop());
      const V = El(), ne = v({
        id: String(++d),
        dataset: w,
        createdAt: M(),
        result: V.promise,
        resultResolve: V.resolve,
        resultReject: V.reject,
        niceness: P.niceness ?? ln.normal,
        deadline: P.deadline ?? Jr,
        retry: P.retry ?? 0,
        signal: P.signal
      });
      return A(), ne;
    },
    cancel(w) {
      h = h.filter((T) => T.id !== w.id), w.signal && w.abortHandler && w.signal.removeEventListener("abort", w.abortHandler), S();
    },
    clear() {
      for (const w of h)
        w.signal && w.abortHandler && w.signal.removeEventListener("abort", w.abortHandler), w.resultReject(new Error("Cleared"));
      h.length = 0, S();
    },
    run: k,
    once(w) {
      const T = k((...P) => {
        try {
          return w(...P);
        } finally {
          T();
        }
      });
      return T;
    },
    async onDrain() {
      if (!(D === 0 && h.length === 0))
        return new Promise((w) => {
          F.push(w);
        });
    },
    async onIdle() {
      if (D !== 0)
        return new Promise((w) => {
          y.push(w);
        });
    },
    pause: a,
    resume: c,
    get paused() {
      return u();
    },
    startFrame: s,
    yieldIfNeeded: f
  };
}
class Uo {
  pool;
  concurrency;
  maxWorkerRunTime;
  constructor(t = { concurrency: 1 }) {
    this.concurrency = t.concurrency ?? 1, this.maxWorkerRunTime = t.maxWorkerRunTime ?? 6e4, this.pool = $l({
      concurrency: this.concurrency,
      maxWorkerRunTime: this.maxWorkerRunTime
    });
    for (let n = 0; n < this.concurrency; n++)
      this.pool.run(async function(i) {
        return await i();
      });
  }
  cancel(t) {
    this.pool.cancel(t);
  }
  clear() {
    this.pool.clear();
  }
  get paused() {
    return this.pool.paused;
  }
  startFrame(t) {
    this.pool.startFrame(t);
  }
  // 立即执行
  async immediate(t) {
    try {
      return this.pool.pause(), await this.pool.onIdle(), await zo(Promise.resolve(t()), this.maxWorkerRunTime);
    } finally {
      this.pool.resume();
    }
  }
  // 立即执行
  // public immediate(fn: TinyFn): TaskEvent<[TinyFn], void> {
  //   const event = this.pool.put(fn, { niceness: PRIORITIES.immediate });
  //   return event;
  // }
  // as soon as possible
  asap(t, n) {
    return this.pool.put(t, {
      niceness: n?.niceness ?? ln.normal,
      deadline: typeof n?.timeout == "number" ? M() + n?.timeout : Jr
    });
  }
}
class Gw {
  pool;
  closes = [];
  constructor(t = { concurrency: 1 }) {
    this.pool = new Uo({ ...t, maxWorkerRunTime: 1 / 0 });
  }
  // 强制关闭
  close(t = !0) {
    const n = t ? this.closes.length : Math.max(0, this.closes.length - this.pool.concurrency + 1), r = il(this.closes, n);
    for (const i of r)
      i();
  }
  clear() {
    this.pool.clear(), this.close();
  }
  createNotifyTask(t, n, r = !0) {
    return () => new Promise((i, s) => {
      try {
        this.close(r);
        const o = t({
          ...n,
          onClose: () => {
            n?.onClose?.(), i(), nl(this.closes, u);
          }
        }), u = () => {
          o(), i();
        };
        this.closes.push(u);
      } catch (o) {
        s(o);
      }
    });
  }
  // 强制显示
  exclusive(t, n) {
    return this.pool.immediate(
      this.createNotifyTask(t, n, !0)
    );
  }
  // 放入队列，依次关闭后显示
  enqueue(t, n) {
    const r = this.pool.asap(
      this.createNotifyTask(t, n, !1)
    );
    return () => {
      this.pool.cancel(r);
    };
  }
}
class Ll {
  pool;
  started = !1;
  constructor(t = { concurrency: 1 }) {
    this.pool = new Uo(t), this.pool.startFrame(0);
  }
  clear() {
    this.pool.clear();
  }
  // 懒启动
  start() {
    this.started || (this.started = !0, Mo((t) => {
      this.pool.startFrame(t - M());
    }));
  }
  async idle(t, n) {
    return this.start(), await this.pool.asap(t, { niceness: ln.idle, timeout: n }).result;
  }
}
const Qi = new Ll(), Ji = Qi.idle.bind(Qi);
function Vw(e) {
  let t = !0;
  return Ji(function n() {
    t && e() && Ji(n);
  }), () => {
    t = !1;
  };
}
class Kw {
  queue = [];
  waiters = [];
  changed = jo();
  _revision = 0;
  get length() {
    return this.queue.length;
  }
  get revision() {
    return this._revision;
  }
  send(t) {
    this._revision++;
    const n = this.waiters.findIndex((r) => r.fn(t));
    if (n !== -1) {
      const r = this.waiters.splice(n, 1)[0];
      if (r) {
        r.resolve(t), this.notify();
        return;
      }
    }
    this.queue.push(t), this.notify();
  }
  poll(t = () => !0) {
    const n = this.queue.findIndex(t);
    if (n !== -1)
      return this.queue.splice(n, 1)[0];
  }
  receive(t = () => !0) {
    const n = this.queue.findIndex(t);
    if (n !== -1) {
      const r = this.queue.splice(n, 1)[0];
      if (r)
        return this.notify(), Promise.resolve(r);
    }
    return new Promise((r) => {
      this.waiters.push({ fn: t, resolve: r });
    });
  }
  subscribe = this.changed.subscribe;
  notify() {
    this.changed.emit();
  }
}
function Qw(e) {
  let t = new AbortController();
  function n() {
    t.abort(), t = new AbortController();
  }
  function r() {
    const i = new AbortController(), s = () => i.abort();
    if (e.aborted || t.signal.aborted)
      return i.abort(), { signal: i.signal, cleanup: () => {
      } };
    e.addEventListener("abort", s, { once: !0 });
    const o = t.signal;
    return o.addEventListener("abort", s, { once: !0 }), {
      signal: i.signal,
      cleanup: () => {
        e.removeEventListener("abort", s), o.removeEventListener("abort", s);
      }
    };
  }
  return { signal: r, wake: n };
}
function Ml(e) {
  try {
    return AbortSignal.any(e);
  } catch {
    const n = new AbortController(), r = () => n.abort();
    for (const i of e)
      if (i) {
        if (i.aborted) {
          n.abort();
          break;
        }
        i.addEventListener("abort", r, { once: !0 });
      }
    return n.signal;
  }
}
class Jw {
  events;
  constructor() {
    this.events = {};
  }
  isEmpty(t) {
    return this.events[t] == null || this.events[t].length == 0;
  }
  has(t, n) {
    return this.events[t] !== void 0 && this.events[t].indexOf(n) !== -1;
  }
  prependListener(t, n, r) {
    return this.events[t] || (this.events[t] = []), this.events[t].unshift(
      r ? n.bind(r) : n
    ), this;
  }
  addListener(t, n, r) {
    return this.events[t] || (this.events[t] = []), this.events[t].push(
      r ? n.bind(r) : n
    ), this;
  }
  on(t, n, r) {
    return this.addListener(t, n, r), this;
  }
  removeListener(t, n) {
    return this.events[t] && (this.events[t] = this.events[t].filter((r) => r !== n)), this;
  }
  off(t, n) {
    return this.removeListener(t, n), this;
  }
  removeAllListeners(t) {
    return t ? this.events[t] = [] : this.events = {}, this;
  }
  // 注意：handler 自己绑定 this
  emit(t, ...n) {
    return this.events[t] && this.events[t].slice(0).forEach((i) => {
      i(...n);
    }), this;
  }
  once(t, n, r) {
    const i = (...s) => {
      r ? n.apply(r, s) : n(...s), this.off(t, i);
    };
    return this.on(t, i), this;
  }
}
var Ar = function(e, t) {
  return Ar = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Ar(e, t);
};
function ht(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Ar(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function jl(e, t, n, r) {
  function i(s) {
    return s instanceof n ? s : new n(function(o) {
      o(s);
    });
  }
  return new (n || (n = Promise))(function(s, o) {
    function u(l) {
      try {
        c(r.next(l));
      } catch (f) {
        o(f);
      }
    }
    function a(l) {
      try {
        c(r.throw(l));
      } catch (f) {
        o(f);
      }
    }
    function c(l) {
      l.done ? s(l.value) : i(l.value).then(u, a);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function Zo(e, t) {
  var n = { label: 0, sent: function() {
    if (s[0] & 1)
      throw s[1];
    return s[1];
  }, trys: [], ops: [] }, r, i, s, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = u(0), o.throw = u(1), o.return = u(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function u(c) {
    return function(l) {
      return a([c, l]);
    };
  }
  function a(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, i && (s = c[0] & 2 ? i.return : c[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, c[1])).done)
          return s;
        switch (i = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
          case 0:
          case 1:
            s = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (s = n.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < s[1]) {
              n.label = s[1], s = c;
              break;
            }
            if (s && n.label < s[2]) {
              n.label = s[2], n.ops.push(c);
              break;
            }
            s[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (l) {
        c = [6, l], i = 0;
      } finally {
        r = s = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function st(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function mn(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, s = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      s.push(i.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}
function Dn(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, s; r < i; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function nt(e) {
  return this instanceof nt ? (this.v = e, this) : new nt(e);
}
function Ul(e, t, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, s = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), u("next"), u("throw"), u("return", o), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function o(h) {
    return function(p) {
      return Promise.resolve(p).then(h, f);
    };
  }
  function u(h, p) {
    r[h] && (i[h] = function(m) {
      return new Promise(function(D, y) {
        s.push([h, m, D, y]) > 1 || a(h, m);
      });
    }, p && (i[h] = p(i[h])));
  }
  function a(h, p) {
    try {
      c(r[h](p));
    } catch (m) {
      d(s[0][3], m);
    }
  }
  function c(h) {
    h.value instanceof nt ? Promise.resolve(h.value.v).then(l, f) : d(s[0][2], h);
  }
  function l(h) {
    a("next", h);
  }
  function f(h) {
    a("throw", h);
  }
  function d(h, p) {
    h(p), s.shift(), s.length && a(s[0][0], s[0][1]);
  }
}
function Zl(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof st == "function" ? st(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(s) {
    n[s] = e[s] && function(o) {
      return new Promise(function(u, a) {
        o = e[s](o), i(u, a, o.done, o.value);
      });
    };
  }
  function i(s, o, u, a) {
    Promise.resolve(a).then(function(c) {
      s({ value: c, done: u });
    }, o);
  }
}
function W(e) {
  return typeof e == "function";
}
function qo(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var ir = qo(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function Or(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var $n = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, i, s;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var u = st(o), a = u.next(); !a.done; a = u.next()) {
              var c = a.value;
              c.remove(this);
            }
          } catch (m) {
            t = { error: m };
          } finally {
            try {
              a && !a.done && (n = u.return) && n.call(u);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          o.remove(this);
      var l = this.initialTeardown;
      if (W(l))
        try {
          l();
        } catch (m) {
          s = m instanceof ir ? m.errors : [m];
        }
      var f = this._finalizers;
      if (f) {
        this._finalizers = null;
        try {
          for (var d = st(f), h = d.next(); !h.done; h = d.next()) {
            var p = h.value;
            try {
              Hi(p);
            } catch (m) {
              s = s ?? [], m instanceof ir ? s = Dn(Dn([], mn(s)), mn(m.errors)) : s.push(m);
            }
          }
        } catch (m) {
          r = { error: m };
        } finally {
          try {
            h && !h.done && (i = d.return) && i.call(d);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (s)
        throw new ir(s);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        Hi(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && Or(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && Or(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}(), Wo = $n.EMPTY;
function Go(e) {
  return e instanceof $n || e && "closed" in e && W(e.remove) && W(e.add) && W(e.unsubscribe);
}
function Hi(e) {
  W(e) ? e() : e.unsubscribe();
}
var Vo = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, Cr = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    var i = Cr.delegate;
    return i?.setTimeout ? i.setTimeout.apply(i, Dn([e, t], mn(n))) : setTimeout.apply(void 0, Dn([e, t], mn(n)));
  },
  clearTimeout: function(e) {
    var t = Cr.delegate;
    return (t?.clearTimeout || clearTimeout)(e);
  },
  delegate: void 0
};
function Ko(e) {
  Cr.setTimeout(function() {
    throw e;
  });
}
function Tr() {
}
function tn(e) {
  e();
}
var hi = function(e) {
  ht(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, Go(n) && n.add(r)) : r.destination = Vl, r;
  }
  return t.create = function(n, r, i) {
    return new Rr(n, r, i);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}($n), ql = Function.prototype.bind;
function sr(e, t) {
  return ql.call(e, t);
}
var Wl = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        Gt(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        Gt(r);
      }
    else
      Gt(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        Gt(n);
      }
  }, e;
}(), Rr = function(e) {
  ht(t, e);
  function t(n, r, i) {
    var s = e.call(this) || this, o;
    if (W(n) || !n)
      o = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: i ?? void 0
      };
    else {
      var u;
      s && Vo.useDeprecatedNextContext ? (u = Object.create(n), u.unsubscribe = function() {
        return s.unsubscribe();
      }, o = {
        next: n.next && sr(n.next, u),
        error: n.error && sr(n.error, u),
        complete: n.complete && sr(n.complete, u)
      }) : o = n;
    }
    return s.destination = new Wl(o), s;
  }
  return t;
}(hi);
function Gt(e) {
  Ko(e);
}
function Gl(e) {
  throw e;
}
var Vl = {
  closed: !0,
  next: Tr,
  error: Gl,
  complete: Tr
}, fi = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Qo(e) {
  return e;
}
function Kl() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Jo(e);
}
function Jo(e) {
  return e.length === 0 ? Qo : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, i) {
      return i(r);
    }, n);
  };
}
var ee = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var i = this, s = Jl(t) ? t : new Rr(t, n, r);
    return tn(function() {
      var o = i, u = o.operator, a = o.source;
      s.add(u ? u.call(s, a) : a ? i._subscribe(s) : i._trySubscribe(s));
    }), s;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = Xi(n), new n(function(i, s) {
      var o = new Rr({
        next: function(u) {
          try {
            t(u);
          } catch (a) {
            s(a), o.unsubscribe();
          }
        },
        error: s,
        complete: i
      });
      r.subscribe(o);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[fi] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return Jo(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = Xi(t), new t(function(r, i) {
      var s;
      n.subscribe(function(o) {
        return s = o;
      }, function(o) {
        return i(o);
      }, function() {
        return r(s);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Xi(e) {
  var t;
  return (t = e ?? Vo.Promise) !== null && t !== void 0 ? t : Promise;
}
function Ql(e) {
  return e && W(e.next) && W(e.error) && W(e.complete);
}
function Jl(e) {
  return e && e instanceof hi || Ql(e) && Go(e);
}
function Hl(e) {
  return W(e?.lift);
}
function Qe(e) {
  return function(t) {
    if (Hl(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Ce(e, t, n, r, i) {
  return new Xl(e, t, n, r, i);
}
var Xl = function(e) {
  ht(t, e);
  function t(n, r, i, s, o, u) {
    var a = e.call(this, n) || this;
    return a.onFinalize = o, a.shouldUnsubscribe = u, a._next = r ? function(c) {
      try {
        r(c);
      } catch (l) {
        n.error(l);
      }
    } : e.prototype._next, a._error = s ? function(c) {
      try {
        s(c);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, a._complete = i ? function() {
      try {
        i();
      } catch (c) {
        n.error(c);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, a;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(hi), Yl = qo(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), di = function(e) {
  ht(t, e);
  function t() {
    var n = e.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return t.prototype.lift = function(n) {
    var r = new Yi(this, this);
    return r.operator = n, r;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Yl();
  }, t.prototype.next = function(n) {
    var r = this;
    tn(function() {
      var i, s;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var o = st(r.currentObservers), u = o.next(); !u.done; u = o.next()) {
            var a = u.value;
            a.next(n);
          }
        } catch (c) {
          i = { error: c };
        } finally {
          try {
            u && !u.done && (s = o.return) && s.call(o);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(n) {
    var r = this;
    tn(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var i = r.observers; i.length; )
          i.shift().error(n);
      }
    });
  }, t.prototype.complete = function() {
    var n = this;
    tn(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, n);
  }, t.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, t.prototype._innerSubscribe = function(n) {
    var r = this, i = this, s = i.hasError, o = i.isStopped, u = i.observers;
    return s || o ? Wo : (this.currentObservers = null, u.push(n), new $n(function() {
      r.currentObservers = null, Or(u, n);
    }));
  }, t.prototype._checkFinalizedStatuses = function(n) {
    var r = this, i = r.hasError, s = r.thrownError, o = r.isStopped;
    i ? n.error(s) : o && n.complete();
  }, t.prototype.asObservable = function() {
    var n = new ee();
    return n.source = this, n;
  }, t.create = function(n, r) {
    return new Yi(n, r);
  }, t;
}(ee), Yi = function(e) {
  ht(t, e);
  function t(n, r) {
    var i = e.call(this) || this;
    return i.destination = n, i.source = r, i;
  }
  return t.prototype.next = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || i === void 0 || i.call(r, n);
  }, t.prototype.error = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || i === void 0 || i.call(r, n);
  }, t.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, t.prototype._subscribe = function(n) {
    var r, i;
    return (i = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && i !== void 0 ? i : Wo;
  }, t;
}(di), Ho = function(e) {
  ht(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r._value = n, r;
  }
  return Object.defineProperty(t.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._subscribe = function(n) {
    var r = e.prototype._subscribe.call(this, n);
    return !r.closed && n.next(this._value), r;
  }, t.prototype.getValue = function() {
    var n = this, r = n.hasError, i = n.thrownError, s = n._value;
    if (r)
      throw i;
    return this._throwIfClosed(), s;
  }, t.prototype.next = function(n) {
    e.prototype.next.call(this, this._value = n);
  }, t;
}(di), eh = new ee(function(e) {
  return e.complete();
});
function th(e) {
  return e && W(e.schedule);
}
function Xo(e) {
  return e[e.length - 1];
}
function nh(e) {
  return th(Xo(e)) ? e.pop() : void 0;
}
function rh(e, t) {
  return typeof Xo(e) == "number" ? e.pop() : t;
}
var Yo = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function eu(e) {
  return W(e?.then);
}
function tu(e) {
  return W(e[fi]);
}
function nu(e) {
  return Symbol.asyncIterator && W(e?.[Symbol.asyncIterator]);
}
function ru(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function ih() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var iu = ih();
function su(e) {
  return W(e?.[iu]);
}
function ou(e) {
  return Ul(this, arguments, function() {
    var n, r, i, s;
    return Zo(this, function(o) {
      switch (o.label) {
        case 0:
          n = e.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, nt(n.read())];
        case 3:
          return r = o.sent(), i = r.value, s = r.done, s ? [4, nt(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, nt(i)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function uu(e) {
  return W(e?.getReader);
}
function Re(e) {
  if (e instanceof ee)
    return e;
  if (e != null) {
    if (tu(e))
      return sh(e);
    if (Yo(e))
      return oh(e);
    if (eu(e))
      return uh(e);
    if (nu(e))
      return au(e);
    if (su(e))
      return ah(e);
    if (uu(e))
      return ch(e);
  }
  throw ru(e);
}
function sh(e) {
  return new ee(function(t) {
    var n = e[fi]();
    if (W(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function oh(e) {
  return new ee(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function uh(e) {
  return new ee(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, Ko);
  });
}
function ah(e) {
  return new ee(function(t) {
    var n, r;
    try {
      for (var i = st(e), s = i.next(); !s.done; s = i.next()) {
        var o = s.value;
        if (t.next(o), t.closed)
          return;
      }
    } catch (u) {
      n = { error: u };
    } finally {
      try {
        s && !s.done && (r = i.return) && r.call(i);
      } finally {
        if (n)
          throw n.error;
      }
    }
    t.complete();
  });
}
function au(e) {
  return new ee(function(t) {
    lh(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function ch(e) {
  return au(ou(e));
}
function lh(e, t) {
  var n, r, i, s;
  return jl(this, void 0, void 0, function() {
    var o, u;
    return Zo(this, function(a) {
      switch (a.label) {
        case 0:
          a.trys.push([0, 5, 6, 11]), n = Zl(e), a.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = a.sent(), !!r.done)
            return [3, 4];
          if (o = r.value, t.next(o), t.closed)
            return [2];
          a.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return u = a.sent(), i = { error: u }, [3, 11];
        case 6:
          return a.trys.push([6, , 9, 10]), r && !r.done && (s = n.return) ? [4, s.call(n)] : [3, 8];
        case 7:
          a.sent(), a.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i)
            throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function Se(e, t, n, r, i) {
  r === void 0 && (r = 0), i === void 0 && (i = !1);
  var s = t.schedule(function() {
    n(), i ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(s), !i)
    return s;
}
function cu(e, t) {
  return t === void 0 && (t = 0), Qe(function(n, r) {
    n.subscribe(Ce(r, function(i) {
      return Se(r, e, function() {
        return r.next(i);
      }, t);
    }, function() {
      return Se(r, e, function() {
        return r.complete();
      }, t);
    }, function(i) {
      return Se(r, e, function() {
        return r.error(i);
      }, t);
    }));
  });
}
function lu(e, t) {
  return t === void 0 && (t = 0), Qe(function(n, r) {
    r.add(e.schedule(function() {
      return n.subscribe(r);
    }, t));
  });
}
function hh(e, t) {
  return Re(e).pipe(lu(t), cu(t));
}
function fh(e, t) {
  return Re(e).pipe(lu(t), cu(t));
}
function dh(e, t) {
  return new ee(function(n) {
    var r = 0;
    return t.schedule(function() {
      r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
    });
  });
}
function ph(e, t) {
  return new ee(function(n) {
    var r;
    return Se(n, t, function() {
      r = e[iu](), Se(n, t, function() {
        var i, s, o;
        try {
          i = r.next(), s = i.value, o = i.done;
        } catch (u) {
          n.error(u);
          return;
        }
        o ? n.complete() : n.next(s);
      }, 0, !0);
    }), function() {
      return W(r?.return) && r.return();
    };
  });
}
function hu(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new ee(function(n) {
    Se(n, t, function() {
      var r = e[Symbol.asyncIterator]();
      Se(n, t, function() {
        r.next().then(function(i) {
          i.done ? n.complete() : n.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function mh(e, t) {
  return hu(ou(e), t);
}
function Dh(e, t) {
  if (e != null) {
    if (tu(e))
      return hh(e, t);
    if (Yo(e))
      return dh(e, t);
    if (eu(e))
      return fh(e, t);
    if (nu(e))
      return hu(e, t);
    if (su(e))
      return ph(e, t);
    if (uu(e))
      return mh(e, t);
  }
  throw ru(e);
}
function gh(e, t) {
  return t ? Dh(e, t) : Re(e);
}
function pi(e, t) {
  return Qe(function(n, r) {
    var i = 0;
    n.subscribe(Ce(r, function(s) {
      r.next(e.call(t, s, i++));
    }));
  });
}
function yh(e, t, n, r, i, s, o, u) {
  var a = [], c = 0, l = 0, f = !1, d = function() {
    f && !a.length && !c && t.complete();
  }, h = function(m) {
    return c < r ? p(m) : a.push(m);
  }, p = function(m) {
    s && t.next(m), c++;
    var D = !1;
    Re(n(m, l++)).subscribe(Ce(t, function(y) {
      i?.(y), s ? h(y) : t.next(y);
    }, function() {
      D = !0;
    }, void 0, function() {
      if (D)
        try {
          c--;
          for (var y = function() {
            var F = a.shift();
            o ? Se(t, o, function() {
              return p(F);
            }) : p(F);
          }; a.length && c < r; )
            y();
          d();
        } catch (F) {
          t.error(F);
        }
    }));
  };
  return e.subscribe(Ce(t, h, function() {
    f = !0, d();
  })), function() {
    u?.();
  };
}
function fu(e, t, n) {
  return n === void 0 && (n = 1 / 0), W(t) ? fu(function(r, i) {
    return pi(function(s, o) {
      return t(r, s, i, o);
    })(Re(e(r, i)));
  }, n) : (typeof t == "number" && (n = t), Qe(function(r, i) {
    return yh(r, i, e, n);
  }));
}
function bh(e) {
  return e === void 0 && (e = 1 / 0), fu(Qo, e);
}
function wh() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = nh(e), r = rh(e, 1 / 0), i = e;
  return i.length ? i.length === 1 ? Re(i[0]) : bh(r)(gh(i, n)) : eh;
}
var Fh = new ee(Tr);
function du(e, t) {
  return Qe(function(n, r) {
    var i = 0;
    n.subscribe(Ce(r, function(s) {
      return e.call(t, s, i++) && r.next(s);
    }));
  });
}
function pu(e) {
  return Qe(function(t, n) {
    var r = null, i = !1, s;
    r = t.subscribe(Ce(n, void 0, void 0, function(o) {
      s = Re(e(o, pu(e)(t))), r ? (r.unsubscribe(), r = null, s.subscribe(n)) : i = !0;
    })), i && (r.unsubscribe(), r = null, s.subscribe(n));
  });
}
function Eh(e, t) {
  return Qe(function(n, r) {
    var i = null, s = 0, o = !1, u = function() {
      return o && !i && r.complete();
    };
    n.subscribe(Ce(r, function(a) {
      i?.unsubscribe();
      var c = 0, l = s++;
      Re(e(a, l)).subscribe(i = Ce(r, function(f) {
        return r.next(t ? t(a, f, l, c++) : f);
      }, function() {
        i = null, u();
      }));
    }, function() {
      o = !0, u();
    }));
  });
}
function Hw() {
  return Kl(
    du((e) => !(e % 2)),
    pi((e) => e + e)
  );
}
function Xw(e) {
  return (t) => new ee((n) => {
    const r = /* @__PURE__ */ new Set();
    let i = !1;
    const s = t.subscribe({
      next(o) {
        const u = setTimeout(() => {
          n.next(o), r.delete(u), i && r.size === 0 && n.complete();
        }, e);
        r.add(u);
      },
      error(o) {
        n.error(o);
      },
      complete() {
        i = !0, r.size === 0 && n.complete();
      }
    });
    return () => {
      s.unsubscribe();
      for (const o of r)
        clearTimeout(o);
    };
  });
}
function Yw(e, t) {
  return e.pipe(Eh((n) => n ? t : Fh));
}
function eF(e, t) {
  return e.pipe(pi((n) => n[t]));
}
const vh = () => typeof window == "object" && typeof document == "object", tF = () => !vh(), nF = () => !!cn.versions.node;
function rF(e, t) {
  const n = e.split("."), r = t.split(".");
  for (let i = 0, s = n.length; i < s; i++) {
    if (r.length == i)
      return 1;
    if (n[i] != r[i])
      return n[i] > r[i] ? 1 : -1;
  }
  return n.length != r.length ? -1 : 0;
}
function mi() {
  const e = _.navigator?.userAgent?.toLowerCase();
  let t = "Unknown";
  return /iphone|ipad|ipod/i.test(e) ? t = "iOS" : /android/i.test(e) ? t = "Android" : /BlackBerry/i.test(e) ? t = "BlackBerry" : /mac/i.test(e) ? t = "macOS" : /win/i.test(e) ? t = "Windows" : /linux/i.test(e) ? t = "Linux" : /bsd/i.test(e) && (t = "BSD"), t.toLowerCase();
}
function iF(e = _.navigator?.userAgent) {
  let t = "Unknown";
  if (/iPhone|iPad|iPod/i.test(e)) {
    const n = e.match(/OS (\d+_\d+)/i);
    n && (t = n[1].replace("_", "."));
  } else if (/Android/i.test(e)) {
    const n = e.match(/Android (\d+\.\d+)/i);
    n && (t = n[1]);
  } else if (/Mac OS X/i.test(e)) {
    const n = e.match(/Mac OS X (\d+_\d+)/i);
    n && (t = n[1].replace("_", "."));
  } else if (/Windows NT/i.test(e)) {
    const n = e.match(/Windows NT (\d+\.\d+)/i);
    n && (t = n[1]);
  }
  return t.toLowerCase();
}
function Di() {
  const e = _.navigator?.userAgent?.toLowerCase();
  let t = "Unknown";
  return /opr/i.test(e) || /opera/i.test(e) ? t = "Opera" : /chrome/i.test(e) ? t = "Chrome" : /firefox/i.test(e) ? t = "Firefox" : /safari/i.test(e) ? t = "Safari" : /edge/i.test(e) ? t = "Edge" : /msie|trident/i.test(e) ? t = "IE" : /MicroMessenger/i.test(e) ? t = "Wechat" : /alipay/i.test(e) && (t = "Ali"), t.toLowerCase();
}
function sF() {
  const e = _.navigator?.userAgent;
  let t = "Unknown";
  if (/Chrome/.test(e)) {
    const n = e.match(/Chrome\/(\d+\.\d+)/);
    n && (t = n[1]);
  } else if (/Firefox/.test(e)) {
    const n = e.match(/Firefox\/(\d+\.\d+)/);
    n && (t = n[1]);
  } else if (/Safari/.test(e)) {
    const n = e.match(/Version\/(\d+\.\d+)/);
    n && (t = n[1]);
  } else if (/Edge/.test(e)) {
    const n = e.match(/Edge\/(\d+\.\d+)/);
    n && (t = n[1]);
  } else if (/MSIE|Trident/.test(e)) {
    const n = e.match(/(?:MSIE|rv:)(\d+\.\d+)/);
    n && (t = n[1]);
  }
  return t;
}
function oF() {
  return (_.navigator?.browserLanguage || _.navigator?.language || "").toLowerCase();
}
function uF() {
  return _.Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone?.toLowerCase();
}
function aF() {
  return Di() == "safari";
}
function mu() {
  return mi() === "ios";
}
function _h() {
  return mi() === "macos";
}
function cF() {
  return mu() || _h();
}
function Sh() {
  return mi() === "android";
}
function lF() {
  const e = _.navigator?.appVersion;
  if (/Android/.test(e) && !/Chrome\/\d/.test(e)) {
    const t = e.match(/Safari\/(\d+.\d)/);
    return t && typeof t == "object" && t.length >= 2 ? parseFloat(t[1]) < 535.19 : !0;
  } else
    return !1;
}
function hF() {
  return mu() || Sh();
}
function Ah() {
  const e = _.navigator?.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  if (e.indexOf("Trident/") > 0) {
    const i = e.indexOf("rv:");
    return parseInt(e.substring(i + 3, e.indexOf(".", i)), 10);
  }
  const r = e.indexOf("Edge/");
  return r > 0 ? parseInt(e.substring(r + 5, e.indexOf(".", r)), 10) : -1;
}
const fF = Ah() !== -1, dF = _.document && _.document.documentMode && _.document.documentMode === 9, pF = _.document && _.document.documentMode && _.document.documentMode === 10, mF = _.document && _.document.documentMode && _.document.documentMode === 11;
function Oh() {
  return Di() === "wechat";
}
function Ch() {
  return Di() === "ali";
}
function DF() {
  return Oh() && _.navigator?.userAgent?.match(/miniprogram/i) || _.__wxjs_environment === "miniprogram";
}
function gF() {
  return Ch() && _.navigator?.userAgent?.match(/miniprogram/i);
}
const Th = (() => !!(_.Worker && _.Blob && _.Promise && _.OffscreenCanvas && _.OffscreenCanvasRenderingContext2D && _.HTMLCanvasElement && _.HTMLCanvasElement.prototype.transferControlToOffscreen && _.URL && _.URL.createObjectURL))(), yF = (() => {
  if (!_.OffscreenCanvas)
    return !1;
  const e = new OffscreenCanvas(1, 1), t = e.getContext("2d");
  if (!t)
    return !1;
  t.fillRect(0, 0, 1, 1);
  const n = e.transferToImageBitmap();
  try {
    t.createPattern(n, "no-repeat");
  } catch {
    return !1;
  }
  return !0;
})();
function bF(e, t) {
  return e.name == t.name || e.constructor.name == t.name || e instanceof t;
}
function wF(e, t) {
  return e instanceof Error && e.message === t;
}
function FF(e) {
  return e instanceof Error ? e : new Error(String(e));
}
function Rh(e) {
  return e instanceof Error ? e.message : String(e);
}
function Du(e) {
  if (e && typeof e == "object" && "code" in e && typeof e.code == "string")
    return e.code;
}
function EF(e) {
  return Du(e) === "ENOENT";
}
function vF(e) {
  const t = Du(e);
  return t === "ENOENT" || t === "EACCES" || t === "EPERM" || t === "ENOTDIR" || t === "ELOOP";
}
function _F(e) {
  if (e && typeof e == "object" && "path" in e && typeof e.path == "string")
    return e.path;
}
function SF(e, t = 5) {
  if (!(e instanceof Error))
    return String(e);
  if (!e.stack)
    return e.message;
  const n = e.stack.split(`
`), r = n[0] ?? e.message, i = n.slice(1).filter((s) => s.trim().startsWith("at "));
  return i.length <= t ? e.stack : [r, ...i.slice(0, t)].join(`
`);
}
class AF extends Error {
  name;
  response;
  statusCode;
  constructor(t, n) {
    super(t), this.name = this.constructor.name, this.response = n, this.statusCode = n.status;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      response: this.response,
      statusCode: this.statusCode
    };
  }
}
class xh extends Error {
  constructor(t) {
    super(t), this.name = "AbortError";
  }
}
function OF(e) {
  return e instanceof xh || e instanceof Error && e.name === "AbortError";
}
class CF extends Error {
  constructor(t, n, r, i) {
    super("Shell command failed"), this.stdout = t, this.stderr = n, this.code = r, this.interrupted = i, this.name = "ShellError";
  }
}
function TF(e) {
  const t = Rh(e);
  if (!e || typeof e != "object" || !("isAxiosError" in e) || !e.isAxiosError)
    return { kind: "other", message: t };
  const n = e, r = n.response?.status;
  return r === 401 || r === 403 ? { kind: "auth", status: r, message: t } : n.code === "ECONNABORTED" ? { kind: "timeout", status: r, message: t } : n.code === "ECONNREFUSED" || n.code === "ENOTFOUND" ? { kind: "network", status: r, message: t } : { kind: "http", status: r, message: t };
}
class gu extends Error {
  constructor(t) {
    super(t);
  }
}
function kh(e) {
  return Ih(encodeURIComponent(e)).replaceAll("+", "*").replaceAll("/", "-").replaceAll("=", "");
}
function Nh(e) {
  let t = e.replaceAll("*", "+").replaceAll("-", "/");
  const n = t.length % 4;
  return n && (t = t.padEnd(t.length + (4 - n), "=")), decodeURIComponent(Ph(t));
}
function RF(e) {
  return kh(
    g0(p0(e))
  );
}
function xF(e) {
  return a0(
    m0(Nh(e))
  );
}
const yu = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function Ih(e) {
  const t = String(e);
  let n = "";
  for (
    let r = 0, i, s = 0, o = yu;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    t.charAt(s | 0) || (o = "=", s % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    n += o.charAt(63 & r >> 8 - s % 1 * 8)
  ) {
    if (i = t.charCodeAt(s += 3 / 4), i > 255)
      throw new gu(
        "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range."
      );
    r = r << 8 | i;
  }
  return n;
}
function Ph(e) {
  const t = String(e).replace(/[=]+$/, "");
  if (t.length % 4 === 1)
    throw new gu(
      "'atob' failed: The string to be decoded is not correctly encoded."
    );
  let n = "";
  for (
    let r = 0, i = 0, s, o = 0;
    // get next character
    s = t.charAt(o++);
    // eslint-disable-line no-cond-assign
    // character found in table? initialize bit storage and add its ascii value;
    ~s && (i = r % 4 ? i * 64 + s : s, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    r++ % 4) ? n += String.fromCharCode(255 & i >> (-2 * r & 6)) : 0
  )
    s = yu.indexOf(s);
  return n;
}
const or = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", es = 22;
function zh(e) {
  const t = BigInt(or.length), n = new Array(es).fill(or[0]);
  let r = es - 1, i = e;
  for (; i > 0n; ) {
    const s = Number(i % t);
    n[r] = or[s], i = i / t, r--;
  }
  return n.join("");
}
function kF(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    t = (t << 5) - t + e.charCodeAt(n) | 0;
  return t;
}
const Lt = _.crypto, ce = Lt?.subtle;
function Bh(e) {
  if (!Number.isInteger(e) || e < 0)
    throw new TypeError("size must be a non-negative integer");
  try {
    return Lt.randomBytes(e);
  } catch {
    const n = new Uint8Array(e);
    for (let r = 0; r < e; r++)
      n[r] = Math.floor(Math.random() * 256);
    return n;
  }
}
function NF() {
  try {
    return Lt.randomUUID();
  } catch {
    let t = (/* @__PURE__ */ new Date()).getTime();
    return "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function(r) {
        const i = (t + Math.random() * 16) % 16 | 0;
        return t = Math.floor(t / 16), (r == "x" ? i : i & 3 | 8).toString(16);
      }
    );
  }
}
function IF(e) {
  return typeof e != "string" ? !1 : /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    e
  );
}
function $h(e) {
  const t = e.replace(/-/g, "");
  if (t.length !== 32)
    throw new Error(`Invalid UUID hex length: ${t.length}`);
  return BigInt("0x" + t);
}
function PF(e, t) {
  const n = $h(t);
  return `${e}_${zh(n)}`;
}
async function zF(e = "") {
  return e ? Lh(e, {
    algorithm: zn.sha256,
    encoding: tt.hex,
    slice: 16
  }) : D0(Bh(8));
}
function BF() {
  return Math.random().toString(36).slice(2, 8);
}
async function Lh(e, t) {
  const n = t?.algorithm || zn.sha256, r = t?.encoding || tt.hex, i = t?.slice || 0;
  try {
    let s = Lt.createHash(n).update(e).digest(r);
    return i && (s = s.slice(0, i)), s;
  } catch {
    try {
      const o = await ce.digest(
        n,
        ei(e)
      );
      let u = yo(o);
      return i && (u = u.slice(0, i)), u;
    } catch {
      return i ? e.slice(0, i) : e;
    }
  }
}
function Mh(e, t) {
  return JSON.stringify(k0(e));
}
async function $F(e, t = zn["AES-GCM"]) {
  if (!ce)
    throw new Error("Crypto API not supported");
  const n = Lt.getRandomValues(new Uint8Array(12)), r = await ce.generateKey(
    { name: t, length: 256 },
    !1,
    // defines key as extractable, use false b/c we do not need to store it
    ["encrypt", "decrypt"]
  ), i = await ce.encrypt(
    { name: t, iv: n },
    r,
    ei(e)
  );
  return { algorithm: t, iv: n, key: r, encryptedData: i };
}
async function LF(e) {
  if (!ce)
    throw new Error("Crypto API not supported");
  const t = await ce.decrypt(
    {
      name: e.algorithm,
      iv: e.iv
    },
    e.key,
    e.encryptedData
  );
  return yo(t);
}
async function MF(e, t = zn.ECDSA, n = "SHA-384") {
  if (!ce)
    throw new Error("Crypto API not supported");
  const { privateKey: r, publicKey: i } = await ce.generateKey(
    {
      name: t,
      namedCurve: "P-384"
    },
    !1,
    // defines key as extractable, use false b/c we do not need to store it
    ["sign", "verify"]
  ), s = ei(
    JSON.stringify(e)
  ), o = await ce.sign(
    {
      name: t,
      hash: { name: n }
    },
    r,
    s
  );
  return {
    algorithm: t,
    hash: n,
    publicKey: i,
    signature: o,
    encodedData: s
  };
}
async function jF(e) {
  if (!ce)
    throw new Error("Crypto API not supported");
  return await ce.verify(
    {
      name: e.algorithm,
      hash: { name: e.hash }
    },
    e.publicKey,
    e.signature,
    e.encodedData
  );
}
const jh = "\uFEFF";
function bu(e) {
  return e.startsWith(jh) ? e.slice(1) : e;
}
function Uh(e) {
  try {
    return { ok: !0, value: JSON.parse(bu(e)) };
  } catch {
    return { ok: !1 };
  }
}
Ke(Uh, {
  createCache: () => new ai({ max: 50 }),
  cacheKeyResolver: (e) => e
});
function Zh(e) {
  const t = e.length;
  let n = 0;
  e[0] === 239 && e[1] === 187 && e[2] === 191 && (n = 3);
  const r = [];
  for (; n < t; ) {
    let i = e.indexOf(10, n);
    i === -1 && (i = t);
    const s = e.toString("utf8", n, i).trim();
    if (n = i + 1, !!s)
      try {
        r.push(JSON.parse(s));
      } catch {
      }
  }
  return r;
}
function qh(e) {
  const t = bu(e), n = t.length;
  let r = 0;
  const i = [];
  for (; r < n; ) {
    let s = t.indexOf(`
`, r);
    s === -1 && (s = n);
    const o = t.substring(r, s).trim();
    if (r = s + 1, !!o)
      try {
        i.push(JSON.parse(o));
      } catch {
      }
  }
  return i;
}
function UF(e) {
  return typeof e == "string" ? qh(e) : Zh(e);
}
const Wh = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED8\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])))?))?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE8A\uDE8E-\uDEC2\uDEC6\uDEC8\uDECD-\uDEDC\uDEDF-\uDEEA\uDEEF]|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g, Gh = 161, Vh = 1114109, Kh = [161, 161, 164, 164, 167, 168, 170, 170, 173, 174, 176, 180, 182, 186, 188, 191, 198, 198, 208, 208, 215, 216, 222, 225, 230, 230, 232, 234, 236, 237, 240, 240, 242, 243, 247, 250, 252, 252, 254, 254, 257, 257, 273, 273, 275, 275, 283, 283, 294, 295, 299, 299, 305, 307, 312, 312, 319, 322, 324, 324, 328, 331, 333, 333, 338, 339, 358, 359, 363, 363, 462, 462, 464, 464, 466, 466, 468, 468, 470, 470, 472, 472, 474, 474, 476, 476, 593, 593, 609, 609, 708, 708, 711, 711, 713, 715, 717, 717, 720, 720, 728, 731, 733, 733, 735, 735, 768, 879, 913, 929, 931, 937, 945, 961, 963, 969, 1025, 1025, 1040, 1103, 1105, 1105, 8208, 8208, 8211, 8214, 8216, 8217, 8220, 8221, 8224, 8226, 8228, 8231, 8240, 8240, 8242, 8243, 8245, 8245, 8251, 8251, 8254, 8254, 8308, 8308, 8319, 8319, 8321, 8324, 8364, 8364, 8451, 8451, 8453, 8453, 8457, 8457, 8467, 8467, 8470, 8470, 8481, 8482, 8486, 8486, 8491, 8491, 8531, 8532, 8539, 8542, 8544, 8555, 8560, 8569, 8585, 8585, 8592, 8601, 8632, 8633, 8658, 8658, 8660, 8660, 8679, 8679, 8704, 8704, 8706, 8707, 8711, 8712, 8715, 8715, 8719, 8719, 8721, 8721, 8725, 8725, 8730, 8730, 8733, 8736, 8739, 8739, 8741, 8741, 8743, 8748, 8750, 8750, 8756, 8759, 8764, 8765, 8776, 8776, 8780, 8780, 8786, 8786, 8800, 8801, 8804, 8807, 8810, 8811, 8814, 8815, 8834, 8835, 8838, 8839, 8853, 8853, 8857, 8857, 8869, 8869, 8895, 8895, 8978, 8978, 9312, 9449, 9451, 9547, 9552, 9587, 9600, 9615, 9618, 9621, 9632, 9633, 9635, 9641, 9650, 9651, 9654, 9655, 9660, 9661, 9664, 9665, 9670, 9672, 9675, 9675, 9678, 9681, 9698, 9701, 9711, 9711, 9733, 9734, 9737, 9737, 9742, 9743, 9756, 9756, 9758, 9758, 9792, 9792, 9794, 9794, 9824, 9825, 9827, 9829, 9831, 9834, 9836, 9837, 9839, 9839, 9886, 9887, 9919, 9919, 9926, 9933, 9935, 9939, 9941, 9953, 9955, 9955, 9960, 9961, 9963, 9969, 9972, 9972, 9974, 9977, 9979, 9980, 9982, 9983, 10045, 10045, 10102, 10111, 11094, 11097, 12872, 12879, 57344, 63743, 65024, 65039, 65533, 65533, 127232, 127242, 127248, 127277, 127280, 127337, 127344, 127373, 127375, 127376, 127387, 127404, 917760, 917999, 983040, 1048573, 1048576, 1114109], Qh = 12288, Jh = 65510, Hh = [12288, 12288, 65281, 65376, 65504, 65510], Xh = 4352, Yh = 262141, wu = [4352, 4447, 8986, 8987, 9001, 9002, 9193, 9196, 9200, 9200, 9203, 9203, 9725, 9726, 9748, 9749, 9776, 9783, 9800, 9811, 9855, 9855, 9866, 9871, 9875, 9875, 9889, 9889, 9898, 9899, 9917, 9918, 9924, 9925, 9934, 9934, 9940, 9940, 9962, 9962, 9970, 9971, 9973, 9973, 9978, 9978, 9981, 9981, 9989, 9989, 9994, 9995, 10024, 10024, 10060, 10060, 10062, 10062, 10067, 10069, 10071, 10071, 10133, 10135, 10160, 10160, 10175, 10175, 11035, 11036, 11088, 11088, 11093, 11093, 11904, 11929, 11931, 12019, 12032, 12245, 12272, 12287, 12289, 12350, 12353, 12438, 12441, 12543, 12549, 12591, 12593, 12686, 12688, 12773, 12783, 12830, 12832, 12871, 12880, 42124, 42128, 42182, 43360, 43388, 44032, 55203, 63744, 64255, 65040, 65049, 65072, 65106, 65108, 65126, 65128, 65131, 94176, 94180, 94192, 94198, 94208, 101589, 101631, 101662, 101760, 101874, 110576, 110579, 110581, 110587, 110589, 110590, 110592, 110882, 110898, 110898, 110928, 110930, 110933, 110933, 110948, 110951, 110960, 111355, 119552, 119638, 119648, 119670, 126980, 126980, 127183, 127183, 127374, 127374, 127377, 127386, 127488, 127490, 127504, 127547, 127552, 127560, 127568, 127569, 127584, 127589, 127744, 127776, 127789, 127797, 127799, 127868, 127870, 127891, 127904, 127946, 127951, 127955, 127968, 127984, 127988, 127988, 127992, 128062, 128064, 128064, 128066, 128252, 128255, 128317, 128331, 128334, 128336, 128359, 128378, 128378, 128405, 128406, 128420, 128420, 128507, 128591, 128640, 128709, 128716, 128716, 128720, 128722, 128725, 128728, 128732, 128735, 128747, 128748, 128756, 128764, 128992, 129003, 129008, 129008, 129292, 129338, 129340, 129349, 129351, 129535, 129648, 129660, 129664, 129674, 129678, 129734, 129736, 129736, 129741, 129756, 129759, 129770, 129775, 129784, 131072, 196605, 196608, 262141], gi = (e, t) => {
  let n = 0, r = Math.floor(e.length / 2) - 1;
  for (; n <= r; ) {
    const i = Math.floor((n + r) / 2), s = i * 2;
    if (t < e[s])
      r = i - 1;
    else if (t > e[s + 1])
      n = i + 1;
    else
      return !0;
  }
  return !1;
}, ts = 19968, [ef, tf] = /* @__PURE__ */ nf(wu);
function nf(e) {
  let t = e[0], n = e[1];
  for (let r = 0; r < e.length; r += 2) {
    const i = e[r], s = e[r + 1];
    if (ts >= i && ts <= s)
      return [i, s];
    s - i > n - t && (t = i, n = s);
  }
  return [t, n];
}
const rf = (e) => e < Gh || e > Vh ? !1 : gi(Kh, e), sf = (e) => e < Qh || e > Jh ? !1 : gi(Hh, e), of = (e) => e >= ef && e <= tf ? !0 : e < Xh || e > Yh ? !1 : gi(wu, e);
function uf(e) {
  if (!Number.isSafeInteger(e))
    throw new TypeError(`Expected a code point, got \`${typeof e}\`.`);
}
function ot(e, { ambiguousAsWide: t = !1 } = {}) {
  return uf(e), sf(e) || of(e) || t && rf(e) ? 2 : 1;
}
function af({ onlyFirst: e = !1 } = {}) {
  const i = "(?:\\u001B\\][\\s\\S]*?(?:\\u0007|\\u001B\\u005C|\\u009C))|[\\u001B\\u009B][[\\]()#;?]*(?:\\d{1,4}(?:[;:]\\d{0,4})*)?[\\dA-PR-TZcf-nq-uy=><~]";
  return new RegExp(i, e ? void 0 : "g");
}
const cf = af();
function yi(e) {
  if (typeof e != "string")
    throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
  return !e.includes("\x1B") && !e.includes("") ? e : e.replace(cf, "");
}
let ur = null;
function lf() {
  return ur || (ur = new Intl.Segmenter(void 0, {
    granularity: "grapheme"
  })), ur;
}
const ns = Wh();
function hf(e) {
  if (typeof e != "string" || e.length === 0)
    return 0;
  let t = !0;
  for (let r = 0; r < e.length; r++) {
    const i = e.charCodeAt(r);
    if (i >= 127 || i === 27) {
      t = !1;
      break;
    }
  }
  if (t) {
    let r = 0;
    for (let i = 0; i < e.length; i++)
      e.charCodeAt(i) > 31 && r++;
    return r;
  }
  if (e.includes("\x1B") && (e = yi(e), e.length === 0))
    return 0;
  if (!ff(e)) {
    let r = 0;
    for (const i of e) {
      const s = i.codePointAt(0);
      rs(s) || (r += ot(s, { ambiguousAsWide: !1 }));
    }
    return r;
  }
  let n = 0;
  for (const { segment: r } of lf().segment(e)) {
    if (ns.lastIndex = 0, ns.test(r)) {
      n += df(r);
      continue;
    }
    for (const i of r) {
      const s = i.codePointAt(0);
      if (!rs(s)) {
        n += ot(s, { ambiguousAsWide: !1 });
        break;
      }
    }
  }
  return n;
}
function ff(e) {
  for (const t of e) {
    const n = t.codePointAt(0);
    if (n >= 127744 && n <= 129791 || n >= 9728 && n <= 10175 || n >= 127462 && n <= 127487 || n >= 65024 && n <= 65039 || n === 8205)
      return !0;
  }
  return !1;
}
function df(e) {
  const t = e.codePointAt(0);
  if (t >= 127462 && t <= 127487) {
    let n = 0;
    for (const r of e)
      n++;
    return n === 1 ? 1 : 2;
  }
  return e.length === 2 && e.codePointAt(1) === 65039 && (t >= 48 && t <= 57 || t === 35 || t === 42) ? 1 : 2;
}
function rs(e) {
  if (e >= 32 && e < 127)
    return !1;
  if (e >= 160 && e < 768)
    return e === 173;
  if (e <= 31 || e >= 127 && e <= 159 || e >= 8203 && e <= 8205 || // ZW space/joiner
  e === 65279 || // BOM
  e >= 8288 && e <= 8292 || e >= 65024 && e <= 65039 || e >= 917760 && e <= 917999 || e >= 768 && e <= 879 || e >= 6832 && e <= 6911 || e >= 7616 && e <= 7679 || e >= 8400 && e <= 8447 || e >= 65056 && e <= 65071)
    return !0;
  if (e >= 2304 && e <= 3407) {
    const t = e & 127;
    if (t <= 3 || t >= 58 && t <= 79 || t >= 81 && t <= 87 || t >= 98 && t <= 99)
      return !0;
  }
  return e === 3633 || // Thai MAI HAN-AKAT
  e >= 3636 && e <= 3642 || // Thai vowel signs (skip U+0E32, U+0E33)
  e >= 3655 && e <= 3662 || // Thai vowel signs and marks
  e === 3761 || // Lao MAI KAN
  e >= 3764 && e <= 3772 || // Lao vowel signs (skip U+0EB2, U+0EB3)
  e >= 3784 && e <= 3789 || e >= 1536 && e <= 1541 || e === 1757 || e === 1807 || e === 2274 || e >= 55296 && e <= 57343 || e >= 917504 && e <= 917631;
}
const ZF = hf, pf = new Intl.Segmenter(), Fu = /^(?:\p{Default_Ignorable_Code_Point}|\p{Control}|\p{Format}|\p{Mark}|\p{Surrogate})+$/v, mf = /^[\p{Default_Ignorable_Code_Point}\p{Control}\p{Format}\p{Mark}\p{Surrogate}]+/v, Df = /^\p{RGI_Emoji}$/v, gf = /^[\d#*]\u20E3$/, yf = /\p{Extended_Pictographic}/gu;
function bf(e) {
  if (e.length > 50)
    return !1;
  if (gf.test(e))
    return !0;
  if (e.includes("‍")) {
    const t = e.match(yf);
    return t !== null && t.length >= 2;
  }
  return !1;
}
function wf(e) {
  return e.replace(mf, "");
}
function Ff(e) {
  return Fu.test(e);
}
function Eu(e) {
  return e >= 4352 && e <= 4447 || e >= 43360 && e <= 43388;
}
function vu(e) {
  return e >= 4448 && e <= 4519 || e >= 55216 && e <= 55238;
}
function _u(e) {
  return e >= 4520 && e <= 4607 || e >= 55243 && e <= 55291;
}
function Ef(e) {
  return Eu(e) || vu(e) || _u(e);
}
function vf(e, t) {
  const n = [];
  for (const i of e)
    Fu.test(i) || n.push(i.codePointAt(0));
  if (n.length === 0)
    return;
  let r = 0;
  for (let i = 0; i < n.length; i++) {
    const s = n[i];
    if (!Ef(s)) {
      if (r === 0)
        return;
      for (let o = i; o < n.length; o++)
        r += ot(n[o], t);
      return r;
    }
    if (Eu(s) && vu(n[i + 1])) {
      r += 2, i += _u(n[i + 2]) ? 2 : 1;
      continue;
    }
    r += ot(s, t);
  }
  return r;
}
function _f(e, t) {
  let n = 0, r = !0;
  for (const i of e) {
    if (r) {
      r = !1;
      continue;
    }
    i >= "＀" && i <= "￯" && (n += ot(i.codePointAt(0), t));
  }
  return n;
}
function ut(e, t = {}) {
  if (typeof e != "string" || e.length === 0)
    return 0;
  const {
    ambiguousIsNarrow: n = !0,
    countAnsiEscapeCodes: r = !1
  } = t;
  let i = e;
  if (!r && (i.includes("\x1B") || i.includes("")) && (i = yi(i)), i.length === 0)
    return 0;
  if (/^[\u0020-\u007E]*$/.test(i))
    return i.length;
  let s = 0;
  const o = { ambiguousAsWide: !n };
  for (const { segment: u } of pf.segment(i)) {
    if (Ff(u))
      continue;
    if (Df.test(u) || bf(u)) {
      s += 2;
      continue;
    }
    const a = wf(u), c = vf(a, o);
    if (c !== void 0) {
      s += c;
      continue;
    }
    const l = a.codePointAt(0);
    s += ot(l, o), s += _f(a, o);
  }
  return s;
}
const ar = 10, is = (e = 0) => (t) => `\x1B[${t + e}m`, ss = (e = 0) => (t) => `\x1B[${38 + e};5;${t}m`, os = (e = 0) => (t, n, r) => `\x1B[${38 + e};2;${t};${n};${r}m`, z = {
  modifier: {
    reset: [0, 0],
    // 21 isn't widely supported and 22 does the same thing
    bold: [1, 22],
    dim: [2, 22],
    italic: [3, 23],
    underline: [4, 24],
    overline: [53, 55],
    inverse: [7, 27],
    hidden: [8, 28],
    strikethrough: [9, 29]
  },
  color: {
    black: [30, 39],
    red: [31, 39],
    green: [32, 39],
    yellow: [33, 39],
    blue: [34, 39],
    magenta: [35, 39],
    cyan: [36, 39],
    white: [37, 39],
    // Bright color
    blackBright: [90, 39],
    gray: [90, 39],
    // Alias of `blackBright`
    grey: [90, 39],
    // Alias of `blackBright`
    redBright: [91, 39],
    greenBright: [92, 39],
    yellowBright: [93, 39],
    blueBright: [94, 39],
    magentaBright: [95, 39],
    cyanBright: [96, 39],
    whiteBright: [97, 39]
  },
  bgColor: {
    bgBlack: [40, 49],
    bgRed: [41, 49],
    bgGreen: [42, 49],
    bgYellow: [43, 49],
    bgBlue: [44, 49],
    bgMagenta: [45, 49],
    bgCyan: [46, 49],
    bgWhite: [47, 49],
    // Bright color
    bgBlackBright: [100, 49],
    bgGray: [100, 49],
    // Alias of `bgBlackBright`
    bgGrey: [100, 49],
    // Alias of `bgBlackBright`
    bgRedBright: [101, 49],
    bgGreenBright: [102, 49],
    bgYellowBright: [103, 49],
    bgBlueBright: [104, 49],
    bgMagentaBright: [105, 49],
    bgCyanBright: [106, 49],
    bgWhiteBright: [107, 49]
  }
};
Object.keys(z.modifier);
const Sf = Object.keys(z.color), Af = Object.keys(z.bgColor);
[...Sf, ...Af];
function Of() {
  const e = /* @__PURE__ */ new Map();
  for (const [t, n] of Object.entries(z)) {
    for (const [r, i] of Object.entries(n))
      z[r] = {
        open: `\x1B[${i[0]}m`,
        close: `\x1B[${i[1]}m`
      }, n[r] = z[r], e.set(i[0], i[1]);
    Object.defineProperty(z, t, {
      value: n,
      enumerable: !1
    });
  }
  return Object.defineProperty(z, "codes", {
    value: e,
    enumerable: !1
  }), z.color.close = "\x1B[39m", z.bgColor.close = "\x1B[49m", z.color.ansi = is(), z.color.ansi256 = ss(), z.color.ansi16m = os(), z.bgColor.ansi = is(ar), z.bgColor.ansi256 = ss(ar), z.bgColor.ansi16m = os(ar), Object.defineProperties(z, {
    rgbToAnsi256: {
      value(t, n, r) {
        return t === n && n === r ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
      },
      enumerable: !1
    },
    hexToRgb: {
      value(t) {
        const n = /[a-f\d]{6}|[a-f\d]{3}/i.exec(t.toString(16));
        if (!n)
          return [0, 0, 0];
        let [r] = n;
        r.length === 3 && (r = [...r].map((s) => s + s).join(""));
        const i = Number.parseInt(r, 16);
        return [
          /* eslint-disable no-bitwise */
          i >> 16 & 255,
          i >> 8 & 255,
          i & 255
          /* eslint-enable no-bitwise */
        ];
      },
      enumerable: !1
    },
    hexToAnsi256: {
      value: (t) => z.rgbToAnsi256(...z.hexToRgb(t)),
      enumerable: !1
    },
    ansi256ToAnsi: {
      value(t) {
        if (t < 8)
          return 30 + t;
        if (t < 16)
          return 90 + (t - 8);
        let n, r, i;
        if (t >= 232)
          n = ((t - 232) * 10 + 8) / 255, r = n, i = n;
        else {
          t -= 16;
          const u = t % 36;
          n = Math.floor(t / 36) / 5, r = Math.floor(u / 6) / 5, i = u % 6 / 5;
        }
        const s = Math.max(n, r, i) * 2;
        if (s === 0)
          return 30;
        let o = 30 + (Math.round(i) << 2 | Math.round(r) << 1 | Math.round(n));
        return s === 2 && (o += 60), o;
      },
      enumerable: !1
    },
    rgbToAnsi: {
      value: (t, n, r) => z.ansi256ToAnsi(z.rgbToAnsi256(t, n, r)),
      enumerable: !1
    },
    hexToAnsi: {
      value: (t) => z.ansi256ToAnsi(z.hexToAnsi256(t)),
      enumerable: !1
    }
  }), z;
}
const Su = Of(), Me = "\x1B", bi = "", Cf = /* @__PURE__ */ new Set([
  Me,
  bi
]), Au = "\x07", Ou = "[", Tf = "]", Ln = "m", Mn = 0, Cu = 39, Tu = 49, Ru = 59, xu = 38, ku = 48, Nu = 58, Rf = 5, xf = 2, gn = `${Tf}8;;`, Iu = new RegExp(`^\\u001B(?:\\${Ou}(?<sgr>[0-9;]*)${Ln}|${gn}(?<uri>[^\\u0007\\u001B]*)(?:\\u0007|\\u001B\\\\))`), Pu = new RegExp(`^\\u009B(?<sgr>[0-9;]*)${Ln}`), zu = new Set(Su.codes.values());
zu.delete(Mn);
const kf = new Intl.Segmenter(), Bu = (e) => Array.from(kf.segment(e), ({ segment: t }) => t), us = 8, $u = (e) => `${Me}${Ou}${e}${Ln}`, as = (e) => `${Me}${gn}${e}${Au}`, Lu = (e) => {
  const t = e.split(";").map((r) => r === "" ? Mn : Number.parseInt(r, 10)), n = [];
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    if (Number.isFinite(i)) {
      if (i === xu || i === ku || i === Nu) {
        if (r + 1 >= t.length)
          break;
        const s = t[r + 1];
        if (s === Rf && Number.isFinite(t[r + 2])) {
          n.push([i, s, t[r + 2]]), r += 2;
          continue;
        }
        const o = t[r + 2], u = t[r + 3], a = t[r + 4];
        if (s === xf && Number.isFinite(o) && Number.isFinite(u) && Number.isFinite(a)) {
          n.push([i, s, o, u, a]), r += 4;
          continue;
        }
        break;
      }
      n.push([i]);
    }
  }
  return n;
}, nn = (e, t) => {
  const n = e.findIndex((r) => r.family === t);
  n !== -1 && e.splice(n, 1);
}, cs = (e, t) => {
  nn(e, t.family), e.push(t);
}, Nf = (e, t) => {
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.family.startsWith("modifier-") && r.close === t && e.splice(n, 1);
  }
}, If = (e, t) => {
  if (e >= 30 && e <= 37 || e >= 90 && e <= 97 || e === xu && t.length > 1)
    return {
      family: "foreground",
      open: t.join(";"),
      close: Cu
    };
  if (e >= 40 && e <= 47 || e >= 100 && e <= 107 || e === ku && t.length > 1)
    return {
      family: "background",
      open: t.join(";"),
      close: Tu
    };
  if (e === Nu && t.length > 1)
    return {
      family: "underlineColor",
      open: t.join(";"),
      close: Ru
    };
}, Mu = (e, t) => e === Mn ? (t.length = 0, !0) : e === Cu ? (nn(t, "foreground"), !0) : e === Tu ? (nn(t, "background"), !0) : e === Ru ? (nn(t, "underlineColor"), !0) : zu.has(e) ? (Nf(t, e), !0) : !1, Pf = (e, t) => {
  const [n] = e;
  if (Mu(n, t))
    return;
  const r = If(n, e);
  if (r) {
    cs(t, r);
    return;
  }
  const i = Su.codes.get(n);
  i !== void 0 && i !== Mn && cs(t, {
    family: `modifier-${n}`,
    open: e.join(";"),
    close: i
  });
}, ls = (e, t) => {
  for (const n of Lu(e))
    Pf(n, t);
}, hs = (e, t) => {
  for (const n of Lu(e)) {
    const [r] = n;
    Mu(r, t);
  }
}, zf = (e, t) => {
  let n = e;
  for (; n.length > 0; ) {
    if (n.startsWith(Me) && n[1] !== "\\") {
      const r = Iu.exec(n);
      if (!r)
        break;
      r.groups.sgr !== void 0 && hs(r.groups.sgr, t), n = n.slice(r[0].length);
      continue;
    }
    if (n.startsWith(bi)) {
      const r = Pu.exec(n);
      if (!r || r.groups.sgr === void 0)
        break;
      hs(r.groups.sgr, t), n = n.slice(r[0].length);
      continue;
    }
    break;
  }
}, Bf = (e) => [...e].reverse().map((t) => $u(t.close)).join(""), $f = (e) => e.map((t) => $u(t.open)).join(""), Lf = (e) => e.split(" ").map((t) => ut(t)), cr = (e, t, n) => {
  const r = Bu(t);
  let i = !1, s = !1, o = ut(yi(e.at(-1)));
  for (const [u, a] of r.entries()) {
    const c = ut(a);
    if (o + c <= n ? e[e.length - 1] += a : (e.push(a), o = 0), Cf.has(a) && !(s && a === Me && r[u + 1] === "\\") && (i = !0, s = r.slice(u + 1, u + 1 + gn.length).join("") === gn), i) {
      s ? (a === Au || a === "\\" && u > 0 && r[u - 1] === Me) && (i = !1, s = !1) : a === Ln && (i = !1);
      continue;
    }
    o += c, o === n && u < r.length - 1 && (e.push(""), o = 0);
  }
  !o && e.at(-1).length > 0 && e.length > 1 && (e[e.length - 2] += e.pop());
}, Mf = (e) => {
  const t = e.split(" ");
  let n = t.length;
  for (; n > 0 && !(ut(t[n - 1]) > 0); )
    n--;
  return n === t.length ? e : t.slice(0, n).join(" ") + t.slice(n).join("");
}, jf = (e) => {
  if (!e.includes("	"))
    return e;
  const t = e.split("	");
  let n = 0, r = "";
  for (const [i, s] of t.entries())
    if (r += s, n += ut(s), i < t.length - 1) {
      const o = us - n % us;
      r += " ".repeat(o), n += o;
    }
  return r;
}, Uf = (e, t, n = {}) => {
  if (n.trim !== !1 && e.trim() === "")
    return "";
  let r = "", i;
  const s = [], o = Lf(e);
  let u = [""];
  for (const [f, d] of e.split(" ").entries()) {
    n.trim !== !1 && (u[u.length - 1] = u.at(-1).trimStart());
    let h = ut(u.at(-1));
    if (f !== 0 && (h >= t && (n.wordWrap === !1 || n.trim === !1) && (u.push(""), h = 0), (h > 0 || n.trim === !1) && (u[u.length - 1] += " ", h++)), n.hard && n.wordWrap !== !1 && o[f] > t) {
      const p = t - h, m = 1 + Math.floor((o[f] - p - 1) / t);
      Math.floor((o[f] - 1) / t) < m && u.push(""), cr(u, d, t);
      continue;
    }
    if (h + o[f] > t && h > 0 && o[f] > 0) {
      if (n.wordWrap === !1 && h < t) {
        cr(u, d, t);
        continue;
      }
      u.push("");
    }
    if (h + o[f] > t && n.wordWrap === !1) {
      cr(u, d, t);
      continue;
    }
    u[u.length - 1] += d;
  }
  n.trim !== !1 && (u = u.map((f) => Mf(f)));
  const a = u.join(`
`), c = Bu(a);
  let l = 0;
  for (const [f, d] of c.entries()) {
    if (r += d, d === Me && c[f + 1] !== "\\") {
      const { groups: h } = Iu.exec(a.slice(l)) || { groups: {} };
      h.sgr !== void 0 ? ls(h.sgr, s) : h.uri !== void 0 && (i = h.uri.length === 0 ? void 0 : h.uri);
    } else if (d === bi) {
      const { groups: h } = Pu.exec(a.slice(l)) || { groups: {} };
      h.sgr !== void 0 && ls(h.sgr, s);
    }
    if (c[f + 1] === `
`)
      i && (r += as("")), r += Bf(s);
    else if (d === `
`) {
      const h = [...s];
      zf(a.slice(l + 1), h), r += $f(h), i && (r += as(i));
    }
    l += d.length;
  }
  return r;
};
function qF(e, t, n) {
  return String(e).normalize().replaceAll(`\r
`, `
`).split(`
`).map((r) => Uf(jf(r), t, n)).join(`
`);
}
class Ye {
  data = {
    r: 0,
    // 0 ~ 255
    g: 0,
    // 0 ~ 255
    b: 0,
    // 0 ~ 255
    a: 1,
    // 0 ~ 1
    brightness: 0
    // 0 ~ 1
  };
  constructor(t, n) {
    t && (this.color = t), this.setAlpha(n);
  }
  get color() {
    return this.data;
  }
  // parse color
  set color(t) {
    const n = `Color Set Unknown Error: color(${t}) type(${typeof t})`;
    if (t instanceof Ye)
      this.setRGB(t.r, t.g, t.b, t.a);
    else if (typeof t == "number")
      this.setHEX(t);
    else if (typeof t == "string") {
      let r;
      if (r = /^(\w+)\(([^)]*)\)/.exec(t)) {
        const i = r[2];
        let s;
        switch (r[1]) {
          case "rgb":
          case "rgba":
            (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
              i
            )) ? (this.r = parseInt(s[1], 10), this.g = parseInt(s[2], 10), this.b = parseInt(s[3], 10), this.a = s[4] ? parseFloat(s[4]) : 1) : (s = /^\s*(\d+)%\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
              i
            )) ? (this.r = N(parseFloat(s[1]), 0, 100) * 255 / 100, this.g = N(parseFloat(s[2]), 0, 100) * 255 / 100, this.b = N(parseFloat(s[3]), 0, 100) * 255 / 100, this.a = s[4] ? parseFloat(s[4]) : 1) : _e(n);
            break;
          case "hsl":
          case "hsla":
            (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)%\s*,\s*(\d*\.?\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
              i
            )) ? this.setHSL(
              parseFloat(s[1]) / 360,
              parseFloat(s[2]) / 100,
              parseFloat(s[3]) / 100,
              s[4] ? parseFloat(s[4]) : 1
            ) : _e(n);
            break;
          case "hsv":
          case "hsva":
          case "hsb":
          case "hsba":
            (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)%\s*,\s*(\d*\.?\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
              i
            )) ? this.setHSV(
              parseFloat(s[1]) / 360,
              parseFloat(s[2]) / 100,
              parseFloat(s[3]) / 100,
              s[4] ? parseFloat(s[4]) : 1
            ) : _e(n);
            break;
          default:
            _e(n);
        }
      } else if (r = /#([A-Fa-f0-9]+)/.exec(t)) {
        const i = r[1], s = i.length;
        s === 3 ? this.setRGB(
          parseInt(i.charAt(0), 16),
          parseInt(i.charAt(1), 16),
          parseInt(i.charAt(2), 16),
          1
        ) : s === 4 ? this.setRGB(
          parseInt(i.charAt(0), 16),
          parseInt(i.charAt(1), 16),
          parseInt(i.charAt(2), 16),
          N(parseInt(i.charAt(3), 16) / 16, 0, 1)
        ) : s === 6 || s === 8 ? this.setHEX(parseInt(i, 16)) : _e(n);
      } else
        _e(n);
    } else
      Object.prototype.hasOwnProperty.call(t, "r") && Object.prototype.hasOwnProperty.call(t, "g") && Object.prototype.hasOwnProperty.call(t, "b") ? this.setRGB(
        t.r,
        t.g,
        t.b,
        Object.prototype.hasOwnProperty.call(t, "a") ? t.a : 1
      ) : Object.prototype.hasOwnProperty.call(t, "h") && Object.prototype.hasOwnProperty.call(t, "s") && Object.prototype.hasOwnProperty.call(t, "l") ? this.setHSL(
        t.h,
        t.s,
        t.l,
        Object.prototype.hasOwnProperty.call(t, "a") ? t.a : 1
      ) : Object.prototype.hasOwnProperty.call(t, "h") && Object.prototype.hasOwnProperty.call(t, "s") && Object.prototype.hasOwnProperty.call(t, "v") ? this.setHSV(
        t.h,
        t.s,
        t.v,
        Object.prototype.hasOwnProperty.call(t, "a") ? t.a : 1
      ) : Object.prototype.hasOwnProperty.call(t, "h") && Object.prototype.hasOwnProperty.call(t, "s") && Object.prototype.hasOwnProperty.call(t, "b") ? this.setHSV(
        t.h,
        t.s,
        t.b,
        Object.prototype.hasOwnProperty.call(t, "a") ? t.a : 1
      ) : _e(n);
    this.data.brightness = Zf(this.r, this.g, this.b);
  }
  set(t) {
    return this.color = t, this;
  }
  get r() {
    return this.data.r;
  }
  set r(t) {
    this.data.r = N(Math.round(X(t, this.r)), 0, 255);
  }
  get g() {
    return this.data.g;
  }
  set g(t) {
    this.data.g = N(Math.round(X(t, this.g)), 0, 255);
  }
  get b() {
    return this.data.b;
  }
  set b(t) {
    this.data.b = N(Math.round(X(t, this.b)), 0, 255);
  }
  get a() {
    return this.data.a;
  }
  set a(t) {
    this.data.a = N(X(t, this.a), 0, 1);
  }
  setAlpha(t) {
    return this.a = t, this;
  }
  get brightness() {
    return this.data.brightness;
  }
  fromArray(t, n = 0) {
    return this.r = t[n], this.g = t[n + 1], this.b = t[n + 2], this.a = t[n + 3], this;
  }
  toArray(t = [], n = 0) {
    return t[n] = this.r, t[n + 1] = this.g, t[n + 2] = this.b, t[n + 3] = this.a, t;
  }
  toRGBString() {
    return this.a === 1 ? `rgb(${this.r},${this.g},${this.b})` : `rgba(${this.r},${this.g},${this.b},${Fe(this.a, 6)})`;
  }
  toHexString() {
    return this.a === 1 ? ("000000" + this.hex.toString(16)).slice(-6) : ("00000000" + this.hex.toString(16)).slice(-8);
  }
  toString() {
    return this.a === 1 ? "#" + this.toHexString() : this.toRGBString();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b, yield this.a;
  }
  clone() {
    return new Ye(this.color);
  }
  copy(t) {
    return this.color = t.color, this;
  }
  equals(t) {
    return t.r === this.r && t.g === this.g && t.b === this.b && t.a === this.a;
  }
  add(t) {
    return this.r = this.r + t.r, this.g = this.g + t.g, this.b = this.b + t.b, this;
  }
  addColors(t, n) {
    return this.r = t.r + n.r, this.g = t.g + n.g, this.b = t.b + n.b, this;
  }
  addScalar(t) {
    return this.r = this.r + t, this.g = this.g + t, this.b = this.b + t, this;
  }
  setScalar(t) {
    return this.r = t, this.g = t, this.b = t, this;
  }
  sub(t) {
    return this.r = this.r - t.r, this.g = this.g - t.g, this.b = this.b - t.b, this;
  }
  multiply(t) {
    return this.r = this.r * t.r, this.g = this.g * t.g, this.b = this.b * t.b, this;
  }
  multiplyScalar(t) {
    return this.r = this.r * t, this.g = this.g * t, this.b = this.b * t, this;
  }
  opposite(t = !0, n = "#000000", r = "#ffffff") {
    if (t)
      return this.color = this.r * 0.299 + this.g * 0.587 + this.b * 0.114 > 186 ? n : r, this;
    {
      const { r: i, g: s, b: o } = this.color;
      return this.r = 255 - i, this.g = 255 - s, this.b = 255 - o, this;
    }
  }
  closet(t = "#000000", n = "#ffffff") {
    return this.opposite(!0, t, n).opposite(
      !0,
      t,
      n
    );
  }
  // t: 0 ~ 1
  lighten(t) {
    t = N(t, 0, 1);
    const { r: n, g: r, b: i, a: s } = this.color;
    return s == 0 ? this.a = t : (this.r = n + (255 - n) * t, this.g = r + (255 - r) * t, this.b = i + (255 - i) * t), this;
  }
  // t: 0 ~ 1
  darken(t) {
    t = N(t, 0, 1);
    const { r: n, g: r, b: i, a: s } = this.color;
    return s == 0 ? this.a = t : (this.r = n * (1 - t), this.g = r * (1 - t), this.b = i * (1 - t)), this;
  }
  // 渐变色
  // t: 0 ~ 1
  lerp(t, n) {
    n = N(n, 0, 1);
    const { r, g: i, b: s } = this.color;
    return this.r = r + (t.r - r) * n, this.g = i + (t.g - i) * n, this.b = s + (t.b - s) * n, this;
  }
  // 渐变色
  // t: 0 ~ 1
  lerpColors(t, n, r) {
    return r = N(r, 0, 1), this.r = t.r + (n.r - t.r) * r, this.g = t.g + (n.g - t.g) * r, this.b = t.b + (n.b - t.b) * r, this;
  }
  // 渐变色
  // t: 0 ~ 1
  static gradient(t, n, r) {
    try {
      return fs.lerpColors(new Ye(t), new Ye(n), r).toString();
    } catch {
      return n;
    }
  }
  static random() {
    return fs.setHEX(Math.random() * 16777215).toString();
  }
  setRGB(t, n, r, i = 1) {
    return this.r = N(t, 0, 255), this.g = N(n, 0, 255), this.b = N(r, 0, 255), this.a = N(i, 0, 1), this;
  }
  // RRGGBB(AA)
  setHEX(t) {
    return t = Math.floor(t), t < 16777216 ? (this.r = t >> 16 & 255, this.g = t >> 8 & 255, this.b = t & 255, this.a = 1) : (this.r = t >> 24 & 255, this.g = t >> 16 & 255, this.b = t >> 8 & 255, this.a = (t & 255) / 255), this;
  }
  get hex() {
    let t = (this.r << 16) + (this.g << 8) + this.b;
    return this.a !== 1 && (t = t << 8, t += Math.round(this.a * 255)), t;
  }
  // hsl(a) : hue 色相 + saturation 饱和度 + lightness luminosity 亮度
  // h,s,l ranges are in 0.0 ~ 1.0
  setHSL(t, n, r, i = 1) {
    const s = Q0(t, 1), o = N(n, 0, 1), u = N(r, 0, 1);
    if (o === 0)
      this.r = u * 255, this.g = u * 255, this.b = u * 255;
    else {
      const a = u <= 0.5 ? u * (1 + o) : u + o - u * o, c = 2 * u - a;
      this.r = lr(c, a, s + 1 / 3) * 255, this.g = lr(c, a, s) * 255, this.b = lr(c, a, s - 1 / 3) * 255;
    }
    return this.a = i, this;
  }
  getHSL(t) {
    const n = this.r, r = this.g, i = this.b, s = Math.max(n, r, i) / 255, o = Math.min(n, r, i) / 255;
    let u, a;
    const c = (o + s) / 2;
    if (o === s)
      u = 0, a = 0;
    else {
      const l = s - o;
      switch (a = c <= 0.5 ? l / (s + o) : l / (2 - s - o), s) {
        case n:
          u = (r - i) / l + (r < i ? 6 : 0);
          break;
        case r:
          u = (i - n) / l + 2;
          break;
        case i:
        default:
          u = (n - r) / l + 4;
          break;
      }
      u /= 6;
    }
    return t && t.setHSL(u, a, c, this.a), {
      h: u,
      s: a,
      l: c,
      a: this.a
    };
  }
  offsetHSL(t, n, r) {
    const i = this.getHSL();
    return this.setHSL(i.h + t, i.s + n, i.l + r);
  }
  lerpHSL(t, n) {
    const r = this.getHSL(), i = t.getHSL(), s = Xt(r.h, i.h, n), o = Xt(r.s, i.s, n), u = Xt(r.l, i.l, n);
    return this.setHSL(s, o, u), this;
  }
  // hsv(a) / hsb(a) : hue 色相 + saturation 饱和度 + value or brightness 明度
  // h,s,v ranges are in 0.0 ~ 1.0
  setHSV(t, n, r, i = 1) {
    const s = N(t, 0, 1) * 360, o = N(n, 0, 1), u = N(r, 0, 1), a = Math.floor(s / 60) % 6, c = s / 60 - Math.floor(s / 60), l = u * (1 - o), f = u * (1 - c * o), d = u * (1 - (1 - c) * o), h = [
      [u, d, l],
      [f, u, l],
      [l, u, d],
      [l, f, u],
      [d, l, u],
      [u, l, f]
    ][a];
    return this.r = h[0] * 255, this.g = h[1] * 255, this.b = h[2] * 255, this.a = i, this;
  }
  setHSB(t, n, r, i = 1) {
    this.setHSV(t, n, r, i);
  }
  getHSV(t) {
    const { r: n, g: r, b: i, a: s } = this.color, o = Math.max(n, r, i), u = Math.min(n, r, i), a = o - u;
    let c;
    n === o ? c = (r - i) / a : r === o ? c = 2 + (i - n) / a : c = 4 + (n - r) / a, c /= 6, c < 0 && (c += 1);
    const l = a == 0 ? 0 : c, f = o === 0 ? 0 : a / o, d = o / 255;
    return t && t.setHSV(l, f, d, s), {
      h: l,
      s: f,
      v: d,
      a: s
    };
  }
  getHSB(t) {
    const { h: n, s: r, v: i, a: s } = this.getHSV(t);
    return {
      h: n,
      s: r,
      b: i,
      a: s
    };
  }
}
const fs = new Ye();
function lr(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * 6 * (2 / 3 - n) : e;
}
function Zf(e, t, n) {
  return 0.2126 * e + 0.7152 * t + 0.0722 * n;
}
function qf(e) {
  const t = String(e).toLowerCase();
  if (t.indexOf("km") >= 0 || t.indexOf("m") >= 0)
    return t;
  const n = parseFloat(t);
  return !It(n) || n < 0 ? "" : n >= 1e3 ? Math.ceil(n / 1e3 * 10) / 10 + "km" : Math.ceil(n) + "m";
}
function wi(e, t = 2) {
  return xo(e / 100, t);
}
function Wf(e, t = 2) {
  return String(Number(wi(e, t)));
}
function WF(e) {
  const t = e / 1024;
  if (t < 1)
    return `${e} bytes`;
  if (t < 1024)
    return `${t.toFixed(1).replace(/\.0$/, "")}KB`;
  const n = t / 1024;
  return n < 1024 ? `${n.toFixed(1).replace(/\.0$/, "")}MB` : `${(n / 1024).toFixed(1).replace(/\.0$/, "")}GB`;
}
const yn = 3.141592653589793 * 3e3 / 180, G = 3.141592653589793, bn = 6378245, wn = 0.006693421622965943;
function ju(e, t) {
  return e < 72.004 || e > 137.8347 || t < 0.8293 || t > 55.8271 || !1;
}
function Uu(e, t) {
  let n = -100 + 2 * e + 3 * t + 0.2 * t * t + 0.1 * e * t + 0.2 * Math.sqrt(Math.abs(e));
  return n += (20 * Math.sin(6 * e * G) + 20 * Math.sin(2 * e * G)) * 2 / 3, n += (20 * Math.sin(t * G) + 40 * Math.sin(t / 3 * G)) * 2 / 3, n += (160 * Math.sin(t / 12 * G) + 320 * Math.sin(t * G / 30)) * 2 / 3, n;
}
function Zu(e, t) {
  let n = 300 + e + 2 * t + 0.1 * e * e + 0.1 * e * t + 0.1 * Math.sqrt(Math.abs(e));
  return n += (20 * Math.sin(6 * e * G) + 20 * Math.sin(2 * e * G)) * 2 / 3, n += (20 * Math.sin(e * G) + 40 * Math.sin(e / 3 * G)) * 2 / 3, n += (150 * Math.sin(e / 12 * G) + 300 * Math.sin(e / 30 * G)) * 2 / 3, n;
}
function Gf(e, t) {
  if (ju(e, t))
    return [e, t];
  {
    let n = Zu(e - 105, t - 35), r = Uu(e - 105, t - 35);
    const i = t / 180 * G;
    let s = Math.sin(i);
    s = 1 - wn * s * s;
    const o = Math.sqrt(s);
    n = n * 180 / (bn / o * Math.cos(i) * G), r = r * 180 / (bn * (1 - wn) / (s * o) * G);
    const u = t + r;
    return [e + n, u];
  }
}
function Vf(e, t) {
  if (ju(e, t))
    return [e, t];
  {
    let n = Uu(e - 105, t - 35), r = Zu(e - 105, t - 35);
    const i = t / 180 * G;
    let s = Math.sin(i);
    s = 1 - wn * s * s;
    const o = Math.sqrt(s);
    n = n * 180 / (bn * (1 - wn) / (s * o) * G), r = r * 180 / (bn / o * Math.cos(i) * G);
    const u = t + n, a = e + r;
    return [e * 2 - a, t * 2 - u];
  }
}
function Kf(e, t) {
  const n = Math.sqrt(e * e + t * t) + 2e-5 * Math.sin(t * yn), r = Math.atan2(t, e) + 3e-7 * Math.cos(e * yn), i = n * Math.cos(r) + 65e-4, s = n * Math.sin(r) + 6e-3;
  return [i, s];
}
function Qf(e, t) {
  const n = e - 65e-4, r = t - 6e-3, i = Math.sqrt(n * n + r * r) - 2e-5 * Math.sin(r * yn), s = Math.atan2(r, n) - 3e-6 * Math.cos(r * yn), o = i * Math.cos(s), u = i * Math.sin(s);
  return [o, u];
}
function GF(e, t) {
  const n = Gf(e, t);
  return Kf(n[0], n[1]);
}
function VF(e, t) {
  const n = Qf(e, t);
  return Vf(n[0], n[1]);
}
const Jf = {
  11e4: "北京市",
  110100: "市辖区",
  110101: "东城区",
  110102: "西城区",
  110105: "朝阳区",
  110106: "丰台区",
  110107: "石景山区",
  110108: "海淀区",
  110109: "门头沟区",
  110111: "房山区",
  110112: "通州区",
  110113: "顺义区",
  110114: "昌平区",
  110115: "大兴区",
  110116: "怀柔区",
  110117: "平谷区",
  110118: "密云区",
  110119: "延庆区",
  12e4: "天津市",
  120100: "市辖区",
  120101: "和平区",
  120102: "河东区",
  120103: "河西区",
  120104: "南开区",
  120105: "河北区",
  120106: "红桥区",
  120110: "东丽区",
  120111: "西青区",
  120112: "津南区",
  120113: "北辰区",
  120114: "武清区",
  120115: "宝坻区",
  120116: "滨海新区",
  120117: "宁河区",
  120118: "静海区",
  120119: "蓟州区",
  13e4: "河北省",
  130100: "石家庄市",
  130101: "市辖区",
  130102: "长安区",
  130104: "桥西区",
  130105: "新华区",
  130107: "井陉矿区",
  130108: "裕华区",
  130109: "藁城区",
  130110: "鹿泉区",
  130111: "栾城区",
  130121: "井陉县",
  130123: "正定县",
  130125: "行唐县",
  130126: "灵寿县",
  130127: "高邑县",
  130128: "深泽县",
  130129: "赞皇县",
  130130: "无极县",
  130131: "平山县",
  130132: "元氏县",
  130133: "赵县",
  130183: "晋州市",
  130184: "新乐市",
  130200: "唐山市",
  130201: "市辖区",
  130202: "路南区",
  130203: "路北区",
  130204: "古冶区",
  130205: "开平区",
  130207: "丰南区",
  130208: "丰润区",
  130209: "曹妃甸区",
  130223: "滦县",
  130224: "滦南县",
  130225: "乐亭县",
  130227: "迁西县",
  130229: "玉田县",
  130281: "遵化市",
  130283: "迁安市",
  130300: "秦皇岛市",
  130301: "市辖区",
  130302: "海港区",
  130303: "山海关区",
  130304: "北戴河区",
  130306: "抚宁区",
  130321: "青龙满族自治县",
  130322: "昌黎县",
  130324: "卢龙县",
  130400: "邯郸市",
  130401: "市辖区",
  130402: "邯山区",
  130403: "丛台区",
  130404: "复兴区",
  130406: "峰峰矿区",
  130421: "邯郸县",
  130423: "临漳县",
  130424: "成安县",
  130425: "大名县",
  130426: "涉县",
  130427: "磁县",
  130428: "肥乡县",
  130429: "永年县",
  130430: "邱县",
  130431: "鸡泽县",
  130432: "广平县",
  130433: "馆陶县",
  130434: "魏县",
  130435: "曲周县",
  130481: "武安市",
  130500: "邢台市",
  130501: "市辖区",
  130502: "桥东区",
  130503: "桥西区",
  130521: "邢台县",
  130522: "临城县",
  130523: "内丘县",
  130524: "柏乡县",
  130525: "隆尧县",
  130526: "任县",
  130527: "南和县",
  130528: "宁晋县",
  130529: "巨鹿县",
  130530: "新河县",
  130531: "广宗县",
  130532: "平乡县",
  130533: "威县",
  130534: "清河县",
  130535: "临西县",
  130581: "南宫市",
  130582: "沙河市",
  130600: "保定市",
  130601: "市辖区",
  130602: "竞秀区",
  130606: "莲池区",
  130607: "满城区",
  130608: "清苑区",
  130609: "徐水区",
  130623: "涞水县",
  130624: "阜平县",
  130626: "定兴县",
  130627: "唐县",
  130628: "高阳县",
  130629: "容城县",
  130630: "涞源县",
  130631: "望都县",
  130632: "安新县",
  130633: "易县",
  130634: "曲阳县",
  130635: "蠡县",
  130636: "顺平县",
  130637: "博野县",
  130638: "雄县",
  130681: "涿州市",
  130683: "安国市",
  130684: "高碑店市",
  130700: "张家口市",
  130701: "市辖区",
  130702: "桥东区",
  130703: "桥西区",
  130705: "宣化区",
  130706: "下花园区",
  130708: "万全区",
  130709: "崇礼区",
  130722: "张北县",
  130723: "康保县",
  130724: "沽源县",
  130725: "尚义县",
  130726: "蔚县",
  130727: "阳原县",
  130728: "怀安县",
  130730: "怀来县",
  130731: "涿鹿县",
  130732: "赤城县",
  130800: "承德市",
  130801: "市辖区",
  130802: "双桥区",
  130803: "双滦区",
  130804: "鹰手营子矿区",
  130821: "承德县",
  130822: "兴隆县",
  130823: "平泉县",
  130824: "滦平县",
  130825: "隆化县",
  130826: "丰宁满族自治县",
  130827: "宽城满族自治县",
  130828: "围场满族蒙古族自治县",
  130900: "沧州市",
  130901: "市辖区",
  130902: "新华区",
  130903: "运河区",
  130921: "沧县",
  130922: "青县",
  130923: "东光县",
  130924: "海兴县",
  130925: "盐山县",
  130926: "肃宁县",
  130927: "南皮县",
  130928: "吴桥县",
  130929: "献县",
  130930: "孟村回族自治县",
  130981: "泊头市",
  130982: "任丘市",
  130983: "黄骅市",
  130984: "河间市",
  131e3: "廊坊市",
  131001: "市辖区",
  131002: "安次区",
  131003: "广阳区",
  131022: "固安县",
  131023: "永清县",
  131024: "香河县",
  131025: "大城县",
  131026: "文安县",
  131028: "大厂回族自治县",
  131081: "霸州市",
  131082: "三河市",
  131100: "衡水市",
  131101: "市辖区",
  131102: "桃城区",
  131103: "冀州区",
  131121: "枣强县",
  131122: "武邑县",
  131123: "武强县",
  131124: "饶阳县",
  131125: "安平县",
  131126: "故城县",
  131127: "景县",
  131128: "阜城县",
  131182: "深州市",
  139e3: "省直辖县级行政区划",
  139001: "定州市",
  139002: "辛集市",
  14e4: "山西省",
  140100: "太原市",
  140101: "市辖区",
  140105: "小店区",
  140106: "迎泽区",
  140107: "杏花岭区",
  140108: "尖草坪区",
  140109: "万柏林区",
  140110: "晋源区",
  140121: "清徐县",
  140122: "阳曲县",
  140123: "娄烦县",
  140181: "古交市",
  140200: "大同市",
  140201: "市辖区",
  140202: "城区",
  140203: "矿区",
  140211: "南郊区",
  140212: "新荣区",
  140221: "阳高县",
  140222: "天镇县",
  140223: "广灵县",
  140224: "灵丘县",
  140225: "浑源县",
  140226: "左云县",
  140227: "大同县",
  140300: "阳泉市",
  140301: "市辖区",
  140302: "城区",
  140303: "矿区",
  140311: "郊区",
  140321: "平定县",
  140322: "盂县",
  140400: "长治市",
  140401: "市辖区",
  140402: "城区",
  140411: "郊区",
  140421: "长治县",
  140423: "襄垣县",
  140424: "屯留县",
  140425: "平顺县",
  140426: "黎城县",
  140427: "壶关县",
  140428: "长子县",
  140429: "武乡县",
  140430: "沁县",
  140431: "沁源县",
  140481: "潞城市",
  140500: "晋城市",
  140501: "市辖区",
  140502: "城区",
  140521: "沁水县",
  140522: "阳城县",
  140524: "陵川县",
  140525: "泽州县",
  140581: "高平市",
  140600: "朔州市",
  140601: "市辖区",
  140602: "朔城区",
  140603: "平鲁区",
  140621: "山阴县",
  140622: "应县",
  140623: "右玉县",
  140624: "怀仁县",
  140700: "晋中市",
  140701: "市辖区",
  140702: "榆次区",
  140721: "榆社县",
  140722: "左权县",
  140723: "和顺县",
  140724: "昔阳县",
  140725: "寿阳县",
  140726: "太谷县",
  140727: "祁县",
  140728: "平遥县",
  140729: "灵石县",
  140781: "介休市",
  140800: "运城市",
  140801: "市辖区",
  140802: "盐湖区",
  140821: "临猗县",
  140822: "万荣县",
  140823: "闻喜县",
  140824: "稷山县",
  140825: "新绛县",
  140826: "绛县",
  140827: "垣曲县",
  140828: "夏县",
  140829: "平陆县",
  140830: "芮城县",
  140881: "永济市",
  140882: "河津市",
  140900: "忻州市",
  140901: "市辖区",
  140902: "忻府区",
  140921: "定襄县",
  140922: "五台县",
  140923: "代县",
  140924: "繁峙县",
  140925: "宁武县",
  140926: "静乐县",
  140927: "神池县",
  140928: "五寨县",
  140929: "岢岚县",
  140930: "河曲县",
  140931: "保德县",
  140932: "偏关县",
  140981: "原平市",
  141e3: "临汾市",
  141001: "市辖区",
  141002: "尧都区",
  141021: "曲沃县",
  141022: "翼城县",
  141023: "襄汾县",
  141024: "洪洞县",
  141025: "古县",
  141026: "安泽县",
  141027: "浮山县",
  141028: "吉县",
  141029: "乡宁县",
  141030: "大宁县",
  141031: "隰县",
  141032: "永和县",
  141033: "蒲县",
  141034: "汾西县",
  141081: "侯马市",
  141082: "霍州市",
  141100: "吕梁市",
  141101: "市辖区",
  141102: "离石区",
  141121: "文水县",
  141122: "交城县",
  141123: "兴县",
  141124: "临县",
  141125: "柳林县",
  141126: "石楼县",
  141127: "岚县",
  141128: "方山县",
  141129: "中阳县",
  141130: "交口县",
  141181: "孝义市",
  141182: "汾阳市",
  15e4: "内蒙古自治区",
  150100: "呼和浩特市",
  150101: "市辖区",
  150102: "新城区",
  150103: "回民区",
  150104: "玉泉区",
  150105: "赛罕区",
  150121: "土默特左旗",
  150122: "托克托县",
  150123: "和林格尔县",
  150124: "清水河县",
  150125: "武川县",
  150200: "包头市",
  150201: "市辖区",
  150202: "东河区",
  150203: "昆都仑区",
  150204: "青山区",
  150205: "石拐区",
  150206: "白云鄂博矿区",
  150207: "九原区",
  150221: "土默特右旗",
  150222: "固阳县",
  150223: "达尔罕茂明安联合旗",
  150300: "乌海市",
  150301: "市辖区",
  150302: "海勃湾区",
  150303: "海南区",
  150304: "乌达区",
  150400: "赤峰市",
  150401: "市辖区",
  150402: "红山区",
  150403: "元宝山区",
  150404: "松山区",
  150421: "阿鲁科尔沁旗",
  150422: "巴林左旗",
  150423: "巴林右旗",
  150424: "林西县",
  150425: "克什克腾旗",
  150426: "翁牛特旗",
  150428: "喀喇沁旗",
  150429: "宁城县",
  150430: "敖汉旗",
  150500: "通辽市",
  150501: "市辖区",
  150502: "科尔沁区",
  150521: "科尔沁左翼中旗",
  150522: "科尔沁左翼后旗",
  150523: "开鲁县",
  150524: "库伦旗",
  150525: "奈曼旗",
  150526: "扎鲁特旗",
  150581: "霍林郭勒市",
  150600: "鄂尔多斯市",
  150601: "市辖区",
  150602: "东胜区",
  150603: "康巴什区",
  150621: "达拉特旗",
  150622: "准格尔旗",
  150623: "鄂托克前旗",
  150624: "鄂托克旗",
  150625: "杭锦旗",
  150626: "乌审旗",
  150627: "伊金霍洛旗",
  150700: "呼伦贝尔市",
  150701: "市辖区",
  150702: "海拉尔区",
  150703: "扎赉诺尔区",
  150721: "阿荣旗",
  150722: "莫力达瓦达斡尔族自治旗",
  150723: "鄂伦春自治旗",
  150724: "鄂温克族自治旗",
  150725: "陈巴尔虎旗",
  150726: "新巴尔虎左旗",
  150727: "新巴尔虎右旗",
  150781: "满洲里市",
  150782: "牙克石市",
  150783: "扎兰屯市",
  150784: "额尔古纳市",
  150785: "根河市",
  150800: "巴彦淖尔市",
  150801: "市辖区",
  150802: "临河区",
  150821: "五原县",
  150822: "磴口县",
  150823: "乌拉特前旗",
  150824: "乌拉特中旗",
  150825: "乌拉特后旗",
  150826: "杭锦后旗",
  150900: "乌兰察布市",
  150901: "市辖区",
  150902: "集宁区",
  150921: "卓资县",
  150922: "化德县",
  150923: "商都县",
  150924: "兴和县",
  150925: "凉城县",
  150926: "察哈尔右翼前旗",
  150927: "察哈尔右翼中旗",
  150928: "察哈尔右翼后旗",
  150929: "四子王旗",
  150981: "丰镇市",
  152200: "兴安盟",
  152201: "乌兰浩特市",
  152202: "阿尔山市",
  152221: "科尔沁右翼前旗",
  152222: "科尔沁右翼中旗",
  152223: "扎赉特旗",
  152224: "突泉县",
  152500: "锡林郭勒盟",
  152501: "二连浩特市",
  152502: "锡林浩特市",
  152522: "阿巴嘎旗",
  152523: "苏尼特左旗",
  152524: "苏尼特右旗",
  152525: "东乌珠穆沁旗",
  152526: "西乌珠穆沁旗",
  152527: "太仆寺旗",
  152528: "镶黄旗",
  152529: "正镶白旗",
  152530: "正蓝旗",
  152531: "多伦县",
  152900: "阿拉善盟",
  152921: "阿拉善左旗",
  152922: "阿拉善右旗",
  152923: "额济纳旗",
  21e4: "辽宁省",
  210100: "沈阳市",
  210101: "市辖区",
  210102: "和平区",
  210103: "沈河区",
  210104: "大东区",
  210105: "皇姑区",
  210106: "铁西区",
  210111: "苏家屯区",
  210112: "浑南区",
  210113: "沈北新区",
  210114: "于洪区",
  210115: "辽中区",
  210123: "康平县",
  210124: "法库县",
  210181: "新民市",
  210200: "大连市",
  210201: "市辖区",
  210202: "中山区",
  210203: "西岗区",
  210204: "沙河口区",
  210211: "甘井子区",
  210212: "旅顺口区",
  210213: "金州区",
  210214: "普兰店区",
  210224: "长海县",
  210281: "瓦房店市",
  210283: "庄河市",
  210300: "鞍山市",
  210301: "市辖区",
  210302: "铁东区",
  210303: "铁西区",
  210304: "立山区",
  210311: "千山区",
  210321: "台安县",
  210323: "岫岩满族自治县",
  210381: "海城市",
  210400: "抚顺市",
  210401: "市辖区",
  210402: "新抚区",
  210403: "东洲区",
  210404: "望花区",
  210411: "顺城区",
  210421: "抚顺县",
  210422: "新宾满族自治县",
  210423: "清原满族自治县",
  210500: "本溪市",
  210501: "市辖区",
  210502: "平山区",
  210503: "溪湖区",
  210504: "明山区",
  210505: "南芬区",
  210521: "本溪满族自治县",
  210522: "桓仁满族自治县",
  210600: "丹东市",
  210601: "市辖区",
  210602: "元宝区",
  210603: "振兴区",
  210604: "振安区",
  210624: "宽甸满族自治县",
  210681: "东港市",
  210682: "凤城市",
  210700: "锦州市",
  210701: "市辖区",
  210702: "古塔区",
  210703: "凌河区",
  210711: "太和区",
  210726: "黑山县",
  210727: "义县",
  210781: "凌海市",
  210782: "北镇市",
  210800: "营口市",
  210801: "市辖区",
  210802: "站前区",
  210803: "西市区",
  210804: "鲅鱼圈区",
  210811: "老边区",
  210881: "盖州市",
  210882: "大石桥市",
  210900: "阜新市",
  210901: "市辖区",
  210902: "海州区",
  210903: "新邱区",
  210904: "太平区",
  210905: "清河门区",
  210911: "细河区",
  210921: "阜新蒙古族自治县",
  210922: "彰武县",
  211e3: "辽阳市",
  211001: "市辖区",
  211002: "白塔区",
  211003: "文圣区",
  211004: "宏伟区",
  211005: "弓长岭区",
  211011: "太子河区",
  211021: "辽阳县",
  211081: "灯塔市",
  211100: "盘锦市",
  211101: "市辖区",
  211102: "双台子区",
  211103: "兴隆台区",
  211104: "大洼区",
  211122: "盘山县",
  211200: "铁岭市",
  211201: "市辖区",
  211202: "银州区",
  211204: "清河区",
  211221: "铁岭县",
  211223: "西丰县",
  211224: "昌图县",
  211281: "调兵山市",
  211282: "开原市",
  211300: "朝阳市",
  211301: "市辖区",
  211302: "双塔区",
  211303: "龙城区",
  211321: "朝阳县",
  211322: "建平县",
  211324: "喀喇沁左翼蒙古族自治县",
  211381: "北票市",
  211382: "凌源市",
  211400: "葫芦岛市",
  211401: "市辖区",
  211402: "连山区",
  211403: "龙港区",
  211404: "南票区",
  211421: "绥中县",
  211422: "建昌县",
  211481: "兴城市",
  22e4: "吉林省",
  220100: "长春市",
  220101: "市辖区",
  220102: "南关区",
  220103: "宽城区",
  220104: "朝阳区",
  220105: "二道区",
  220106: "绿园区",
  220112: "双阳区",
  220113: "九台区",
  220122: "农安县",
  220182: "榆树市",
  220183: "德惠市",
  220200: "吉林市",
  220201: "市辖区",
  220202: "昌邑区",
  220203: "龙潭区",
  220204: "船营区",
  220211: "丰满区",
  220221: "永吉县",
  220281: "蛟河市",
  220282: "桦甸市",
  220283: "舒兰市",
  220284: "磐石市",
  220300: "四平市",
  220301: "市辖区",
  220302: "铁西区",
  220303: "铁东区",
  220322: "梨树县",
  220323: "伊通满族自治县",
  220381: "公主岭市",
  220382: "双辽市",
  220400: "辽源市",
  220401: "市辖区",
  220402: "龙山区",
  220403: "西安区",
  220421: "东丰县",
  220422: "东辽县",
  220500: "通化市",
  220501: "市辖区",
  220502: "东昌区",
  220503: "二道江区",
  220521: "通化县",
  220523: "辉南县",
  220524: "柳河县",
  220581: "梅河口市",
  220582: "集安市",
  220600: "白山市",
  220601: "市辖区",
  220602: "浑江区",
  220605: "江源区",
  220621: "抚松县",
  220622: "靖宇县",
  220623: "长白朝鲜族自治县",
  220681: "临江市",
  220700: "松原市",
  220701: "市辖区",
  220702: "宁江区",
  220721: "前郭尔罗斯蒙古族自治县",
  220722: "长岭县",
  220723: "乾安县",
  220781: "扶余市",
  220800: "白城市",
  220801: "市辖区",
  220802: "洮北区",
  220821: "镇赉县",
  220822: "通榆县",
  220881: "洮南市",
  220882: "大安市",
  222400: "延边朝鲜族自治州",
  222401: "延吉市",
  222402: "图们市",
  222403: "敦化市",
  222404: "珲春市",
  222405: "龙井市",
  222406: "和龙市",
  222424: "汪清县",
  222426: "安图县",
  23e4: "黑龙江省",
  230100: "哈尔滨市",
  230101: "市辖区",
  230102: "道里区",
  230103: "南岗区",
  230104: "道外区",
  230108: "平房区",
  230109: "松北区",
  230110: "香坊区",
  230111: "呼兰区",
  230112: "阿城区",
  230113: "双城区",
  230123: "依兰县",
  230124: "方正县",
  230125: "宾县",
  230126: "巴彦县",
  230127: "木兰县",
  230128: "通河县",
  230129: "延寿县",
  230183: "尚志市",
  230184: "五常市",
  230200: "齐齐哈尔市",
  230201: "市辖区",
  230202: "龙沙区",
  230203: "建华区",
  230204: "铁锋区",
  230205: "昂昂溪区",
  230206: "富拉尔基区",
  230207: "碾子山区",
  230208: "梅里斯达斡尔族区",
  230221: "龙江县",
  230223: "依安县",
  230224: "泰来县",
  230225: "甘南县",
  230227: "富裕县",
  230229: "克山县",
  230230: "克东县",
  230231: "拜泉县",
  230281: "讷河市",
  230300: "鸡西市",
  230301: "市辖区",
  230302: "鸡冠区",
  230303: "恒山区",
  230304: "滴道区",
  230305: "梨树区",
  230306: "城子河区",
  230307: "麻山区",
  230321: "鸡东县",
  230381: "虎林市",
  230382: "密山市",
  230400: "鹤岗市",
  230401: "市辖区",
  230402: "向阳区",
  230403: "工农区",
  230404: "南山区",
  230405: "兴安区",
  230406: "东山区",
  230407: "兴山区",
  230421: "萝北县",
  230422: "绥滨县",
  230500: "双鸭山市",
  230501: "市辖区",
  230502: "尖山区",
  230503: "岭东区",
  230505: "四方台区",
  230506: "宝山区",
  230521: "集贤县",
  230522: "友谊县",
  230523: "宝清县",
  230524: "饶河县",
  230600: "大庆市",
  230601: "市辖区",
  230602: "萨尔图区",
  230603: "龙凤区",
  230604: "让胡路区",
  230605: "红岗区",
  230606: "大同区",
  230621: "肇州县",
  230622: "肇源县",
  230623: "林甸县",
  230624: "杜尔伯特蒙古族自治县",
  230700: "伊春市",
  230701: "市辖区",
  230702: "伊春区",
  230703: "南岔区",
  230704: "友好区",
  230705: "西林区",
  230706: "翠峦区",
  230707: "新青区",
  230708: "美溪区",
  230709: "金山屯区",
  230710: "五营区",
  230711: "乌马河区",
  230712: "汤旺河区",
  230713: "带岭区",
  230714: "乌伊岭区",
  230715: "红星区",
  230716: "上甘岭区",
  230722: "嘉荫县",
  230781: "铁力市",
  230800: "佳木斯市",
  230801: "市辖区",
  230803: "向阳区",
  230804: "前进区",
  230805: "东风区",
  230811: "郊区",
  230822: "桦南县",
  230826: "桦川县",
  230828: "汤原县",
  230881: "同江市",
  230882: "富锦市",
  230883: "抚远市",
  230900: "七台河市",
  230901: "市辖区",
  230902: "新兴区",
  230903: "桃山区",
  230904: "茄子河区",
  230921: "勃利县",
  231e3: "牡丹江市",
  231001: "市辖区",
  231002: "东安区",
  231003: "阳明区",
  231004: "爱民区",
  231005: "西安区",
  231025: "林口县",
  231081: "绥芬河市",
  231083: "海林市",
  231084: "宁安市",
  231085: "穆棱市",
  231086: "东宁市",
  231100: "黑河市",
  231101: "市辖区",
  231102: "爱辉区",
  231121: "嫩江县",
  231123: "逊克县",
  231124: "孙吴县",
  231181: "北安市",
  231182: "五大连池市",
  231200: "绥化市",
  231201: "市辖区",
  231202: "北林区",
  231221: "望奎县",
  231222: "兰西县",
  231223: "青冈县",
  231224: "庆安县",
  231225: "明水县",
  231226: "绥棱县",
  231281: "安达市",
  231282: "肇东市",
  231283: "海伦市",
  232700: "大兴安岭地区",
  232721: "呼玛县",
  232722: "塔河县",
  232723: "漠河县",
  31e4: "上海市",
  310100: "市辖区",
  310101: "黄浦区",
  310104: "徐汇区",
  310105: "长宁区",
  310106: "静安区",
  310107: "普陀区",
  310109: "虹口区",
  310110: "杨浦区",
  310112: "闵行区",
  310113: "宝山区",
  310114: "嘉定区",
  310115: "浦东新区",
  310116: "金山区",
  310117: "松江区",
  310118: "青浦区",
  310120: "奉贤区",
  310151: "崇明区",
  32e4: "江苏省",
  320100: "南京市",
  320101: "市辖区",
  320102: "玄武区",
  320104: "秦淮区",
  320105: "建邺区",
  320106: "鼓楼区",
  320111: "浦口区",
  320113: "栖霞区",
  320114: "雨花台区",
  320115: "江宁区",
  320116: "六合区",
  320117: "溧水区",
  320118: "高淳区",
  320200: "无锡市",
  320201: "市辖区",
  320205: "锡山区",
  320206: "惠山区",
  320211: "滨湖区",
  320213: "梁溪区",
  320214: "新吴区",
  320281: "江阴市",
  320282: "宜兴市",
  320300: "徐州市",
  320301: "市辖区",
  320302: "鼓楼区",
  320303: "云龙区",
  320305: "贾汪区",
  320311: "泉山区",
  320312: "铜山区",
  320321: "丰县",
  320322: "沛县",
  320324: "睢宁县",
  320381: "新沂市",
  320382: "邳州市",
  320400: "常州市",
  320401: "市辖区",
  320402: "天宁区",
  320404: "钟楼区",
  320411: "新北区",
  320412: "武进区",
  320413: "金坛区",
  320481: "溧阳市",
  320500: "苏州市",
  320501: "市辖区",
  320505: "虎丘区",
  320506: "吴中区",
  320507: "相城区",
  320508: "姑苏区",
  320509: "吴江区",
  320581: "常熟市",
  320582: "张家港市",
  320583: "昆山市",
  320585: "太仓市",
  320594: "苏州工业园区",
  320600: "南通市",
  320601: "市辖区",
  320602: "崇川区",
  320611: "港闸区",
  320612: "通州区",
  320621: "海安县",
  320623: "如东县",
  320681: "启东市",
  320682: "如皋市",
  320684: "海门市",
  320700: "连云港市",
  320701: "市辖区",
  320703: "连云区",
  320706: "海州区",
  320707: "赣榆区",
  320722: "东海县",
  320723: "灌云县",
  320724: "灌南县",
  320800: "淮安市",
  320801: "市辖区",
  320803: "淮安区",
  320804: "淮阴区",
  320812: "清江浦区",
  320813: "洪泽区",
  320826: "涟水县",
  320830: "盱眙县",
  320831: "金湖县",
  320900: "盐城市",
  320901: "市辖区",
  320902: "亭湖区",
  320903: "盐都区",
  320904: "大丰区",
  320921: "响水县",
  320922: "滨海县",
  320923: "阜宁县",
  320924: "射阳县",
  320925: "建湖县",
  320981: "东台市",
  321e3: "扬州市",
  321001: "市辖区",
  321002: "广陵区",
  321003: "邗江区",
  321012: "江都区",
  321023: "宝应县",
  321081: "仪征市",
  321084: "高邮市",
  321100: "镇江市",
  321101: "市辖区",
  321102: "京口区",
  321111: "润州区",
  321112: "丹徒区",
  321181: "丹阳市",
  321182: "扬中市",
  321183: "句容市",
  321200: "泰州市",
  321201: "市辖区",
  321202: "海陵区",
  321203: "高港区",
  321204: "姜堰区",
  321281: "兴化市",
  321282: "靖江市",
  321283: "泰兴市",
  321300: "宿迁市",
  321301: "市辖区",
  321302: "宿城区",
  321311: "宿豫区",
  321322: "沭阳县",
  321323: "泗阳县",
  321324: "泗洪县",
  33e4: "浙江省",
  330100: "杭州市",
  330101: "市辖区",
  330102: "上城区",
  330103: "下城区",
  330104: "江干区",
  330105: "拱墅区",
  330106: "西湖区",
  330108: "滨江区",
  330109: "萧山区",
  330110: "余杭区",
  330111: "富阳区",
  330122: "桐庐县",
  330127: "淳安县",
  330182: "建德市",
  330185: "临安市",
  330200: "宁波市",
  330201: "市辖区",
  330203: "海曙区",
  330204: "江东区",
  330205: "江北区",
  330206: "北仑区",
  330211: "镇海区",
  330212: "鄞州区",
  330225: "象山县",
  330226: "宁海县",
  330281: "余姚市",
  330282: "慈溪市",
  330283: "奉化市",
  330300: "温州市",
  330301: "市辖区",
  330302: "鹿城区",
  330303: "龙湾区",
  330304: "瓯海区",
  330305: "洞头区",
  330324: "永嘉县",
  330326: "平阳县",
  330327: "苍南县",
  330328: "文成县",
  330329: "泰顺县",
  330381: "瑞安市",
  330382: "乐清市",
  330400: "嘉兴市",
  330401: "市辖区",
  330402: "南湖区",
  330411: "秀洲区",
  330421: "嘉善县",
  330424: "海盐县",
  330481: "海宁市",
  330482: "平湖市",
  330483: "桐乡市",
  330500: "湖州市",
  330501: "市辖区",
  330502: "吴兴区",
  330503: "南浔区",
  330521: "德清县",
  330522: "长兴县",
  330523: "安吉县",
  330600: "绍兴市",
  330601: "市辖区",
  330602: "越城区",
  330603: "柯桥区",
  330604: "上虞区",
  330624: "新昌县",
  330681: "诸暨市",
  330683: "嵊州市",
  330700: "金华市",
  330701: "市辖区",
  330702: "婺城区",
  330703: "金东区",
  330723: "武义县",
  330726: "浦江县",
  330727: "磐安县",
  330781: "兰溪市",
  330782: "义乌市",
  330783: "东阳市",
  330784: "永康市",
  330800: "衢州市",
  330801: "市辖区",
  330802: "柯城区",
  330803: "衢江区",
  330822: "常山县",
  330824: "开化县",
  330825: "龙游县",
  330881: "江山市",
  330900: "舟山市",
  330901: "市辖区",
  330902: "定海区",
  330903: "普陀区",
  330921: "岱山县",
  330922: "嵊泗县",
  331e3: "台州市",
  331001: "市辖区",
  331002: "椒江区",
  331003: "黄岩区",
  331004: "路桥区",
  331021: "玉环县",
  331022: "三门县",
  331023: "天台县",
  331024: "仙居县",
  331081: "温岭市",
  331082: "临海市",
  331100: "丽水市",
  331101: "市辖区",
  331102: "莲都区",
  331121: "青田县",
  331122: "缙云县",
  331123: "遂昌县",
  331124: "松阳县",
  331125: "云和县",
  331126: "庆元县",
  331127: "景宁畲族自治县",
  331181: "龙泉市",
  34e4: "安徽省",
  340100: "合肥市",
  340101: "市辖区",
  340102: "瑶海区",
  340103: "庐阳区",
  340104: "蜀山区",
  340111: "包河区",
  340121: "长丰县",
  340122: "肥东县",
  340123: "肥西县",
  340124: "庐江县",
  340181: "巢湖市",
  340200: "芜湖市",
  340201: "市辖区",
  340202: "镜湖区",
  340203: "弋江区",
  340207: "鸠江区",
  340208: "三山区",
  340221: "芜湖县",
  340222: "繁昌县",
  340223: "南陵县",
  340225: "无为县",
  340300: "蚌埠市",
  340301: "市辖区",
  340302: "龙子湖区",
  340303: "蚌山区",
  340304: "禹会区",
  340311: "淮上区",
  340321: "怀远县",
  340322: "五河县",
  340323: "固镇县",
  340400: "淮南市",
  340401: "市辖区",
  340402: "大通区",
  340403: "田家庵区",
  340404: "谢家集区",
  340405: "八公山区",
  340406: "潘集区",
  340421: "凤台县",
  340422: "寿县",
  340500: "马鞍山市",
  340501: "市辖区",
  340503: "花山区",
  340504: "雨山区",
  340506: "博望区",
  340521: "当涂县",
  340522: "含山县",
  340523: "和县",
  340600: "淮北市",
  340601: "市辖区",
  340602: "杜集区",
  340603: "相山区",
  340604: "烈山区",
  340621: "濉溪县",
  340700: "铜陵市",
  340701: "市辖区",
  340705: "铜官区",
  340706: "义安区",
  340711: "郊区",
  340722: "枞阳县",
  340800: "安庆市",
  340801: "市辖区",
  340802: "迎江区",
  340803: "大观区",
  340811: "宜秀区",
  340822: "怀宁县",
  340824: "潜山县",
  340825: "太湖县",
  340826: "宿松县",
  340827: "望江县",
  340828: "岳西县",
  340881: "桐城市",
  341e3: "黄山市",
  341001: "市辖区",
  341002: "屯溪区",
  341003: "黄山区",
  341004: "徽州区",
  341021: "歙县",
  341022: "休宁县",
  341023: "黟县",
  341024: "祁门县",
  341100: "滁州市",
  341101: "市辖区",
  341102: "琅琊区",
  341103: "南谯区",
  341122: "来安县",
  341124: "全椒县",
  341125: "定远县",
  341126: "凤阳县",
  341181: "天长市",
  341182: "明光市",
  341200: "阜阳市",
  341201: "市辖区",
  341202: "颍州区",
  341203: "颍东区",
  341204: "颍泉区",
  341221: "临泉县",
  341222: "太和县",
  341225: "阜南县",
  341226: "颍上县",
  341282: "界首市",
  341300: "宿州市",
  341301: "市辖区",
  341302: "埇桥区",
  341321: "砀山县",
  341322: "萧县",
  341323: "灵璧县",
  341324: "泗县",
  341500: "六安市",
  341501: "市辖区",
  341502: "金安区",
  341503: "裕安区",
  341504: "叶集区",
  341522: "霍邱县",
  341523: "舒城县",
  341524: "金寨县",
  341525: "霍山县",
  341600: "亳州市",
  341601: "市辖区",
  341602: "谯城区",
  341621: "涡阳县",
  341622: "蒙城县",
  341623: "利辛县",
  341700: "池州市",
  341701: "市辖区",
  341702: "贵池区",
  341721: "东至县",
  341722: "石台县",
  341723: "青阳县",
  341800: "宣城市",
  341801: "市辖区",
  341802: "宣州区",
  341821: "郎溪县",
  341822: "广德县",
  341823: "泾县",
  341824: "绩溪县",
  341825: "旌德县",
  341881: "宁国市",
  35e4: "福建省",
  350100: "福州市",
  350101: "市辖区",
  350102: "鼓楼区",
  350103: "台江区",
  350104: "仓山区",
  350105: "马尾区",
  350111: "晋安区",
  350121: "闽侯县",
  350122: "连江县",
  350123: "罗源县",
  350124: "闽清县",
  350125: "永泰县",
  350128: "平潭县",
  350181: "福清市",
  350182: "长乐市",
  350200: "厦门市",
  350201: "市辖区",
  350203: "思明区",
  350205: "海沧区",
  350206: "湖里区",
  350211: "集美区",
  350212: "同安区",
  350213: "翔安区",
  350300: "莆田市",
  350301: "市辖区",
  350302: "城厢区",
  350303: "涵江区",
  350304: "荔城区",
  350305: "秀屿区",
  350322: "仙游县",
  350400: "三明市",
  350401: "市辖区",
  350402: "梅列区",
  350403: "三元区",
  350421: "明溪县",
  350423: "清流县",
  350424: "宁化县",
  350425: "大田县",
  350426: "尤溪县",
  350427: "沙县",
  350428: "将乐县",
  350429: "泰宁县",
  350430: "建宁县",
  350481: "永安市",
  350500: "泉州市",
  350501: "市辖区",
  350502: "鲤城区",
  350503: "丰泽区",
  350504: "洛江区",
  350505: "泉港区",
  350521: "惠安县",
  350524: "安溪县",
  350525: "永春县",
  350526: "德化县",
  350527: "金门县",
  350581: "石狮市",
  350582: "晋江市",
  350583: "南安市",
  350600: "漳州市",
  350601: "市辖区",
  350602: "芗城区",
  350603: "龙文区",
  350622: "云霄县",
  350623: "漳浦县",
  350624: "诏安县",
  350625: "长泰县",
  350626: "东山县",
  350627: "南靖县",
  350628: "平和县",
  350629: "华安县",
  350681: "龙海市",
  350700: "南平市",
  350701: "市辖区",
  350702: "延平区",
  350703: "建阳区",
  350721: "顺昌县",
  350722: "浦城县",
  350723: "光泽县",
  350724: "松溪县",
  350725: "政和县",
  350781: "邵武市",
  350782: "武夷山市",
  350783: "建瓯市",
  350800: "龙岩市",
  350801: "市辖区",
  350802: "新罗区",
  350803: "永定区",
  350821: "长汀县",
  350823: "上杭县",
  350824: "武平县",
  350825: "连城县",
  350881: "漳平市",
  350900: "宁德市",
  350901: "市辖区",
  350902: "蕉城区",
  350921: "霞浦县",
  350922: "古田县",
  350923: "屏南县",
  350924: "寿宁县",
  350925: "周宁县",
  350926: "柘荣县",
  350981: "福安市",
  350982: "福鼎市",
  36e4: "江西省",
  360100: "南昌市",
  360101: "市辖区",
  360102: "东湖区",
  360103: "西湖区",
  360104: "青云谱区",
  360105: "湾里区",
  360111: "青山湖区",
  360112: "新建区",
  360121: "南昌县",
  360123: "安义县",
  360124: "进贤县",
  360200: "景德镇市",
  360201: "市辖区",
  360202: "昌江区",
  360203: "珠山区",
  360222: "浮梁县",
  360281: "乐平市",
  360300: "萍乡市",
  360301: "市辖区",
  360302: "安源区",
  360313: "湘东区",
  360321: "莲花县",
  360322: "上栗县",
  360323: "芦溪县",
  360400: "九江市",
  360401: "市辖区",
  360402: "濂溪区",
  360403: "浔阳区",
  360421: "九江县",
  360423: "武宁县",
  360424: "修水县",
  360425: "永修县",
  360426: "德安县",
  360428: "都昌县",
  360429: "湖口县",
  360430: "彭泽县",
  360481: "瑞昌市",
  360482: "共青城市",
  360483: "庐山市",
  360500: "新余市",
  360501: "市辖区",
  360502: "渝水区",
  360521: "分宜县",
  360600: "鹰潭市",
  360601: "市辖区",
  360602: "月湖区",
  360622: "余江县",
  360681: "贵溪市",
  360700: "赣州市",
  360701: "市辖区",
  360702: "章贡区",
  360703: "南康区",
  360721: "赣县",
  360722: "信丰县",
  360723: "大余县",
  360724: "上犹县",
  360725: "崇义县",
  360726: "安远县",
  360727: "龙南县",
  360728: "定南县",
  360729: "全南县",
  360730: "宁都县",
  360731: "于都县",
  360732: "兴国县",
  360733: "会昌县",
  360734: "寻乌县",
  360735: "石城县",
  360781: "瑞金市",
  360800: "吉安市",
  360801: "市辖区",
  360802: "吉州区",
  360803: "青原区",
  360821: "吉安县",
  360822: "吉水县",
  360823: "峡江县",
  360824: "新干县",
  360825: "永丰县",
  360826: "泰和县",
  360827: "遂川县",
  360828: "万安县",
  360829: "安福县",
  360830: "永新县",
  360881: "井冈山市",
  360900: "宜春市",
  360901: "市辖区",
  360902: "袁州区",
  360921: "奉新县",
  360922: "万载县",
  360923: "上高县",
  360924: "宜丰县",
  360925: "靖安县",
  360926: "铜鼓县",
  360981: "丰城市",
  360982: "樟树市",
  360983: "高安市",
  361e3: "抚州市",
  361001: "市辖区",
  361002: "临川区",
  361021: "南城县",
  361022: "黎川县",
  361023: "南丰县",
  361024: "崇仁县",
  361025: "乐安县",
  361026: "宜黄县",
  361027: "金溪县",
  361028: "资溪县",
  361029: "东乡县",
  361030: "广昌县",
  361100: "上饶市",
  361101: "市辖区",
  361102: "信州区",
  361103: "广丰区",
  361121: "上饶县",
  361123: "玉山县",
  361124: "铅山县",
  361125: "横峰县",
  361126: "弋阳县",
  361127: "余干县",
  361128: "鄱阳县",
  361129: "万年县",
  361130: "婺源县",
  361181: "德兴市",
  37e4: "山东省",
  370100: "济南市",
  370101: "市辖区",
  370102: "历下区",
  370103: "市中区",
  370104: "槐荫区",
  370105: "天桥区",
  370112: "历城区",
  370113: "长清区",
  370124: "平阴县",
  370125: "济阳县",
  370126: "商河县",
  370181: "章丘市",
  370200: "青岛市",
  370201: "市辖区",
  370202: "市南区",
  370203: "市北区",
  370211: "黄岛区",
  370212: "崂山区",
  370213: "李沧区",
  370214: "城阳区",
  370281: "胶州市",
  370282: "即墨市",
  370283: "平度市",
  370285: "莱西市",
  370300: "淄博市",
  370301: "市辖区",
  370302: "淄川区",
  370303: "张店区",
  370304: "博山区",
  370305: "临淄区",
  370306: "周村区",
  370321: "桓台县",
  370322: "高青县",
  370323: "沂源县",
  370400: "枣庄市",
  370401: "市辖区",
  370402: "市中区",
  370403: "薛城区",
  370404: "峄城区",
  370405: "台儿庄区",
  370406: "山亭区",
  370481: "滕州市",
  370500: "东营市",
  370501: "市辖区",
  370502: "东营区",
  370503: "河口区",
  370505: "垦利区",
  370522: "利津县",
  370523: "广饶县",
  370600: "烟台市",
  370601: "市辖区",
  370602: "芝罘区",
  370611: "福山区",
  370612: "牟平区",
  370613: "莱山区",
  370634: "长岛县",
  370681: "龙口市",
  370682: "莱阳市",
  370683: "莱州市",
  370684: "蓬莱市",
  370685: "招远市",
  370686: "栖霞市",
  370687: "海阳市",
  370700: "潍坊市",
  370701: "市辖区",
  370702: "潍城区",
  370703: "寒亭区",
  370704: "坊子区",
  370705: "奎文区",
  370724: "临朐县",
  370725: "昌乐县",
  370781: "青州市",
  370782: "诸城市",
  370783: "寿光市",
  370784: "安丘市",
  370785: "高密市",
  370786: "昌邑市",
  370800: "济宁市",
  370801: "市辖区",
  370811: "任城区",
  370812: "兖州区",
  370826: "微山县",
  370827: "鱼台县",
  370828: "金乡县",
  370829: "嘉祥县",
  370830: "汶上县",
  370831: "泗水县",
  370832: "梁山县",
  370881: "曲阜市",
  370883: "邹城市",
  370900: "泰安市",
  370901: "市辖区",
  370902: "泰山区",
  370911: "岱岳区",
  370921: "宁阳县",
  370923: "东平县",
  370982: "新泰市",
  370983: "肥城市",
  371e3: "威海市",
  371001: "市辖区",
  371002: "环翠区",
  371003: "文登区",
  371082: "荣成市",
  371083: "乳山市",
  371100: "日照市",
  371101: "市辖区",
  371102: "东港区",
  371103: "岚山区",
  371121: "五莲县",
  371122: "莒县",
  371200: "莱芜市",
  371201: "市辖区",
  371202: "莱城区",
  371203: "钢城区",
  371300: "临沂市",
  371301: "市辖区",
  371302: "兰山区",
  371311: "罗庄区",
  371312: "河东区",
  371321: "沂南县",
  371322: "郯城县",
  371323: "沂水县",
  371324: "兰陵县",
  371325: "费县",
  371326: "平邑县",
  371327: "莒南县",
  371328: "蒙阴县",
  371329: "临沭县",
  371400: "德州市",
  371401: "市辖区",
  371402: "德城区",
  371403: "陵城区",
  371422: "宁津县",
  371423: "庆云县",
  371424: "临邑县",
  371425: "齐河县",
  371426: "平原县",
  371427: "夏津县",
  371428: "武城县",
  371481: "乐陵市",
  371482: "禹城市",
  371500: "聊城市",
  371501: "市辖区",
  371502: "东昌府区",
  371521: "阳谷县",
  371522: "莘县",
  371523: "茌平县",
  371524: "东阿县",
  371525: "冠县",
  371526: "高唐县",
  371581: "临清市",
  371600: "滨州市",
  371601: "市辖区",
  371602: "滨城区",
  371603: "沾化区",
  371621: "惠民县",
  371622: "阳信县",
  371623: "无棣县",
  371625: "博兴县",
  371626: "邹平县",
  371700: "菏泽市",
  371701: "市辖区",
  371702: "牡丹区",
  371703: "定陶区",
  371721: "曹县",
  371722: "单县",
  371723: "成武县",
  371724: "巨野县",
  371725: "郓城县",
  371726: "鄄城县",
  371728: "东明县",
  41e4: "河南省",
  410100: "郑州市",
  410101: "市辖区",
  410102: "中原区",
  410103: "二七区",
  410104: "管城回族区",
  410105: "金水区",
  410106: "上街区",
  410108: "惠济区",
  410122: "中牟县",
  410181: "巩义市",
  410182: "荥阳市",
  410183: "新密市",
  410184: "新郑市",
  410185: "登封市",
  410200: "开封市",
  410201: "市辖区",
  410202: "龙亭区",
  410203: "顺河回族区",
  410204: "鼓楼区",
  410205: "禹王台区",
  410211: "金明区",
  410212: "祥符区",
  410221: "杞县",
  410222: "通许县",
  410223: "尉氏县",
  410225: "兰考县",
  410300: "洛阳市",
  410301: "市辖区",
  410302: "老城区",
  410303: "西工区",
  410304: "瀍河回族区",
  410305: "涧西区",
  410306: "吉利区",
  410311: "洛龙区",
  410322: "孟津县",
  410323: "新安县",
  410324: "栾川县",
  410325: "嵩县",
  410326: "汝阳县",
  410327: "宜阳县",
  410328: "洛宁县",
  410329: "伊川县",
  410381: "偃师市",
  410400: "平顶山市",
  410401: "市辖区",
  410402: "新华区",
  410403: "卫东区",
  410404: "石龙区",
  410411: "湛河区",
  410421: "宝丰县",
  410422: "叶县",
  410423: "鲁山县",
  410425: "郏县",
  410481: "舞钢市",
  410482: "汝州市",
  410500: "安阳市",
  410501: "市辖区",
  410502: "文峰区",
  410503: "北关区",
  410505: "殷都区",
  410506: "龙安区",
  410522: "安阳县",
  410523: "汤阴县",
  410526: "滑县",
  410527: "内黄县",
  410581: "林州市",
  410600: "鹤壁市",
  410601: "市辖区",
  410602: "鹤山区",
  410603: "山城区",
  410611: "淇滨区",
  410621: "浚县",
  410622: "淇县",
  410700: "新乡市",
  410701: "市辖区",
  410702: "红旗区",
  410703: "卫滨区",
  410704: "凤泉区",
  410711: "牧野区",
  410721: "新乡县",
  410724: "获嘉县",
  410725: "原阳县",
  410726: "延津县",
  410727: "封丘县",
  410728: "长垣县",
  410781: "卫辉市",
  410782: "辉县市",
  410800: "焦作市",
  410801: "市辖区",
  410802: "解放区",
  410803: "中站区",
  410804: "马村区",
  410811: "山阳区",
  410821: "修武县",
  410822: "博爱县",
  410823: "武陟县",
  410825: "温县",
  410882: "沁阳市",
  410883: "孟州市",
  410900: "濮阳市",
  410901: "市辖区",
  410902: "华龙区",
  410922: "清丰县",
  410923: "南乐县",
  410926: "范县",
  410927: "台前县",
  410928: "濮阳县",
  411e3: "许昌市",
  411001: "市辖区",
  411002: "魏都区",
  411023: "许昌县",
  411024: "鄢陵县",
  411025: "襄城县",
  411081: "禹州市",
  411082: "长葛市",
  411100: "漯河市",
  411101: "市辖区",
  411102: "源汇区",
  411103: "郾城区",
  411104: "召陵区",
  411121: "舞阳县",
  411122: "临颍县",
  411200: "三门峡市",
  411201: "市辖区",
  411202: "湖滨区",
  411203: "陕州区",
  411221: "渑池县",
  411224: "卢氏县",
  411281: "义马市",
  411282: "灵宝市",
  411300: "南阳市",
  411301: "市辖区",
  411302: "宛城区",
  411303: "卧龙区",
  411321: "南召县",
  411322: "方城县",
  411323: "西峡县",
  411324: "镇平县",
  411325: "内乡县",
  411326: "淅川县",
  411327: "社旗县",
  411328: "唐河县",
  411329: "新野县",
  411330: "桐柏县",
  411381: "邓州市",
  411400: "商丘市",
  411401: "市辖区",
  411402: "梁园区",
  411403: "睢阳区",
  411421: "民权县",
  411422: "睢县",
  411423: "宁陵县",
  411424: "柘城县",
  411425: "虞城县",
  411426: "夏邑县",
  411481: "永城市",
  411500: "信阳市",
  411501: "市辖区",
  411502: "浉河区",
  411503: "平桥区",
  411521: "罗山县",
  411522: "光山县",
  411523: "新县",
  411524: "商城县",
  411525: "固始县",
  411526: "潢川县",
  411527: "淮滨县",
  411528: "息县",
  411600: "周口市",
  411601: "市辖区",
  411602: "川汇区",
  411621: "扶沟县",
  411622: "西华县",
  411623: "商水县",
  411624: "沈丘县",
  411625: "郸城县",
  411626: "淮阳县",
  411627: "太康县",
  411628: "鹿邑县",
  411681: "项城市",
  411700: "驻马店市",
  411701: "市辖区",
  411702: "驿城区",
  411721: "西平县",
  411722: "上蔡县",
  411723: "平舆县",
  411724: "正阳县",
  411725: "确山县",
  411726: "泌阳县",
  411727: "汝南县",
  411728: "遂平县",
  411729: "新蔡县",
  419e3: "省直辖县级行政区划",
  419001: "济源市",
  42e4: "湖北省",
  420100: "武汉市",
  420101: "市辖区",
  420102: "江岸区",
  420103: "江汉区",
  420104: "硚口区",
  420105: "汉阳区",
  420106: "武昌区",
  420107: "青山区",
  420111: "洪山区",
  420112: "东西湖区",
  420113: "汉南区",
  420114: "蔡甸区",
  420115: "江夏区",
  420116: "黄陂区",
  420117: "新洲区",
  420200: "黄石市",
  420201: "市辖区",
  420202: "黄石港区",
  420203: "西塞山区",
  420204: "下陆区",
  420205: "铁山区",
  420222: "阳新县",
  420281: "大冶市",
  420300: "十堰市",
  420301: "市辖区",
  420302: "茅箭区",
  420303: "张湾区",
  420304: "郧阳区",
  420322: "郧西县",
  420323: "竹山县",
  420324: "竹溪县",
  420325: "房县",
  420381: "丹江口市",
  420500: "宜昌市",
  420501: "市辖区",
  420502: "西陵区",
  420503: "伍家岗区",
  420504: "点军区",
  420505: "猇亭区",
  420506: "夷陵区",
  420525: "远安县",
  420526: "兴山县",
  420527: "秭归县",
  420528: "长阳土家族自治县",
  420529: "五峰土家族自治县",
  420581: "宜都市",
  420582: "当阳市",
  420583: "枝江市",
  420600: "襄阳市",
  420601: "市辖区",
  420602: "襄城区",
  420606: "樊城区",
  420607: "襄州区",
  420624: "南漳县",
  420625: "谷城县",
  420626: "保康县",
  420682: "老河口市",
  420683: "枣阳市",
  420684: "宜城市",
  420700: "鄂州市",
  420701: "市辖区",
  420702: "梁子湖区",
  420703: "华容区",
  420704: "鄂城区",
  420800: "荆门市",
  420801: "市辖区",
  420802: "东宝区",
  420804: "掇刀区",
  420821: "京山县",
  420822: "沙洋县",
  420881: "钟祥市",
  420900: "孝感市",
  420901: "市辖区",
  420902: "孝南区",
  420921: "孝昌县",
  420922: "大悟县",
  420923: "云梦县",
  420981: "应城市",
  420982: "安陆市",
  420984: "汉川市",
  421e3: "荆州市",
  421001: "市辖区",
  421002: "沙市区",
  421003: "荆州区",
  421022: "公安县",
  421023: "监利县",
  421024: "江陵县",
  421081: "石首市",
  421083: "洪湖市",
  421087: "松滋市",
  421100: "黄冈市",
  421101: "市辖区",
  421102: "黄州区",
  421121: "团风县",
  421122: "红安县",
  421123: "罗田县",
  421124: "英山县",
  421125: "浠水县",
  421126: "蕲春县",
  421127: "黄梅县",
  421181: "麻城市",
  421182: "武穴市",
  421200: "咸宁市",
  421201: "市辖区",
  421202: "咸安区",
  421221: "嘉鱼县",
  421222: "通城县",
  421223: "崇阳县",
  421224: "通山县",
  421281: "赤壁市",
  421300: "随州市",
  421301: "市辖区",
  421303: "曾都区",
  421321: "随县",
  421381: "广水市",
  422800: "恩施土家族苗族自治州",
  422801: "恩施市",
  422802: "利川市",
  422822: "建始县",
  422823: "巴东县",
  422825: "宣恩县",
  422826: "咸丰县",
  422827: "来凤县",
  422828: "鹤峰县",
  429e3: "省直辖县级行政区划",
  429004: "仙桃市",
  429005: "潜江市",
  429006: "天门市",
  429021: "神农架林区",
  43e4: "湖南省",
  430100: "长沙市",
  430101: "市辖区",
  430102: "芙蓉区",
  430103: "天心区",
  430104: "岳麓区",
  430105: "开福区",
  430111: "雨花区",
  430112: "望城区",
  430121: "长沙县",
  430124: "宁乡县",
  430181: "浏阳市",
  430200: "株洲市",
  430201: "市辖区",
  430202: "荷塘区",
  430203: "芦淞区",
  430204: "石峰区",
  430211: "天元区",
  430221: "株洲县",
  430223: "攸县",
  430224: "茶陵县",
  430225: "炎陵县",
  430281: "醴陵市",
  430300: "湘潭市",
  430301: "市辖区",
  430302: "雨湖区",
  430304: "岳塘区",
  430321: "湘潭县",
  430381: "湘乡市",
  430382: "韶山市",
  430400: "衡阳市",
  430401: "市辖区",
  430405: "珠晖区",
  430406: "雁峰区",
  430407: "石鼓区",
  430408: "蒸湘区",
  430412: "南岳区",
  430421: "衡阳县",
  430422: "衡南县",
  430423: "衡山县",
  430424: "衡东县",
  430426: "祁东县",
  430481: "耒阳市",
  430482: "常宁市",
  430500: "邵阳市",
  430501: "市辖区",
  430502: "双清区",
  430503: "大祥区",
  430511: "北塔区",
  430521: "邵东县",
  430522: "新邵县",
  430523: "邵阳县",
  430524: "隆回县",
  430525: "洞口县",
  430527: "绥宁县",
  430528: "新宁县",
  430529: "城步苗族自治县",
  430581: "武冈市",
  430600: "岳阳市",
  430601: "市辖区",
  430602: "岳阳楼区",
  430603: "云溪区",
  430611: "君山区",
  430621: "岳阳县",
  430623: "华容县",
  430624: "湘阴县",
  430626: "平江县",
  430681: "汨罗市",
  430682: "临湘市",
  430700: "常德市",
  430701: "市辖区",
  430702: "武陵区",
  430703: "鼎城区",
  430721: "安乡县",
  430722: "汉寿县",
  430723: "澧县",
  430724: "临澧县",
  430725: "桃源县",
  430726: "石门县",
  430781: "津市市",
  430800: "张家界市",
  430801: "市辖区",
  430802: "永定区",
  430811: "武陵源区",
  430821: "慈利县",
  430822: "桑植县",
  430900: "益阳市",
  430901: "市辖区",
  430902: "资阳区",
  430903: "赫山区",
  430921: "南县",
  430922: "桃江县",
  430923: "安化县",
  430981: "沅江市",
  431e3: "郴州市",
  431001: "市辖区",
  431002: "北湖区",
  431003: "苏仙区",
  431021: "桂阳县",
  431022: "宜章县",
  431023: "永兴县",
  431024: "嘉禾县",
  431025: "临武县",
  431026: "汝城县",
  431027: "桂东县",
  431028: "安仁县",
  431081: "资兴市",
  431100: "永州市",
  431101: "市辖区",
  431102: "零陵区",
  431103: "冷水滩区",
  431121: "祁阳县",
  431122: "东安县",
  431123: "双牌县",
  431124: "道县",
  431125: "江永县",
  431126: "宁远县",
  431127: "蓝山县",
  431128: "新田县",
  431129: "江华瑶族自治县",
  431200: "怀化市",
  431201: "市辖区",
  431202: "鹤城区",
  431221: "中方县",
  431222: "沅陵县",
  431223: "辰溪县",
  431224: "溆浦县",
  431225: "会同县",
  431226: "麻阳苗族自治县",
  431227: "新晃侗族自治县",
  431228: "芷江侗族自治县",
  431229: "靖州苗族侗族自治县",
  431230: "通道侗族自治县",
  431281: "洪江市",
  431300: "娄底市",
  431301: "市辖区",
  431302: "娄星区",
  431321: "双峰县",
  431322: "新化县",
  431381: "冷水江市",
  431382: "涟源市",
  433100: "湘西土家族苗族自治州",
  433101: "吉首市",
  433122: "泸溪县",
  433123: "凤凰县",
  433124: "花垣县",
  433125: "保靖县",
  433126: "古丈县",
  433127: "永顺县",
  433130: "龙山县",
  44e4: "广东省",
  440100: "广州市",
  440101: "市辖区",
  440103: "荔湾区",
  440104: "越秀区",
  440105: "海珠区",
  440106: "天河区",
  440111: "白云区",
  440112: "黄埔区",
  440113: "番禺区",
  440114: "花都区",
  440115: "南沙区",
  440117: "从化区",
  440118: "增城区",
  440200: "韶关市",
  440201: "市辖区",
  440203: "武江区",
  440204: "浈江区",
  440205: "曲江区",
  440222: "始兴县",
  440224: "仁化县",
  440229: "翁源县",
  440232: "乳源瑶族自治县",
  440233: "新丰县",
  440281: "乐昌市",
  440282: "南雄市",
  440300: "深圳市",
  440301: "市辖区",
  440303: "罗湖区",
  440304: "福田区",
  440305: "南山区",
  440306: "宝安区",
  440307: "龙岗区",
  440308: "盐田区",
  440400: "珠海市",
  440401: "市辖区",
  440402: "香洲区",
  440403: "斗门区",
  440404: "金湾区",
  440500: "汕头市",
  440501: "市辖区",
  440507: "龙湖区",
  440511: "金平区",
  440512: "濠江区",
  440513: "潮阳区",
  440514: "潮南区",
  440515: "澄海区",
  440523: "南澳县",
  440600: "佛山市",
  440601: "市辖区",
  440604: "禅城区",
  440605: "南海区",
  440606: "顺德区",
  440607: "三水区",
  440608: "高明区",
  440700: "江门市",
  440701: "市辖区",
  440703: "蓬江区",
  440704: "江海区",
  440705: "新会区",
  440781: "台山市",
  440783: "开平市",
  440784: "鹤山市",
  440785: "恩平市",
  440800: "湛江市",
  440801: "市辖区",
  440802: "赤坎区",
  440803: "霞山区",
  440804: "坡头区",
  440811: "麻章区",
  440823: "遂溪县",
  440825: "徐闻县",
  440881: "廉江市",
  440882: "雷州市",
  440883: "吴川市",
  440900: "茂名市",
  440901: "市辖区",
  440902: "茂南区",
  440904: "电白区",
  440981: "高州市",
  440982: "化州市",
  440983: "信宜市",
  441200: "肇庆市",
  441201: "市辖区",
  441202: "端州区",
  441203: "鼎湖区",
  441204: "高要区",
  441223: "广宁县",
  441224: "怀集县",
  441225: "封开县",
  441226: "德庆县",
  441284: "四会市",
  441300: "惠州市",
  441301: "市辖区",
  441302: "惠城区",
  441303: "惠阳区",
  441322: "博罗县",
  441323: "惠东县",
  441324: "龙门县",
  441400: "梅州市",
  441401: "市辖区",
  441402: "梅江区",
  441403: "梅县区",
  441422: "大埔县",
  441423: "丰顺县",
  441424: "五华县",
  441426: "平远县",
  441427: "蕉岭县",
  441481: "兴宁市",
  441500: "汕尾市",
  441501: "市辖区",
  441502: "城区",
  441521: "海丰县",
  441523: "陆河县",
  441581: "陆丰市",
  441600: "河源市",
  441601: "市辖区",
  441602: "源城区",
  441621: "紫金县",
  441622: "龙川县",
  441623: "连平县",
  441624: "和平县",
  441625: "东源县",
  441700: "阳江市",
  441701: "市辖区",
  441702: "江城区",
  441704: "阳东区",
  441721: "阳西县",
  441781: "阳春市",
  441800: "清远市",
  441801: "市辖区",
  441802: "清城区",
  441803: "清新区",
  441821: "佛冈县",
  441823: "阳山县",
  441825: "连山壮族瑶族自治县",
  441826: "连南瑶族自治县",
  441881: "英德市",
  441882: "连州市",
  441900: "东莞市",
  442e3: "中山市",
  445100: "潮州市",
  445101: "市辖区",
  445102: "湘桥区",
  445103: "潮安区",
  445122: "饶平县",
  445200: "揭阳市",
  445201: "市辖区",
  445202: "榕城区",
  445203: "揭东区",
  445222: "揭西县",
  445224: "惠来县",
  445281: "普宁市",
  445300: "云浮市",
  445301: "市辖区",
  445302: "云城区",
  445303: "云安区",
  445321: "新兴县",
  445322: "郁南县",
  445381: "罗定市",
  45e4: "广西壮族自治区",
  450100: "南宁市",
  450101: "市辖区",
  450102: "兴宁区",
  450103: "青秀区",
  450105: "江南区",
  450107: "西乡塘区",
  450108: "良庆区",
  450109: "邕宁区",
  450110: "武鸣区",
  450123: "隆安县",
  450124: "马山县",
  450125: "上林县",
  450126: "宾阳县",
  450127: "横县",
  450200: "柳州市",
  450201: "市辖区",
  450202: "城中区",
  450203: "鱼峰区",
  450204: "柳南区",
  450205: "柳北区",
  450206: "柳江区",
  450222: "柳城县",
  450223: "鹿寨县",
  450224: "融安县",
  450225: "融水苗族自治县",
  450226: "三江侗族自治县",
  450300: "桂林市",
  450301: "市辖区",
  450302: "秀峰区",
  450303: "叠彩区",
  450304: "象山区",
  450305: "七星区",
  450311: "雁山区",
  450312: "临桂区",
  450321: "阳朔县",
  450323: "灵川县",
  450324: "全州县",
  450325: "兴安县",
  450326: "永福县",
  450327: "灌阳县",
  450328: "龙胜各族自治县",
  450329: "资源县",
  450330: "平乐县",
  450331: "荔浦县",
  450332: "恭城瑶族自治县",
  450400: "梧州市",
  450401: "市辖区",
  450403: "万秀区",
  450405: "长洲区",
  450406: "龙圩区",
  450421: "苍梧县",
  450422: "藤县",
  450423: "蒙山县",
  450481: "岑溪市",
  450500: "北海市",
  450501: "市辖区",
  450502: "海城区",
  450503: "银海区",
  450512: "铁山港区",
  450521: "合浦县",
  450600: "防城港市",
  450601: "市辖区",
  450602: "港口区",
  450603: "防城区",
  450621: "上思县",
  450681: "东兴市",
  450700: "钦州市",
  450701: "市辖区",
  450702: "钦南区",
  450703: "钦北区",
  450721: "灵山县",
  450722: "浦北县",
  450800: "贵港市",
  450801: "市辖区",
  450802: "港北区",
  450803: "港南区",
  450804: "覃塘区",
  450821: "平南县",
  450881: "桂平市",
  450900: "玉林市",
  450901: "市辖区",
  450902: "玉州区",
  450903: "福绵区",
  450921: "容县",
  450922: "陆川县",
  450923: "博白县",
  450924: "兴业县",
  450981: "北流市",
  451e3: "百色市",
  451001: "市辖区",
  451002: "右江区",
  451021: "田阳县",
  451022: "田东县",
  451023: "平果县",
  451024: "德保县",
  451026: "那坡县",
  451027: "凌云县",
  451028: "乐业县",
  451029: "田林县",
  451030: "西林县",
  451031: "隆林各族自治县",
  451081: "靖西市",
  451100: "贺州市",
  451101: "市辖区",
  451102: "八步区",
  451103: "平桂区",
  451121: "昭平县",
  451122: "钟山县",
  451123: "富川瑶族自治县",
  451200: "河池市",
  451201: "市辖区",
  451202: "金城江区",
  451221: "南丹县",
  451222: "天峨县",
  451223: "凤山县",
  451224: "东兰县",
  451225: "罗城仫佬族自治县",
  451226: "环江毛南族自治县",
  451227: "巴马瑶族自治县",
  451228: "都安瑶族自治县",
  451229: "大化瑶族自治县",
  451281: "宜州市",
  451300: "来宾市",
  451301: "市辖区",
  451302: "兴宾区",
  451321: "忻城县",
  451322: "象州县",
  451323: "武宣县",
  451324: "金秀瑶族自治县",
  451381: "合山市",
  451400: "崇左市",
  451401: "市辖区",
  451402: "江州区",
  451421: "扶绥县",
  451422: "宁明县",
  451423: "龙州县",
  451424: "大新县",
  451425: "天等县",
  451481: "凭祥市",
  46e4: "海南省",
  460100: "海口市",
  460101: "市辖区",
  460105: "秀英区",
  460106: "龙华区",
  460107: "琼山区",
  460108: "美兰区",
  460200: "三亚市",
  460201: "市辖区",
  460202: "海棠区",
  460203: "吉阳区",
  460204: "天涯区",
  460205: "崖州区",
  460300: "三沙市",
  460400: "儋州市",
  469e3: "省直辖县级行政区划",
  469001: "五指山市",
  469002: "琼海市",
  469005: "文昌市",
  469006: "万宁市",
  469007: "东方市",
  469021: "定安县",
  469022: "屯昌县",
  469023: "澄迈县",
  469024: "临高县",
  469025: "白沙黎族自治县",
  469026: "昌江黎族自治县",
  469027: "乐东黎族自治县",
  469028: "陵水黎族自治县",
  469029: "保亭黎族苗族自治县",
  469030: "琼中黎族苗族自治县",
  5e5: "重庆市",
  500100: "市辖区",
  500101: "万州区",
  500102: "涪陵区",
  500103: "渝中区",
  500104: "大渡口区",
  500105: "江北区",
  500106: "沙坪坝区",
  500107: "九龙坡区",
  500108: "南岸区",
  500109: "北碚区",
  500110: "綦江区",
  500111: "大足区",
  500112: "渝北区",
  500113: "巴南区",
  500114: "黔江区",
  500115: "长寿区",
  500116: "江津区",
  500117: "合川区",
  500118: "永川区",
  500119: "南川区",
  500120: "璧山区",
  500151: "铜梁区",
  500152: "潼南区",
  500153: "荣昌区",
  500154: "开州区",
  500200: "县",
  500228: "梁平县",
  500229: "城口县",
  500230: "丰都县",
  500231: "垫江县",
  500232: "武隆县",
  500233: "忠县",
  500235: "云阳县",
  500236: "奉节县",
  500237: "巫山县",
  500238: "巫溪县",
  500240: "石柱土家族自治县",
  500241: "秀山土家族苗族自治县",
  500242: "酉阳土家族苗族自治县",
  500243: "彭水苗族土家族自治县",
  51e4: "四川省",
  510100: "成都市",
  510101: "市辖区",
  510104: "锦江区",
  510105: "青羊区",
  510106: "金牛区",
  510107: "武侯区",
  510108: "成华区",
  510112: "龙泉驿区",
  510113: "青白江区",
  510114: "新都区",
  510115: "温江区",
  510116: "双流区",
  510121: "金堂县",
  510124: "郫县",
  510129: "大邑县",
  510131: "蒲江县",
  510132: "新津县",
  510181: "都江堰市",
  510182: "彭州市",
  510183: "邛崃市",
  510184: "崇州市",
  510185: "简阳市",
  510300: "自贡市",
  510301: "市辖区",
  510302: "自流井区",
  510303: "贡井区",
  510304: "大安区",
  510311: "沿滩区",
  510321: "荣县",
  510322: "富顺县",
  510400: "攀枝花市",
  510401: "市辖区",
  510402: "东区",
  510403: "西区",
  510411: "仁和区",
  510421: "米易县",
  510422: "盐边县",
  510500: "泸州市",
  510501: "市辖区",
  510502: "江阳区",
  510503: "纳溪区",
  510504: "龙马潭区",
  510521: "泸县",
  510522: "合江县",
  510524: "叙永县",
  510525: "古蔺县",
  510600: "德阳市",
  510601: "市辖区",
  510603: "旌阳区",
  510623: "中江县",
  510626: "罗江县",
  510681: "广汉市",
  510682: "什邡市",
  510683: "绵竹市",
  510700: "绵阳市",
  510701: "市辖区",
  510703: "涪城区",
  510704: "游仙区",
  510705: "安州区",
  510722: "三台县",
  510723: "盐亭县",
  510725: "梓潼县",
  510726: "北川羌族自治县",
  510727: "平武县",
  510781: "江油市",
  510800: "广元市",
  510801: "市辖区",
  510802: "利州区",
  510811: "昭化区",
  510812: "朝天区",
  510821: "旺苍县",
  510822: "青川县",
  510823: "剑阁县",
  510824: "苍溪县",
  510900: "遂宁市",
  510901: "市辖区",
  510903: "船山区",
  510904: "安居区",
  510921: "蓬溪县",
  510922: "射洪县",
  510923: "大英县",
  511e3: "内江市",
  511001: "市辖区",
  511002: "市中区",
  511011: "东兴区",
  511024: "威远县",
  511025: "资中县",
  511028: "隆昌县",
  511100: "乐山市",
  511101: "市辖区",
  511102: "市中区",
  511111: "沙湾区",
  511112: "五通桥区",
  511113: "金口河区",
  511123: "犍为县",
  511124: "井研县",
  511126: "夹江县",
  511129: "沐川县",
  511132: "峨边彝族自治县",
  511133: "马边彝族自治县",
  511181: "峨眉山市",
  511300: "南充市",
  511301: "市辖区",
  511302: "顺庆区",
  511303: "高坪区",
  511304: "嘉陵区",
  511321: "南部县",
  511322: "营山县",
  511323: "蓬安县",
  511324: "仪陇县",
  511325: "西充县",
  511381: "阆中市",
  511400: "眉山市",
  511401: "市辖区",
  511402: "东坡区",
  511403: "彭山区",
  511421: "仁寿县",
  511423: "洪雅县",
  511424: "丹棱县",
  511425: "青神县",
  511500: "宜宾市",
  511501: "市辖区",
  511502: "翠屏区",
  511503: "南溪区",
  511521: "宜宾县",
  511523: "江安县",
  511524: "长宁县",
  511525: "高县",
  511526: "珙县",
  511527: "筠连县",
  511528: "兴文县",
  511529: "屏山县",
  511600: "广安市",
  511601: "市辖区",
  511602: "广安区",
  511603: "前锋区",
  511621: "岳池县",
  511622: "武胜县",
  511623: "邻水县",
  511681: "华蓥市",
  511700: "达州市",
  511701: "市辖区",
  511702: "通川区",
  511703: "达川区",
  511722: "宣汉县",
  511723: "开江县",
  511724: "大竹县",
  511725: "渠县",
  511781: "万源市",
  511800: "雅安市",
  511801: "市辖区",
  511802: "雨城区",
  511803: "名山区",
  511822: "荥经县",
  511823: "汉源县",
  511824: "石棉县",
  511825: "天全县",
  511826: "芦山县",
  511827: "宝兴县",
  511900: "巴中市",
  511901: "市辖区",
  511902: "巴州区",
  511903: "恩阳区",
  511921: "通江县",
  511922: "南江县",
  511923: "平昌县",
  512e3: "资阳市",
  512001: "市辖区",
  512002: "雁江区",
  512021: "安岳县",
  512022: "乐至县",
  513200: "阿坝藏族羌族自治州",
  513201: "马尔康市",
  513221: "汶川县",
  513222: "理县",
  513223: "茂县",
  513224: "松潘县",
  513225: "九寨沟县",
  513226: "金川县",
  513227: "小金县",
  513228: "黑水县",
  513230: "壤塘县",
  513231: "阿坝县",
  513232: "若尔盖县",
  513233: "红原县",
  513300: "甘孜藏族自治州",
  513301: "康定市",
  513322: "泸定县",
  513323: "丹巴县",
  513324: "九龙县",
  513325: "雅江县",
  513326: "道孚县",
  513327: "炉霍县",
  513328: "甘孜县",
  513329: "新龙县",
  513330: "德格县",
  513331: "白玉县",
  513332: "石渠县",
  513333: "色达县",
  513334: "理塘县",
  513335: "巴塘县",
  513336: "乡城县",
  513337: "稻城县",
  513338: "得荣县",
  513400: "凉山彝族自治州",
  513401: "西昌市",
  513422: "木里藏族自治县",
  513423: "盐源县",
  513424: "德昌县",
  513425: "会理县",
  513426: "会东县",
  513427: "宁南县",
  513428: "普格县",
  513429: "布拖县",
  513430: "金阳县",
  513431: "昭觉县",
  513432: "喜德县",
  513433: "冕宁县",
  513434: "越西县",
  513435: "甘洛县",
  513436: "美姑县",
  513437: "雷波县",
  52e4: "贵州省",
  520100: "贵阳市",
  520101: "市辖区",
  520102: "南明区",
  520103: "云岩区",
  520111: "花溪区",
  520112: "乌当区",
  520113: "白云区",
  520115: "观山湖区",
  520121: "开阳县",
  520122: "息烽县",
  520123: "修文县",
  520181: "清镇市",
  520200: "六盘水市",
  520201: "钟山区",
  520203: "六枝特区",
  520221: "水城县",
  520222: "盘县",
  520300: "遵义市",
  520301: "市辖区",
  520302: "红花岗区",
  520303: "汇川区",
  520304: "播州区",
  520322: "桐梓县",
  520323: "绥阳县",
  520324: "正安县",
  520325: "道真仡佬族苗族自治县",
  520326: "务川仡佬族苗族自治县",
  520327: "凤冈县",
  520328: "湄潭县",
  520329: "余庆县",
  520330: "习水县",
  520381: "赤水市",
  520382: "仁怀市",
  520400: "安顺市",
  520401: "市辖区",
  520402: "西秀区",
  520403: "平坝区",
  520422: "普定县",
  520423: "镇宁布依族苗族自治县",
  520424: "关岭布依族苗族自治县",
  520425: "紫云苗族布依族自治县",
  520500: "毕节市",
  520501: "市辖区",
  520502: "七星关区",
  520521: "大方县",
  520522: "黔西县",
  520523: "金沙县",
  520524: "织金县",
  520525: "纳雍县",
  520526: "威宁彝族回族苗族自治县",
  520527: "赫章县",
  520600: "铜仁市",
  520601: "市辖区",
  520602: "碧江区",
  520603: "万山区",
  520621: "江口县",
  520622: "玉屏侗族自治县",
  520623: "石阡县",
  520624: "思南县",
  520625: "印江土家族苗族自治县",
  520626: "德江县",
  520627: "沿河土家族自治县",
  520628: "松桃苗族自治县",
  522300: "黔西南布依族苗族自治州",
  522301: "兴义市",
  522322: "兴仁县",
  522323: "普安县",
  522324: "晴隆县",
  522325: "贞丰县",
  522326: "望谟县",
  522327: "册亨县",
  522328: "安龙县",
  522600: "黔东南苗族侗族自治州",
  522601: "凯里市",
  522622: "黄平县",
  522623: "施秉县",
  522624: "三穗县",
  522625: "镇远县",
  522626: "岑巩县",
  522627: "天柱县",
  522628: "锦屏县",
  522629: "剑河县",
  522630: "台江县",
  522631: "黎平县",
  522632: "榕江县",
  522633: "从江县",
  522634: "雷山县",
  522635: "麻江县",
  522636: "丹寨县",
  522700: "黔南布依族苗族自治州",
  522701: "都匀市",
  522702: "福泉市",
  522722: "荔波县",
  522723: "贵定县",
  522725: "瓮安县",
  522726: "独山县",
  522727: "平塘县",
  522728: "罗甸县",
  522729: "长顺县",
  522730: "龙里县",
  522731: "惠水县",
  522732: "三都水族自治县",
  53e4: "云南省",
  530100: "昆明市",
  530101: "市辖区",
  530102: "五华区",
  530103: "盘龙区",
  530111: "官渡区",
  530112: "西山区",
  530113: "东川区",
  530114: "呈贡区",
  530122: "晋宁县",
  530124: "富民县",
  530125: "宜良县",
  530126: "石林彝族自治县",
  530127: "嵩明县",
  530128: "禄劝彝族苗族自治县",
  530129: "寻甸回族彝族自治县",
  530181: "安宁市",
  530300: "曲靖市",
  530301: "市辖区",
  530302: "麒麟区",
  530303: "沾益区",
  530321: "马龙县",
  530322: "陆良县",
  530323: "师宗县",
  530324: "罗平县",
  530325: "富源县",
  530326: "会泽县",
  530381: "宣威市",
  530400: "玉溪市",
  530401: "市辖区",
  530402: "红塔区",
  530403: "江川区",
  530422: "澄江县",
  530423: "通海县",
  530424: "华宁县",
  530425: "易门县",
  530426: "峨山彝族自治县",
  530427: "新平彝族傣族自治县",
  530428: "元江哈尼族彝族傣族自治县",
  530500: "保山市",
  530501: "市辖区",
  530502: "隆阳区",
  530521: "施甸县",
  530523: "龙陵县",
  530524: "昌宁县",
  530581: "腾冲市",
  530600: "昭通市",
  530601: "市辖区",
  530602: "昭阳区",
  530621: "鲁甸县",
  530622: "巧家县",
  530623: "盐津县",
  530624: "大关县",
  530625: "永善县",
  530626: "绥江县",
  530627: "镇雄县",
  530628: "彝良县",
  530629: "威信县",
  530630: "水富县",
  530700: "丽江市",
  530701: "市辖区",
  530702: "古城区",
  530721: "玉龙纳西族自治县",
  530722: "永胜县",
  530723: "华坪县",
  530724: "宁蒗彝族自治县",
  530800: "普洱市",
  530801: "市辖区",
  530802: "思茅区",
  530821: "宁洱哈尼族彝族自治县",
  530822: "墨江哈尼族自治县",
  530823: "景东彝族自治县",
  530824: "景谷傣族彝族自治县",
  530825: "镇沅彝族哈尼族拉祜族自治县",
  530826: "江城哈尼族彝族自治县",
  530827: "孟连傣族拉祜族佤族自治县",
  530828: "澜沧拉祜族自治县",
  530829: "西盟佤族自治县",
  530900: "临沧市",
  530901: "市辖区",
  530902: "临翔区",
  530921: "凤庆县",
  530922: "云县",
  530923: "永德县",
  530924: "镇康县",
  530925: "双江拉祜族佤族布朗族傣族自治县",
  530926: "耿马傣族佤族自治县",
  530927: "沧源佤族自治县",
  532300: "楚雄彝族自治州",
  532301: "楚雄市",
  532322: "双柏县",
  532323: "牟定县",
  532324: "南华县",
  532325: "姚安县",
  532326: "大姚县",
  532327: "永仁县",
  532328: "元谋县",
  532329: "武定县",
  532331: "禄丰县",
  532500: "红河哈尼族彝族自治州",
  532501: "个旧市",
  532502: "开远市",
  532503: "蒙自市",
  532504: "弥勒市",
  532523: "屏边苗族自治县",
  532524: "建水县",
  532525: "石屏县",
  532527: "泸西县",
  532528: "元阳县",
  532529: "红河县",
  532530: "金平苗族瑶族傣族自治县",
  532531: "绿春县",
  532532: "河口瑶族自治县",
  532600: "文山壮族苗族自治州",
  532601: "文山市",
  532622: "砚山县",
  532623: "西畴县",
  532624: "麻栗坡县",
  532625: "马关县",
  532626: "丘北县",
  532627: "广南县",
  532628: "富宁县",
  532800: "西双版纳傣族自治州",
  532801: "景洪市",
  532822: "勐海县",
  532823: "勐腊县",
  532900: "大理白族自治州",
  532901: "大理市",
  532922: "漾濞彝族自治县",
  532923: "祥云县",
  532924: "宾川县",
  532925: "弥渡县",
  532926: "南涧彝族自治县",
  532927: "巍山彝族回族自治县",
  532928: "永平县",
  532929: "云龙县",
  532930: "洱源县",
  532931: "剑川县",
  532932: "鹤庆县",
  533100: "德宏傣族景颇族自治州",
  533102: "瑞丽市",
  533103: "芒市",
  533122: "梁河县",
  533123: "盈江县",
  533124: "陇川县",
  533300: "怒江傈僳族自治州",
  533301: "泸水市",
  533323: "福贡县",
  533324: "贡山独龙族怒族自治县",
  533325: "兰坪白族普米族自治县",
  533400: "迪庆藏族自治州",
  533401: "香格里拉市",
  533422: "德钦县",
  533423: "维西傈僳族自治县",
  54e4: "西藏自治区",
  540100: "拉萨市",
  540101: "市辖区",
  540102: "城关区",
  540103: "堆龙德庆区",
  540121: "林周县",
  540122: "当雄县",
  540123: "尼木县",
  540124: "曲水县",
  540126: "达孜县",
  540127: "墨竹工卡县",
  540200: "日喀则市",
  540202: "桑珠孜区",
  540221: "南木林县",
  540222: "江孜县",
  540223: "定日县",
  540224: "萨迦县",
  540225: "拉孜县",
  540226: "昂仁县",
  540227: "谢通门县",
  540228: "白朗县",
  540229: "仁布县",
  540230: "康马县",
  540231: "定结县",
  540232: "仲巴县",
  540233: "亚东县",
  540234: "吉隆县",
  540235: "聂拉木县",
  540236: "萨嘎县",
  540237: "岗巴县",
  540300: "昌都市",
  540302: "卡若区",
  540321: "江达县",
  540322: "贡觉县",
  540323: "类乌齐县",
  540324: "丁青县",
  540325: "察雅县",
  540326: "八宿县",
  540327: "左贡县",
  540328: "芒康县",
  540329: "洛隆县",
  540330: "边坝县",
  540400: "林芝市",
  540402: "巴宜区",
  540421: "工布江达县",
  540422: "米林县",
  540423: "墨脱县",
  540424: "波密县",
  540425: "察隅县",
  540426: "朗县",
  540500: "山南市",
  540501: "市辖区",
  540502: "乃东区",
  540521: "扎囊县",
  540522: "贡嘎县",
  540523: "桑日县",
  540524: "琼结县",
  540525: "曲松县",
  540526: "措美县",
  540527: "洛扎县",
  540528: "加查县",
  540529: "隆子县",
  540530: "错那县",
  540531: "浪卡子县",
  542400: "那曲地区",
  542421: "那曲县",
  542422: "嘉黎县",
  542423: "比如县",
  542424: "聂荣县",
  542425: "安多县",
  542426: "申扎县",
  542427: "索县",
  542428: "班戈县",
  542429: "巴青县",
  542430: "尼玛县",
  542431: "双湖县",
  542500: "阿里地区",
  542521: "普兰县",
  542522: "札达县",
  542523: "噶尔县",
  542524: "日土县",
  542525: "革吉县",
  542526: "改则县",
  542527: "措勤县",
  61e4: "陕西省",
  610100: "西安市",
  610101: "市辖区",
  610102: "新城区",
  610103: "碑林区",
  610104: "莲湖区",
  610111: "灞桥区",
  610112: "未央区",
  610113: "雁塔区",
  610114: "阎良区",
  610115: "临潼区",
  610116: "长安区",
  610117: "高陵区",
  610122: "蓝田县",
  610124: "周至县",
  610125: "户县",
  610200: "铜川市",
  610201: "市辖区",
  610202: "王益区",
  610203: "印台区",
  610204: "耀州区",
  610222: "宜君县",
  610300: "宝鸡市",
  610301: "市辖区",
  610302: "渭滨区",
  610303: "金台区",
  610304: "陈仓区",
  610322: "凤翔县",
  610323: "岐山县",
  610324: "扶风县",
  610326: "眉县",
  610327: "陇县",
  610328: "千阳县",
  610329: "麟游县",
  610330: "凤县",
  610331: "太白县",
  610400: "咸阳市",
  610401: "市辖区",
  610402: "秦都区",
  610403: "杨陵区",
  610404: "渭城区",
  610422: "三原县",
  610423: "泾阳县",
  610424: "乾县",
  610425: "礼泉县",
  610426: "永寿县",
  610427: "彬县",
  610428: "长武县",
  610429: "旬邑县",
  610430: "淳化县",
  610431: "武功县",
  610481: "兴平市",
  610500: "渭南市",
  610501: "市辖区",
  610502: "临渭区",
  610503: "华州区",
  610522: "潼关县",
  610523: "大荔县",
  610524: "合阳县",
  610525: "澄城县",
  610526: "蒲城县",
  610527: "白水县",
  610528: "富平县",
  610581: "韩城市",
  610582: "华阴市",
  610600: "延安市",
  610601: "市辖区",
  610602: "宝塔区",
  610603: "安塞区",
  610621: "延长县",
  610622: "延川县",
  610623: "子长县",
  610625: "志丹县",
  610626: "吴起县",
  610627: "甘泉县",
  610628: "富县",
  610629: "洛川县",
  610630: "宜川县",
  610631: "黄龙县",
  610632: "黄陵县",
  610700: "汉中市",
  610701: "市辖区",
  610702: "汉台区",
  610721: "南郑县",
  610722: "城固县",
  610723: "洋县",
  610724: "西乡县",
  610725: "勉县",
  610726: "宁强县",
  610727: "略阳县",
  610728: "镇巴县",
  610729: "留坝县",
  610730: "佛坪县",
  610800: "榆林市",
  610801: "市辖区",
  610802: "榆阳区",
  610803: "横山区",
  610821: "神木县",
  610822: "府谷县",
  610824: "靖边县",
  610825: "定边县",
  610826: "绥德县",
  610827: "米脂县",
  610828: "佳县",
  610829: "吴堡县",
  610830: "清涧县",
  610831: "子洲县",
  610900: "安康市",
  610901: "市辖区",
  610902: "汉滨区",
  610921: "汉阴县",
  610922: "石泉县",
  610923: "宁陕县",
  610924: "紫阳县",
  610925: "岚皋县",
  610926: "平利县",
  610927: "镇坪县",
  610928: "旬阳县",
  610929: "白河县",
  611e3: "商洛市",
  611001: "市辖区",
  611002: "商州区",
  611021: "洛南县",
  611022: "丹凤县",
  611023: "商南县",
  611024: "山阳县",
  611025: "镇安县",
  611026: "柞水县",
  62e4: "甘肃省",
  620100: "兰州市",
  620101: "市辖区",
  620102: "城关区",
  620103: "七里河区",
  620104: "西固区",
  620105: "安宁区",
  620111: "红古区",
  620121: "永登县",
  620122: "皋兰县",
  620123: "榆中县",
  620200: "嘉峪关市",
  620201: "市辖区",
  620300: "金昌市",
  620301: "市辖区",
  620302: "金川区",
  620321: "永昌县",
  620400: "白银市",
  620401: "市辖区",
  620402: "白银区",
  620403: "平川区",
  620421: "靖远县",
  620422: "会宁县",
  620423: "景泰县",
  620500: "天水市",
  620501: "市辖区",
  620502: "秦州区",
  620503: "麦积区",
  620521: "清水县",
  620522: "秦安县",
  620523: "甘谷县",
  620524: "武山县",
  620525: "张家川回族自治县",
  620600: "武威市",
  620601: "市辖区",
  620602: "凉州区",
  620621: "民勤县",
  620622: "古浪县",
  620623: "天祝藏族自治县",
  620700: "张掖市",
  620701: "市辖区",
  620702: "甘州区",
  620721: "肃南裕固族自治县",
  620722: "民乐县",
  620723: "临泽县",
  620724: "高台县",
  620725: "山丹县",
  620800: "平凉市",
  620801: "市辖区",
  620802: "崆峒区",
  620821: "泾川县",
  620822: "灵台县",
  620823: "崇信县",
  620824: "华亭县",
  620825: "庄浪县",
  620826: "静宁县",
  620900: "酒泉市",
  620901: "市辖区",
  620902: "肃州区",
  620921: "金塔县",
  620922: "瓜州县",
  620923: "肃北蒙古族自治县",
  620924: "阿克塞哈萨克族自治县",
  620981: "玉门市",
  620982: "敦煌市",
  621e3: "庆阳市",
  621001: "市辖区",
  621002: "西峰区",
  621021: "庆城县",
  621022: "环县",
  621023: "华池县",
  621024: "合水县",
  621025: "正宁县",
  621026: "宁县",
  621027: "镇原县",
  621100: "定西市",
  621101: "市辖区",
  621102: "安定区",
  621121: "通渭县",
  621122: "陇西县",
  621123: "渭源县",
  621124: "临洮县",
  621125: "漳县",
  621126: "岷县",
  621200: "陇南市",
  621201: "市辖区",
  621202: "武都区",
  621221: "成县",
  621222: "文县",
  621223: "宕昌县",
  621224: "康县",
  621225: "西和县",
  621226: "礼县",
  621227: "徽县",
  621228: "两当县",
  622900: "临夏回族自治州",
  622901: "临夏市",
  622921: "临夏县",
  622922: "康乐县",
  622923: "永靖县",
  622924: "广河县",
  622925: "和政县",
  622926: "东乡族自治县",
  622927: "积石山保安族东乡族撒拉族自治县",
  623e3: "甘南藏族自治州",
  623001: "合作市",
  623021: "临潭县",
  623022: "卓尼县",
  623023: "舟曲县",
  623024: "迭部县",
  623025: "玛曲县",
  623026: "碌曲县",
  623027: "夏河县",
  63e4: "青海省",
  630100: "西宁市",
  630101: "市辖区",
  630102: "城东区",
  630103: "城中区",
  630104: "城西区",
  630105: "城北区",
  630121: "大通回族土族自治县",
  630122: "湟中县",
  630123: "湟源县",
  630200: "海东市",
  630202: "乐都区",
  630203: "平安区",
  630222: "民和回族土族自治县",
  630223: "互助土族自治县",
  630224: "化隆回族自治县",
  630225: "循化撒拉族自治县",
  632200: "海北藏族自治州",
  632221: "门源回族自治县",
  632222: "祁连县",
  632223: "海晏县",
  632224: "刚察县",
  632300: "黄南藏族自治州",
  632321: "同仁县",
  632322: "尖扎县",
  632323: "泽库县",
  632324: "河南蒙古族自治县",
  632500: "海南藏族自治州",
  632521: "共和县",
  632522: "同德县",
  632523: "贵德县",
  632524: "兴海县",
  632525: "贵南县",
  632600: "果洛藏族自治州",
  632621: "玛沁县",
  632622: "班玛县",
  632623: "甘德县",
  632624: "达日县",
  632625: "久治县",
  632626: "玛多县",
  632700: "玉树藏族自治州",
  632701: "玉树市",
  632722: "杂多县",
  632723: "称多县",
  632724: "治多县",
  632725: "囊谦县",
  632726: "曲麻莱县",
  632800: "海西蒙古族藏族自治州",
  632801: "格尔木市",
  632802: "德令哈市",
  632821: "乌兰县",
  632822: "都兰县",
  632823: "天峻县",
  64e4: "宁夏回族自治区",
  640100: "银川市",
  640101: "市辖区",
  640104: "兴庆区",
  640105: "西夏区",
  640106: "金凤区",
  640121: "永宁县",
  640122: "贺兰县",
  640181: "灵武市",
  640200: "石嘴山市",
  640201: "市辖区",
  640202: "大武口区",
  640205: "惠农区",
  640221: "平罗县",
  640300: "吴忠市",
  640301: "市辖区",
  640302: "利通区",
  640303: "红寺堡区",
  640323: "盐池县",
  640324: "同心县",
  640381: "青铜峡市",
  640400: "固原市",
  640401: "市辖区",
  640402: "原州区",
  640422: "西吉县",
  640423: "隆德县",
  640424: "泾源县",
  640425: "彭阳县",
  640500: "中卫市",
  640501: "市辖区",
  640502: "沙坡头区",
  640521: "中宁县",
  640522: "海原县",
  65e4: "新疆维吾尔自治区",
  650100: "乌鲁木齐市",
  650101: "市辖区",
  650102: "天山区",
  650103: "沙依巴克区",
  650104: "新市区",
  650105: "水磨沟区",
  650106: "头屯河区",
  650107: "达坂城区",
  650109: "米东区",
  650121: "乌鲁木齐县",
  650200: "克拉玛依市",
  650201: "市辖区",
  650202: "独山子区",
  650203: "克拉玛依区",
  650204: "白碱滩区",
  650205: "乌尔禾区",
  650400: "吐鲁番市",
  650402: "高昌区",
  650421: "鄯善县",
  650422: "托克逊县",
  650500: "哈密市",
  650502: "伊州区",
  650521: "巴里坤哈萨克自治县",
  650522: "伊吾县",
  652300: "昌吉回族自治州",
  652301: "昌吉市",
  652302: "阜康市",
  652323: "呼图壁县",
  652324: "玛纳斯县",
  652325: "奇台县",
  652327: "吉木萨尔县",
  652328: "木垒哈萨克自治县",
  652700: "博尔塔拉蒙古自治州",
  652701: "博乐市",
  652702: "阿拉山口市",
  652722: "精河县",
  652723: "温泉县",
  652800: "巴音郭楞蒙古自治州",
  652801: "库尔勒市",
  652822: "轮台县",
  652823: "尉犁县",
  652824: "若羌县",
  652825: "且末县",
  652826: "焉耆回族自治县",
  652827: "和静县",
  652828: "和硕县",
  652829: "博湖县",
  652900: "阿克苏地区",
  652901: "阿克苏市",
  652922: "温宿县",
  652923: "库车县",
  652924: "沙雅县",
  652925: "新和县",
  652926: "拜城县",
  652927: "乌什县",
  652928: "阿瓦提县",
  652929: "柯坪县",
  653e3: "克孜勒苏柯尔克孜自治州",
  653001: "阿图什市",
  653022: "阿克陶县",
  653023: "阿合奇县",
  653024: "乌恰县",
  653100: "喀什地区",
  653101: "喀什市",
  653121: "疏附县",
  653122: "疏勒县",
  653123: "英吉沙县",
  653124: "泽普县",
  653125: "莎车县",
  653126: "叶城县",
  653127: "麦盖提县",
  653128: "岳普湖县",
  653129: "伽师县",
  653130: "巴楚县",
  653131: "塔什库尔干塔吉克自治县",
  653200: "和田地区",
  653201: "和田市",
  653221: "和田县",
  653222: "墨玉县",
  653223: "皮山县",
  653224: "洛浦县",
  653225: "策勒县",
  653226: "于田县",
  653227: "民丰县",
  654e3: "伊犁哈萨克自治州",
  654002: "伊宁市",
  654003: "奎屯市",
  654004: "霍尔果斯市",
  654021: "伊宁县",
  654022: "察布查尔锡伯自治县",
  654023: "霍城县",
  654024: "巩留县",
  654025: "新源县",
  654026: "昭苏县",
  654027: "特克斯县",
  654028: "尼勒克县",
  654200: "塔城地区",
  654201: "塔城市",
  654202: "乌苏市",
  654221: "额敏县",
  654223: "沙湾县",
  654224: "托里县",
  654225: "裕民县",
  654226: "和布克赛尔蒙古自治县",
  654300: "阿勒泰地区",
  654301: "阿勒泰市",
  654321: "布尔津县",
  654322: "富蕴县",
  654323: "福海县",
  654324: "哈巴河县",
  654325: "青河县",
  654326: "吉木乃县",
  659e3: "自治区直辖县级行政区划",
  659001: "石河子市",
  659002: "阿拉尔市",
  659003: "图木舒克市",
  659004: "五家渠市",
  659006: "铁门关市",
  71e4: "台湾省",
  81e4: "香港特别行政区",
  82e4: "澳门特别行政区"
};
function qu(e, t, n) {
  if (!e || e.length !== t || !/^[0-9A-Z]+$/.test(e))
    throw new Error(n);
}
function re(e, t, n) {
  if (t.findIndex((r) => r == e) < 0)
    throw new Error(n);
}
function Hf(e, t, n) {
  const r = Object.entries(t).find(([i]) => i == e);
  if (!r)
    throw new Error(n || `{ ${e} } 不在范围内！`);
  return r[1];
}
function Xf(e, t, n) {
  const r = Object.entries(t).find(([i, s]) => s == e);
  if (!r)
    throw new Error(n || `{ ${e} } 不在范围内！`);
  return r[0];
}
function Wu(e, t, n, r) {
  let i = 0;
  for (let s = 0, o = n.length; s < o; s++) {
    if (!(e[s] in r))
      throw new Error(
        `计算校验码失败: 参与校验的字符 { ${e[s]} } 不在代码字符集范围内！`
      );
    const u = r[e[s]];
    i += u * n[s];
  }
  return i = (t - i % t) % t, Xf(
    i,
    r,
    `计算校验码失败: 校验码 { ${i} } 不在代码字符集范围内！`
  );
}
const Yf = 11, e1 = [3, 7, 9, 10, 5, 8, 4, 2], t1 = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  G: 16,
  H: 17,
  I: 18,
  J: 19,
  K: 20,
  L: 21,
  M: 22,
  N: 23,
  O: 24,
  P: 25,
  Q: 26,
  R: 27,
  S: 28,
  T: 29,
  U: 30,
  V: 31,
  W: 32,
  X: 33,
  Y: 34,
  Z: 35
};
function n1(e) {
  if (qu(
    e,
    9,
    "不符合《GB 11714-1997》：组织机构代码只能 9 位 且 大写！"
  ), Wu(e, Yf, e1, t1) !== e[8])
    throw new Error("不符合《GB 11714-1997》：校验码检验失败");
  return !0;
}
const r1 = 31, i1 = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28], s1 = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  G: 16,
  H: 17,
  J: 18,
  K: 19,
  L: 20,
  M: 21,
  N: 22,
  P: 23,
  Q: 24,
  R: 25,
  T: 26,
  U: 27,
  W: 28,
  X: 29,
  Y: 30
};
function KF(e) {
  qu(
    e,
    18,
    "不符合《GB 32100-2015》：税号只能 18 位 且 大写！"
  );
  const t = e[0];
  re(
    t,
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "N", "Y"],
    "不符合《GB 32100-2015》： { 第1位 : 登记管理部门代码 } "
  );
  const n = e[1], r = "不符合《GB 32100-2015》： { 第2位 : 机构类别代码 } ";
  switch (t) {
    case "1":
      re(n, ["1", "2", "3", "9"], r);
      break;
    case "2":
      re(n, ["1", "9"], r);
      break;
    case "3":
      re(
        n,
        ["1", "2", "3", "4", "5", "9"],
        r
      );
      break;
    case "4":
      re(n, ["1", "9"], r);
      break;
    case "5":
      re(n, ["1", "2", "3", "9"], r);
      break;
    case "6":
      re(n, ["1", "2", "9"], r);
      break;
    case "7":
      re(n, ["1", "2", "9"], r);
      break;
    case "8":
      re(n, ["1", "9"], r);
      break;
    case "9":
      re(n, ["1", "2", "3"], r);
      break;
    case "A":
      re(n, ["1", "9"], r);
      break;
    case "N":
      re(n, ["1", "2", "3", "9"], r);
      break;
    case "Y":
      re(n, ["1"], r);
      break;
  }
  const i = e.substring(2, 8);
  Hf(
    i,
    Jf,
    "不符合《GB 32100-2015》： { 第3位 ~ 第8位 : 登记管理机关行政区划码 } "
  );
  const s = e.substring(8, 17);
  try {
    n1(s);
  } catch {
    throw new Error(
      "不符合《GB 32100-2015》： { 第9位 ~ 第17位 : 主体标识码 (组织机构代码) }"
    );
  }
  if (Wu(e, r1, i1, s1) !== e[17])
    throw new Error("不符合《GB 32100-2015》：校验码检验失败");
  return !0;
}
function Gu(e = window.location.href, t) {
  try {
    return new URL(e, t);
  } catch {
    const r = "(?<protocol>https?:)", i = "(?<host>(?<hostname>[^/#?:]+)(?::(?<port>\\d+))?)", s = "(?<pathname>(?:\\/[^/#?]+)*\\/?)", o = "(?<search>(?:\\?[^#]*)?)", u = "(?<hash>(?:#.*)?)", c = new RegExp(`^${r}//${i}${s}${o}${u}$`).exec(e);
    return {
      href: e,
      protocol: c?.groups?.protocol || "",
      host: c?.groups?.host || "",
      hostname: c?.groups?.hostname || "",
      port: c?.groups?.port || "",
      pathname: c?.groups?.pathname || "",
      search: c?.groups?.search || "",
      hash: c?.groups?.hash || ""
    };
  }
}
const o1 = /https?|ftp|gopher|file/;
function QF(e) {
  let { auth: t } = e;
  const { hostname: n } = e;
  let r = e.protocol || "", i = e.pathname || "", s = e.hash || "", o = e.query || "", u = !1;
  t = t ? encodeURIComponent(t).replace(/%3A/i, ":") + "@" : "", e.host ? u = t + e.host : n && (u = t + (~n.indexOf(":") ? `[${n}]` : n), e.port && (u += ":" + e.port)), o && typeof o == "object" && (o = String(u1(o)));
  let a = e.search || o && `?${o}` || "";
  return r && !r.endsWith(":") && (r += ":"), e.slashes || (!r || o1.test(r)) && u !== !1 ? (u = "//" + (u || ""), i && i[0] !== "/" && (i = "/" + i)) : u || (u = ""), s && s[0] !== "#" && (s = "#" + s), a && a[0] !== "?" && (a = "?" + a), i = i.replace(/[?#]/g, encodeURIComponent), a = a.replace("#", "%23"), `${r}${u}${i}${a}${s}`;
}
function JF(e) {
  const t = Gu(e);
  return t.protocol === "http:" || t.protocol === "https:";
}
function HF() {
  return new URLSearchParams(window.location.search);
}
function ds(e) {
  return typeof e == "string" || typeof e == "number" && !Number.isNaN(e) || typeof e == "boolean" ? String(e) : "";
}
function u1(e) {
  const t = new URLSearchParams();
  return Object.entries(e).forEach(([n, r]) => {
    Array.isArray(r) ? r.forEach((i) => t.append(n, ds(i))) : t.set(n, ds(r));
  }), t;
}
function a1(e) {
  return !e.includes("://") || e.includes(window.location.origin);
}
function XF(e = window.location.href) {
  const t = Gu(e), n = t.href.indexOf(t.hash);
  return t.hash && n >= 0 ? t.href.substring(0, n) : t.href;
}
function c1(e, t) {
  return e.replace(/(?:\?.*)?$/, t.replace(/^[&?]/, "?"));
}
function YF(e, t) {
  return c1(e, Vu(t));
}
function l1(e, t) {
  return e + t.replace(/^[&?]/, e.indexOf("?") >= 0 ? "&" : "?");
}
function eE(e, t) {
  return l1(e, Vu(t));
}
function tE(e = window.location.href) {
  const t = {};
  let n = decodeURIComponent(e).split(/[?]/)[1];
  if (n || (n = e), n = n.replace(/^[#?&]/, ""), n = n.replace(/#\/(([^?&=]*))$/, ""), n) {
    const r = /(?:^|&)([^&=]*)=?([^&]*?)(?=&|$)/y;
    let i = r.exec(n);
    for (; i; )
      t[i[1]] = i[2], i = r.exec(n);
  }
  return t;
}
function nE(e = window.location.href) {
  return JSON.parse(
    '{"' + decodeURI(e.split("?")[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
  );
}
function Vu(e) {
  return "?" + Object.entries(e).map(([t, n]) => `${encodeURIComponent(t)}=${encodeURIComponent(n)}`).join("&");
}
function rE(e) {
  return "?" + [...e.entries()].map(
    (t) => encodeURIComponent(t[0]) + "=" + encodeURIComponent(t[1] instanceof File ? t[1].name : t[1])
  ).join("&");
}
async function h1(e, t) {
  if (a1(e))
    return e;
  const r = await (await fetch(e)).text(), i = new URL(e).href.split("/");
  i.pop();
  const s = `const _importScripts = importScripts;
const _fixImports = (url) => new URL(url, '${i.join("/") + "/"}').href;
importScripts = (...urls) => _importScripts(...urls.map(_fixImports));
`, o = "application/javascript";
  let u = `data:${o},` + encodeURIComponent(s + r);
  return (typeof t?.useBlob == "boolean" ? t?.useBlob : !0) && (u = URL.createObjectURL(
    new Blob([`importScripts("${u}")`], { type: o })
  )), u;
}
class iE {
  worker;
  constructor() {
    if (!Th)
      throw new Error("Your environment do not support Worker !");
  }
  async createFromURL(t, n = !1) {
    const r = await h1(t);
    return n ? (this.worker = new SharedWorker(r, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker.port.start()) : this.worker = new Worker(r, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker;
  }
  async createFromCode(t, n = !1) {
    const r = new Blob([t]), i = URL.createObjectURL(r);
    return n ? (this.worker = new SharedWorker(i, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker.port.start()) : this.worker = new Worker(i, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker;
  }
  terminate() {
    this.worker instanceof Worker && this.worker.terminate(), this.worker instanceof SharedWorker && this.worker.port.close();
  }
  // type Transferable = OffscreenCanvas | ImageBitmap | MessagePort | ReadableStream | WritableStream | TransformStream | ArrayBuffer;
  postMessage(t, n = []) {
    const r = Do();
    return this.worker instanceof Worker && this.worker.postMessage({ id: r, message: t }, n), this.worker instanceof SharedWorker && this.worker.port.postMessage({ id: r, message: t }, n), r;
  }
  postCanvas(t) {
    const n = t.transferControlToOffscreen();
    this.postMessage({ canvas: n }, [n]);
  }
  postPort(t) {
    this.postMessage({ port: t }, [t]);
  }
  onmessage(t) {
    this.worker instanceof Worker && this.worker.addEventListener("message", t), this.worker instanceof SharedWorker && this.worker.port.addEventListener("message", t);
  }
  offmessage(t) {
    this.worker instanceof Worker && this.worker.removeEventListener("message", t), this.worker instanceof SharedWorker && this.worker.port.removeEventListener("message", t);
  }
  onmessageerror(t) {
    this.worker instanceof Worker && this.worker.addEventListener("messageerror", t), this.worker instanceof SharedWorker && this.worker.port.addEventListener("messageerror", t);
  }
  offmessageerror(t) {
    this.worker instanceof Worker && this.worker.removeEventListener("messageerror", t), this.worker instanceof SharedWorker && this.worker.port.removeEventListener("messageerror", t);
  }
}
function Ku(e) {
  return e * Math.PI / 180;
}
const sE = Ku;
function oe(e) {
  return e * 180 / Math.PI;
}
const oE = oe;
function xr(e, t, n = 0) {
  return Math.sqrt(e * e + t * t + n * n);
}
function uE(e, t, n, r) {
  return xr(n - e, r - t);
}
function f1(e, t, n, r) {
  let i = Math.atan2(r - t, n - e);
  return i < 0 && (i += Math.PI * 2), i;
}
function aE(e, t) {
  return {
    dx: Math.cos(e) * t,
    dy: Math.sin(e) * t
  };
}
function cE(e, t, n) {
  if (typeof n == "number") {
    const r = xr(e, t, n);
    return {
      x: e /= r,
      y: t /= r,
      z: n /= r
    };
  } else {
    const r = xr(e, t);
    return {
      x: e /= r,
      y: t /= r
    };
  }
}
function lE(e, t, n, r, i = 10) {
  if (Math.abs(n - e) < i && Math.abs(r - t) < i)
    return "no";
  const s = oe(f1(e, t, n, r));
  return s >= -135 && s <= -45 ? "up" : s > 45 && s < 135 ? "down" : s >= 135 && s <= 180 || s >= -180 && s < -135 ? "left" : "right";
}
function d1(e) {
  const t = [];
  return e.replace(
    /([a-z0-9]+)\s*\(?\s*((-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)*[a-z%]*\s*,?\s*)+)\)?/gi,
    (n, r, i) => {
      const s = [];
      return i.split(/\s*[,\s]+\s*/).forEach((o) => {
        o.trim() && s.push({
          v: X(o, 0),
          unit: o.match(/[a-z%]+$/)?.[0] || ""
        });
      }), t.push({
        command: r,
        values: s
      }), "";
    }
  ), t;
}
function ye(e, t = 0) {
  if (!e)
    return t;
  switch (e.unit) {
    case "turn":
      return e.v * 360;
    case "rad":
      return oe(e.v);
    case "deg":
    default:
      return e.v;
  }
}
function hE(e, t) {
  if (!e || !t)
    return !1;
  const n = e.x !== t.x, r = e.y !== t.y;
  return n || r;
}
class Z {
  precision = 1e-6;
  x;
  y;
  z;
  w;
  // 齐次坐标 w = 1：表示 3D 点坐标  w = 0：作为一个向量或方向使用
  constructor(t = 0, n = 0, r = 0, i = 1) {
    this.x = t, this.y = n, this.z = r, this.w = i;
  }
  clone() {
    return new Z(this.x, this.y, this.z, this.w);
  }
  add(t) {
    return new Z(this.x + t.x, this.y + t.y, this.z + t.z, this.w);
  }
  sub(t) {
    return new Z(this.x - t.x, this.y - t.y, this.z - t.z, this.w);
  }
  multiply(t) {
    return new Z(this.x * t.x, this.y * t.y, this.z * t.z, this.w);
  }
  divide(t) {
    return new Z(this.x / t.x, this.y / t.y, this.z / t.z, this.w);
  }
  min(t) {
    return new Z(
      Math.min(this.x, t.x),
      Math.min(this.y, t.y),
      Math.min(this.z, t.z),
      this.w
    );
  }
  max(t) {
    return new Z(
      Math.max(this.x, t.x),
      Math.max(this.y, t.y),
      Math.max(this.z, t.z),
      this.w
    );
  }
  clamp(t, n) {
    return new Z(
      N(this.x, t.x, n.x),
      N(this.y, t.y, n.y),
      N(this.z, t.z, n.z),
      this.w
    );
  }
  floor() {
    return new Z(
      Math.floor(this.x),
      Math.floor(this.y),
      Math.floor(this.z),
      this.w
    );
  }
  ceil() {
    return new Z(
      Math.ceil(this.x),
      Math.ceil(this.y),
      Math.ceil(this.z),
      this.w
    );
  }
  round() {
    return new Z(
      Math.round(this.x),
      Math.round(this.y),
      Math.round(this.z),
      this.w
    );
  }
  roundToZero() {
    return new Z(
      Math.trunc(this.x),
      Math.trunc(this.y),
      Math.trunc(this.z),
      this.w
    );
  }
  negate() {
    return new Z(
      this.x - this.x,
      this.y - this.y,
      this.z - this.z,
      this.w
    );
  }
  // Returns the scalar product of the vector with the argument
  // Both vectors must have equal dimensionality
  dot(t) {
    const n = t.toArray(), r = this.toArray();
    let i = 0, s = 3;
    do
      i += r[s - 1] * n[s - 1];
    while (--s);
    return i;
  }
  // Returns the vector product of the vector with the argument
  // Both vectors must have dimensionality 3
  cross(t) {
    const n = t.toArray(), r = this.toArray();
    return new Z(
      r[1] * n[2] - r[2] * n[1],
      r[2] * n[0] - r[0] * n[2],
      r[0] * n[1] - r[1] * n[0]
    );
  }
  length() {
    return Math.sqrt(this.dot(this));
  }
  distance(t) {
    return this.sub(t).length();
  }
  normalize() {
    const t = this.length();
    return t == 0 ? new Z() : new Z(this.x / t, this.y / t, this.z / t, this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  // Returns the angle between the vector and the argument (also a vector)
  degreeFrom(t) {
    const n = t.toArray();
    let r = 0, i = 0, s = 0;
    if (this.toArray().forEach((u, a) => {
      r += u * n[a], i += u * u, s += n[a] * n[a];
    }), i = Math.sqrt(i), s = Math.sqrt(s), i * s === 0)
      return;
    let o = r / (i * s);
    return o < -1 && (o = -1), o > 1 && (o = 1), oe(Math.acos(o));
  }
  // Returns true iff the vector is parallel to the argument
  isParallelTo(t) {
    const n = this.degreeFrom(t);
    return n === void 0 ? void 0 : n <= this.precision;
  }
  // 2D: 与 x 轴正方向之间的弧度值
  radian() {
    let t = Math.atan2(this.y, this.x);
    return t < 0 && (t += Math.PI * 2), t;
  }
  // 2D: 与 x 轴正方向之间的角度值
  degree() {
    return oe(this.radian());
  }
  // 2D: 返回滑动方向
  getDirection(t = 10) {
    if (Math.abs(this.x) < t && Math.abs(this.y) < t)
      return "no";
    const n = this.degree();
    return n >= -135 && n <= -45 ? "up" : n > 45 && n < 135 ? "down" : n >= 135 && n <= 180 || n >= -180 && n < -135 ? "left" : "right";
  }
  toArray() {
    return [this.x, this.y, this.z, this.w];
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class pe {
  _elements;
  _margin;
  // protected isCoordinateChanged = false;
  // private _is2D: boolean;
  // 2D矩阵属性
  get a() {
    return this._elements[0];
  }
  set a(t) {
    this._elements[0] = t;
  }
  get b() {
    return this._elements[1];
  }
  set b(t) {
    this._elements[1] = t;
  }
  get c() {
    return this._elements[4];
  }
  set c(t) {
    this._elements[4] = t;
  }
  get d() {
    return this._elements[5];
  }
  set d(t) {
    this._elements[5] = t;
  }
  get e() {
    return this._elements[12];
  }
  set e(t) {
    this._elements[12] = t;
  }
  get f() {
    return this._elements[13];
  }
  set f(t) {
    this._elements[13] = t;
  }
  // 3D矩阵属性
  get m11() {
    return this._elements[0];
  }
  set m11(t) {
    this._elements[0] = t;
  }
  get m12() {
    return this._elements[1];
  }
  set m12(t) {
    this._elements[1] = t;
  }
  get m13() {
    return this._elements[2];
  }
  set m13(t) {
    this._elements[2] = t;
  }
  get m14() {
    return this._elements[3];
  }
  set m14(t) {
    this._elements[3] = t;
  }
  get m21() {
    return this._elements[4];
  }
  set m21(t) {
    this._elements[4] = t;
  }
  get m22() {
    return this._elements[5];
  }
  set m22(t) {
    this._elements[5] = t;
  }
  get m23() {
    return this._elements[6];
  }
  set m23(t) {
    this._elements[6] = t;
  }
  get m24() {
    return this._elements[7];
  }
  set m24(t) {
    this._elements[7] = t;
  }
  get m31() {
    return this._elements[8];
  }
  set m31(t) {
    this._elements[8] = t;
  }
  get m32() {
    return this._elements[9];
  }
  set m32(t) {
    this._elements[9] = t;
  }
  get m33() {
    return this._elements[10];
  }
  set m33(t) {
    this._elements[10] = t;
  }
  get m34() {
    return this._elements[11];
  }
  set m34(t) {
    this._elements[11] = t;
  }
  get m41() {
    return this._elements[12];
  }
  set m41(t) {
    this._elements[12] = t;
  }
  get m42() {
    return this._elements[13];
  }
  set m42(t) {
    this._elements[13] = t;
  }
  get m43() {
    return this._elements[14];
  }
  set m43(t) {
    this._elements[14] = t;
  }
  get m44() {
    return this._elements[15];
  }
  set m44(t) {
    this._elements[15] = t;
  }
  get elements() {
    return Array.from(this._elements);
  }
  constructor(t, n) {
    this._margin = K0(n), this._elements = new Float64Array(16), this.identity(), t && (typeof t == "string" ? this._parseTransformString(t) : Array.isArray(t) ? this._fromArray(t) : t instanceof pe && this._elements.set(t._elements));
  }
  identity() {
    this._elements.fill(0), this.m11 = 1, this.m22 = 1, this.m33 = 1, this.m44 = 1;
  }
  get isIdentity() {
    return this._margin(this.m11, 1) && this._margin(this.m12, 0) && this._margin(this.m13, 0) && this._margin(this.m14, 0) && this._margin(this.m21, 0) && this._margin(this.m22, 1) && this._margin(this.m23, 0) && this._margin(this.m24, 0) && this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && this._margin(this.m41, 0) && this._margin(this.m42, 0) && this._margin(this.m43, 0) && this._margin(this.m44, 1);
  }
  get isCoordinateChanged() {
    return !(this._margin(this.m11, 1) && this._margin(this.m12, 0) && this._margin(this.m13, 0) && this._margin(this.m14, 0) && this._margin(this.m21, 0) && this._margin(this.m22, 1) && this._margin(this.m23, 0) && this._margin(this.m24, 0) && this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && // this._margin(this.m41, 0) &&
    // this._margin(this.m42, 0) &&
    // this._margin(this.m43, 0) &&
    this._margin(this.m44, 1));
  }
  get is2D() {
    return this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && this._margin(this.m43, 0) && this._margin(this.m44, 1);
  }
  _fromArray(t) {
    if (t.length === 6)
      this._elements.set([
        t[0],
        t[1],
        0,
        0,
        t[2],
        t[3],
        0,
        0,
        0,
        0,
        1,
        0,
        t[4],
        t[5],
        0,
        1
      ]);
    else if (t.length === 16)
      this._elements.set(t);
    else
      throw new TypeError(
        "Invalid matrix length (must be 6 for 2D or 16 for 3D)"
      );
  }
  // 矩阵不满足交换律，所以顺序很重要
  _parseTransformString(t) {
    return d1(t).forEach(({ command: n, values: r }) => {
      switch (n) {
        case "m":
        case "matrix":
        case "matrix3d":
          this._fromArray(r.map((i) => i.v));
          break;
        case "t":
        case "translate":
        case "translate3d":
          this.translateSelf(
            r[0]?.v || 0,
            r[1]?.v || 0,
            r[2]?.v || 0
          );
          break;
        case "translateX":
          this.translateSelf(r[0]?.v || 0, 0, 0);
          break;
        case "translateY":
          this.translateSelf(0, r[0]?.v || 0, 0);
          break;
        case "translateZ":
          this.translateSelf(0, 0, r[0]?.v || 0);
          break;
        case "r":
        case "rotate":
        case "rotateZ":
          this.rotateSelf(ye(r[0], 0), 0, 0, 1);
          break;
        case "rotateX":
          this.rotateSelf(ye(r[0], 0), 1, 0, 0);
          break;
        case "rotateY":
          this.rotateSelf(ye(r[0], 0), 0, 1, 0);
          break;
        case "rotate3d":
          this.rotateSelf(
            ye(r[3], 0),
            ye(r[0], 0),
            ye(r[1], 0),
            ye(r[2], 0)
          );
          break;
        case "s":
        case "scale":
        case "scale3d":
          this.scaleSelf(
            r[0]?.v || 1,
            r[1]?.v || r[0]?.v || 1,
            r[2]?.v || 1
          );
          break;
        case "scaleX":
          this.scaleSelf(r[0]?.v || 1, 1, 1);
          break;
        case "scaleY":
          this.scaleSelf(1, r[0]?.v || 1, 1);
          break;
        case "scaleZ":
          this.scaleSelf(1, 1, r[0]?.v || 1);
          break;
        case "skewX":
          this.skewXSelf(ye(r[0], 0));
          break;
        case "skewY":
          this.skewYSelf(ye(r[0], 0));
          break;
        case "none":
        default:
          _e(`Unsupported transform function: ${n}`);
      }
    }), this;
  }
  // other * this  =>  this first, then other
  multiply(t) {
    return this.clone().multiplySelf(t);
  }
  // other * this  =>  this first, then other
  multiplySelf(t) {
    const n = this.elements, r = t.elements, i = new Float64Array(16);
    for (let s = 0; s < 4; s++)
      for (let o = 0; o < 4; o++)
        i[s * 4 + o] = n[s * 4 + 0] * r[0 * 4 + o] + n[s * 4 + 1] * r[1 * 4 + o] + n[s * 4 + 2] * r[2 * 4 + o] + n[s * 4 + 3] * r[3 * 4 + o];
    return this._elements.set(i), this;
  }
  translate(t, n = 0, r = 0) {
    return this.clone().translateSelf(t, n, r);
  }
  translateSelf(t, n = 0, r = 0) {
    const i = new pe();
    if (this.isCoordinateChanged) {
      const s = this.transformPoint(new Z(t, n, r));
      i.m41 = s.x, i.m42 = s.y, i.m43 = s.z;
    } else
      i.m41 = t, i.m42 = n, i.m43 = r;
    return this.multiplySelf(i);
  }
  rotate(t, n = 0, r = 0, i = 1) {
    return this.clone().rotateSelf(t, n, r, i);
  }
  // x, y, z 代表旋转轴的方向向量
  // 对于多个旋转，通常是先绕 Z 轴旋转，然后绕 Y 轴，再绕 X 轴
  rotateSelf(t, n = 0, r = 0, i = 1) {
    if (this.isCoordinateChanged) {
      const c = this.transformPoint(new Z(n, r, i));
      n = c.x, r = c.y, i = c.z;
    }
    const s = t * Math.PI / 180, o = Math.cos(s), u = Math.sin(s), a = new pe();
    if (n === 0 && r === 0 && i === 1)
      a.m11 = o, a.m12 = u, a.m21 = -u, a.m22 = o;
    else if (n === 1 && r === 0 && i === 0)
      a.m22 = o, a.m23 = u, a.m32 = -u, a.m33 = o;
    else if (n === 0 && r === 1 && i === 0)
      a.m11 = o, a.m13 = -u, a.m31 = u, a.m33 = o;
    else {
      const c = Math.sqrt(n * n + r * r + i * i) || 1;
      if (c == 0)
        return this;
      const l = n / c, f = r / c, d = i / c, h = 1 - o;
      a.m11 = o + l * l * h, a.m12 = l * f * h + d * u, a.m13 = l * d * h - f * u, a.m21 = f * l * h - d * u, a.m22 = o + f * f * h, a.m23 = f * d * h + l * u, a.m31 = d * l * h + f * u, a.m32 = d * f * h - l * u, a.m33 = o + d * d * h;
    }
    return this.multiplySelf(a);
  }
  scale(t, n = t, r = 1) {
    return this.clone().scaleSelf(t, n, r);
  }
  scaleSelf(t, n = t, r = 1) {
    const i = new pe();
    return i.m11 = t, i.m22 = n, i.m33 = r, this.multiplySelf(i);
  }
  skewX(t) {
    return this.clone().skewXSelf(t);
  }
  skewXSelf(t) {
    const n = t * Math.PI / 180, r = new pe();
    return r.m21 = Math.tan(n), this.multiplySelf(r);
  }
  skewY(t) {
    return this.clone().skewYSelf(t);
  }
  skewYSelf(t) {
    const n = t * Math.PI / 180, r = new pe();
    return r.m12 = Math.tan(n), this.multiplySelf(r);
  }
  // skewZ(degree: number): DomMatrix {
  //   return this.clone().skewZSelf(degree);
  // }
  // skewZSelf(degree: number): this {
  //   const rad = (degree * Math.PI) / 180;
  //   const skew = new DomMatrix();
  //   skew.m13 = Math.tan(rad); // c参数
  //   // if (skew.m13 !== 0) {
  //   //   this.isCoordinateChanged = true;
  //   // }
  //   return this.multiplySelf(skew);
  // }
  to2D() {
    return new pe([
      this.a,
      this.b,
      this.c,
      this.d,
      this.e,
      this.f
    ]);
  }
  // 正射投影
  // | 2/(r-l)   0         0      -(r+l)/(r-l) |
  // | 0         2/(t-b)   0      -(t+b)/(t-b) |
  // | 0         0         -2/(f-n)  -(f+n)/(f-n) |
  // | 0         0         0       1            |
  // 透视投影
  // | 2n/(r-l)  0        (r+l)/(r-l)   0       |
  // | 0        2n/(t-b)  (t+b)/(t-b)   0       |
  // | 0        0        -(f+n)/(f-n)   -2fn/(f-n) |
  // | 0        0        -1             0       |
  inverse() {
    return this.clone().invertSelf();
  }
  /**
   * Inverts the matrix
   * -> based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
   * -> based on https://github.com/mrdoob/three.js/blob/master/src/math/Matrix4.js
   */
  invertSelf() {
    if (this.is2D) {
      const t = this.a * this.d - this.b * this.c;
      if (t === 0)
        throw new Error("Matrix is not invertible.");
      const n = 1 / t;
      return this.multiplySelf(
        new pe([
          this.d * n,
          -this.b * n,
          -this.c * n,
          this.a * n,
          (this.c * this.f - this.d * this.e) * n,
          (this.b * this.e - this.a * this.f) * n
        ])
      );
    } else {
      const t = Array.from(this.elements), n = t[0], r = t[1], i = t[2], s = t[3], o = t[4], u = t[5], a = t[6], c = t[7], l = t[8], f = t[9], d = t[10], h = t[11], p = t[12], m = t[13], D = t[14], y = t[15], F = f * D * c - m * d * c + m * a * h - u * D * h - f * a * y + u * d * y, S = p * d * c - l * D * c - p * a * h + o * D * h + l * a * y - o * d * y, v = l * m * c - p * f * c + p * u * h - o * m * h - l * u * y + o * f * y, E = p * f * a - l * m * a - p * u * d + o * m * d + l * u * D - o * f * D, R = n * F + r * S + i * v + s * E;
      if (R === 0)
        throw new Error("Matrix is not invertible.");
      const A = 1 / R;
      return t[0] = F * A, t[1] = (m * d * s - f * D * s - m * i * h + r * D * h + f * i * y - r * d * y) * A, t[2] = (u * D * s - m * a * s + m * i * c - r * D * c - u * i * y + r * a * y) * A, t[3] = (f * a * s - u * d * s - f * i * c + r * d * c + u * i * h - r * a * h) * A, t[4] = S * A, t[5] = (l * D * s - p * d * s + p * i * h - n * D * h - l * i * y + n * d * y) * A, t[6] = (p * a * s - o * D * s - p * i * c + n * D * c + o * i * y - n * a * y) * A, t[7] = (o * d * s - l * a * s + l * i * c - n * d * c - o * i * h + n * a * h) * A, t[8] = v * A, t[9] = (p * f * s - l * m * s - p * r * h + n * m * h + l * r * y - n * f * y) * A, t[10] = (o * m * s - p * u * s + p * r * c - n * m * c - o * r * y + n * u * y) * A, t[11] = (l * u * s - o * f * s - l * r * c + n * f * c + o * r * h - n * u * h) * A, t[12] = E * A, t[13] = (l * m * i - p * f * i + p * r * d - n * m * d - l * r * D + n * f * D) * A, t[14] = (p * u * i - o * m * i - p * r * a + n * m * a + o * r * D - n * u * D) * A, t[15] = (o * f * i - l * u * i + l * r * a - n * f * a - o * r * d + n * u * d) * A, this._elements.set(t), this;
    }
  }
  transformPoint(t) {
    const { x: n = 0, y: r = 0, z: i = 0, w: s = 1 } = t, o = new Z(
      this.m11 * n + this.m21 * r + this.m31 * i + this.m41 * s,
      this.m12 * n + this.m22 * r + this.m32 * i + this.m42 * s,
      this.m13 * n + this.m23 * r + this.m33 * i + this.m43 * s,
      this.m14 * n + this.m24 * r + this.m34 * i + this.m44 * s
    );
    return o.w !== 1 && (o.x /= o.w, o.y /= o.w, o.z /= o.w), o;
  }
  toString(t = 6) {
    return this.is2D ? `matrix(${[
      Fe(this.a, t),
      Fe(this.b, t),
      Fe(this.c, t),
      Fe(this.d, t),
      Fe(this.e, t),
      Fe(this.f, t)
    ].join(", ")})` : `matrix3d(${Array.from(this.elements).map((n) => Fe(n, t)).join(", ")})`;
  }
  toArray() {
    return this.is2D ? [this.a, this.b, this.c, this.d, this.e, this.f] : [
      this.m11,
      this.m12,
      this.m13,
      this.m14,
      this.m21,
      this.m22,
      this.m23,
      this.m24,
      this.m31,
      this.m32,
      this.m33,
      this.m34,
      this.m41,
      this.m42,
      this.m43,
      this.m44
    ];
  }
  clone() {
    return new pe(this);
  }
  split() {
    const t = Math.sqrt(
      this.m11 * this.m11 + this.m12 * this.m12 + this.m13 * this.m13
    ), n = Math.sqrt(
      this.m21 * this.m21 + this.m22 * this.m22 + this.m23 * this.m23
    ), r = Math.sqrt(
      this.m31 * this.m31 + this.m32 * this.m32 + this.m33 * this.m33
    ), i = oe(N(Math.asin(-this.m13), -1, 1));
    let s = oe(Math.atan2(this.m23, this.m33));
    Math.cos(Ku(i)) === 0 && (s = oe(Math.atan2(-this.m31, this.m22)));
    let o = oe(Math.atan2(this.m12, this.m11));
    return this.m11 < 0 && this.m22 >= 0 && (o += 180), {
      x: this.m41,
      y: this.m42,
      z: this.m43,
      scalarX: t,
      scalarY: n,
      scalarZ: r,
      degreeX: s,
      degreeY: i,
      degreeZ: o,
      skewX: oe(this.m14),
      skewY: oe(this.m24),
      skewZ: oe(this.m34),
      skewW: this.m44,
      perspective: this.m34 ? -(1 / this.m34) : 0
    };
  }
  // 行列式
  determinant() {
    if (this.is2D)
      return this.a * this.d - this.b * this.c;
    const t = this.elements, n = t[0], r = t[4], i = t[8], s = t[12], o = t[1], u = t[5], a = t[9], c = t[13], l = t[2], f = t[6], d = t[10], h = t[14], p = t[3], m = t[7], D = t[11], y = t[15];
    return p * (+s * a * f - i * c * f - s * u * d + r * c * d + i * u * h - r * a * h) + m * (+n * a * h - n * c * d + s * o * d - i * o * h + i * c * l - s * a * l) + D * (+n * c * f - n * u * h - s * o * f + r * o * h + s * u * l - r * c * l) + y * (-i * u * l - n * a * f + n * u * d + i * o * f - r * o * d + r * a * l);
  }
}
function Qu(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: p1 } = Object.prototype, { getPrototypeOf: Fi } = Object, jn = ((e) => (t) => {
  const n = p1.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), he = (e) => (e = e.toLowerCase(), (t) => jn(t) === e), Un = (e) => (t) => typeof t === e, { isArray: ft } = Array, Tt = Un("undefined");
function m1(e) {
  return e !== null && !Tt(e) && e.constructor !== null && !Tt(e.constructor) && se(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ju = he("ArrayBuffer");
function D1(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Ju(e.buffer), t;
}
const g1 = Un("string"), se = Un("function"), Hu = Un("number"), Zn = (e) => e !== null && typeof e == "object", y1 = (e) => e === !0 || e === !1, rn = (e) => {
  if (jn(e) !== "object")
    return !1;
  const t = Fi(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, b1 = he("Date"), w1 = he("File"), F1 = he("Blob"), E1 = he("FileList"), v1 = (e) => Zn(e) && se(e.pipe), _1 = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || se(e.append) && ((t = jn(e)) === "formdata" || // detect form-data instance
  t === "object" && se(e.toString) && e.toString() === "[object FormData]"));
}, S1 = he("URLSearchParams"), [A1, O1, C1, T1] = ["ReadableStream", "Request", "Response", "Headers"].map(he), R1 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Mt(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, i;
  if (typeof e != "object" && (e = [e]), ft(e))
    for (r = 0, i = e.length; r < i; r++)
      t.call(null, e[r], r, e);
  else {
    const s = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = s.length;
    let u;
    for (r = 0; r < o; r++)
      u = s[r], t.call(null, e[u], u, e);
  }
}
function Xu(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], t === i.toLowerCase())
      return i;
  return null;
}
const ze = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Yu = (e) => !Tt(e) && e !== ze;
function kr() {
  const { caseless: e } = Yu(this) && this || {}, t = {}, n = (r, i) => {
    const s = e && Xu(t, i) || i;
    rn(t[s]) && rn(r) ? t[s] = kr(t[s], r) : rn(r) ? t[s] = kr({}, r) : ft(r) ? t[s] = r.slice() : t[s] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && Mt(arguments[r], n);
  return t;
}
const x1 = (e, t, n, { allOwnKeys: r } = {}) => (Mt(t, (i, s) => {
  n && se(i) ? e[s] = Qu(i, n) : e[s] = i;
}, { allOwnKeys: r }), e), k1 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), N1 = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, I1 = (e, t, n, r) => {
  let i, s, o;
  const u = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (i = Object.getOwnPropertyNames(e), s = i.length; s-- > 0; )
      o = i[s], (!r || r(o, e, t)) && !u[o] && (t[o] = e[o], u[o] = !0);
    e = n !== !1 && Fi(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, P1 = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, z1 = (e) => {
  if (!e)
    return null;
  if (ft(e))
    return e;
  let t = e.length;
  if (!Hu(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, B1 = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Fi(Uint8Array)), $1 = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const s = i.value;
    t.call(e, s[0], s[1]);
  }
}, L1 = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, M1 = he("HTMLFormElement"), j1 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), ps = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), U1 = he("RegExp"), ea = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Mt(n, (i, s) => {
    let o;
    (o = t(i, s, e)) !== !1 && (r[s] = o || i);
  }), Object.defineProperties(e, r);
}, Z1 = (e) => {
  ea(e, (t, n) => {
    if (se(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (se(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, q1 = (e, t) => {
  const n = {}, r = (i) => {
    i.forEach((s) => {
      n[s] = !0;
    });
  };
  return ft(e) ? r(e) : r(String(e).split(t)), n;
}, W1 = () => {
}, G1 = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function V1(e) {
  return !!(e && se(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const K1 = (e) => {
  const t = new Array(10), n = (r, i) => {
    if (Zn(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[i] = r;
        const s = ft(r) ? [] : {};
        return Mt(r, (o, u) => {
          const a = n(o, i + 1);
          !Tt(a) && (s[u] = a);
        }), t[i] = void 0, s;
      }
    }
    return r;
  };
  return n(e, 0);
}, Q1 = he("AsyncFunction"), J1 = (e) => e && (Zn(e) || se(e)) && se(e.then) && se(e.catch), ta = ((e, t) => e ? setImmediate : t ? ((n, r) => (ze.addEventListener("message", ({ source: i, data: s }) => {
  i === ze && s === n && r.length && r.shift()();
}, !1), (i) => {
  r.push(i), ze.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  se(ze.postMessage)
), H1 = typeof queueMicrotask < "u" ? queueMicrotask.bind(ze) : typeof process < "u" && process.nextTick || ta, g = {
  isArray: ft,
  isArrayBuffer: Ju,
  isBuffer: m1,
  isFormData: _1,
  isArrayBufferView: D1,
  isString: g1,
  isNumber: Hu,
  isBoolean: y1,
  isObject: Zn,
  isPlainObject: rn,
  isReadableStream: A1,
  isRequest: O1,
  isResponse: C1,
  isHeaders: T1,
  isUndefined: Tt,
  isDate: b1,
  isFile: w1,
  isBlob: F1,
  isRegExp: U1,
  isFunction: se,
  isStream: v1,
  isURLSearchParams: S1,
  isTypedArray: B1,
  isFileList: E1,
  forEach: Mt,
  merge: kr,
  extend: x1,
  trim: R1,
  stripBOM: k1,
  inherits: N1,
  toFlatObject: I1,
  kindOf: jn,
  kindOfTest: he,
  endsWith: P1,
  toArray: z1,
  forEachEntry: $1,
  matchAll: L1,
  isHTMLForm: M1,
  hasOwnProperty: ps,
  hasOwnProp: ps,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ea,
  freezeMethods: Z1,
  toObjectSet: q1,
  toCamelCase: j1,
  noop: W1,
  toFiniteNumber: G1,
  findKey: Xu,
  global: ze,
  isContextDefined: Yu,
  isSpecCompliantForm: V1,
  toJSONObject: K1,
  isAsyncFn: Q1,
  isThenable: J1,
  setImmediate: ta,
  asap: H1
};
function C(e, t, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status ? i.status : null);
}
g.inherits(C, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: g.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const na = C.prototype, ra = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  ra[e] = { value: e };
});
Object.defineProperties(C, ra);
Object.defineProperty(na, "isAxiosError", { value: !0 });
C.from = (e, t, n, r, i, s) => {
  const o = Object.create(na);
  return g.toFlatObject(e, o, function(a) {
    return a !== Error.prototype;
  }, (u) => u !== "isAxiosError"), C.call(o, e.message, t, n, r, i), o.cause = e, o.name = e.name, s && Object.assign(o, s), o;
};
const X1 = null;
function Nr(e) {
  return g.isPlainObject(e) || g.isArray(e);
}
function ia(e) {
  return g.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ms(e, t, n) {
  return e ? e.concat(t).map(function(i, s) {
    return i = ia(i), !n && s ? "[" + i + "]" : i;
  }).join(n ? "." : "") : t;
}
function Y1(e) {
  return g.isArray(e) && !e.some(Nr);
}
const e2 = g.toFlatObject(g, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function qn(e, t, n) {
  if (!g.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = g.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, D) {
    return !g.isUndefined(D[m]);
  });
  const r = n.metaTokens, i = n.visitor || l, s = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && g.isSpecCompliantForm(t);
  if (!g.isFunction(i))
    throw new TypeError("visitor must be a function");
  function c(p) {
    if (p === null)
      return "";
    if (g.isDate(p))
      return p.toISOString();
    if (!a && g.isBlob(p))
      throw new C("Blob is not supported. Use a Buffer instead.");
    return g.isArrayBuffer(p) || g.isTypedArray(p) ? a && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function l(p, m, D) {
    let y = p;
    if (p && !D && typeof p == "object") {
      if (g.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), p = JSON.stringify(p);
      else if (g.isArray(p) && Y1(p) || (g.isFileList(p) || g.endsWith(m, "[]")) && (y = g.toArray(p)))
        return m = ia(m), y.forEach(function(S, v) {
          !(g.isUndefined(S) || S === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? ms([m], v, s) : o === null ? m : m + "[]",
            c(S)
          );
        }), !1;
    }
    return Nr(p) ? !0 : (t.append(ms(D, m, s), c(p)), !1);
  }
  const f = [], d = Object.assign(e2, {
    defaultVisitor: l,
    convertValue: c,
    isVisitable: Nr
  });
  function h(p, m) {
    if (!g.isUndefined(p)) {
      if (f.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      f.push(p), g.forEach(p, function(y, F) {
        (!(g.isUndefined(y) || y === null) && i.call(
          t,
          y,
          g.isString(F) ? F.trim() : F,
          m,
          d
        )) === !0 && h(y, m ? m.concat(F) : [F]);
      }), f.pop();
    }
  }
  if (!g.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function Ds(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Ei(e, t) {
  this._pairs = [], e && qn(e, this, t);
}
const sa = Ei.prototype;
sa.append = function(t, n) {
  this._pairs.push([t, n]);
};
sa.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Ds);
  } : Ds;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function t2(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function oa(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || t2;
  g.isFunction(n) && (n = {
    serialize: n
  });
  const i = n && n.serialize;
  let s;
  if (i ? s = i(t, n) : s = g.isURLSearchParams(t) ? t.toString() : new Ei(t, n).toString(r), s) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class n2 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    g.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const gs = n2, ua = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, r2 = typeof URLSearchParams < "u" ? URLSearchParams : Ei, i2 = typeof FormData < "u" ? FormData : null, s2 = typeof Blob < "u" ? Blob : null, o2 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: r2,
    FormData: i2,
    Blob: s2
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, vi = typeof window < "u" && typeof document < "u", Ir = typeof navigator == "object" && navigator || void 0, u2 = vi && (!Ir || ["ReactNative", "NativeScript", "NS"].indexOf(Ir.product) < 0), a2 = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), c2 = vi && window.location.href || "http://localhost", l2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: vi,
  hasStandardBrowserEnv: u2,
  hasStandardBrowserWebWorkerEnv: a2,
  navigator: Ir,
  origin: c2
}, Symbol.toStringTag, { value: "Module" })), J = {
  ...l2,
  ...o2
};
function h2(e, t) {
  return qn(e, new J.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, s) {
      return J.isNode && g.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function f2(e) {
  return g.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function d2(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const i = n.length;
  let s;
  for (r = 0; r < i; r++)
    s = n[r], t[s] = e[s];
  return t;
}
function aa(e) {
  function t(n, r, i, s) {
    let o = n[s++];
    if (o === "__proto__")
      return !0;
    const u = Number.isFinite(+o), a = s >= n.length;
    return o = !o && g.isArray(i) ? i.length : o, a ? (g.hasOwnProp(i, o) ? i[o] = [i[o], r] : i[o] = r, !u) : ((!i[o] || !g.isObject(i[o])) && (i[o] = []), t(n, r, i[o], s) && g.isArray(i[o]) && (i[o] = d2(i[o])), !u);
  }
  if (g.isFormData(e) && g.isFunction(e.entries)) {
    const n = {};
    return g.forEachEntry(e, (r, i) => {
      t(f2(r), i, n, 0);
    }), n;
  }
  return null;
}
function p2(e, t, n) {
  if (g.isString(e))
    try {
      return (t || JSON.parse)(e), g.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const _i = {
  transitional: ua,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, s = g.isObject(t);
    if (s && g.isHTMLForm(t) && (t = new FormData(t)), g.isFormData(t))
      return i ? JSON.stringify(aa(t)) : t;
    if (g.isArrayBuffer(t) || g.isBuffer(t) || g.isStream(t) || g.isFile(t) || g.isBlob(t) || g.isReadableStream(t))
      return t;
    if (g.isArrayBufferView(t))
      return t.buffer;
    if (g.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let u;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return h2(t, this.formSerializer).toString();
      if ((u = g.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return qn(
          u ? { "files[]": t } : t,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return s || i ? (n.setContentType("application/json", !1), p2(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || _i.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (g.isResponse(t) || g.isReadableStream(t))
      return t;
    if (t && g.isString(t) && (r && !this.responseType || i)) {
      const o = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (u) {
        if (o)
          throw u.name === "SyntaxError" ? C.from(u, C.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: J.classes.FormData,
    Blob: J.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
g.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  _i.headers[e] = {};
});
const Si = _i, m2 = g.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), D2 = (e) => {
  const t = {};
  let n, r, i;
  return e && e.split(`
`).forEach(function(o) {
    i = o.indexOf(":"), n = o.substring(0, i).trim().toLowerCase(), r = o.substring(i + 1).trim(), !(!n || t[n] && m2[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, ys = Symbol("internals");
function Et(e) {
  return e && String(e).trim().toLowerCase();
}
function sn(e) {
  return e === !1 || e == null ? e : g.isArray(e) ? e.map(sn) : String(e);
}
function g2(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const y2 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function hr(e, t, n, r, i) {
  if (g.isFunction(r))
    return r.call(this, t, n);
  if (i && (t = n), !!g.isString(t)) {
    if (g.isString(r))
      return t.indexOf(r) !== -1;
    if (g.isRegExp(r))
      return r.test(t);
  }
}
function b2(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function w2(e, t) {
  const n = g.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(i, s, o) {
        return this[r].call(this, t, i, s, o);
      },
      configurable: !0
    });
  });
}
class Wn {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const i = this;
    function s(u, a, c) {
      const l = Et(a);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const f = g.findKey(i, l);
      (!f || i[f] === void 0 || c === !0 || c === void 0 && i[f] !== !1) && (i[f || a] = sn(u));
    }
    const o = (u, a) => g.forEach(u, (c, l) => s(c, l, a));
    if (g.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (g.isString(t) && (t = t.trim()) && !y2(t))
      o(D2(t), n);
    else if (g.isHeaders(t))
      for (const [u, a] of t.entries())
        s(a, u, r);
    else
      t != null && s(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Et(t), t) {
      const r = g.findKey(this, t);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return g2(i);
        if (g.isFunction(n))
          return n.call(this, i, r);
        if (g.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Et(t), t) {
      const r = g.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || hr(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let i = !1;
    function s(o) {
      if (o = Et(o), o) {
        const u = g.findKey(r, o);
        u && (!n || hr(r, r[u], u, n)) && (delete r[u], i = !0);
      }
    }
    return g.isArray(t) ? t.forEach(s) : s(t), i;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const s = n[r];
      (!t || hr(this, this[s], s, t, !0)) && (delete this[s], i = !0);
    }
    return i;
  }
  normalize(t) {
    const n = this, r = {};
    return g.forEach(this, (i, s) => {
      const o = g.findKey(r, s);
      if (o) {
        n[o] = sn(i), delete n[s];
        return;
      }
      const u = t ? b2(s) : String(s).trim();
      u !== s && delete n[s], n[u] = sn(i), r[u] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return g.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = t && g.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(t) {
    const r = (this[ys] = this[ys] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function s(o) {
      const u = Et(o);
      r[u] || (w2(i, o), r[u] = !0);
    }
    return g.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
Wn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
g.reduceDescriptors(Wn.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
g.freezeMethods(Wn);
const le = Wn;
function fr(e, t) {
  const n = this || Si, r = t || n, i = le.from(r.headers);
  let s = r.data;
  return g.forEach(e, function(u) {
    s = u.call(n, s, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), s;
}
function ca(e) {
  return !!(e && e.__CANCEL__);
}
function dt(e, t, n) {
  C.call(this, e ?? "canceled", C.ERR_CANCELED, t, n), this.name = "CanceledError";
}
g.inherits(dt, C, {
  __CANCEL__: !0
});
function la(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new C(
    "Request failed with status code " + n.status,
    [C.ERR_BAD_REQUEST, C.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function F2(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function E2(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let i = 0, s = 0, o;
  return t = t !== void 0 ? t : 1e3, function(a) {
    const c = Date.now(), l = r[s];
    o || (o = c), n[i] = a, r[i] = c;
    let f = s, d = 0;
    for (; f !== i; )
      d += n[f++], f = f % e;
    if (i = (i + 1) % e, i === s && (s = (s + 1) % e), c - o < t)
      return;
    const h = l && c - l;
    return h ? Math.round(d * 1e3 / h) : void 0;
  };
}
function v2(e, t) {
  let n = 0, r = 1e3 / t, i, s;
  const o = (c, l = Date.now()) => {
    n = l, i = null, s && (clearTimeout(s), s = null), e.apply(null, c);
  };
  return [(...c) => {
    const l = Date.now(), f = l - n;
    f >= r ? o(c, l) : (i = c, s || (s = setTimeout(() => {
      s = null, o(i);
    }, r - f)));
  }, () => i && o(i)];
}
const Fn = (e, t, n = 3) => {
  let r = 0;
  const i = E2(50, 250);
  return v2((s) => {
    const o = s.loaded, u = s.lengthComputable ? s.total : void 0, a = o - r, c = i(a), l = o <= u;
    r = o;
    const f = {
      loaded: o,
      total: u,
      progress: u ? o / u : void 0,
      bytes: a,
      rate: c || void 0,
      estimated: c && u && l ? (u - o) / c : void 0,
      event: s,
      lengthComputable: u != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, n);
}, bs = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, ws = (e) => (...t) => g.asap(() => e(...t)), _2 = J.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, J.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(J.origin),
  J.navigator && /(msie|trident)/i.test(J.navigator.userAgent)
) : () => !0, S2 = J.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, i, s) {
      const o = [e + "=" + encodeURIComponent(t)];
      g.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), g.isString(r) && o.push("path=" + r), g.isString(i) && o.push("domain=" + i), s === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function A2(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function O2(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function ha(e, t, n) {
  let r = !A2(t);
  return e && (r || n == !1) ? O2(e, t) : t;
}
const Fs = (e) => e instanceof le ? { ...e } : e;
function je(e, t) {
  t = t || {};
  const n = {};
  function r(c, l, f, d) {
    return g.isPlainObject(c) && g.isPlainObject(l) ? g.merge.call({ caseless: d }, c, l) : g.isPlainObject(l) ? g.merge({}, l) : g.isArray(l) ? l.slice() : l;
  }
  function i(c, l, f, d) {
    if (g.isUndefined(l)) {
      if (!g.isUndefined(c))
        return r(void 0, c, f, d);
    } else
      return r(c, l, f, d);
  }
  function s(c, l) {
    if (!g.isUndefined(l))
      return r(void 0, l);
  }
  function o(c, l) {
    if (g.isUndefined(l)) {
      if (!g.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, l);
  }
  function u(c, l, f) {
    if (f in t)
      return r(c, l);
    if (f in e)
      return r(void 0, c);
  }
  const a = {
    url: s,
    method: s,
    data: s,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: u,
    headers: (c, l, f) => i(Fs(c), Fs(l), f, !0)
  };
  return g.forEach(Object.keys(Object.assign({}, e, t)), function(l) {
    const f = a[l] || i, d = f(e[l], t[l], l);
    g.isUndefined(d) && f !== u || (n[l] = d);
  }), n;
}
const fa = (e) => {
  const t = je({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: i, xsrfCookieName: s, headers: o, auth: u } = t;
  t.headers = o = le.from(o), t.url = oa(ha(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), u && o.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  );
  let a;
  if (g.isFormData(n)) {
    if (J.hasStandardBrowserEnv || J.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((a = o.getContentType()) !== !1) {
      const [c, ...l] = a ? a.split(";").map((f) => f.trim()).filter(Boolean) : [];
      o.setContentType([c || "multipart/form-data", ...l].join("; "));
    }
  }
  if (J.hasStandardBrowserEnv && (r && g.isFunction(r) && (r = r(t)), r || r !== !1 && _2(t.url))) {
    const c = i && s && S2.read(s);
    c && o.set(i, c);
  }
  return t;
}, C2 = typeof XMLHttpRequest < "u", T2 = C2 && function(e) {
  return new Promise(function(n, r) {
    const i = fa(e);
    let s = i.data;
    const o = le.from(i.headers).normalize();
    let { responseType: u, onUploadProgress: a, onDownloadProgress: c } = i, l, f, d, h, p;
    function m() {
      h && h(), p && p(), i.cancelToken && i.cancelToken.unsubscribe(l), i.signal && i.signal.removeEventListener("abort", l);
    }
    let D = new XMLHttpRequest();
    D.open(i.method.toUpperCase(), i.url, !0), D.timeout = i.timeout;
    function y() {
      if (!D)
        return;
      const S = le.from(
        "getAllResponseHeaders" in D && D.getAllResponseHeaders()
      ), E = {
        data: !u || u === "text" || u === "json" ? D.responseText : D.response,
        status: D.status,
        statusText: D.statusText,
        headers: S,
        config: e,
        request: D
      };
      la(function(A) {
        n(A), m();
      }, function(A) {
        r(A), m();
      }, E), D = null;
    }
    "onloadend" in D ? D.onloadend = y : D.onreadystatechange = function() {
      !D || D.readyState !== 4 || D.status === 0 && !(D.responseURL && D.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, D.onabort = function() {
      D && (r(new C("Request aborted", C.ECONNABORTED, e, D)), D = null);
    }, D.onerror = function() {
      r(new C("Network Error", C.ERR_NETWORK, e, D)), D = null;
    }, D.ontimeout = function() {
      let v = i.timeout ? "timeout of " + i.timeout + "ms exceeded" : "timeout exceeded";
      const E = i.transitional || ua;
      i.timeoutErrorMessage && (v = i.timeoutErrorMessage), r(new C(
        v,
        E.clarifyTimeoutError ? C.ETIMEDOUT : C.ECONNABORTED,
        e,
        D
      )), D = null;
    }, s === void 0 && o.setContentType(null), "setRequestHeader" in D && g.forEach(o.toJSON(), function(v, E) {
      D.setRequestHeader(E, v);
    }), g.isUndefined(i.withCredentials) || (D.withCredentials = !!i.withCredentials), u && u !== "json" && (D.responseType = i.responseType), c && ([d, p] = Fn(c, !0), D.addEventListener("progress", d)), a && D.upload && ([f, h] = Fn(a), D.upload.addEventListener("progress", f), D.upload.addEventListener("loadend", h)), (i.cancelToken || i.signal) && (l = (S) => {
      D && (r(!S || S.type ? new dt(null, e, D) : S), D.abort(), D = null);
    }, i.cancelToken && i.cancelToken.subscribe(l), i.signal && (i.signal.aborted ? l() : i.signal.addEventListener("abort", l)));
    const F = F2(i.url);
    if (F && J.protocols.indexOf(F) === -1) {
      r(new C("Unsupported protocol " + F + ":", C.ERR_BAD_REQUEST, e));
      return;
    }
    D.send(s || null);
  });
}, R2 = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), i;
    const s = function(c) {
      if (!i) {
        i = !0, u();
        const l = c instanceof Error ? c : this.reason;
        r.abort(l instanceof C ? l : new dt(l instanceof Error ? l.message : l));
      }
    };
    let o = t && setTimeout(() => {
      o = null, s(new C(`timeout ${t} of ms exceeded`, C.ETIMEDOUT));
    }, t);
    const u = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(s) : c.removeEventListener("abort", s);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", s));
    const { signal: a } = r;
    return a.unsubscribe = () => g.asap(u), a;
  }
}, x2 = R2, k2 = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, i;
  for (; r < n; )
    i = r + t, yield e.slice(r, i), r = i;
}, N2 = async function* (e, t) {
  for await (const n of I2(e))
    yield* k2(n, t);
}, I2 = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, Es = (e, t, n, r) => {
  const i = N2(e, t);
  let s = 0, o, u = (a) => {
    o || (o = !0, r && r(a));
  };
  return new ReadableStream({
    async pull(a) {
      try {
        const { done: c, value: l } = await i.next();
        if (c) {
          u(), a.close();
          return;
        }
        let f = l.byteLength;
        if (n) {
          let d = s += f;
          n(d);
        }
        a.enqueue(new Uint8Array(l));
      } catch (c) {
        throw u(c), c;
      }
    },
    cancel(a) {
      return u(a), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, Gn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", da = Gn && typeof ReadableStream == "function", P2 = Gn && (typeof TextEncoder == "function" ? ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), pa = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, z2 = da && pa(() => {
  let e = !1;
  const t = new Request(J.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), vs = 64 * 1024, Pr = da && pa(() => g.isReadableStream(new Response("").body)), En = {
  stream: Pr && ((e) => e.body)
};
Gn && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !En[t] && (En[t] = g.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new C(`Response type '${t}' is not supported`, C.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const B2 = async (e) => {
  if (e == null)
    return 0;
  if (g.isBlob(e))
    return e.size;
  if (g.isSpecCompliantForm(e))
    return (await new Request(J.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (g.isArrayBufferView(e) || g.isArrayBuffer(e))
    return e.byteLength;
  if (g.isURLSearchParams(e) && (e = e + ""), g.isString(e))
    return (await P2(e)).byteLength;
}, $2 = async (e, t) => {
  const n = g.toFiniteNumber(e.getContentLength());
  return n ?? B2(t);
}, L2 = Gn && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: i,
    cancelToken: s,
    timeout: o,
    onDownloadProgress: u,
    onUploadProgress: a,
    responseType: c,
    headers: l,
    withCredentials: f = "same-origin",
    fetchOptions: d
  } = fa(e);
  c = c ? (c + "").toLowerCase() : "text";
  let h = x2([i, s && s.toAbortSignal()], o), p;
  const m = h && h.unsubscribe && (() => {
    h.unsubscribe();
  });
  let D;
  try {
    if (a && z2 && n !== "get" && n !== "head" && (D = await $2(l, r)) !== 0) {
      let E = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), R;
      if (g.isFormData(r) && (R = E.headers.get("content-type")) && l.setContentType(R), E.body) {
        const [A, k] = bs(
          D,
          Fn(ws(a))
        );
        r = Es(E.body, vs, A, k);
      }
    }
    g.isString(f) || (f = f ? "include" : "omit");
    const y = "credentials" in Request.prototype;
    p = new Request(t, {
      ...d,
      signal: h,
      method: n.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: y ? f : void 0
    });
    let F = await fetch(p);
    const S = Pr && (c === "stream" || c === "response");
    if (Pr && (u || S && m)) {
      const E = {};
      ["status", "statusText", "headers"].forEach((w) => {
        E[w] = F[w];
      });
      const R = g.toFiniteNumber(F.headers.get("content-length")), [A, k] = u && bs(
        R,
        Fn(ws(u), !0)
      ) || [];
      F = new Response(
        Es(F.body, vs, A, () => {
          k && k(), m && m();
        }),
        E
      );
    }
    c = c || "text";
    let v = await En[g.findKey(En, c) || "text"](F, e);
    return !S && m && m(), await new Promise((E, R) => {
      la(E, R, {
        data: v,
        headers: le.from(F.headers),
        status: F.status,
        statusText: F.statusText,
        config: e,
        request: p
      });
    });
  } catch (y) {
    throw m && m(), y && y.name === "TypeError" && /fetch/i.test(y.message) ? Object.assign(
      new C("Network Error", C.ERR_NETWORK, e, p),
      {
        cause: y.cause || y
      }
    ) : C.from(y, y && y.code, e, p);
  }
}), zr = {
  http: X1,
  xhr: T2,
  fetch: L2
};
g.forEach(zr, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const _s = (e) => `- ${e}`, M2 = (e) => g.isFunction(e) || e === null || e === !1, ma = {
  getAdapter: (e) => {
    e = g.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const i = {};
    for (let s = 0; s < t; s++) {
      n = e[s];
      let o;
      if (r = n, !M2(n) && (r = zr[(o = String(n)).toLowerCase()], r === void 0))
        throw new C(`Unknown adapter '${o}'`);
      if (r)
        break;
      i[o || "#" + s] = r;
    }
    if (!r) {
      const s = Object.entries(i).map(
        ([u, a]) => `adapter ${u} ` + (a === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? s.length > 1 ? `since :
` + s.map(_s).join(`
`) : " " + _s(s[0]) : "as no adapter specified";
      throw new C(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: zr
};
function dr(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new dt(null, e);
}
function Ss(e) {
  return dr(e), e.headers = le.from(e.headers), e.data = fr.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), ma.getAdapter(e.adapter || Si.adapter)(e).then(function(r) {
    return dr(e), r.data = fr.call(
      e,
      e.transformResponse,
      r
    ), r.headers = le.from(r.headers), r;
  }, function(r) {
    return ca(r) || (dr(e), r && r.response && (r.response.data = fr.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = le.from(r.response.headers))), Promise.reject(r);
  });
}
const Da = "1.8.4", Vn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Vn[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const As = {};
Vn.transitional = function(t, n, r) {
  function i(s, o) {
    return "[Axios v" + Da + "] Transitional option '" + s + "'" + o + (r ? ". " + r : "");
  }
  return (s, o, u) => {
    if (t === !1)
      throw new C(
        i(o, " has been removed" + (n ? " in " + n : "")),
        C.ERR_DEPRECATED
      );
    return n && !As[o] && (As[o] = !0, console.warn(
      i(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(s, o, u) : !0;
  };
};
Vn.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function j2(e, t, n) {
  if (typeof e != "object")
    throw new C("options must be an object", C.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let i = r.length;
  for (; i-- > 0; ) {
    const s = r[i], o = t[s];
    if (o) {
      const u = e[s], a = u === void 0 || o(u, s, e);
      if (a !== !0)
        throw new C("option " + s + " must be " + a, C.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new C("Unknown option " + s, C.ERR_BAD_OPTION);
  }
}
const on = {
  assertOptions: j2,
  validators: Vn
}, fe = on.validators;
class vn {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new gs(),
      response: new gs()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let i = {};
        Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
        const s = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = je(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: s } = n;
    r !== void 0 && on.assertOptions(r, {
      silentJSONParsing: fe.transitional(fe.boolean),
      forcedJSONParsing: fe.transitional(fe.boolean),
      clarifyTimeoutError: fe.transitional(fe.boolean)
    }, !1), i != null && (g.isFunction(i) ? n.paramsSerializer = {
      serialize: i
    } : on.assertOptions(i, {
      encode: fe.function,
      serialize: fe.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), on.assertOptions(n, {
      baseUrl: fe.spelling("baseURL"),
      withXsrfToken: fe.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = s && g.merge(
      s.common,
      s[n.method]
    );
    s && g.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete s[p];
      }
    ), n.headers = le.concat(o, s);
    const u = [];
    let a = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (a = a && m.synchronous, u.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let l, f = 0, d;
    if (!a) {
      const p = [Ss.bind(this), void 0];
      for (p.unshift.apply(p, u), p.push.apply(p, c), d = p.length, l = Promise.resolve(n); f < d; )
        l = l.then(p[f++], p[f++]);
      return l;
    }
    d = u.length;
    let h = n;
    for (f = 0; f < d; ) {
      const p = u[f++], m = u[f++];
      try {
        h = p(h);
      } catch (D) {
        m.call(this, D);
        break;
      }
    }
    try {
      l = Ss.call(this, h);
    } catch (p) {
      return Promise.reject(p);
    }
    for (f = 0, d = c.length; f < d; )
      l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(t) {
    t = je(this.defaults, t);
    const n = ha(t.baseURL, t.url, t.allowAbsoluteUrls);
    return oa(n, t.params, t.paramsSerializer);
  }
}
g.forEach(["delete", "get", "head", "options"], function(t) {
  vn.prototype[t] = function(n, r) {
    return this.request(je(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
g.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(s, o, u) {
      return this.request(je(u || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: o
      }));
    };
  }
  vn.prototype[t] = n(), vn.prototype[t + "Form"] = n(!0);
});
const un = vn;
class Ai {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners)
        return;
      let s = r._listeners.length;
      for (; s-- > 0; )
        r._listeners[s](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let s;
      const o = new Promise((u) => {
        r.subscribe(u), s = u;
      }).then(i);
      return o.cancel = function() {
        r.unsubscribe(s);
      }, o;
    }, t(function(s, o, u) {
      r.reason || (r.reason = new dt(s, o, u), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ai(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
}
const U2 = Ai;
function Z2(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function q2(e) {
  return g.isObject(e) && e.isAxiosError === !0;
}
const Br = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Br).forEach(([e, t]) => {
  Br[t] = e;
});
const W2 = Br;
function ga(e) {
  const t = new un(e), n = Qu(un.prototype.request, t);
  return g.extend(n, un.prototype, t, { allOwnKeys: !0 }), g.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(i) {
    return ga(je(e, i));
  }, n;
}
const q = ga(Si);
q.Axios = un;
q.CanceledError = dt;
q.CancelToken = U2;
q.isCancel = ca;
q.VERSION = Da;
q.toFormData = qn;
q.AxiosError = C;
q.Cancel = q.CanceledError;
q.all = function(t) {
  return Promise.all(t);
};
q.spread = Z2;
q.isAxiosError = q2;
q.mergeConfig = je;
q.AxiosHeaders = le;
q.formToJSON = (e) => aa(g.isHTMLForm(e) ? new FormData(e) : e);
q.getAdapter = ma.getAdapter;
q.HttpStatusCode = W2;
q.default = q;
const ya = q;
class G2 {
  instance;
  constructor(t) {
    this.instance = ya.create(t), this.instance.interceptors.request.use(
      (n) => (t?.interceptors?.request?.(n), n),
      (n) => (t?.interceptors?.requestError?.(n), Promise.reject(n))
    ), this.instance.interceptors.response.use(
      (n) => (t?.interceptors?.response?.(n), n.status == 200, Promise.resolve(n)),
      (n) => (t?.interceptors?.responseError?.(n), Promise.reject(n))
    );
  }
  request(t) {
    let n = !1;
    const r = this.instance.request(t);
    return r.cancel = () => {
      n = !0;
    }, r.then((i) => {
      if (n)
        throw new Error("Canceled!");
      return i;
    });
  }
  get(t, n) {
    return this.request({ ...n, method: "get", url: t });
  }
  delete(t, n) {
    return this.request({ ...n, method: "delete", url: t });
  }
  head(t, n) {
    return this.request({ ...n, method: "head", url: t });
  }
  options(t, n) {
    return this.request({ ...n, method: "options", url: t });
  }
  post(t, n, r) {
    return this.request({ ...r, method: "post", url: t, data: n });
  }
  postFormData(t, n, r) {
    return r = {
      ...r,
      headers: {
        ...r?.headers,
        "Content-Type": "multipart/form-data"
      }
      // onUploadProgress: (e) => {
      //   console.log(Math.round((e.loaded / e.total) * 100) + "%");
      // }
    }, this.request({ ...r, method: "post", url: t, data: n });
  }
  // UNDO : application/octet-stream
  postForm(t, n, r) {
    return this.instance.postForm(t, n, {
      ...r
    });
  }
  put(t, n, r) {
    return this.request({ ...r, method: "put", url: t, data: n });
  }
  patch(t, n, r) {
    return this.request({ ...r, method: "patch", url: t, data: n });
  }
  getUri(t) {
    return this.instance.getUri(t);
  }
}
function V2(e) {
  return ya.isAxiosError(e) ? !e.response : !1;
}
function K2(e, t) {
  return zt(e.get, {
    ...t,
    shouldRetry: (n) => t?.shouldRetry ? t.shouldRetry(n) : V2(n)
  });
}
function fE(e, t) {
  return Ke(e.get, t);
}
function dE(e, t) {
  let n = K2(e, t);
  return n = Ke(n, t), n;
}
function pE(e, t, n = () => Date.now().toString(16)) {
  const r = `----FormBoundary${n()}`, i = [];
  i.push(
    Buffer.from(
      `--${r}\r
Content-Disposition: form-data; name="file"; filename="${t}"\r
Content-Type: application/octet-stream\r
\r
`
    )
  ), i.push(e), i.push(Buffer.from(`\r
`)), i.push(
    Buffer.from(
      `--${r}\r
Content-Disposition: form-data; name="purpose"\r
\r
user_data\r
`
    )
  ), i.push(Buffer.from(`--${r}--\r
`));
  const s = Buffer.concat(i);
  return {
    body: s,
    headers: {
      "Content-Type": `multipart/form-data; boundary=${r}`,
      "Content-Length": s.length.toString()
    }
  };
}
const $r = new kl({
  cacheKeyResolver: (e) => {
    const { method: t, url: n, body: r } = e;
    return Mh({ method: t, url: n, body: r });
  }
});
async function Oi(e, t) {
  if (typeof fetch > "u")
    throw new Error("fetch not supported!");
  const {
    responseType: n = gt.json,
    timeout: r = 6e4,
    onProgress: i
  } = t, s = { url: e, ...t }, o = $r.set(s), u = Ml([
    o.signal,
    // AbortError
    AbortSignal.timeout(r)
    // TimeoutError
  ]);
  let a = await fetch(
    new Request(e, {
      ...t,
      signal: u
      // headers: new Headers(headers),
      // credentials: "include" || "same-origin"
    })
  );
  if ($r.delete(s), !a.ok)
    throw new Error(
      `fetchWithFetch(${a.url}) failed: status(${a.status}) statusText(${a.statusText})`
    );
  if (i && typeof ReadableStream < "u" && a.body && a.body.getReader) {
    const c = a.body.getReader(), l = a.headers.get("X-File-Size") || a.headers.get("Content-Length"), f = l ? parseInt(l) : 0, d = f !== 0;
    let h = 0;
    const p = new ReadableStream({
      start(m) {
        function D() {
          c.read().then(({ done: y, value: F }) => {
            y ? m.close() : (h += F.byteLength, i?.(
              new ProgressEvent("progress", {
                lengthComputable: d,
                loaded: h,
                total: f
              })
            ), m.enqueue(F), D());
          }).catch((y) => {
            m.error(y);
          });
        }
        D();
      }
    });
    a = new Response(p);
  }
  switch (n) {
    case gt.arraybuffer:
      return await a.arrayBuffer();
    case gt.blob:
      return await a.blob();
    case gt.json:
      return await a.json();
    case gt.text:
    default:
      return await a.text();
  }
}
function mE(e, t) {
  $r.abort({ url: e, ...t });
}
function DE(e) {
  return zt(Oi, e);
}
function gE(e) {
  return Ke(Oi, e);
}
function yE(e) {
  return Ke(zt(Oi, e), e);
}
function bE(e, t = (n, r) => n <= r) {
  for (let n = 1, r = e.length; n < r; n++) {
    let i = !1;
    for (let s = 0; s < r - n; s++)
      t(e[s], e[s + 1]) || ([e[s], e[s + 1]] = [e[s + 1], e[s]], i = !0);
    if (!i)
      return;
  }
}
function wE(e, t = (n, r) => n <= r) {
  let n;
  for (let r = 0, i = e.length; r < i - 1; r++) {
    n = r;
    for (let s = r + 1; s < i; s++)
      t(e[n], e[s]) || (n = s);
    n != r && ([e[n], e[r]] = [e[r], e[n]]);
  }
}
function FE(e, t = (n, r) => n <= r) {
  for (let n = 1, r = e.length; n < r; n++) {
    const i = e[n];
    let s = n - 1;
    for (; s >= 0 && !t(e[s], i); )
      e[s + 1] = e[s], s--;
    e[s + 1] = i;
  }
}
function Os(e, t = (n, r) => n <= r) {
  const n = e.length;
  if (n < 2)
    return e;
  const r = Math.floor(n / 2), i = Os(e.slice(0, r), t), s = Os(e.slice(r), t), o = [];
  for (; i.length && s.length; )
    t(i[0], s[0]) ? o.push(i.shift()) : o.push(s.shift());
  for (; i.length; )
    o.push(i.shift());
  for (; s.length; )
    o.push(s.shift());
  return o;
}
function Cs(e, t = 0, n = e.length - 1, r = (i, s) => i <= s) {
  if (t >= n)
    return;
  const i = t + n >> 1;
  Cs(e, t, i, r), Cs(e, i + 1, n, r);
  let s = t, o = i + 1;
  const u = [];
  for (; s <= i && o <= n; )
    r(e[s], e[o]) ? u.push(e[s++]) : u.push(e[o++]);
  for (; s <= i; )
    u.push(e[s++]);
  for (; o <= n; )
    u.push(e[o++]);
  for (s = t, o = 0; s <= n; ++s, ++o)
    e[s] = u[o];
}
function Q2(e, t = 0, n = e.length - 1, r = (i, s) => i <= s) {
  if (t >= n)
    return t;
  const i = n, s = e[i];
  let o = t;
  for (let u = t; u <= n; u++)
    u != i && r(e[u], s) && ([e[o], e[u]] = [e[u], e[o]], o++);
  return [e[o], e[i]] = [
    e[i],
    e[o]
  ], o;
}
function Ts(e, t = 0, n = e.length - 1, r = (i, s) => i <= s) {
  if (t >= n)
    return;
  const i = Q2(e, t, n, r);
  Ts(e, t, i - 1, r), Ts(e, i + 1, n, r);
}
function Rs(e, t = 0, n = e.length - 1, r = (i, s) => i <= s) {
  if (t >= n)
    return;
  const i = t, s = e[i];
  let o = t, u = n;
  for (; o < u; ) {
    for (; o < n && r(e[o], s); )
      o++;
    for (; u > t && r(s, e[u]); )
      u--;
    o < u && ([e[o], e[u]] = [e[u], e[o]]);
  }
  [e[i], e[u]] = [e[u], e[i]], Rs(e, t, u - 1, r), Rs(e, u + 1, n, r);
}
function xs(e, t = 0, n = e.length - 1, r = (i, s) => i <= s) {
  if (t >= n)
    return;
  const i = t, s = e[i];
  let o = t, u = n, a = t;
  for (; a <= u; )
    r(e[a], s) ? ([e[o], e[a]] = [e[a], e[o]], o++, a++) : r(s, e[a]) ? ([e[a], e[u]] = [e[u], e[a]], u--) : a++;
  [e[i], e[u]] = [e[u], e[i]], xs(e, t, u - 1, r), xs(e, u + 1, n, r);
}
function EE(e, t = (n, r) => n <= r) {
  const n = e.length;
  let r = Math.floor(n / 2);
  for (; r > 0; ) {
    for (let i = r; i < n; i++) {
      const s = e[i];
      let o = i;
      for (; o >= r && !t(e[o - r], s); )
        e[o] = e[o - r], o -= r;
      e[o] = s;
    }
    r = Math.floor(r / 2);
  }
}
function vE(e, t = (n, r) => n <= r) {
  const n = new Bn(t, e), r = [];
  let i;
  for (; (i = n.pop()) !== null; )
    r.push(i);
  return r;
}
function _E(e, t) {
  let n = 0, r = e.length - 1;
  for (; n < r; ) {
    const i = Math.floor((n + r) / 2), s = e[i];
    if (s === t)
      return i;
    s < t ? n = i + 1 : r = i - 1;
  }
  return -1;
}
function SE(e, t) {
  function n(i, s, o) {
    const u = i[o];
    let a = s - 1;
    for (let c = s; c < o; c++)
      i[c] >= u && (a++, [i[a], i[c]] = [i[c], i[a]]);
    return [i[a + 1], i[o]] = [i[o], i[a + 1]], a + 1;
  }
  function r(i, s, o) {
    if (i === s)
      return e[i];
    const u = n(e, i, s);
    return u === o ? e[u] : u < o ? r(u + 1, s, o) : r(i, u - 1, o);
  }
  return r(0, e.length - 1, t - 1);
}
class AE {
  prefixSumArray;
  constructor(t) {
    const n = t.length + 1;
    this.prefixSumArray = Array.from({ length: n }).fill(0);
    for (let r = 1; r < n; r++)
      this.prefixSumArray[r] = this.prefixSumArray[r - 1] + t[r - 1];
  }
  // 查询闭区间 [i, j] 的累加和
  sum(t, n) {
    return this.prefixSumArray[n + 1] - this.prefixSumArray[t];
  }
}
class OE {
  diffArray;
  constructor(t) {
    const n = t.length;
    this.diffArray = Array.from({ length: n }).fill(0), this.diffArray[0] = t[0];
    for (let r = 1; r < n; r++)
      this.diffArray[r] = t[r] - t[r - 1];
  }
  // 根据差分数组构造结果数组
  result() {
    const t = this.diffArray.length, n = Array.from({ length: t }).fill(0);
    n[0] = this.diffArray[0];
    for (let r = 1; r < t; r++)
      n[r] = n[r - 1] + this.diffArray[r];
    return n;
  }
  // 对闭区间 [i, j]进行增减的操作 ，num 可以为负数
  // 原理很简单，根据 diffArray 数组反推 nums 数组的过程，diff[i] += 3 意味着给 nums[i..] 所有的元素都加了 3，然后 diffArray[j+1] -= 3 又意味着对于 nums[j+1..] 所有元素再减 3，那综合起来，是不是就是对 nums[i..j] 中的所有元素都加 3 了
  // 只要花费 O(1) 的时间修改 diffArray 数组，就相当于给 原数组 的整个区间做了修改
  operate(t, n, r) {
    t >= 0 && t < this.diffArray.length && (this.diffArray[t] += r), n + 1 >= 0 && n + 1 < this.diffArray.length && (this.diffArray[n + 1] -= r);
  }
}
class J2 {
  commands = [];
  pushCommand(t) {
    this.commands.push(t);
  }
  popCommand() {
    this.commands.pop();
  }
  executeCommands(...t) {
    this.commands.forEach((n) => this.executeCommand(n, ...t)), this.commands = [];
  }
  // 子类只需修改此方法
  executeCommand(t, ...n) {
    t.execute(...n);
  }
}
class H2 {
  data;
  constructor(t) {
    this.data = t;
  }
  get() {
    return this.data;
  }
}
class CE {
  state;
  saveState() {
    if (this.state)
      return new H2(this.state);
  }
  restoreState(t) {
    this.state = t.get();
  }
}
class TE extends J2 {
  originator;
  mementos = [];
  constructor(t) {
    super(), this.originator = t;
  }
  pushMemento(t) {
    this.mementos.push(t);
  }
  popMemento() {
    return this.mementos.pop();
  }
  executeCommand(t) {
    t.execute(this);
  }
}
class RE {
  execute(t) {
    const n = t.originator.saveState();
    n && t.pushMemento(n);
  }
}
class xE {
  execute(t) {
    const n = t.popMemento();
    n && t.originator.restoreState(n);
  }
}
function kE(e, t) {
  const n = typeof t?.aliveInSeconds == "number" ? Math.max(t.aliveInSeconds, 0) : -1, r = typeof t?.aliveUntilTimestamp == "number" ? Math.max(t.aliveUntilTimestamp, 0) : -1;
  function i(a, c = !1) {
    return ti(a) || Ge(a) || Oe(a) ? { value: a, timestamp: Zt() } : c && Object.prototype.hasOwnProperty.call(a, "timestamp") ? a : {
      ...a,
      timestamp: Zt()
    };
  }
  let s = i(e, !0);
  function o() {
    let a = !1;
    return (n >= 0 && Zt() > X(s.timestamp, 0) + n * 1e3 || r >= 0 && Zt() > r) && (a = !0), a && (s.value = void 0), s;
  }
  function u(a) {
    return s = i(a, !1);
  }
  return {
    get: o,
    set: u
  };
}
function NE(e) {
  const t = new Ho(e);
  return {
    // getState: () => state$.value[0],
    getState: () => t.value,
    setState: (n) => {
      const r = t.value, i = typeof n == "function" ? n(r) : n;
      Object.is(r, i) || t.next(i);
    },
    subscribe: (n) => {
      const r = t.subscribe((i) => {
        Sr(() => n(i));
      });
      return () => r.unsubscribe();
    }
  };
}
function X2(e, t) {
  let n = e;
  const r = jo();
  return {
    getState: () => n,
    setState: (i) => {
      const s = typeof i == "function" ? i(n) : i;
      Object.is(n, s) || t?.beforeChange && !t.beforeChange(s) || (n = s, r.emit(n));
    },
    subscribe: (i) => {
      Sr(() => i(n));
      const s = r.subscribe((o) => {
        Sr(() => i(o));
      });
      return () => s();
    }
  };
}
function ba(e) {
  const t = e.initState || {};
  let n = e.reducer;
  if (e.enhancer)
    return e.enhancer(ba)({ reducer: n, initState: t });
  const r = X2(t), i = (o) => {
    const u = n(r.getState(), o);
    r.setState(u);
  }, s = (o) => {
    n = o, i({ type: Symbol() });
  };
  return i({ type: Symbol() }), {
    getState: r.getState,
    dispatch: i,
    subscribe: r.subscribe,
    replaceReducer: s
  };
}
function Y2(e, t = !0) {
  const n = Object.keys(e);
  return (r = {}, i) => {
    const s = t ? { ...r } : r;
    for (const o of n) {
      const u = e[o](s[o] ?? {}, i);
      if (u === void 0)
        throw new Error(`Reducer "${o}" returned undefined`);
      s[o] = u;
    }
    return s;
  };
}
function ed(...e) {
  return (t) => (n) => {
    const r = t(n);
    let i = r.dispatch;
    const s = { getState: r.getState, dispatch: i }, o = e.map((u) => u(s));
    return i = bl(...o)(i), r.dispatch = i, r;
  };
}
function td(e) {
  const t = new Ho(void 0), n = new di();
  let r = null, i = !1, s = !1;
  return {
    middleware(o) {
      return i ? (u) => u : (i = !0, t.next(o.getState()), (u) => (a) => {
        const c = u(a);
        return t.next(o.getState()), n.next(a), c;
      });
    },
    // 延迟注入
    run(o, u) {
      if (!i)
        throw new Error(
          "EpicMiddleware should applyMiddleware() to store before"
        );
      if (s)
        throw new Error("EpicMiddleware destroyed");
      return r || (r = o(n, t, {
        ...e?.dependencies ?? {},
        dispatch: u.dispatch
        // 配合 框架 context, 注入 dispatch 给 epic 使用
      }).pipe(
        // Uncaught errors can bubble up to the root epic and cause the entire stream to terminate.
        // As a consequence, epics registered in the middleware will no longer run in your application.
        // To alleviate this issue, you can add a global error handler to the root epic that catches uncaught errors and resubscribes to the source stream.
        pu((a, c) => (Il("[Epic Error]", a), c))
      ).subscribe({
        next(a) {
          u.dispatch(a);
        },
        error(a) {
          console.error("[Epic Fatal Error]", a);
        }
      }), r);
    },
    destroy() {
      s = !0, r?.unsubscribe(), r = null, n.complete(), t.complete();
    }
  };
}
function IE(...e) {
  return (t, n, r) => wh(...e.map((i) => i(t, n, r)));
}
function PE(...e) {
  return du((t) => e.includes(t.type));
}
function zE() {
  return {
    middleware(e) {
      return (t) => (n) => typeof n == "function" ? n(e.dispatch, e.getState) : t(n);
    }
  };
}
const nd = (e) => {
  let t = 0;
  return (n) => (r) => {
    Gi.start(`--- ${++t}: action(${String(r.type)}) ---`), $e(`action: ${nr(r)}`), $e(`old-state: ${nr(e.getState())}`), n(r), $e(`new-state: ${nr(e.getState())}`), Gi.end();
  };
}, rd = (e) => (t) => (n) => {
  try {
    t(n);
  } catch (r) {
    throw $e(`Reducer错误报告: ${r}`), r;
  }
}, BE = (e) => (t) => (n) => {
  const r = `dispatch(${String(n.type)}) execute time`;
  dn.start(r), t(n), dn.end(r);
};
function $E(e = "", t) {
  const {
    OPERATION_DELIMITER: n = "/",
    KEY_DELIMITER: r = ",",
    KEY_VALUE_DELIMITER: i = ":"
  } = t || {};
  return e.split(n).filter((s) => s !== "").reduce((s, o) => {
    const [u, ...a] = o.split(r);
    if (a.length === 0) {
      const [c, l] = u.split(i);
      s.push({
        type: c,
        payload: l !== void 0 ? decodeURIComponent(l) : !0
      });
    } else {
      if (u.indexOf(i) !== -1)
        throw new Error(`"${u}" is invalid`);
      s.push(
        a.reduce(
          (c, l) => {
            const [f, d] = l.split(i);
            return c[f] = d !== void 0 ? decodeURIComponent(d) : !0, c;
          },
          {
            type: u
          }
        )
      );
    }
    return s;
  }, []);
}
var pt = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, id = class extends pt {
  #e;
  #t;
  #n;
  constructor() {
    super(), this.#n = (e) => {
      if (typeof window < "u" && window.addEventListener) {
        const t = () => e();
        return window.addEventListener("visibilitychange", t, !1), () => {
          window.removeEventListener("visibilitychange", t);
        };
      }
    };
  }
  onSubscribe() {
    this.#t || this.setEventListener(this.#n);
  }
  onUnsubscribe() {
    this.hasListeners() || (this.#t?.(), this.#t = void 0);
  }
  setEventListener(e) {
    this.#n = e, this.#t?.(), this.#t = e((t) => {
      typeof t == "boolean" ? this.setFocused(t) : this.onFocus();
    });
  }
  setFocused(e) {
    this.#e !== e && (this.#e = e, this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((t) => {
      t(e);
    });
  }
  isFocused() {
    return typeof this.#e == "boolean" ? this.#e : globalThis.document?.visibilityState !== "hidden";
  }
}, Ci = new id(), sd = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (e, t) => setTimeout(e, t),
  clearTimeout: (e) => clearTimeout(e),
  setInterval: (e, t) => setInterval(e, t),
  clearInterval: (e) => clearInterval(e)
}, od = class {
  // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
  // type at app boot; and if we leave that type, then any new timer provider
  // would need to support the default provider's concrete timer ID, which is
  // infeasible across environments.
  //
  // We settle for type safety for the TimeoutProvider type, and accept that
  // this class is unsafe internally to allow for extension.
  #e = sd;
  #t = !1;
  setTimeoutProvider(e) {
    ({}).NODE_ENV !== "production" && this.#t && e !== this.#e && console.error(
      "[timeoutManager]: Switching provider after calls to previous provider might result in unexpected behavior.",
      { previous: this.#e, provider: e }
    ), this.#e = e, {}.NODE_ENV !== "production" && (this.#t = !1);
  }
  setTimeout(e, t) {
    return {}.NODE_ENV !== "production" && (this.#t = !0), this.#e.setTimeout(e, t);
  }
  clearTimeout(e) {
    this.#e.clearTimeout(e);
  }
  setInterval(e, t) {
    return {}.NODE_ENV !== "production" && (this.#t = !0), this.#e.setInterval(e, t);
  }
  clearInterval(e) {
    this.#e.clearInterval(e);
  }
}, Be = new od();
function ud(e) {
  setTimeout(e, 0);
}
var ad = typeof window > "u" || "Deno" in globalThis;
function Q() {
}
function cd(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Lr(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function wa(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Ae(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ie(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ks(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: i,
    predicate: s,
    queryKey: o,
    stale: u
  } = e;
  if (o) {
    if (r) {
      if (t.queryHash !== Ti(o, t.options))
        return !1;
    } else if (!Rt(t.queryKey, o))
      return !1;
  }
  if (n !== "all") {
    const a = t.isActive();
    if (n === "active" && !a || n === "inactive" && a)
      return !1;
  }
  return !(typeof u == "boolean" && t.isStale() !== u || i && i !== t.state.fetchStatus || s && !s(t));
}
function Ns(e, t) {
  const { exact: n, status: r, predicate: i, mutationKey: s } = e;
  if (s) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Ue(t.options.mutationKey) !== Ue(s))
        return !1;
    } else if (!Rt(t.options.mutationKey, s))
      return !1;
  }
  return !(r && t.state.status !== r || i && !i(t));
}
function Ti(e, t) {
  return (t?.queryKeyHashFn || Ue)(e);
}
function Ue(e) {
  return JSON.stringify(
    e,
    (t, n) => jr(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n
  );
}
function Rt(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? Object.keys(t).every((n) => Rt(e[n], t[n])) : !1;
}
var ld = Object.prototype.hasOwnProperty;
function Mr(e, t, n = 0) {
  if (e === t)
    return e;
  if (n > 500)
    return t;
  const r = Is(e) && Is(t);
  if (!r && !(jr(e) && jr(t)))
    return t;
  const s = (r ? e : Object.keys(e)).length, o = r ? t : Object.keys(t), u = o.length, a = r ? new Array(u) : {};
  let c = 0;
  for (let l = 0; l < u; l++) {
    const f = r ? l : o[l], d = e[f], h = t[f];
    if (d === h) {
      a[f] = d, (r ? l < s : ld.call(e, f)) && c++;
      continue;
    }
    if (d === null || h === null || typeof d != "object" || typeof h != "object") {
      a[f] = h;
      continue;
    }
    const p = Mr(d, h, n + 1);
    a[f] = p, p === d && c++;
  }
  return s === u && c === s ? e : a;
}
function _n(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Is(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function jr(e) {
  if (!Ps(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!Ps(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function Ps(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function hd(e) {
  return new Promise((t) => {
    Be.setTimeout(t, e);
  });
}
function Ur(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if ({}.NODE_ENV !== "production")
      try {
        return Mr(e, t);
      } catch (r) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        ), r;
      }
    return Mr(e, t);
  }
  return t;
}
function fd(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function dd(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var Sn = /* @__PURE__ */ Symbol();
function Fa(e, t) {
  return {}.NODE_ENV !== "production" && e.queryFn === Sn && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && t?.initialPromise ? () => t.initialPromise : !e.queryFn || e.queryFn === Sn ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
function pd(e, t, n) {
  let r = !1, i;
  return Object.defineProperty(e, "signal", {
    enumerable: !0,
    get: () => (i ??= t(), r || (r = !0, i.aborted ? n() : i.addEventListener("abort", n, { once: !0 })), i)
  }), e;
}
var An = /* @__PURE__ */ (() => {
  let e = () => ad;
  return {
    /**
     * Returns whether the current runtime should be treated as a server environment.
     */
    isServer() {
      return e();
    },
    /**
     * Overrides the server check globally.
     */
    setIsServer(t) {
      e = t;
    }
  };
})();
function Zr() {
  let e, t;
  const n = new Promise((i, s) => {
    e = i, t = s;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(i) {
    Object.assign(n, i), delete n.resolve, delete n.reject;
  }
  return n.resolve = (i) => {
    r({
      status: "fulfilled",
      value: i
    }), e(i);
  }, n.reject = (i) => {
    r({
      status: "rejected",
      reason: i
    }), t(i);
  }, n;
}
function md(e) {
  let t;
  if (e.then((n) => (t = n, n), Q)?.catch(Q), t !== void 0)
    return { data: t };
}
function Ea(e) {
  return e;
}
function Dd(e) {
  return {
    mutationKey: e.options.mutationKey,
    state: e.state,
    ...e.options.scope && { scope: e.options.scope },
    ...e.meta && { meta: e.meta }
  };
}
function gd(e, t, n) {
  const r = () => {
    const i = e.promise?.then(t).catch((s) => n(s) ? ({}.NODE_ENV !== "production" && console.error(
      `A query that was dehydrated as pending ended up rejecting. [${e.queryHash}]: ${s}; The error will be redacted in production builds`
    ), Promise.reject(new Error("redacted"))) : Promise.reject(s));
    return i?.catch(Q), i;
  };
  return {
    dehydratedAt: Date.now(),
    state: {
      ...e.state,
      ...e.state.data !== void 0 && {
        data: t(e.state.data)
      }
    },
    queryKey: e.queryKey,
    queryHash: e.queryHash,
    ...e.state.status === "pending" && {
      promise: r()
    },
    ...e.meta && { meta: e.meta },
    ...e.queryType && { queryType: e.queryType }
  };
}
function yd(e) {
  return e.state.isPaused;
}
function bd(e) {
  return e.state.status === "success";
}
function wd(e) {
  return !0;
}
function Fd(e, t = {}) {
  const n = t.shouldDehydrateMutation ?? e.getDefaultOptions().dehydrate?.shouldDehydrateMutation ?? yd, r = e.getMutationCache().getAll().flatMap(
    (a) => n(a) ? [Dd(a)] : []
  ), i = t.shouldDehydrateQuery ?? e.getDefaultOptions().dehydrate?.shouldDehydrateQuery ?? bd, s = t.shouldRedactErrors ?? e.getDefaultOptions().dehydrate?.shouldRedactErrors ?? wd, o = t.serializeData ?? e.getDefaultOptions().dehydrate?.serializeData ?? Ea, u = e.getQueryCache().getAll().flatMap(
    (a) => i(a) ? [gd(a, o, s)] : []
  );
  return { mutations: r, queries: u };
}
function Ed(e, t, n) {
  if (typeof t != "object" || t === null)
    return;
  const r = e.getMutationCache(), i = e.getQueryCache(), s = n?.defaultOptions?.deserializeData ?? e.getDefaultOptions().hydrate?.deserializeData ?? Ea, o = t.mutations || [], u = t.queries || [];
  o.forEach(({ state: a, ...c }) => {
    r.build(
      e,
      {
        ...e.getDefaultOptions().hydrate?.mutations,
        ...n?.defaultOptions?.mutations,
        ...c
      },
      a
    );
  }), u.forEach(
    ({
      queryKey: a,
      state: c,
      queryHash: l,
      meta: f,
      promise: d,
      dehydratedAt: h,
      queryType: p
    }) => {
      const m = d ? md(d) : void 0, D = c.data === void 0 ? m?.data : c.data, y = D === void 0 ? D : s(D);
      let F = i.get(l);
      const S = F?.state.status === "pending", v = F?.state.fetchStatus === "fetching";
      if (F) {
        const E = m && // We only need this undefined check to handle older dehydration
        // payloads that might not have dehydratedAt
        h !== void 0 && h > F.state.dataUpdatedAt;
        if (c.dataUpdatedAt > F.state.dataUpdatedAt || E) {
          const { fetchStatus: R, ...A } = c;
          F.setState({
            ...A,
            data: y,
            // If the query was pending at the moment of dehydration, but resolved to have data
            // before hydration, we can assume the query should be hydrated as successful.
            //
            // Since you can opt into dehydrating failed queries, and those can have data from
            // previous successful fetches, we make sure we only do this for pending queries.
            ...c.status === "pending" && y !== void 0 && {
              status: "success",
              dataUpdatedAt: h ?? Date.now(),
              // Preserve existing fetchStatus if the existing query is actively fetching.
              ...!v && {
                fetchStatus: "idle"
              }
            }
          });
        }
      } else
        F = i.build(
          e,
          {
            ...e.getDefaultOptions().hydrate?.queries,
            ...n?.defaultOptions?.queries,
            queryKey: a,
            queryHash: l,
            meta: f,
            _type: p
          },
          // Reset fetch status to idle to avoid
          // query being stuck in fetching state upon hydration
          {
            ...c,
            data: y,
            fetchStatus: "idle",
            // Like above, if the query was pending at the moment of dehydration but has data,
            // we can assume it should be hydrated as successful.
            status: c.status === "pending" && y !== void 0 ? "success" : c.status,
            ...c.status === "pending" && y !== void 0 && {
              dataUpdatedAt: h ?? Date.now()
            }
          }
        );
      d && // If the data was synchronously available, there is no need to set up
      // a retryer and thus no reason to call fetch
      !m && !S && !v && // Only hydrate if dehydration is newer than any existing data,
      // this is always true for new queries
      (h === void 0 || h > F.state.dataUpdatedAt) && F.fetch(void 0, {
        // RSC transformed promises are not thenable
        initialPromise: Promise.resolve(d).then(s)
      }).catch(Q);
    }
  );
}
var vd = ud;
function _d() {
  let e = [], t = 0, n = (u) => {
    u();
  }, r = (u) => {
    u();
  }, i = vd;
  const s = (u) => {
    t ? e.push(u) : i(() => {
      n(u);
    });
  }, o = () => {
    const u = e;
    e = [], u.length && i(() => {
      r(() => {
        u.forEach((a) => {
          n(a);
        });
      });
    });
  };
  return {
    batch: (u) => {
      let a;
      t++;
      try {
        a = u();
      } finally {
        t--, t || o();
      }
      return a;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (u) => (...a) => {
      s(() => {
        u(...a);
      });
    },
    schedule: s,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (u) => {
      n = u;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (u) => {
      r = u;
    },
    setScheduler: (u) => {
      i = u;
    }
  };
}
var K = _d(), Sd = class extends pt {
  #e = !0;
  #t;
  #n;
  constructor() {
    super(), this.#n = (e) => {
      if (typeof window < "u" && window.addEventListener) {
        const t = () => e(!0), n = () => e(!1);
        return window.addEventListener("online", t, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", t), window.removeEventListener("offline", n);
        };
      }
    };
  }
  onSubscribe() {
    this.#t || this.setEventListener(this.#n);
  }
  onUnsubscribe() {
    this.hasListeners() || (this.#t?.(), this.#t = void 0);
  }
  setEventListener(e) {
    this.#n = e, this.#t?.(), this.#t = e(this.setOnline.bind(this));
  }
  setOnline(e) {
    this.#e !== e && (this.#e = e, this.listeners.forEach((n) => {
      n(e);
    }));
  }
  isOnline() {
    return this.#e;
  }
}, On = new Sd();
function Ad(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function va(e) {
  return (e ?? "online") === "online" ? On.isOnline() : !0;
}
var qr = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e?.revert, this.silent = e?.silent;
  }
};
function _a(e) {
  let t = !1, n = 0, r;
  const i = Zr(), s = () => i.status !== "pending", o = (m) => {
    if (!s()) {
      const D = new qr(m);
      d(D), e.onCancel?.(D);
    }
  }, u = () => {
    t = !0;
  }, a = () => {
    t = !1;
  }, c = () => Ci.isFocused() && (e.networkMode === "always" || On.isOnline()) && e.canRun(), l = () => va(e.networkMode) && e.canRun(), f = (m) => {
    s() || (r?.(), i.resolve(m));
  }, d = (m) => {
    s() || (r?.(), i.reject(m));
  }, h = () => new Promise((m) => {
    r = (D) => {
      (s() || c()) && m(D);
    }, e.onPause?.();
  }).then(() => {
    r = void 0, s() || e.onContinue?.();
  }), p = () => {
    if (s())
      return;
    let m;
    const D = n === 0 ? e.initialPromise : void 0;
    try {
      m = D ?? e.fn();
    } catch (y) {
      m = Promise.reject(y);
    }
    Promise.resolve(m).then(f).catch((y) => {
      if (s())
        return;
      const F = e.retry ?? (An.isServer() ? 0 : 3), S = e.retryDelay ?? Ad, v = typeof S == "function" ? S(n, y) : S, E = F === !0 || typeof F == "number" && n < F || typeof F == "function" && F(n, y);
      if (t || !E) {
        d(y);
        return;
      }
      n++, e.onFail?.(n, y), hd(v).then(() => c() ? void 0 : h()).then(() => {
        t ? d(y) : p();
      });
    });
  };
  return {
    promise: i,
    status: () => i.status,
    cancel: o,
    continue: () => (r?.(), i),
    cancelRetry: u,
    continueRetry: a,
    canStart: l,
    start: () => (l() ? p() : h().then(p), i)
  };
}
var Sa = class {
  #e;
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Lr(this.gcTime) && (this.#e = Be.setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (An.isServer() ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    this.#e !== void 0 && (Be.clearTimeout(this.#e), this.#e = void 0);
  }
};
function Od(e) {
  return {
    onFetch: (t, n) => {
      const r = t.options, i = t.fetchOptions?.meta?.fetchMore?.direction, s = t.state.data?.pages || [], o = t.state.data?.pageParams || [];
      let u = { pages: [], pageParams: [] }, a = 0;
      const c = async () => {
        let l = !1;
        const f = (p) => {
          pd(
            p,
            () => t.signal,
            () => l = !0
          );
        }, d = Fa(t.options, t.fetchOptions), h = async (p, m, D) => {
          if (l)
            return Promise.reject(t.signal.reason);
          if (m == null && p.pages.length)
            return Promise.resolve(p);
          const F = (() => {
            const R = {
              client: t.client,
              queryKey: t.queryKey,
              pageParam: m,
              direction: D ? "backward" : "forward",
              meta: t.options.meta
            };
            return f(R), R;
          })(), S = await d(F), { maxPages: v } = t.options, E = D ? dd : fd;
          return {
            pages: E(p.pages, S, v),
            pageParams: E(p.pageParams, m, v)
          };
        };
        if (i && s.length) {
          const p = i === "backward", m = p ? Cd : zs, D = {
            pages: s,
            pageParams: o
          }, y = m(r, D);
          u = await h(D, y, p);
        } else {
          const p = e ?? s.length;
          do {
            const m = a === 0 ? o[0] ?? r.initialPageParam : zs(r, u);
            if (a > 0 && m == null)
              break;
            u = await h(u, m), a++;
          } while (a < p);
        }
        return u;
      };
      t.options.persister ? t.fetchFn = () => t.options.persister?.(
        c,
        {
          client: t.client,
          queryKey: t.queryKey,
          meta: t.options.meta,
          signal: t.signal
        },
        n
      ) : t.fetchFn = c;
    }
  };
}
function zs(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  ) : void 0;
}
function Cd(e, { pages: t, pageParams: n }) {
  return t.length > 0 ? e.getPreviousPageParam?.(t[0], t, n[0], n) : void 0;
}
var Td = class extends Sa {
  #e;
  #t;
  #n;
  #i;
  #s;
  #o;
  #g;
  #c;
  constructor(e) {
    super(), this.#c = !1, this.#g = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.#s = e.client, this.#i = this.#s.getQueryCache(), this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.#t = $s(this.options), this.state = e.state ?? this.#t, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get queryType() {
    return this.#e;
  }
  get promise() {
    return this.#o?.promise;
  }
  setOptions(e) {
    if (this.options = { ...this.#g, ...e }, e?._type && (this.#e = e._type), this.updateGcTime(this.options.gcTime), this.state && this.state.data === void 0) {
      const t = $s(this.options);
      t.data !== void 0 && (this.setState(
        Bs(t.data, t.dataUpdatedAt)
      ), this.#t = t);
    }
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.#i.remove(this);
  }
  setData(e, t) {
    const n = Ur(this.state.data, e, this.options);
    return this.#h({
      data: n,
      type: "success",
      dataUpdatedAt: t?.updatedAt,
      manual: t?.manual
    }), n;
  }
  setState(e) {
    this.#h({ type: "setState", state: e });
  }
  cancel(e) {
    const t = this.#o?.promise;
    return this.#o?.cancel(e), t ? t.then(Q).catch(Q) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  get resetState() {
    return this.#t;
  }
  reset() {
    this.destroy(), this.setState(this.resetState);
  }
  isActive() {
    return this.observers.some(
      (e) => ie(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Sn || !this.isFetched();
  }
  isFetched() {
    return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
  }
  isStatic() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (e) => Ae(e.options.staleTime, this) === "static"
    ) : !1;
  }
  isStale() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0 || this.state.isInvalidated;
  }
  isStaleByTime(e = 0) {
    return this.state.data === void 0 ? !0 : e === "static" ? !1 : this.state.isInvalidated ? !0 : !wa(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    this.observers.find((t) => t.shouldFetchOnWindowFocus())?.refetch({ cancelRefetch: !1 }), this.#o?.continue();
  }
  onOnline() {
    this.observers.find((t) => t.shouldFetchOnReconnect())?.refetch({ cancelRefetch: !1 }), this.#o?.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.#i.notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (this.#o && (this.#c || this.#l() ? this.#o.cancel({ revert: !0 }) : this.#o.cancelRetry()), this.scheduleGc()), this.#i.notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  #l() {
    return this.state.fetchStatus === "paused" && this.state.status === "pending";
  }
  invalidate() {
    this.state.isInvalidated || this.#h({ type: "invalidate" });
  }
  async fetch(e, t) {
    if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
    // re-start the fetch; there is a chance that the query is still in a
    // pending state when that happens
    this.#o?.status() !== "rejected") {
      if (this.state.data !== void 0 && t?.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (this.#o)
        return this.#o.continueRetry(), this.#o.promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const a = this.observers.find((c) => c.options.queryFn);
      a && this.setOptions(a.options);
    }
    ({}).NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const n = new AbortController(), r = (a) => {
      Object.defineProperty(a, "signal", {
        enumerable: !0,
        get: () => (this.#c = !0, n.signal)
      });
    }, i = () => {
      const a = Fa(this.options, t), l = (() => {
        const f = {
          client: this.#s,
          queryKey: this.queryKey,
          meta: this.meta
        };
        return r(f), f;
      })();
      return this.#c = !1, this.options.persister ? this.options.persister(
        a,
        l,
        this
      ) : a(l);
    }, o = (() => {
      const a = {
        fetchOptions: t,
        options: this.options,
        queryKey: this.queryKey,
        client: this.#s,
        state: this.state,
        fetchFn: i
      };
      return r(a), a;
    })();
    (this.#e === "infinite" ? Od(
      this.options.pages
    ) : this.options.behavior)?.onFetch(o, this), this.#n = this.state, (this.state.fetchStatus === "idle" || this.state.fetchMeta !== o.fetchOptions?.meta) && this.#h({ type: "fetch", meta: o.fetchOptions?.meta }), this.#o = _a({
      initialPromise: t?.initialPromise,
      fn: o.fetchFn,
      onCancel: (a) => {
        a instanceof qr && a.revert && this.setState({
          ...this.#n,
          fetchStatus: "idle"
        }), n.abort();
      },
      onFail: (a, c) => {
        this.#h({ type: "failed", failureCount: a, error: c });
      },
      onPause: () => {
        this.#h({ type: "pause" });
      },
      onContinue: () => {
        this.#h({ type: "continue" });
      },
      retry: o.options.retry,
      retryDelay: o.options.retryDelay,
      networkMode: o.options.networkMode,
      canRun: () => !0
    });
    try {
      const a = await this.#o.start();
      if (a === void 0)
        throw {}.NODE_ENV !== "production" && console.error(
          `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
        ), new Error(`${this.queryHash} data is undefined`);
      return this.setData(a), this.#i.config.onSuccess?.(a, this), this.#i.config.onSettled?.(
        a,
        this.state.error,
        this
      ), a;
    } catch (a) {
      if (a instanceof qr) {
        if (a.silent)
          return this.#o.promise;
        if (a.revert) {
          if (this.state.data === void 0)
            throw a;
          return this.state.data;
        }
      }
      throw this.#h({
        type: "error",
        error: a
      }), this.#i.config.onError?.(
        a,
        this
      ), this.#i.config.onSettled?.(
        this.state.data,
        a,
        this
      ), a;
    } finally {
      this.scheduleGc();
    }
  }
  #h(e) {
    const t = (n) => {
      switch (e.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            ...Aa(n.data, this.options),
            fetchMeta: e.meta ?? null
          };
        case "success":
          const r = {
            ...n,
            ...Bs(e.data, e.dataUpdatedAt),
            dataUpdateCount: n.dataUpdateCount + 1,
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
          return this.#n = e.manual ? r : void 0, r;
        case "error":
          const i = e.error;
          return {
            ...n,
            error: i,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: i,
            fetchStatus: "idle",
            status: "error",
            // flag existing data as invalidated if we get a background error
            // note that "no data" always means stale so we can set unconditionally here
            isInvalidated: !0
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = t(this.state), K.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate();
      }), this.#i.notify({ query: this, type: "updated", action: e });
    });
  }
};
function Aa(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: va(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Bs(e, t) {
  return {
    data: e,
    dataUpdatedAt: t ?? Date.now(),
    error: null,
    isInvalidated: !1,
    status: "success"
  };
}
function $s(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Rd = class extends pt {
  constructor(e, t) {
    super(), this.options = t, this.#e = e, this.#c = null, this.#g = Zr(), this.bindMethods(), this.setOptions(t);
  }
  #e;
  #t = void 0;
  #n = void 0;
  #i = void 0;
  #s;
  #o;
  #g;
  #c;
  #l;
  #h;
  // This property keeps track of the last query with defined data.
  // It will be used to pass the previous data and query to the placeholder function between renders.
  #f;
  #u;
  #r;
  #d;
  #y = /* @__PURE__ */ new Set();
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.#t.addObserver(this), Ls(this.#t, this.options) ? this.#p() : this.updateResult(), this.#v());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Wr(
      this.#t,
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return Wr(
      this.#t,
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.#_(), this.#b(), this.#t.removeObserver(this);
  }
  setOptions(e) {
    const t = this.options, n = this.#t;
    if (this.options = this.#e.defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof ie(this.options.enabled, this.#t) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    this.#w(), this.#t.setOptions(this.options), t._defaulted && !_n(this.options, t) && this.#e.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.#t,
      observer: this
    });
    const r = this.hasListeners();
    r && Ms(
      this.#t,
      n,
      this.options,
      t
    ) && this.#p(), this.updateResult(), r && (this.#t !== n || ie(this.options.enabled, this.#t) !== ie(t.enabled, this.#t) || Ae(this.options.staleTime, this.#t) !== Ae(t.staleTime, this.#t)) && this.#m();
    const i = this.#E();
    r && (this.#t !== n || ie(this.options.enabled, this.#t) !== ie(t.enabled, this.#t) || i !== this.#d) && this.#D(i);
  }
  getOptimisticResult(e) {
    const t = this.#e.getQueryCache().build(this.#e, e), n = this.createResult(t, e);
    return kd(this, n) && (this.#i = n, this.#o = this.options, this.#s = this.#t.state), n;
  }
  getCurrentResult() {
    return this.#i;
  }
  trackResult(e, t) {
    return new Proxy(e, {
      get: (n, r) => (this.trackProp(r), t?.(r), r === "promise" && (this.trackProp("data"), !this.options.experimental_prefetchInRender && this.#g.status === "pending" && this.#g.reject(
        new Error(
          "experimental_prefetchInRender feature flag is not enabled"
        )
      )), Reflect.get(n, r))
    });
  }
  trackProp(e) {
    this.#y.add(e);
  }
  getCurrentQuery() {
    return this.#t;
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const t = this.#e.defaultQueryOptions(e), n = this.#e.getQueryCache().build(this.#e, t);
    return n.fetch().then(() => this.createResult(n, t));
  }
  fetch(e) {
    return this.#p({
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), this.#i));
  }
  #p(e) {
    this.#w();
    let t = this.#t.fetch(
      this.options,
      e
    );
    return e?.throwOnError || (t = t.catch(Q)), t;
  }
  #m() {
    this.#_();
    const e = Ae(
      this.options.staleTime,
      this.#t
    );
    if (An.isServer() || this.#i.isStale || !Lr(e))
      return;
    const n = wa(this.#i.dataUpdatedAt, e) + 1;
    this.#u = Be.setTimeout(() => {
      this.#i.isStale || this.updateResult();
    }, n);
  }
  #E() {
    return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.#t) : this.options.refetchInterval) ?? !1;
  }
  #D(e) {
    this.#b(), this.#d = e, !(An.isServer() || ie(this.options.enabled, this.#t) === !1 || !Lr(this.#d) || this.#d === 0) && (this.#r = Be.setInterval(() => {
      (this.options.refetchIntervalInBackground || Ci.isFocused()) && this.#p();
    }, this.#d));
  }
  #v() {
    this.#m(), this.#D(this.#E());
  }
  #_() {
    this.#u !== void 0 && (Be.clearTimeout(this.#u), this.#u = void 0);
  }
  #b() {
    this.#r !== void 0 && (Be.clearInterval(this.#r), this.#r = void 0);
  }
  createResult(e, t) {
    const n = this.#t, r = this.options, i = this.#i, s = this.#s, o = this.#o, a = e !== n ? e.state : this.#n, { state: c } = e;
    let l = { ...c }, f = !1, d;
    if (t._optimisticResults) {
      const k = this.hasListeners(), w = !k && Ls(e, t), T = k && Ms(e, n, t, r);
      (w || T) && (l = {
        ...l,
        ...Aa(c.data, e.options)
      }), t._optimisticResults === "isRestoring" && (l.fetchStatus = "idle");
    }
    let { error: h, errorUpdatedAt: p, status: m } = l;
    d = l.data;
    let D = !1;
    if (t.placeholderData !== void 0 && d === void 0 && m === "pending") {
      let k;
      i?.isPlaceholderData && t.placeholderData === o?.placeholderData ? (k = i.data, D = !0) : k = typeof t.placeholderData == "function" ? t.placeholderData(
        this.#f?.state.data,
        this.#f
      ) : t.placeholderData, k !== void 0 && (m = "success", d = Ur(
        i?.data,
        k,
        t
      ), f = !0);
    }
    if (t.select && d !== void 0 && !D)
      if (i && d === s?.data && t.select === this.#l)
        d = this.#h;
      else
        try {
          this.#l = t.select, d = t.select(d), d = Ur(i?.data, d, t), this.#h = d, this.#c = null;
        } catch (k) {
          this.#c = k;
        }
    this.#c && (h = this.#c, d = this.#h, p = Date.now(), m = "error");
    const y = l.fetchStatus === "fetching", F = m === "pending", S = m === "error", v = F && y, E = d !== void 0, A = {
      status: m,
      fetchStatus: l.fetchStatus,
      isPending: F,
      isSuccess: m === "success",
      isError: S,
      isInitialLoading: v,
      isLoading: v,
      data: d,
      dataUpdatedAt: l.dataUpdatedAt,
      error: h,
      errorUpdatedAt: p,
      failureCount: l.fetchFailureCount,
      failureReason: l.fetchFailureReason,
      errorUpdateCount: l.errorUpdateCount,
      isFetched: e.isFetched(),
      isFetchedAfterMount: l.dataUpdateCount > a.dataUpdateCount || l.errorUpdateCount > a.errorUpdateCount,
      isFetching: y,
      isRefetching: y && !F,
      isLoadingError: S && !E,
      isPaused: l.fetchStatus === "paused",
      isPlaceholderData: f,
      isRefetchError: S && E,
      isStale: Ri(e, t),
      refetch: this.refetch,
      promise: this.#g,
      isEnabled: ie(t.enabled, e) !== !1
    };
    if (this.options.experimental_prefetchInRender) {
      const k = A.data !== void 0, w = A.status === "error" && !k, T = (ne) => {
        w ? ne.reject(A.error) : k && ne.resolve(A.data);
      }, P = () => {
        const ne = this.#g = A.promise = Zr();
        T(ne);
      }, V = this.#g;
      switch (V.status) {
        case "pending":
          e.queryHash === n.queryHash && T(V);
          break;
        case "fulfilled":
          (w || A.data !== V.value) && P();
          break;
        case "rejected":
          (!w || A.error !== V.reason) && P();
          break;
      }
    }
    return A;
  }
  updateResult() {
    const e = this.#i, t = this.createResult(this.#t, this.options);
    if (this.#s = this.#t.state, this.#o = this.options, this.#s.data !== void 0 && (this.#f = this.#t), _n(t, e))
      return;
    this.#i = t;
    const n = () => {
      if (!e)
        return !0;
      const { notifyOnChangeProps: r } = this.options, i = typeof r == "function" ? r() : r;
      if (i === "all" || !i && !this.#y.size)
        return !0;
      const s = new Set(
        i ?? this.#y
      );
      return this.options.throwOnError && s.add("error"), Object.keys(this.#i).some((o) => {
        const u = o;
        return this.#i[u] !== e[u] && s.has(u);
      });
    };
    this.#S({ listeners: n() });
  }
  #w() {
    const e = this.#e.getQueryCache().build(this.#e, this.options);
    if (e === this.#t)
      return;
    const t = this.#t;
    this.#t = e, this.#n = e.state, this.hasListeners() && (t?.removeObserver(this), e.addObserver(this));
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && this.#v();
  }
  #S(e) {
    K.batch(() => {
      e.listeners && this.listeners.forEach((t) => {
        t(this.#i);
      }), this.#e.getQueryCache().notify({
        query: this.#t,
        type: "observerResultsUpdated"
      });
    });
  }
};
function xd(e, t) {
  return ie(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && ie(t.retryOnMount, e) === !1);
}
function Ls(e, t) {
  return xd(e, t) || e.state.data !== void 0 && Wr(e, t, t.refetchOnMount);
}
function Wr(e, t, n) {
  if (ie(t.enabled, e) !== !1 && Ae(t.staleTime, e) !== "static") {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && Ri(e, t);
  }
  return !1;
}
function Ms(e, t, n, r) {
  return (e !== t || ie(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && Ri(e, n);
}
function Ri(e, t) {
  return ie(t.enabled, e) !== !1 && e.isStaleByTime(Ae(t.staleTime, e));
}
function kd(e, t) {
  return !_n(e.getCurrentResult(), t);
}
var Nd = class extends Sa {
  #e;
  #t;
  #n;
  #i;
  constructor(e) {
    super(), this.#e = e.client, this.mutationId = e.mutationId, this.#n = e.mutationCache, this.#t = [], this.state = e.state || Oa(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    this.#t.includes(e) || (this.#t.push(e), this.clearGcTimeout(), this.#n.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.#t = this.#t.filter((t) => t !== e), this.scheduleGc(), this.#n.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.#t.length || (this.state.status === "pending" ? this.scheduleGc() : this.#n.remove(this));
  }
  continue() {
    return this.#i?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    const t = () => {
      this.#s({ type: "continue" });
    }, n = {
      client: this.#e,
      meta: this.options.meta,
      mutationKey: this.options.mutationKey
    };
    this.#i = _a({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e, n) : Promise.reject(new Error("No mutationFn found")),
      onFail: (s, o) => {
        this.#s({ type: "failed", failureCount: s, error: o });
      },
      onPause: () => {
        this.#s({ type: "pause" });
      },
      onContinue: t,
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => this.#n.canRun(this)
    });
    const r = this.state.status === "pending", i = !this.#i.canStart();
    try {
      if (r)
        t();
      else {
        this.#s({ type: "pending", variables: e, isPaused: i }), this.#n.config.onMutate && await this.#n.config.onMutate(
          e,
          this,
          n
        );
        const o = await this.options.onMutate?.(
          e,
          n
        );
        o !== this.state.context && this.#s({
          type: "pending",
          context: o,
          variables: e,
          isPaused: i
        });
      }
      const s = await this.#i.start();
      return await this.#n.config.onSuccess?.(
        s,
        e,
        this.state.context,
        this,
        n
      ), await this.options.onSuccess?.(
        s,
        e,
        this.state.context,
        n
      ), await this.#n.config.onSettled?.(
        s,
        null,
        this.state.variables,
        this.state.context,
        this,
        n
      ), await this.options.onSettled?.(
        s,
        null,
        e,
        this.state.context,
        n
      ), this.#s({ type: "success", data: s }), s;
    } catch (s) {
      try {
        await this.#n.config.onError?.(
          s,
          e,
          this.state.context,
          this,
          n
        );
      } catch (o) {
        Promise.reject(o);
      }
      try {
        await this.options.onError?.(
          s,
          e,
          this.state.context,
          n
        );
      } catch (o) {
        Promise.reject(o);
      }
      try {
        await this.#n.config.onSettled?.(
          void 0,
          s,
          this.state.variables,
          this.state.context,
          this,
          n
        );
      } catch (o) {
        Promise.reject(o);
      }
      try {
        await this.options.onSettled?.(
          void 0,
          s,
          e,
          this.state.context,
          n
        );
      } catch (o) {
        Promise.reject(o);
      }
      throw this.#s({ type: "error", error: s }), s;
    } finally {
      this.#n.runNext(this);
    }
  }
  #s(e) {
    const t = (n) => {
      switch (e.type) {
        case "failed":
          return {
            ...n,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "pending":
          return {
            ...n,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: e.isPaused,
            status: "pending",
            variables: e.variables,
            submittedAt: Date.now()
          };
        case "success":
          return {
            ...n,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: e.error,
            failureCount: n.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
      }
    };
    this.state = t(this.state), K.batch(() => {
      this.#t.forEach((n) => {
        n.onMutationUpdate(e);
      }), this.#n.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
};
function Oa() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Ca = class extends pt {
  constructor(e = {}) {
    super(), this.config = e, this.#e = /* @__PURE__ */ new Set(), this.#t = /* @__PURE__ */ new Map(), this.#n = 0;
  }
  #e;
  #t;
  #n;
  build(e, t, n) {
    const r = new Nd({
      client: e,
      mutationCache: this,
      mutationId: ++this.#n,
      options: e.defaultMutationOptions(t),
      state: n
    });
    return this.add(r), r;
  }
  add(e) {
    this.#e.add(e);
    const t = Vt(e);
    if (typeof t == "string") {
      const n = this.#t.get(t);
      n ? n.push(e) : this.#t.set(t, [e]);
    }
    this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    if (this.#e.delete(e)) {
      const t = Vt(e);
      if (typeof t == "string") {
        const n = this.#t.get(t);
        if (n)
          if (n.length > 1) {
            const r = n.indexOf(e);
            r !== -1 && n.splice(r, 1);
          } else
            n[0] === e && this.#t.delete(t);
      }
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    const t = Vt(e);
    if (typeof t == "string") {
      const r = this.#t.get(t)?.find(
        (i) => i.state.status === "pending"
      );
      return !r || r === e;
    } else
      return !0;
  }
  runNext(e) {
    const t = Vt(e);
    return typeof t == "string" ? this.#t.get(t)?.find((r) => r !== e && r.state.isPaused)?.continue() ?? Promise.resolve() : Promise.resolve();
  }
  clear() {
    K.batch(() => {
      this.#e.forEach((e) => {
        this.notify({ type: "removed", mutation: e });
      }), this.#e.clear(), this.#t.clear();
    });
  }
  getAll() {
    return Array.from(this.#e);
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (n) => Ns(t, n)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((t) => Ns(e, t));
  }
  notify(e) {
    K.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((t) => t.state.isPaused);
    return K.batch(
      () => Promise.all(
        e.map((t) => t.continue().catch(Q))
      )
    );
  }
};
function Vt(e) {
  return e.options.scope?.id;
}
var Id = class extends pt {
  #e;
  #t = void 0;
  #n;
  #i;
  constructor(e, t) {
    super(), this.#e = e, this.setOptions(t), this.bindMethods(), this.#s();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(e) {
    const t = this.options;
    this.options = this.#e.defaultMutationOptions(e), _n(this.options, t) || this.#e.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.#n,
      observer: this
    }), t?.mutationKey && this.options.mutationKey && Ue(t.mutationKey) !== Ue(this.options.mutationKey) ? this.reset() : this.#n?.state.status === "pending" && this.#n.setOptions(this.options);
  }
  onUnsubscribe() {
    this.hasListeners() || this.#n?.removeObserver(this);
  }
  onMutationUpdate(e) {
    this.#s(), this.#o(e);
  }
  getCurrentResult() {
    return this.#t;
  }
  reset() {
    this.#n?.removeObserver(this), this.#n = void 0, this.#s(), this.#o();
  }
  mutate(e, t) {
    return this.#i = t, this.#n?.removeObserver(this), this.#n = this.#e.getMutationCache().build(this.#e, this.options), this.#n.addObserver(this), this.#n.execute(e);
  }
  #s() {
    const e = this.#n?.state ?? Oa();
    this.#t = {
      ...e,
      isPending: e.status === "pending",
      isSuccess: e.status === "success",
      isError: e.status === "error",
      isIdle: e.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #o(e) {
    K.batch(() => {
      if (this.#i && this.hasListeners()) {
        const t = this.#t.variables, n = this.#t.context, r = {
          client: this.#e,
          meta: this.options.meta,
          mutationKey: this.options.mutationKey
        };
        if (e?.type === "success") {
          try {
            this.#i.onSuccess?.(
              e.data,
              t,
              n,
              r
            );
          } catch (i) {
            Promise.reject(i);
          }
          try {
            this.#i.onSettled?.(
              e.data,
              null,
              t,
              n,
              r
            );
          } catch (i) {
            Promise.reject(i);
          }
        } else if (e?.type === "error") {
          try {
            this.#i.onError?.(
              e.error,
              t,
              n,
              r
            );
          } catch (i) {
            Promise.reject(i);
          }
          try {
            this.#i.onSettled?.(
              void 0,
              e.error,
              t,
              n,
              r
            );
          } catch (i) {
            Promise.reject(i);
          }
        }
      }
      this.listeners.forEach((t) => {
        t(this.#t);
      });
    });
  }
}, Pd = class extends pt {
  constructor(e = {}) {
    super(), this.config = e, this.#e = /* @__PURE__ */ new Map();
  }
  #e;
  build(e, t, n) {
    const r = t.queryKey, i = t.queryHash ?? Ti(r, t);
    let s = this.get(i);
    return s || (s = new Td({
      client: e,
      queryKey: r,
      queryHash: i,
      options: e.defaultQueryOptions(t),
      state: n,
      defaultOptions: e.getQueryDefaults(r)
    }), this.add(s)), s;
  }
  add(e) {
    this.#e.has(e.queryHash) || (this.#e.set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const t = this.#e.get(e.queryHash);
    t && (e.destroy(), t === e && this.#e.delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    K.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.#e.get(e);
  }
  getAll() {
    return [...this.#e.values()];
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (n) => ks(t, n)
    );
  }
  findAll(e = {}) {
    const t = this.getAll();
    return Object.keys(e).length > 0 ? t.filter((n) => ks(e, n)) : t;
  }
  notify(e) {
    K.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  onFocus() {
    K.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    K.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, zd = class {
  #e;
  #t;
  #n;
  #i;
  #s;
  #o;
  #g;
  #c;
  constructor(e = {}) {
    this.#e = e.queryCache || new Pd(), this.#t = e.mutationCache || new Ca(), this.#n = e.defaultOptions || {}, this.#i = /* @__PURE__ */ new Map(), this.#s = /* @__PURE__ */ new Map(), this.#o = 0;
  }
  mount() {
    this.#o++, this.#o === 1 && (this.#g = Ci.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), this.#e.onFocus());
    }), this.#c = On.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), this.#e.onOnline());
    }));
  }
  unmount() {
    this.#o--, this.#o === 0 && (this.#g?.(), this.#g = void 0, this.#c?.(), this.#c = void 0);
  }
  isFetching(e) {
    return this.#e.findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return this.#t.findAll({ ...e, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(e) {
    const t = this.defaultQueryOptions({ queryKey: e });
    return this.#e.get(t.queryHash)?.state.data;
  }
  ensureQueryData(e) {
    const t = this.defaultQueryOptions(e), n = this.#e.build(this, t), r = n.state.data;
    return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime(Ae(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
  }
  getQueriesData(e) {
    return this.#e.findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), s = this.#e.get(
      r.queryHash
    )?.state.data, o = cd(t, s);
    if (o !== void 0)
      return this.#e.build(this, r).setData(o, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return K.batch(
      () => this.#e.findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    const t = this.defaultQueryOptions({ queryKey: e });
    return this.#e.get(
      t.queryHash
    )?.state;
  }
  removeQueries(e) {
    const t = this.#e;
    K.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = this.#e;
    return K.batch(() => (n.findAll(e).forEach((r) => {
      r.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...e
      },
      t
    )));
  }
  cancelQueries(e, t = {}) {
    const n = { revert: !0, ...t }, r = K.batch(
      () => this.#e.findAll(e).map((i) => i.cancel(n))
    );
    return Promise.all(r).then(Q).catch(Q);
  }
  invalidateQueries(e, t = {}) {
    return K.batch(() => (this.#e.findAll(e).forEach((n) => {
      n.invalidate();
    }), e?.refetchType === "none" ? Promise.resolve() : this.refetchQueries(
      {
        ...e,
        type: e?.refetchType ?? e?.type ?? "active"
      },
      t
    )));
  }
  refetchQueries(e, t = {}) {
    const n = {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }, r = K.batch(
      () => this.#e.findAll(e).filter((i) => !i.isDisabled() && !i.isStatic()).map((i) => {
        let s = i.fetch(void 0, n);
        return n.throwOnError || (s = s.catch(Q)), i.state.fetchStatus === "paused" ? Promise.resolve() : s;
      })
    );
    return Promise.all(r).then(Q);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = this.#e.build(this, t);
    return n.isStaleByTime(
      Ae(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(Q).catch(Q);
  }
  fetchInfiniteQuery(e) {
    return e._type = "infinite", this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(Q).catch(Q);
  }
  ensureInfiniteQueryData(e) {
    return e._type = "infinite", this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return On.isOnline() ? this.#t.resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return this.#e;
  }
  getMutationCache() {
    return this.#t;
  }
  getDefaultOptions() {
    return this.#n;
  }
  setDefaultOptions(e) {
    this.#n = e;
  }
  setQueryDefaults(e, t) {
    this.#i.set(Ue(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...this.#i.values()], n = {};
    return t.forEach((r) => {
      Rt(e, r.queryKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  setMutationDefaults(e, t) {
    this.#s.set(Ue(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...this.#s.values()], n = {};
    return t.forEach((r) => {
      Rt(e, r.mutationKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...this.#n.queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = Ti(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === Sn && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e?._defaulted ? e : {
      ...this.#n.mutations,
      ...e?.mutationKey && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.#e.clear(), this.#t.clear();
  }
};
function LE(e) {
  const t = new zd(
    At(
      {
        defaultOptions: {
          queries: {
            gcTime: 864e5,
            // 24 hours
            // staleTime: 2000,
            retry: 0
          }
        },
        mutationCache: new Ca({
          onSuccess: (s) => {
          },
          onError: (s) => {
          }
        })
      },
      e ?? {}
    )
  );
  function n(s) {
    const o = t.fetchQuery(s), u = new Rd(t, s);
    let a = u.getCurrentResult();
    const c = u.subscribe((l) => {
      a = l;
    });
    return {
      data: o,
      observer: u,
      get query() {
        return a;
      },
      invalidate: () => {
        t.invalidateQueries(s);
      },
      refetch: u.refetch,
      // fetchOptimistic: () => {
      //   observer.fetchOptimistic();
      // },
      destroy: () => {
        c();
      }
    };
  }
  function r(s) {
    const o = new Id(t, s);
    let u = o.getCurrentResult();
    const a = o.subscribe((c) => {
      u = c;
    });
    return {
      observer: o,
      get mutation() {
        return u;
      },
      reset: o.reset,
      mutate: (c, l) => {
        o.mutate(c, l);
      },
      mutateAsync: (c, l) => o.mutate(c, l),
      destroy() {
        a();
      }
    };
  }
  function i() {
    const s = Fd(t);
    return () => {
      Ed(t, s), t.resumePausedMutations();
    };
  }
  return { queryClient: t, createQuery: n, createMutation: r, offline: i };
}
const Bd = "400-158-8363", $d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HOTLINE: Bd
}, Symbol.toStringTag, { value: "Module" })), Ld = "https://test.xinge.me", Md = "801414680580298A78ADDAB845688F48", jd = "B233E181D80FA7C5B4A783CB46D30B92", Ud = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  baseURL: Ld,
  sm4_iv: Md,
  sm4_key: jd
}, Symbol.toStringTag, { value: "Module" })), Zd = "https://xinge.ruolin-link.com", qd = "FE593F8EDD5BE9DED482A4FD9B571298", Wd = "A9FDC9950D1C01C365F16A4992ED16E3", Gd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  baseURL: Zd,
  sm4_iv: qd,
  sm4_key: Wd
}, Symbol.toStringTag, { value: "Module" })), Ta = {
  dev: "dev",
  prod: "prod"
};
let Ra = Ta.dev;
function Vd(e) {
  Ra = e;
}
function xi() {
  return {
    ...$d,
    ...Ra === Ta.prod ? Gd : Ud
  };
}
const Kd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get: xi,
  setEnv: Vd
}, Symbol.toStringTag, { value: "Module" }));
var js;
function b(e, t, n) {
  function r(u, a) {
    if (u._zod || Object.defineProperty(u, "_zod", {
      value: {
        def: a,
        constr: o,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), u._zod.traits.has(e))
      return;
    u._zod.traits.add(e), t(u, a);
    const c = o.prototype, l = Object.keys(c);
    for (let f = 0; f < l.length; f++) {
      const d = l[f];
      d in u || (u[d] = c[d].bind(u));
    }
  }
  const i = n?.Parent ?? Object;
  class s extends i {
  }
  Object.defineProperty(s, "name", { value: e });
  function o(u) {
    var a;
    const c = n?.Parent ? new s() : this;
    r(c, u), (a = c._zod).deferred ?? (a.deferred = []);
    for (const l of c._zod.deferred)
      l();
    return c;
  }
  return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, {
    value: (u) => n?.Parent && u instanceof n.Parent ? !0 : u?._zod?.traits?.has(e)
  }), Object.defineProperty(o, "name", { value: e }), o;
}
class rt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class xa extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
(js = globalThis).__zod_globalConfig ?? (js.__zod_globalConfig = {});
const Cn = globalThis.__zod_globalConfig;
function Ze(e) {
  return e && Object.assign(Cn, e), Cn;
}
function ka(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, i]) => t.indexOf(+r) === -1).map(([r, i]) => i);
}
function Gr(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function ki(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Ni(e) {
  return e == null;
}
function Ii(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function Qd(e, t) {
  const n = e / t, r = Math.round(n), i = Number.EPSILON * Math.max(Math.abs(n), 1);
  return Math.abs(n - r) < i ? 0 : n - r;
}
const Us = /* @__PURE__ */ Symbol("evaluating");
function x(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== Us)
        return r === void 0 && (r = Us, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Je(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function xe(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function Zs(e) {
  return JSON.stringify(e);
}
function Jd(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Na = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Tn(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Hd = /* @__PURE__ */ ki(() => {
  if (Cn.jitless || typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function xt(e) {
  if (Tn(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Tn(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function Ia(e) {
  return xt(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
const Xd = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Kn(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function ke(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n?.parent) && (r._zod.parent = e), r;
}
function O(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Yd(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const ep = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function tp(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const s = xe(e._zod.def, {
    get shape() {
      const o = {};
      for (const u in t) {
        if (!(u in n.shape))
          throw new Error(`Unrecognized key: "${u}"`);
        t[u] && (o[u] = n.shape[u]);
      }
      return Je(this, "shape", o), o;
    },
    checks: []
  });
  return ke(e, s);
}
function np(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const s = xe(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const u in t) {
        if (!(u in n.shape))
          throw new Error(`Unrecognized key: "${u}"`);
        t[u] && delete o[u];
      }
      return Je(this, "shape", o), o;
    },
    checks: []
  });
  return ke(e, s);
}
function rp(e, t) {
  if (!xt(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const s = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(s, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const i = xe(e._zod.def, {
    get shape() {
      const s = { ...e._zod.def.shape, ...t };
      return Je(this, "shape", s), s;
    }
  });
  return ke(e, i);
}
function ip(e, t) {
  if (!xt(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = xe(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Je(this, "shape", r), r;
    }
  });
  return ke(e, n);
}
function sp(e, t) {
  if (e._zod.def.checks?.length)
    throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
  const n = xe(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Je(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: t._zod.def.checks ?? []
  });
  return ke(e, n);
}
function op(e, t, n) {
  const i = t._zod.def.checks;
  if (i && i.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const o = xe(t._zod.def, {
    get shape() {
      const u = t._zod.def.shape, a = { ...u };
      if (n)
        for (const c in n) {
          if (!(c in u))
            throw new Error(`Unrecognized key: "${c}"`);
          n[c] && (a[c] = e ? new e({
            type: "optional",
            innerType: u[c]
          }) : u[c]);
        }
      else
        for (const c in u)
          a[c] = e ? new e({
            type: "optional",
            innerType: u[c]
          }) : u[c];
      return Je(this, "shape", a), a;
    },
    checks: []
  });
  return ke(t, o);
}
function up(e, t, n) {
  const r = xe(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, s = { ...i };
      if (n)
        for (const o in n) {
          if (!(o in s))
            throw new Error(`Unrecognized key: "${o}"`);
          n[o] && (s[o] = new e({
            type: "nonoptional",
            innerType: i[o]
          }));
        }
      else
        for (const o in i)
          s[o] = new e({
            type: "nonoptional",
            innerType: i[o]
          });
      return Je(this, "shape", s), s;
    }
  });
  return ke(t, r);
}
function et(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function ap(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue === !1)
      return !0;
  return !1;
}
function Pa(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function Kt(e) {
  return typeof e == "string" ? e : e?.message;
}
function qe(e, t, n) {
  const r = e.message ? e.message : Kt(e.inst?._zod.def?.error?.(e)) ?? Kt(t?.error?.(e)) ?? Kt(n.customError?.(e)) ?? Kt(n.localeError?.(e)) ?? "Invalid input", { inst: i, continue: s, input: o, ...u } = e;
  return u.path ?? (u.path = []), u.message = r, t?.reportInput && (u.input = o), u;
}
function Pi(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function kt(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const za = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Gr, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Ba = b("$ZodError", za), $a = b("$ZodError", za, { Parent: Error });
function cp(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function lp(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i, s = []) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((u) => r({ issues: u }, [...s, ...o.path]));
      else if (o.code === "invalid_key")
        r({ issues: o.issues }, [...s, ...o.path]);
      else if (o.code === "invalid_element")
        r({ issues: o.issues }, [...s, ...o.path]);
      else {
        const u = [...s, ...o.path];
        if (u.length === 0)
          n._errors.push(t(o));
        else {
          let a = n, c = 0;
          for (; c < u.length; ) {
            const l = u[c];
            c === u.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], c++;
          }
        }
      }
  };
  return r(e), n;
}
const zi = (e) => (t, n, r, i) => {
  const s = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, s);
  if (o instanceof Promise)
    throw new rt();
  if (o.issues.length) {
    const u = new (i?.Err ?? e)(o.issues.map((a) => qe(a, s, Ze())));
    throw Na(u, i?.callee), u;
  }
  return o.value;
}, Bi = (e) => async (t, n, r, i) => {
  const s = r ? { ...r, async: !0 } : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, s);
  if (o instanceof Promise && (o = await o), o.issues.length) {
    const u = new (i?.Err ?? e)(o.issues.map((a) => qe(a, s, Ze())));
    throw Na(u, i?.callee), u;
  }
  return o.value;
}, Qn = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, s = t._zod.run({ value: n, issues: [] }, i);
  if (s instanceof Promise)
    throw new rt();
  return s.issues.length ? {
    success: !1,
    error: new (e ?? Ba)(s.issues.map((o) => qe(o, i, Ze())))
  } : { success: !0, data: s.value };
}, hp = /* @__PURE__ */ Qn($a), Jn = (e) => async (t, n, r) => {
  const i = r ? { ...r, async: !0 } : { async: !0 };
  let s = t._zod.run({ value: n, issues: [] }, i);
  return s instanceof Promise && (s = await s), s.issues.length ? {
    success: !1,
    error: new e(s.issues.map((o) => qe(o, i, Ze())))
  } : { success: !0, data: s.value };
}, fp = /* @__PURE__ */ Jn($a), dp = (e) => (t, n, r) => {
  const i = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return zi(e)(t, n, i);
}, pp = (e) => (t, n, r) => zi(e)(t, n, r), mp = (e) => async (t, n, r) => {
  const i = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return Bi(e)(t, n, i);
}, Dp = (e) => async (t, n, r) => Bi(e)(t, n, r), gp = (e) => (t, n, r) => {
  const i = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return Qn(e)(t, n, i);
}, yp = (e) => (t, n, r) => Qn(e)(t, n, r), bp = (e) => async (t, n, r) => {
  const i = r ? { ...r, direction: "backward" } : { direction: "backward" };
  return Jn(e)(t, n, i);
}, wp = (e) => async (t, n, r) => Jn(e)(t, n, r), Fp = /^[cC][0-9a-z]{6,}$/, Ep = /^[0-9a-z]+$/, vp = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, _p = /^[0-9a-vA-V]{20}$/, Sp = /^[A-Za-z0-9]{27}$/, Ap = /^[a-zA-Z0-9_-]{21}$/, Op = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Cp = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, qs = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Tp = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Rp = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function xp() {
  return new RegExp(Rp, "u");
}
const kp = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Np = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Ip = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Pp = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, zp = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, La = /^[A-Za-z0-9_-]*$/, Bp = /^https?$/, $p = /^\+[1-9]\d{6,14}$/, Ma = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Lp = /* @__PURE__ */ new RegExp(`^${Ma}$`);
function ja(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Mp(e) {
  return new RegExp(`^${ja(e)}$`);
}
function jp(e) {
  const t = ja({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${Ma}T(?:${r})$`);
}
const Up = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Zp = /^-?\d+$/, qp = /^-?\d+(?:\.\d+)?$/, Wp = /^[^A-Z]*$/, Gp = /^[^a-z]*$/, te = /* @__PURE__ */ b("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Ua = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Za = /* @__PURE__ */ b("$ZodCheckLessThan", (e, t) => {
  te.init(e, t);
  const n = Ua[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, s = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < s && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), qa = /* @__PURE__ */ b("$ZodCheckGreaterThan", (e, t) => {
  te.init(e, t);
  const n = Ua[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, s = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > s && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Vp = /* @__PURE__ */ b("$ZodCheckMultipleOf", (e, t) => {
  te.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : Qd(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Kp = /* @__PURE__ */ b("$ZodCheckNumberFormat", (e, t) => {
  te.init(e, t), t.format = t.format || "float64";
  const n = t.format?.includes("int"), r = n ? "int" : "number", [i, s] = ep[t.format];
  e._zod.onattach.push((o) => {
    const u = o._zod.bag;
    u.format = t.format, u.minimum = i, u.maximum = s, n && (u.pattern = Zp);
  }), e._zod.check = (o) => {
    const u = o.value;
    if (n) {
      if (!Number.isInteger(u)) {
        o.issues.push({
          expected: r,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: u,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(u)) {
        u > 0 ? o.issues.push({
          input: u,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          inclusive: !0,
          continue: !t.abort
        }) : o.issues.push({
          input: u,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    u < i && o.issues.push({
      origin: "number",
      input: u,
      code: "too_small",
      minimum: i,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), u > s && o.issues.push({
      origin: "number",
      input: u,
      code: "too_big",
      maximum: s,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), Qp = /* @__PURE__ */ b("$ZodCheckMaxLength", (e, t) => {
  var n;
  te.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Ni(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = Pi(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Jp = /* @__PURE__ */ b("$ZodCheckMinLength", (e, t) => {
  var n;
  te.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Ni(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = Pi(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Hp = /* @__PURE__ */ b("$ZodCheckLengthEquals", (e, t) => {
  var n;
  te.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Ni(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, s = i.length;
    if (s === t.length)
      return;
    const o = Pi(i), u = s > t.length;
    r.issues.push({
      origin: o,
      ...u ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Hn = /* @__PURE__ */ b("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  te.init(e, t), e._zod.onattach.push((i) => {
    const s = i._zod.bag;
    s.format = t.format, t.pattern && (s.patterns ?? (s.patterns = /* @__PURE__ */ new Set()), s.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), Xp = /* @__PURE__ */ b("$ZodCheckRegex", (e, t) => {
  Hn.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Yp = /* @__PURE__ */ b("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Wp), Hn.init(e, t);
}), e3 = /* @__PURE__ */ b("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Gp), Hn.init(e, t);
}), t3 = /* @__PURE__ */ b("$ZodCheckIncludes", (e, t) => {
  te.init(e, t);
  const n = Kn(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const s = i._zod.bag;
    s.patterns ?? (s.patterns = /* @__PURE__ */ new Set()), s.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), n3 = /* @__PURE__ */ b("$ZodCheckStartsWith", (e, t) => {
  te.init(e, t);
  const n = new RegExp(`^${Kn(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), r3 = /* @__PURE__ */ b("$ZodCheckEndsWith", (e, t) => {
  te.init(e, t);
  const n = new RegExp(`.*${Kn(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), i3 = /* @__PURE__ */ b("$ZodCheckOverwrite", (e, t) => {
  te.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class s3 {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((o) => o), i = Math.min(...r.map((o) => o.length - o.trimStart().length)), s = r.map((o) => o.slice(i)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of s)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this?.args, i = [...(this?.content ?? [""]).map((s) => `  ${s}`)];
    return new t(...n, i.join(`
`));
  }
}
const o3 = {
  major: 4,
  minor: 4,
  patch: 3
}, j = /* @__PURE__ */ b("$ZodType", (e, t) => {
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = o3;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const i of r)
    for (const s of i._zod.onattach)
      s(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (o, u, a) => {
      let c = et(o), l;
      for (const f of u) {
        if (f._zod.def.when) {
          if (ap(o) || !f._zod.def.when(o))
            continue;
        } else if (c)
          continue;
        const d = o.issues.length, h = f._zod.check(o);
        if (h instanceof Promise && a?.async === !1)
          throw new rt();
        if (l || h instanceof Promise)
          l = (l ?? Promise.resolve()).then(async () => {
            await h, o.issues.length !== d && (c || (c = et(o, d)));
          });
        else {
          if (o.issues.length === d)
            continue;
          c || (c = et(o, d));
        }
      }
      return l ? l.then(() => o) : o;
    }, s = (o, u, a) => {
      if (et(o))
        return o.aborted = !0, o;
      const c = i(u, r, a);
      if (c instanceof Promise) {
        if (a.async === !1)
          throw new rt();
        return c.then((l) => e._zod.parse(l, a));
      }
      return e._zod.parse(c, a);
    };
    e._zod.run = (o, u) => {
      if (u.skipChecks)
        return e._zod.parse(o, u);
      if (u.direction === "backward") {
        const c = e._zod.parse({ value: o.value, issues: [] }, { ...u, skipChecks: !0 });
        return c instanceof Promise ? c.then((l) => s(l, o, u)) : s(c, o, u);
      }
      const a = e._zod.parse(o, u);
      if (a instanceof Promise) {
        if (u.async === !1)
          throw new rt();
        return a.then((c) => i(c, r, u));
      }
      return i(a, r, u);
    };
  }
  x(e, "~standard", () => ({
    validate: (i) => {
      try {
        const s = hp(e, i);
        return s.success ? { value: s.data } : { issues: s.error?.issues };
      } catch {
        return fp(e, i).then((o) => o.success ? { value: o.data } : { issues: o.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), $i = /* @__PURE__ */ b("$ZodString", (e, t) => {
  j.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? Up(e._zod.bag), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), B = /* @__PURE__ */ b("$ZodStringFormat", (e, t) => {
  Hn.init(e, t), $i.init(e, t);
}), u3 = /* @__PURE__ */ b("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Cp), B.init(e, t);
}), a3 = /* @__PURE__ */ b("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = qs(r));
  } else
    t.pattern ?? (t.pattern = qs());
  B.init(e, t);
}), c3 = /* @__PURE__ */ b("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Tp), B.init(e, t);
}), l3 = /* @__PURE__ */ b("$ZodURL", (e, t) => {
  B.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim();
      if (!t.normalize && t.protocol?.source === Bp.source && !/^https?:\/\//i.test(r)) {
        n.issues.push({
          code: "invalid_format",
          format: "url",
          note: "Invalid URL format",
          input: n.value,
          inst: e,
          continue: !t.abort
        });
        return;
      }
      const i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), h3 = /* @__PURE__ */ b("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = xp()), B.init(e, t);
}), f3 = /* @__PURE__ */ b("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Ap), B.init(e, t);
}), d3 = /* @__PURE__ */ b("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Fp), B.init(e, t);
}), p3 = /* @__PURE__ */ b("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = Ep), B.init(e, t);
}), m3 = /* @__PURE__ */ b("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = vp), B.init(e, t);
}), D3 = /* @__PURE__ */ b("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = _p), B.init(e, t);
}), g3 = /* @__PURE__ */ b("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Sp), B.init(e, t);
}), y3 = /* @__PURE__ */ b("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = jp(t)), B.init(e, t);
}), b3 = /* @__PURE__ */ b("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Lp), B.init(e, t);
}), w3 = /* @__PURE__ */ b("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Mp(t)), B.init(e, t);
}), F3 = /* @__PURE__ */ b("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Op), B.init(e, t);
}), E3 = /* @__PURE__ */ b("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = kp), B.init(e, t), e._zod.bag.format = "ipv4";
}), v3 = /* @__PURE__ */ b("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Np), B.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), _3 = /* @__PURE__ */ b("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Ip), B.init(e, t);
}), S3 = /* @__PURE__ */ b("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Pp), B.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, s] = r;
      if (!s)
        throw new Error();
      const o = Number(s);
      if (`${o}` !== s)
        throw new Error();
      if (o < 0 || o > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Wa(e) {
  if (e === "")
    return !0;
  if (/\s/.test(e) || e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const A3 = /* @__PURE__ */ b("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = zp), B.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    Wa(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function O3(e) {
  if (!La.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Wa(n);
}
const C3 = /* @__PURE__ */ b("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = La), B.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    O3(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), T3 = /* @__PURE__ */ b("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = $p), B.init(e, t);
});
function R3(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const x3 = /* @__PURE__ */ b("$ZodJWT", (e, t) => {
  B.init(e, t), e._zod.check = (n) => {
    R3(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ga = /* @__PURE__ */ b("$ZodNumber", (e, t) => {
  j.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? qp, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const s = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...s ? { received: s } : {}
    }), n;
  };
}), k3 = /* @__PURE__ */ b("$ZodNumberFormat", (e, t) => {
  Kp.init(e, t), Ga.init(e, t);
}), N3 = /* @__PURE__ */ b("$ZodUnknown", (e, t) => {
  j.init(e, t), e._zod.parse = (n) => n;
}), I3 = /* @__PURE__ */ b("$ZodNever", (e, t) => {
  j.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function Ws(e, t, n) {
  e.issues.length && t.issues.push(...Pa(n, e.issues)), t.value[n] = e.value;
}
const P3 = /* @__PURE__ */ b("$ZodArray", (e, t) => {
  j.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const s = [];
    for (let o = 0; o < i.length; o++) {
      const u = i[o], a = t.element._zod.run({
        value: u,
        issues: []
      }, r);
      a instanceof Promise ? s.push(a.then((c) => Ws(c, n, o))) : Ws(a, n, o);
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  };
});
function Rn(e, t, n, r, i, s) {
  const o = n in r;
  if (e.issues.length) {
    if (i && s && !o)
      return;
    t.issues.push(...Pa(n, e.issues));
  }
  if (!o && !i) {
    e.issues.length || t.issues.push({
      code: "invalid_type",
      expected: "nonoptional",
      input: void 0,
      path: [n]
    });
    return;
  }
  e.value === void 0 ? o && (t.value[n] = void 0) : t.value[n] = e.value;
}
function Va(e) {
  const t = Object.keys(e.shape);
  for (const r of t)
    if (!e.shape?.[r]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${r}": expected a Zod schema`);
  const n = Yd(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function Ka(e, t, n, r, i, s) {
  const o = [], u = i.keySet, a = i.catchall._zod, c = a.def.type, l = a.optin === "optional", f = a.optout === "optional";
  for (const d in t) {
    if (d === "__proto__" || u.has(d))
      continue;
    if (c === "never") {
      o.push(d);
      continue;
    }
    const h = a.run({ value: t[d], issues: [] }, r);
    h instanceof Promise ? e.push(h.then((p) => Rn(p, n, d, t, l, f))) : Rn(h, n, d, t, l, f);
  }
  return o.length && n.issues.push({
    code: "unrecognized_keys",
    keys: o,
    input: t,
    inst: s
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const z3 = /* @__PURE__ */ b("$ZodObject", (e, t) => {
  if (j.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const u = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const a = { ...u };
        return Object.defineProperty(t, "shape", {
          value: a
        }), a;
      }
    });
  }
  const r = ki(() => Va(t));
  x(e._zod, "propValues", () => {
    const u = t.shape, a = {};
    for (const c in u) {
      const l = u[c]._zod;
      if (l.values) {
        a[c] ?? (a[c] = /* @__PURE__ */ new Set());
        for (const f of l.values)
          a[c].add(f);
      }
    }
    return a;
  });
  const i = Tn, s = t.catchall;
  let o;
  e._zod.parse = (u, a) => {
    o ?? (o = r.value);
    const c = u.value;
    if (!i(c))
      return u.issues.push({
        expected: "object",
        code: "invalid_type",
        input: c,
        inst: e
      }), u;
    u.value = {};
    const l = [], f = o.shape;
    for (const d of o.keys) {
      const h = f[d], p = h._zod.optin === "optional", m = h._zod.optout === "optional", D = h._zod.run({ value: c[d], issues: [] }, a);
      D instanceof Promise ? l.push(D.then((y) => Rn(y, u, d, c, p, m))) : Rn(D, u, d, c, p, m);
    }
    return s ? Ka(l, c, u, a, r.value, e) : l.length ? Promise.all(l).then(() => u) : u;
  };
}), B3 = /* @__PURE__ */ b("$ZodObjectJIT", (e, t) => {
  z3.init(e, t);
  const n = e._zod.parse, r = ki(() => Va(t)), i = (d) => {
    const h = new s3(["shape", "payload", "ctx"]), p = r.value, m = (S) => {
      const v = Zs(S);
      return `shape[${v}]._zod.run({ value: input[${v}], issues: [] }, ctx)`;
    };
    h.write("const input = payload.value;");
    const D = /* @__PURE__ */ Object.create(null);
    let y = 0;
    for (const S of p.keys)
      D[S] = `key_${y++}`;
    h.write("const newResult = {};");
    for (const S of p.keys) {
      const v = D[S], E = Zs(S), R = d[S], A = R?._zod?.optin === "optional", k = R?._zod?.optout === "optional";
      h.write(`const ${v} = ${m(S)};`), A && k ? h.write(`
        if (${v}.issues.length) {
          if (${E} in input) {
            payload.issues = payload.issues.concat(${v}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${E}, ...iss.path] : [${E}]
            })));
          }
        }
        
        if (${v}.value === undefined) {
          if (${E} in input) {
            newResult[${E}] = undefined;
          }
        } else {
          newResult[${E}] = ${v}.value;
        }
        
      `) : A ? h.write(`
        if (${v}.issues.length) {
          payload.issues = payload.issues.concat(${v}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${E}, ...iss.path] : [${E}]
          })));
        }
        
        if (${v}.value === undefined) {
          if (${E} in input) {
            newResult[${E}] = undefined;
          }
        } else {
          newResult[${E}] = ${v}.value;
        }
        
      `) : h.write(`
        const ${v}_present = ${E} in input;
        if (${v}.issues.length) {
          payload.issues = payload.issues.concat(${v}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${E}, ...iss.path] : [${E}]
          })));
        }
        if (!${v}_present && !${v}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${E}]
          });
        }

        if (${v}_present) {
          if (${v}.value === undefined) {
            newResult[${E}] = undefined;
          } else {
            newResult[${E}] = ${v}.value;
          }
        }

      `);
    }
    h.write("payload.value = newResult;"), h.write("return payload;");
    const F = h.compile();
    return (S, v) => F(d, S, v);
  };
  let s;
  const o = Tn, u = !Cn.jitless, c = u && Hd.value, l = t.catchall;
  let f;
  e._zod.parse = (d, h) => {
    f ?? (f = r.value);
    const p = d.value;
    return o(p) ? u && c && h?.async === !1 && h.jitless !== !0 ? (s || (s = i(t.shape)), d = s(d, h), l ? Ka([], p, d, h, f, e) : d) : n(d, h) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), d);
  };
});
function Gs(e, t, n, r) {
  for (const s of e)
    if (s.issues.length === 0)
      return t.value = s.value, t;
  const i = e.filter((s) => !et(s));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((s) => s.issues.map((o) => qe(o, r, Ze())))
  }), t);
}
const $3 = /* @__PURE__ */ b("$ZodUnion", (e, t) => {
  j.init(e, t), x(e._zod, "optin", () => t.options.some((r) => r._zod.optin === "optional") ? "optional" : void 0), x(e._zod, "optout", () => t.options.some((r) => r._zod.optout === "optional") ? "optional" : void 0), x(e._zod, "values", () => {
    if (t.options.every((r) => r._zod.values))
      return new Set(t.options.flatMap((r) => Array.from(r._zod.values)));
  }), x(e._zod, "pattern", () => {
    if (t.options.every((r) => r._zod.pattern)) {
      const r = t.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${r.map((i) => Ii(i.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1 ? t.options[0]._zod.run : null;
  e._zod.parse = (r, i) => {
    if (n)
      return n(r, i);
    let s = !1;
    const o = [];
    for (const u of t.options) {
      const a = u._zod.run({
        value: r.value,
        issues: []
      }, i);
      if (a instanceof Promise)
        o.push(a), s = !0;
      else {
        if (a.issues.length === 0)
          return a;
        o.push(a);
      }
    }
    return s ? Promise.all(o).then((u) => Gs(u, r, e, i)) : Gs(o, r, e, i);
  };
}), L3 = /* @__PURE__ */ b("$ZodIntersection", (e, t) => {
  j.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, s = t.left._zod.run({ value: i, issues: [] }, r), o = t.right._zod.run({ value: i, issues: [] }, r);
    return s instanceof Promise || o instanceof Promise ? Promise.all([s, o]).then(([a, c]) => Vs(n, a, c)) : Vs(n, s, o);
  };
});
function Vr(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (xt(e) && xt(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((s) => n.indexOf(s) !== -1), i = { ...e, ...t };
    for (const s of r) {
      const o = Vr(e[s], t[s]);
      if (!o.valid)
        return {
          valid: !1,
          mergeErrorPath: [s, ...o.mergeErrorPath]
        };
      i[s] = o.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], s = t[r], o = Vr(i, s);
      if (!o.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...o.mergeErrorPath]
        };
      n.push(o.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Vs(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const u of t.issues)
    if (u.code === "unrecognized_keys") {
      i ?? (i = u);
      for (const a of u.keys)
        r.has(a) || r.set(a, {}), r.get(a).l = !0;
    } else
      e.issues.push(u);
  for (const u of n.issues)
    if (u.code === "unrecognized_keys")
      for (const a of u.keys)
        r.has(a) || r.set(a, {}), r.get(a).r = !0;
    else
      e.issues.push(u);
  const s = [...r].filter(([, u]) => u.l && u.r).map(([u]) => u);
  if (s.length && i && e.issues.push({ ...i, keys: s }), et(e))
    return e;
  const o = Vr(t.value, n.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const M3 = /* @__PURE__ */ b("$ZodEnum", (e, t) => {
  j.init(e, t);
  const n = ka(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => Xd.has(typeof i)).map((i) => typeof i == "string" ? Kn(i) : i.toString()).join("|")})$`), e._zod.parse = (i, s) => {
    const o = i.value;
    return r.has(o) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: o,
      inst: e
    }), i;
  };
}), j3 = /* @__PURE__ */ b("$ZodTransform", (e, t) => {
  j.init(e, t), e._zod.optin = "optional", e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new xa(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n.fallback = !0, n));
    if (i instanceof Promise)
      throw new rt();
    return n.value = i, n.fallback = !0, n;
  };
});
function Ks(e, t) {
  return t === void 0 && (e.issues.length || e.fallback) ? { issues: [], value: void 0 } : e;
}
const Qa = /* @__PURE__ */ b("$ZodOptional", (e, t) => {
  j.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", x(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), x(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Ii(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = n.value, s = t.innerType._zod.run(n, r);
      return s instanceof Promise ? s.then((o) => Ks(o, i)) : Ks(s, i);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), U3 = /* @__PURE__ */ b("$ZodExactOptional", (e, t) => {
  Qa.init(e, t), x(e._zod, "values", () => t.innerType._zod.values), x(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), Z3 = /* @__PURE__ */ b("$ZodNullable", (e, t) => {
  j.init(e, t), x(e._zod, "optin", () => t.innerType._zod.optin), x(e._zod, "optout", () => t.innerType._zod.optout), x(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Ii(n.source)}|null)$`) : void 0;
  }), x(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), q3 = /* @__PURE__ */ b("$ZodDefault", (e, t) => {
  j.init(e, t), e._zod.optin = "optional", x(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((s) => Qs(s, t)) : Qs(i, t);
  };
});
function Qs(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const W3 = /* @__PURE__ */ b("$ZodPrefault", (e, t) => {
  j.init(e, t), e._zod.optin = "optional", x(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), G3 = /* @__PURE__ */ b("$ZodNonOptional", (e, t) => {
  j.init(e, t), x(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((s) => Js(s, e)) : Js(i, e);
  };
});
function Js(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const V3 = /* @__PURE__ */ b("$ZodCatch", (e, t) => {
  j.init(e, t), e._zod.optin = "optional", x(e._zod, "optout", () => t.innerType._zod.optout), x(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((s) => (n.value = s.value, s.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: s.issues.map((o) => qe(o, r, Ze()))
      },
      input: n.value
    }), n.issues = [], n.fallback = !0), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((s) => qe(s, r, Ze()))
      },
      input: n.value
    }), n.issues = [], n.fallback = !0), n);
  };
}), K3 = /* @__PURE__ */ b("$ZodPipe", (e, t) => {
  j.init(e, t), x(e._zod, "values", () => t.in._zod.values), x(e._zod, "optin", () => t.in._zod.optin), x(e._zod, "optout", () => t.out._zod.optout), x(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const s = t.out._zod.run(n, r);
      return s instanceof Promise ? s.then((o) => Qt(o, t.in, r)) : Qt(s, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((s) => Qt(s, t.out, r)) : Qt(i, t.out, r);
  };
});
function Qt(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues, fallback: e.fallback }, n);
}
const Q3 = /* @__PURE__ */ b("$ZodReadonly", (e, t) => {
  j.init(e, t), x(e._zod, "propValues", () => t.innerType._zod.propValues), x(e._zod, "values", () => t.innerType._zod.values), x(e._zod, "optin", () => t.innerType?._zod?.optin), x(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(Hs) : Hs(i);
  };
});
function Hs(e) {
  return e.value = Object.freeze(e.value), e;
}
const J3 = /* @__PURE__ */ b("$ZodLazy", (e, t) => {
  j.init(e, t), x(e._zod, "innerType", () => {
    const n = t;
    return n._cachedInner || (n._cachedInner = t.getter()), n._cachedInner;
  }), x(e._zod, "pattern", () => e._zod.innerType?._zod?.pattern), x(e._zod, "propValues", () => e._zod.innerType?._zod?.propValues), x(e._zod, "optin", () => e._zod.innerType?._zod?.optin ?? void 0), x(e._zod, "optout", () => e._zod.innerType?._zod?.optout ?? void 0), e._zod.parse = (n, r) => e._zod.innerType._zod.run(n, r);
}), H3 = /* @__PURE__ */ b("$ZodCustom", (e, t) => {
  te.init(e, t), j.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((s) => Xs(s, n, r, e));
    Xs(i, n, r, e);
  };
});
function Xs(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(kt(i));
  }
}
var Ys;
class X3 {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Y3() {
  return new X3();
}
(Ys = globalThis).__zod_globalRegistry ?? (Ys.__zod_globalRegistry = Y3());
const St = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function em(e, t) {
  return new e({
    type: "string",
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tm(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eo(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nm(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rm(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function im(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sm(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function om(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function um(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function am(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cm(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lm(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hm(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fm(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dm(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pm(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mm(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Dm(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gm(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ym(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function bm(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function wm(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Fm(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Em(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function vm(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _m(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Sm(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Am(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Om(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Cm(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function Tm(e, t) {
  return new e({
    type: "never",
    ...O(t)
  });
}
// @__NO_SIDE_EFFECTS__
function to(e, t) {
  return new Za({
    check: "less_than",
    ...O(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function pr(e, t) {
  return new Za({
    check: "less_than",
    ...O(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function no(e, t) {
  return new qa({
    check: "greater_than",
    ...O(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function mr(e, t) {
  return new qa({
    check: "greater_than",
    ...O(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function ro(e, t) {
  return new Vp({
    check: "multiple_of",
    ...O(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ja(e, t) {
  return new Qp({
    check: "max_length",
    ...O(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function xn(e, t) {
  return new Jp({
    check: "min_length",
    ...O(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Ha(e, t) {
  return new Hp({
    check: "length_equals",
    ...O(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function Rm(e, t) {
  return new Xp({
    check: "string_format",
    format: "regex",
    ...O(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function xm(e) {
  return new Yp({
    check: "string_format",
    format: "lowercase",
    ...O(e)
  });
}
// @__NO_SIDE_EFFECTS__
function km(e) {
  return new e3({
    check: "string_format",
    format: "uppercase",
    ...O(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Nm(e, t) {
  return new t3({
    check: "string_format",
    format: "includes",
    ...O(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function Im(e, t) {
  return new n3({
    check: "string_format",
    format: "starts_with",
    ...O(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Pm(e, t) {
  return new r3({
    check: "string_format",
    format: "ends_with",
    ...O(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function mt(e) {
  return new i3({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function zm(e) {
  return /* @__PURE__ */ mt((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function Bm() {
  return /* @__PURE__ */ mt((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function $m() {
  return /* @__PURE__ */ mt((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Lm() {
  return /* @__PURE__ */ mt((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Mm() {
  return /* @__PURE__ */ mt((e) => Jd(e));
}
// @__NO_SIDE_EFFECTS__
function jm(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...O(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Um(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...O(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Zm(e, t) {
  const n = /* @__PURE__ */ qm((r) => (r.addIssue = (i) => {
    if (typeof i == "string")
      r.issues.push(kt(i, r.value, n._zod.def));
    else {
      const s = i;
      s.fatal && (s.continue = !1), s.code ?? (s.code = "custom"), s.input ?? (s.input = r.value), s.inst ?? (s.inst = n), s.continue ?? (s.continue = !n._zod.def.abort), r.issues.push(kt(s));
    }
  }, e(r.value, r)), t);
  return n;
}
// @__NO_SIDE_EFFECTS__
function qm(e, t) {
  const n = new te({
    check: "custom",
    ...O(t)
  });
  return n._zod.check = e, n;
}
function kn(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? St,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function I(e, t, n = { path: [], schemaPath: [] }) {
  var r;
  const i = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const o = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, o);
  const u = e._zod.toJSONSchema?.();
  if (u)
    o.schema = u;
  else {
    const l = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, o.schema, l);
    else {
      const d = o.schema, h = t.processors[i.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
      h(e, t, d, l);
    }
    const f = e._zod.parent;
    f && (o.ref || (o.ref = f), I(f, t, l), t.seen.get(f).isParent = !0);
  }
  const a = t.metadataRegistry.get(e);
  return a && Object.assign(o.schema, a), t.io === "input" && H(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && "_prefault" in o.schema && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function Nn(e, t) {
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = /* @__PURE__ */ new Map();
  for (const o of e.seen.entries()) {
    const u = e.metadataRegistry.get(o[0])?.id;
    if (u) {
      const a = r.get(u);
      if (a && a !== o[0])
        throw new Error(`Duplicate schema id "${u}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      r.set(u, o[0]);
    }
  }
  const i = (o) => {
    const u = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const f = e.external.registry.get(o[0])?.id, d = e.external.uri ?? ((p) => p);
      if (f)
        return { ref: d(f) };
      const h = o[1].defId ?? o[1].schema.id ?? `schema${e.counter++}`;
      return o[1].defId = h, { defId: h, ref: `${d("__shared")}#/${u}/${h}` };
    }
    if (o[1] === n)
      return { ref: "#" };
    const c = `#/${u}/`, l = o[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: l, ref: c + l };
  }, s = (o) => {
    if (o[1].schema.$ref)
      return;
    const u = o[1], { ref: a, defId: c } = i(o);
    u.def = { ...u.schema }, c && (u.defId = c);
    const l = u.schema;
    for (const f in l)
      delete l[f];
    l.$ref = a;
  };
  if (e.cycles === "throw")
    for (const o of e.seen.entries()) {
      const u = o[1];
      if (u.cycle)
        throw new Error(`Cycle detected: #/${u.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const o of e.seen.entries()) {
    const u = o[1];
    if (t === o[0]) {
      s(o);
      continue;
    }
    if (e.external) {
      const c = e.external.registry.get(o[0])?.id;
      if (t !== o[0] && c) {
        s(o);
        continue;
      }
    }
    if (e.metadataRegistry.get(o[0])?.id) {
      s(o);
      continue;
    }
    if (u.cycle) {
      s(o);
      continue;
    }
    if (u.count > 1 && e.reused === "ref") {
      s(o);
      continue;
    }
  }
}
function In(e, t) {
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = (u) => {
    const a = e.seen.get(u);
    if (a.ref === null)
      return;
    const c = a.def ?? a.schema, l = { ...c }, f = a.ref;
    if (a.ref = null, f) {
      r(f);
      const h = e.seen.get(f), p = h.schema;
      if (p.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (c.allOf = c.allOf ?? [], c.allOf.push(p)) : Object.assign(c, p), Object.assign(c, l), u._zod.parent === f)
        for (const D in c)
          D === "$ref" || D === "allOf" || D in l || delete c[D];
      if (p.$ref && h.def)
        for (const D in c)
          D === "$ref" || D === "allOf" || D in h.def && JSON.stringify(c[D]) === JSON.stringify(h.def[D]) && delete c[D];
    }
    const d = u._zod.parent;
    if (d && d !== f) {
      r(d);
      const h = e.seen.get(d);
      if (h?.schema.$ref && (c.$ref = h.schema.$ref, h.def))
        for (const p in c)
          p === "$ref" || p === "allOf" || p in h.def && JSON.stringify(c[p]) === JSON.stringify(h.def[p]) && delete c[p];
    }
    e.override({
      zodSchema: u,
      jsonSchema: c,
      path: a.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    r(u[0]);
  const i = {};
  if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
    const u = e.external.registry.get(t)?.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    i.$id = e.external.uri(u);
  }
  Object.assign(i, n.def ?? n.schema);
  const s = e.metadataRegistry.get(t)?.id;
  s !== void 0 && i.id === s && delete i.id;
  const o = e.external?.defs ?? {};
  for (const u of e.seen.entries()) {
    const a = u[1];
    a.def && a.defId && (a.def.id === a.defId && delete a.def.id, o[a.defId] = a.def);
  }
  e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
  try {
    const u = JSON.parse(JSON.stringify(i));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Pn(t, "input", e.processors),
          output: Pn(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function H(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return H(r.element, n);
  if (r.type === "set")
    return H(r.valueType, n);
  if (r.type === "lazy")
    return H(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return H(r.innerType, n);
  if (r.type === "intersection")
    return H(r.left, n) || H(r.right, n);
  if (r.type === "record" || r.type === "map")
    return H(r.keyType, n) || H(r.valueType, n);
  if (r.type === "pipe")
    return e._zod.traits.has("$ZodCodec") ? !0 : H(r.in, n) || H(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (H(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (H(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (H(i, n))
        return !0;
    return !!(r.rest && H(r.rest, n));
  }
  return !1;
}
const Wm = (e, t = {}) => (n) => {
  const r = kn({ ...n, processors: t });
  return I(e, r), Nn(r, e), In(r, e);
}, Pn = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: s } = r ?? {}, o = kn({ ...i ?? {}, target: s, io: t, processors: n });
  return I(e, o), Nn(o, e), In(o, e);
}, Gm = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Xa = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: s, maximum: o, format: u, patterns: a, contentEncoding: c } = e._zod.bag;
  if (typeof s == "number" && (i.minLength = s), typeof o == "number" && (i.maxLength = o), u && (i.format = Gm[u] ?? u, i.format === "" && delete i.format, u === "time" && delete i.format), c && (i.contentEncoding = c), a && a.size > 0) {
    const l = [...a];
    l.length === 1 ? i.pattern = l[0].source : l.length > 1 && (i.allOf = [
      ...l.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, Ya = (e, t, n, r) => {
  const i = n, { minimum: s, maximum: o, format: u, multipleOf: a, exclusiveMaximum: c, exclusiveMinimum: l } = e._zod.bag;
  typeof u == "string" && u.includes("int") ? i.type = "integer" : i.type = "number";
  const f = typeof l == "number" && l >= (s ?? Number.NEGATIVE_INFINITY), d = typeof c == "number" && c <= (o ?? Number.POSITIVE_INFINITY), h = t.target === "draft-04" || t.target === "openapi-3.0";
  f ? h ? (i.minimum = l, i.exclusiveMinimum = !0) : i.exclusiveMinimum = l : typeof s == "number" && (i.minimum = s), d ? h ? (i.maximum = c, i.exclusiveMaximum = !0) : i.exclusiveMaximum = c : typeof o == "number" && (i.maximum = o), typeof a == "number" && (i.multipleOf = a);
}, Vm = (e, t, n, r) => {
  n.type = "boolean";
}, Km = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("BigInt cannot be represented in JSON Schema");
}, Qm = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Symbols cannot be represented in JSON Schema");
}, Jm = (e, t, n, r) => {
  t.target === "openapi-3.0" ? (n.type = "string", n.nullable = !0, n.enum = [null]) : n.type = "null";
}, Hm = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Undefined cannot be represented in JSON Schema");
}, Xm = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Void cannot be represented in JSON Schema");
}, ec = (e, t, n, r) => {
  n.not = {};
}, Ym = (e, t, n, r) => {
}, tc = (e, t, n, r) => {
}, eD = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Date cannot be represented in JSON Schema");
}, nc = (e, t, n, r) => {
  const i = e._zod.def, s = ka(i.entries);
  s.every((o) => typeof o == "number") && (n.type = "number"), s.every((o) => typeof o == "string") && (n.type = "string"), n.enum = s;
}, tD = (e, t, n, r) => {
  const i = e._zod.def, s = [];
  for (const o of i.values)
    if (o === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof o == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      s.push(Number(o));
    } else
      s.push(o);
  if (s.length !== 0)
    if (s.length === 1) {
      const o = s[0];
      n.type = o === null ? "null" : typeof o, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [o] : n.const = o;
    } else
      s.every((o) => typeof o == "number") && (n.type = "number"), s.every((o) => typeof o == "string") && (n.type = "string"), s.every((o) => typeof o == "boolean") && (n.type = "boolean"), s.every((o) => o === null) && (n.type = "null"), n.enum = s;
}, nD = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("NaN cannot be represented in JSON Schema");
}, rD = (e, t, n, r) => {
  const i = n, s = e._zod.pattern;
  if (!s)
    throw new Error("Pattern not found in template literal");
  i.type = "string", i.pattern = s.source;
}, iD = (e, t, n, r) => {
  const i = n, s = {
    type: "string",
    format: "binary",
    contentEncoding: "binary"
  }, { minimum: o, maximum: u, mime: a } = e._zod.bag;
  o !== void 0 && (s.minLength = o), u !== void 0 && (s.maxLength = u), a ? a.length === 1 ? (s.contentMediaType = a[0], Object.assign(i, s)) : (Object.assign(i, s), i.anyOf = a.map((c) => ({ contentMediaType: c }))) : Object.assign(i, s);
}, sD = (e, t, n, r) => {
  n.type = "boolean";
}, rc = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, oD = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Function types cannot be represented in JSON Schema");
}, ic = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, uD = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Map cannot be represented in JSON Schema");
}, aD = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Set cannot be represented in JSON Schema");
}, sc = (e, t, n, r) => {
  const i = n, s = e._zod.def, { minimum: o, maximum: u } = e._zod.bag;
  typeof o == "number" && (i.minItems = o), typeof u == "number" && (i.maxItems = u), i.type = "array", i.items = I(s.element, t, {
    ...r,
    path: [...r.path, "items"]
  });
}, oc = (e, t, n, r) => {
  const i = n, s = e._zod.def;
  i.type = "object", i.properties = {};
  const o = s.shape;
  for (const c in o)
    i.properties[c] = I(o[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const u = new Set(Object.keys(o)), a = new Set([...u].filter((c) => {
    const l = s.shape[c]._zod;
    return t.io === "input" ? l.optin === void 0 : l.optout === void 0;
  }));
  a.size > 0 && (i.required = Array.from(a)), s.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : s.catchall ? s.catchall && (i.additionalProperties = I(s.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (i.additionalProperties = !1);
}, uc = (e, t, n, r) => {
  const i = e._zod.def, s = i.inclusive === !1, o = i.options.map((u, a) => I(u, t, {
    ...r,
    path: [...r.path, s ? "oneOf" : "anyOf", a]
  }));
  s ? n.oneOf = o : n.anyOf = o;
}, ac = (e, t, n, r) => {
  const i = e._zod.def, s = I(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), o = I(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), u = (c) => "allOf" in c && Object.keys(c).length === 1, a = [
    ...u(s) ? s.allOf : [s],
    ...u(o) ? o.allOf : [o]
  ];
  n.allOf = a;
}, cD = (e, t, n, r) => {
  const i = n, s = e._zod.def;
  i.type = "array";
  const o = t.target === "draft-2020-12" ? "prefixItems" : "items", u = t.target === "draft-2020-12" || t.target === "openapi-3.0" ? "items" : "additionalItems", a = s.items.map((d, h) => I(d, t, {
    ...r,
    path: [...r.path, o, h]
  })), c = s.rest ? I(s.rest, t, {
    ...r,
    path: [...r.path, u, ...t.target === "openapi-3.0" ? [s.items.length] : []]
  }) : null;
  t.target === "draft-2020-12" ? (i.prefixItems = a, c && (i.items = c)) : t.target === "openapi-3.0" ? (i.items = {
    anyOf: a
  }, c && i.items.anyOf.push(c), i.minItems = a.length, c || (i.maxItems = a.length)) : (i.items = a, c && (i.additionalItems = c));
  const { minimum: l, maximum: f } = e._zod.bag;
  typeof l == "number" && (i.minItems = l), typeof f == "number" && (i.maxItems = f);
}, lD = (e, t, n, r) => {
  const i = n, s = e._zod.def;
  i.type = "object";
  const o = s.keyType, a = o._zod.bag?.patterns;
  if (s.mode === "loose" && a && a.size > 0) {
    const l = I(s.valueType, t, {
      ...r,
      path: [...r.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const f of a)
      i.patternProperties[f.source] = l;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = I(s.keyType, t, {
      ...r,
      path: [...r.path, "propertyNames"]
    })), i.additionalProperties = I(s.valueType, t, {
      ...r,
      path: [...r.path, "additionalProperties"]
    });
  const c = o._zod.values;
  if (c) {
    const l = [...c].filter((f) => typeof f == "string" || typeof f == "number");
    l.length > 0 && (i.required = l);
  }
}, cc = (e, t, n, r) => {
  const i = e._zod.def, s = I(i.innerType, t, r), o = t.seen.get(e);
  t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [s, { type: "null" }];
}, lc = (e, t, n, r) => {
  const i = e._zod.def;
  I(i.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = i.innerType;
}, hc = (e, t, n, r) => {
  const i = e._zod.def;
  I(i.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, fc = (e, t, n, r) => {
  const i = e._zod.def;
  I(i.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, dc = (e, t, n, r) => {
  const i = e._zod.def;
  I(i.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = i.innerType;
  let o;
  try {
    o = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = o;
}, pc = (e, t, n, r) => {
  const i = e._zod.def, s = i.in._zod.traits.has("$ZodTransform"), o = t.io === "input" ? s ? i.out : i.in : i.out;
  I(o, t, r);
  const u = t.seen.get(e);
  u.ref = o;
}, mc = (e, t, n, r) => {
  const i = e._zod.def;
  I(i.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = i.innerType, n.readOnly = !0;
}, hD = (e, t, n, r) => {
  const i = e._zod.def;
  I(i.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = i.innerType;
}, Li = (e, t, n, r) => {
  const i = e._zod.def;
  I(i.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = i.innerType;
}, Dc = (e, t, n, r) => {
  const i = e._zod.innerType;
  I(i, t, r);
  const s = t.seen.get(e);
  s.ref = i;
}, io = {
  string: Xa,
  number: Ya,
  boolean: Vm,
  bigint: Km,
  symbol: Qm,
  null: Jm,
  undefined: Hm,
  void: Xm,
  never: ec,
  any: Ym,
  unknown: tc,
  date: eD,
  enum: nc,
  literal: tD,
  nan: nD,
  template_literal: rD,
  file: iD,
  success: sD,
  custom: rc,
  function: oD,
  transform: ic,
  map: uD,
  set: aD,
  array: sc,
  object: oc,
  union: uc,
  intersection: ac,
  tuple: cD,
  record: lD,
  nullable: cc,
  nonoptional: lc,
  default: hc,
  prefault: fc,
  catch: dc,
  pipe: pc,
  readonly: mc,
  promise: hD,
  optional: Li,
  lazy: Dc
};
function fD(e, t) {
  if ("_idmap" in e) {
    const r = e, i = kn({ ...t, processors: io }), s = {};
    for (const a of r._idmap.entries()) {
      const [c, l] = a;
      I(l, i);
    }
    const o = {}, u = {
      registry: r,
      uri: t?.uri,
      defs: s
    };
    i.external = u;
    for (const a of r._idmap.entries()) {
      const [c, l] = a;
      Nn(i, l), o[c] = In(i, l);
    }
    if (Object.keys(s).length > 0) {
      const a = i.target === "draft-2020-12" ? "$defs" : "definitions";
      o.__shared = {
        [a]: s
      };
    }
    return { schemas: o };
  }
  const n = kn({ ...t, processors: io });
  return I(e, n), Nn(n, e), In(n, e);
}
const dD = /* @__PURE__ */ b("ZodISODateTime", (e, t) => {
  y3.init(e, t), L.init(e, t);
});
function pD(e) {
  return /* @__PURE__ */ Em(dD, e);
}
const mD = /* @__PURE__ */ b("ZodISODate", (e, t) => {
  b3.init(e, t), L.init(e, t);
});
function DD(e) {
  return /* @__PURE__ */ vm(mD, e);
}
const gD = /* @__PURE__ */ b("ZodISOTime", (e, t) => {
  w3.init(e, t), L.init(e, t);
});
function yD(e) {
  return /* @__PURE__ */ _m(gD, e);
}
const bD = /* @__PURE__ */ b("ZodISODuration", (e, t) => {
  F3.init(e, t), L.init(e, t);
});
function wD(e) {
  return /* @__PURE__ */ Sm(bD, e);
}
const gc = (e, t) => {
  Ba.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => lp(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => cp(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Gr, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Gr, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, FD = /* @__PURE__ */ b("ZodError", gc), ae = /* @__PURE__ */ b("ZodError", gc, {
  Parent: Error
}), ED = /* @__PURE__ */ zi(ae), vD = /* @__PURE__ */ Bi(ae), _D = /* @__PURE__ */ Qn(ae), SD = /* @__PURE__ */ Jn(ae), AD = /* @__PURE__ */ dp(ae), OD = /* @__PURE__ */ pp(ae), CD = /* @__PURE__ */ mp(ae), TD = /* @__PURE__ */ Dp(ae), RD = /* @__PURE__ */ gp(ae), xD = /* @__PURE__ */ yp(ae), kD = /* @__PURE__ */ bp(ae), ND = /* @__PURE__ */ wp(ae), so = /* @__PURE__ */ new WeakMap();
function jt(e, t, n) {
  const r = Object.getPrototypeOf(e);
  let i = so.get(r);
  if (i || (i = /* @__PURE__ */ new Set(), so.set(r, i)), !i.has(t)) {
    i.add(t);
    for (const s in n) {
      const o = n[s];
      Object.defineProperty(r, s, {
        configurable: !0,
        enumerable: !1,
        get() {
          const u = o.bind(this);
          return Object.defineProperty(this, s, {
            configurable: !0,
            writable: !0,
            enumerable: !0,
            value: u
          }), u;
        },
        set(u) {
          Object.defineProperty(this, s, {
            configurable: !0,
            writable: !0,
            enumerable: !0,
            value: u
          });
        }
      });
    }
  }
}
const U = /* @__PURE__ */ b("ZodType", (e, t) => (j.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: Pn(e, "input"),
    output: Pn(e, "output")
  }
}), e.toJSONSchema = Wm(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.parse = (n, r) => ED(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => _D(e, n, r), e.parseAsync = async (n, r) => vD(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => SD(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => AD(e, n, r), e.decode = (n, r) => OD(e, n, r), e.encodeAsync = async (n, r) => CD(e, n, r), e.decodeAsync = async (n, r) => TD(e, n, r), e.safeEncode = (n, r) => RD(e, n, r), e.safeDecode = (n, r) => xD(e, n, r), e.safeEncodeAsync = async (n, r) => kD(e, n, r), e.safeDecodeAsync = async (n, r) => ND(e, n, r), jt(e, "ZodType", {
  check(...n) {
    const r = this.def;
    return this.clone(xe(r, {
      checks: [
        ...r.checks ?? [],
        ...n.map((i) => typeof i == "function" ? { _zod: { check: i, def: { check: "custom" }, onattach: [] } } : i)
      ]
    }), { parent: !0 });
  },
  with(...n) {
    return this.check(...n);
  },
  clone(n, r) {
    return ke(this, n, r);
  },
  brand() {
    return this;
  },
  register(n, r) {
    return n.add(this, r), this;
  },
  refine(n, r) {
    return this.check(C4(n, r));
  },
  superRefine(n, r) {
    return this.check(T4(n, r));
  },
  overwrite(n) {
    return this.check(/* @__PURE__ */ mt(n));
  },
  optional() {
    return co(this);
  },
  exactOptional() {
    return d4(this);
  },
  nullable() {
    return lo(this);
  },
  nullish() {
    return co(lo(this));
  },
  nonoptional(n) {
    return b4(this, n);
  },
  array() {
    return r4(this);
  },
  or(n) {
    return Mi([this, n]);
  },
  and(n) {
    return a4(this, n);
  },
  transform(n) {
    return ho(this, h4(n));
  },
  default(n) {
    return D4(this, n);
  },
  prefault(n) {
    return y4(this, n);
  },
  catch(n) {
    return F4(this, n);
  },
  pipe(n) {
    return ho(this, n);
  },
  readonly() {
    return _4(this);
  },
  describe(n) {
    const r = this.clone();
    return St.add(r, { description: n }), r;
  },
  meta(...n) {
    if (n.length === 0)
      return St.get(this);
    const r = this.clone();
    return St.add(r, n[0]), r;
  },
  isOptional() {
    return this.safeParse(void 0).success;
  },
  isNullable() {
    return this.safeParse(null).success;
  },
  apply(n) {
    return n(this);
  }
}), Object.defineProperty(e, "description", {
  get() {
    return St.get(e)?.description;
  },
  configurable: !0
}), e)), yc = /* @__PURE__ */ b("_ZodString", (e, t) => {
  $i.init(e, t), U.init(e, t), e._zod.processJSONSchema = (r, i, s) => Xa(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, jt(e, "_ZodString", {
    regex(...r) {
      return this.check(/* @__PURE__ */ Rm(...r));
    },
    includes(...r) {
      return this.check(/* @__PURE__ */ Nm(...r));
    },
    startsWith(...r) {
      return this.check(/* @__PURE__ */ Im(...r));
    },
    endsWith(...r) {
      return this.check(/* @__PURE__ */ Pm(...r));
    },
    min(...r) {
      return this.check(/* @__PURE__ */ xn(...r));
    },
    max(...r) {
      return this.check(/* @__PURE__ */ Ja(...r));
    },
    length(...r) {
      return this.check(/* @__PURE__ */ Ha(...r));
    },
    nonempty(...r) {
      return this.check(/* @__PURE__ */ xn(1, ...r));
    },
    lowercase(r) {
      return this.check(/* @__PURE__ */ xm(r));
    },
    uppercase(r) {
      return this.check(/* @__PURE__ */ km(r));
    },
    trim() {
      return this.check(/* @__PURE__ */ Bm());
    },
    normalize(...r) {
      return this.check(/* @__PURE__ */ zm(...r));
    },
    toLowerCase() {
      return this.check(/* @__PURE__ */ $m());
    },
    toUpperCase() {
      return this.check(/* @__PURE__ */ Lm());
    },
    slugify() {
      return this.check(/* @__PURE__ */ Mm());
    }
  });
}), ID = /* @__PURE__ */ b("ZodString", (e, t) => {
  $i.init(e, t), yc.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ tm(PD, n)), e.url = (n) => e.check(/* @__PURE__ */ om(zD, n)), e.jwt = (n) => e.check(/* @__PURE__ */ Fm(HD, n)), e.emoji = (n) => e.check(/* @__PURE__ */ um(BD, n)), e.guid = (n) => e.check(/* @__PURE__ */ eo(oo, n)), e.uuid = (n) => e.check(/* @__PURE__ */ nm(Jt, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ rm(Jt, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ im(Jt, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ sm(Jt, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ am($D, n)), e.guid = (n) => e.check(/* @__PURE__ */ eo(oo, n)), e.cuid = (n) => e.check(/* @__PURE__ */ cm(LD, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ lm(MD, n)), e.ulid = (n) => e.check(/* @__PURE__ */ hm(jD, n)), e.base64 = (n) => e.check(/* @__PURE__ */ ym(KD, n)), e.base64url = (n) => e.check(/* @__PURE__ */ bm(QD, n)), e.xid = (n) => e.check(/* @__PURE__ */ fm(UD, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ dm(ZD, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ pm(qD, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ mm(WD, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ Dm(GD, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ gm(VD, n)), e.e164 = (n) => e.check(/* @__PURE__ */ wm(JD, n)), e.datetime = (n) => e.check(pD(n)), e.date = (n) => e.check(DD(n)), e.time = (n) => e.check(yD(n)), e.duration = (n) => e.check(wD(n));
});
function an(e) {
  return /* @__PURE__ */ em(ID, e);
}
const L = /* @__PURE__ */ b("ZodStringFormat", (e, t) => {
  B.init(e, t), yc.init(e, t);
}), PD = /* @__PURE__ */ b("ZodEmail", (e, t) => {
  c3.init(e, t), L.init(e, t);
}), oo = /* @__PURE__ */ b("ZodGUID", (e, t) => {
  u3.init(e, t), L.init(e, t);
}), Jt = /* @__PURE__ */ b("ZodUUID", (e, t) => {
  a3.init(e, t), L.init(e, t);
}), zD = /* @__PURE__ */ b("ZodURL", (e, t) => {
  l3.init(e, t), L.init(e, t);
}), BD = /* @__PURE__ */ b("ZodEmoji", (e, t) => {
  h3.init(e, t), L.init(e, t);
}), $D = /* @__PURE__ */ b("ZodNanoID", (e, t) => {
  f3.init(e, t), L.init(e, t);
}), LD = /* @__PURE__ */ b("ZodCUID", (e, t) => {
  d3.init(e, t), L.init(e, t);
}), MD = /* @__PURE__ */ b("ZodCUID2", (e, t) => {
  p3.init(e, t), L.init(e, t);
}), jD = /* @__PURE__ */ b("ZodULID", (e, t) => {
  m3.init(e, t), L.init(e, t);
}), UD = /* @__PURE__ */ b("ZodXID", (e, t) => {
  D3.init(e, t), L.init(e, t);
}), ZD = /* @__PURE__ */ b("ZodKSUID", (e, t) => {
  g3.init(e, t), L.init(e, t);
}), qD = /* @__PURE__ */ b("ZodIPv4", (e, t) => {
  E3.init(e, t), L.init(e, t);
}), WD = /* @__PURE__ */ b("ZodIPv6", (e, t) => {
  v3.init(e, t), L.init(e, t);
}), GD = /* @__PURE__ */ b("ZodCIDRv4", (e, t) => {
  _3.init(e, t), L.init(e, t);
}), VD = /* @__PURE__ */ b("ZodCIDRv6", (e, t) => {
  S3.init(e, t), L.init(e, t);
}), KD = /* @__PURE__ */ b("ZodBase64", (e, t) => {
  A3.init(e, t), L.init(e, t);
}), QD = /* @__PURE__ */ b("ZodBase64URL", (e, t) => {
  C3.init(e, t), L.init(e, t);
}), JD = /* @__PURE__ */ b("ZodE164", (e, t) => {
  T3.init(e, t), L.init(e, t);
}), HD = /* @__PURE__ */ b("ZodJWT", (e, t) => {
  x3.init(e, t), L.init(e, t);
}), bc = /* @__PURE__ */ b("ZodNumber", (e, t) => {
  Ga.init(e, t), U.init(e, t), e._zod.processJSONSchema = (r, i, s) => Ya(e, r, i), jt(e, "ZodNumber", {
    gt(r, i) {
      return this.check(/* @__PURE__ */ no(r, i));
    },
    gte(r, i) {
      return this.check(/* @__PURE__ */ mr(r, i));
    },
    min(r, i) {
      return this.check(/* @__PURE__ */ mr(r, i));
    },
    lt(r, i) {
      return this.check(/* @__PURE__ */ to(r, i));
    },
    lte(r, i) {
      return this.check(/* @__PURE__ */ pr(r, i));
    },
    max(r, i) {
      return this.check(/* @__PURE__ */ pr(r, i));
    },
    int(r) {
      return this.check(uo(r));
    },
    safe(r) {
      return this.check(uo(r));
    },
    positive(r) {
      return this.check(/* @__PURE__ */ no(0, r));
    },
    nonnegative(r) {
      return this.check(/* @__PURE__ */ mr(0, r));
    },
    negative(r) {
      return this.check(/* @__PURE__ */ to(0, r));
    },
    nonpositive(r) {
      return this.check(/* @__PURE__ */ pr(0, r));
    },
    multipleOf(r, i) {
      return this.check(/* @__PURE__ */ ro(r, i));
    },
    step(r, i) {
      return this.check(/* @__PURE__ */ ro(r, i));
    },
    finite() {
      return this;
    }
  });
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function wc(e) {
  return /* @__PURE__ */ Am(bc, e);
}
const XD = /* @__PURE__ */ b("ZodNumberFormat", (e, t) => {
  k3.init(e, t), bc.init(e, t);
});
function uo(e) {
  return /* @__PURE__ */ Om(XD, e);
}
const YD = /* @__PURE__ */ b("ZodUnknown", (e, t) => {
  N3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => tc();
});
function ao() {
  return /* @__PURE__ */ Cm(YD);
}
const e4 = /* @__PURE__ */ b("ZodNever", (e, t) => {
  I3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => ec(e, n, r);
});
function t4(e) {
  return /* @__PURE__ */ Tm(e4, e);
}
const n4 = /* @__PURE__ */ b("ZodArray", (e, t) => {
  P3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => sc(e, n, r, i), e.element = t.element, jt(e, "ZodArray", {
    min(n, r) {
      return this.check(/* @__PURE__ */ xn(n, r));
    },
    nonempty(n) {
      return this.check(/* @__PURE__ */ xn(1, n));
    },
    max(n, r) {
      return this.check(/* @__PURE__ */ Ja(n, r));
    },
    length(n, r) {
      return this.check(/* @__PURE__ */ Ha(n, r));
    },
    unwrap() {
      return this.element;
    }
  });
});
function r4(e, t) {
  return /* @__PURE__ */ jm(n4, e, t);
}
const i4 = /* @__PURE__ */ b("ZodObject", (e, t) => {
  B3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => oc(e, n, r, i), x(e, "shape", () => t.shape), jt(e, "ZodObject", {
    keyof() {
      return c4(Object.keys(this._zod.def.shape));
    },
    catchall(n) {
      return this.clone({ ...this._zod.def, catchall: n });
    },
    passthrough() {
      return this.clone({ ...this._zod.def, catchall: ao() });
    },
    loose() {
      return this.clone({ ...this._zod.def, catchall: ao() });
    },
    strict() {
      return this.clone({ ...this._zod.def, catchall: t4() });
    },
    strip() {
      return this.clone({ ...this._zod.def, catchall: void 0 });
    },
    extend(n) {
      return rp(this, n);
    },
    safeExtend(n) {
      return ip(this, n);
    },
    merge(n) {
      return sp(this, n);
    },
    pick(n) {
      return tp(this, n);
    },
    omit(n) {
      return np(this, n);
    },
    partial(...n) {
      return op(Fc, this, n[0]);
    },
    required(...n) {
      return up(Ec, this, n[0]);
    }
  });
});
function s4(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...O(t)
  };
  return new i4(n);
}
const o4 = /* @__PURE__ */ b("ZodUnion", (e, t) => {
  $3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => uc(e, n, r, i), e.options = t.options;
});
function Mi(e, t) {
  return new o4({
    type: "union",
    options: e,
    ...O(t)
  });
}
const u4 = /* @__PURE__ */ b("ZodIntersection", (e, t) => {
  L3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => ac(e, n, r, i);
});
function a4(e, t) {
  return new u4({
    type: "intersection",
    left: e,
    right: t
  });
}
const Kr = /* @__PURE__ */ b("ZodEnum", (e, t) => {
  M3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (r, i, s) => nc(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const s = {};
    for (const o of r)
      if (n.has(o))
        s[o] = t.entries[o];
      else
        throw new Error(`Key ${o} not found in enum`);
    return new Kr({
      ...t,
      checks: [],
      ...O(i),
      entries: s
    });
  }, e.exclude = (r, i) => {
    const s = { ...t.entries };
    for (const o of r)
      if (n.has(o))
        delete s[o];
      else
        throw new Error(`Key ${o} not found in enum`);
    return new Kr({
      ...t,
      checks: [],
      ...O(i),
      entries: s
    });
  };
});
function c4(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new Kr({
    type: "enum",
    entries: n,
    ...O(t)
  });
}
const l4 = /* @__PURE__ */ b("ZodTransform", (e, t) => {
  j3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => ic(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new xa(e.constructor.name);
    n.addIssue = (s) => {
      if (typeof s == "string")
        n.issues.push(kt(s, n.value, t));
      else {
        const o = s;
        o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = e), n.issues.push(kt(o));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((s) => (n.value = s, n.fallback = !0, n)) : (n.value = i, n.fallback = !0, n);
  };
});
function h4(e) {
  return new l4({
    type: "transform",
    transform: e
  });
}
const Fc = /* @__PURE__ */ b("ZodOptional", (e, t) => {
  Qa.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => Li(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function co(e) {
  return new Fc({
    type: "optional",
    innerType: e
  });
}
const f4 = /* @__PURE__ */ b("ZodExactOptional", (e, t) => {
  U3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => Li(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function d4(e) {
  return new f4({
    type: "optional",
    innerType: e
  });
}
const p4 = /* @__PURE__ */ b("ZodNullable", (e, t) => {
  Z3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => cc(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function lo(e) {
  return new p4({
    type: "nullable",
    innerType: e
  });
}
const m4 = /* @__PURE__ */ b("ZodDefault", (e, t) => {
  q3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => hc(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function D4(e, t) {
  return new m4({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Ia(t);
    }
  });
}
const g4 = /* @__PURE__ */ b("ZodPrefault", (e, t) => {
  W3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => fc(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function y4(e, t) {
  return new g4({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Ia(t);
    }
  });
}
const Ec = /* @__PURE__ */ b("ZodNonOptional", (e, t) => {
  G3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => lc(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function b4(e, t) {
  return new Ec({
    type: "nonoptional",
    innerType: e,
    ...O(t)
  });
}
const w4 = /* @__PURE__ */ b("ZodCatch", (e, t) => {
  V3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => dc(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function F4(e, t) {
  return new w4({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const E4 = /* @__PURE__ */ b("ZodPipe", (e, t) => {
  K3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => pc(e, n, r, i), e.in = t.in, e.out = t.out;
});
function ho(e, t) {
  return new E4({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const v4 = /* @__PURE__ */ b("ZodReadonly", (e, t) => {
  Q3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => mc(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function _4(e) {
  return new v4({
    type: "readonly",
    innerType: e
  });
}
const S4 = /* @__PURE__ */ b("ZodLazy", (e, t) => {
  J3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => Dc(e, n, r, i), e.unwrap = () => e._zod.def.getter();
});
function A4(e) {
  return new S4({
    type: "lazy",
    getter: e
  });
}
const O4 = /* @__PURE__ */ b("ZodCustom", (e, t) => {
  H3.init(e, t), U.init(e, t), e._zod.processJSONSchema = (n, r, i) => rc(e, n);
});
function C4(e, t = {}) {
  return /* @__PURE__ */ Um(O4, e, t);
}
function T4(e, t) {
  return /* @__PURE__ */ Zm(e, t);
}
class vc {
  meta;
  constructor(t) {
    this.meta = t ?? {};
  }
  label(t) {
    return this.meta.label = t, this;
  }
  component(t, n) {
    return this.meta.component = t, this.meta.props = n, this;
  }
  visible(t) {
    return this.meta.visible = t, this;
  }
  disable(t) {
    return this.meta.disable = t, this;
  }
  editable(t) {
    return this.meta.editable = t, this;
  }
}
const R4 = {
  scope: "global",
  builder: vc,
  defaults: {
    visible: !0
  }
};
class x4 {
  plugins = /* @__PURE__ */ new Map();
  install(t) {
    this.plugins.set(t.scope, t);
  }
  get(t) {
    return this.plugins.get(t);
  }
}
class Dr {
  constructor(t, n) {
    this.context = t, this.schema = typeof n == "function" ? A4(n) : n;
  }
  schema;
  meta = {};
  use(t, n) {
    const r = this.context.get(t);
    if (!r)
      throw new Error(`${t} plugin not installed`);
    const i = new r.builder(r.defaults);
    return n?.(i), this.meta[t] = { ...this.meta[t] ?? {}, ...i.meta }, this;
  }
}
class k4 {
  constructor(t) {
    this.fields = t, this.schema = s4(
      Object.fromEntries(
        Object.entries(this.fields).map(([n, r]) => [
          n,
          r.schema
        ])
      )
    );
  }
  schema;
  // Model Definition DSL = get Component parameters presentation
  resolve(t) {
    return Object.entries(this.fields).filter(
      ([n, r]) => r.meta[t]?.visible !== !1 && r.meta.global?.visible !== !1
    ).map(([n, r]) => ({
      fieldName: n,
      schema: r.schema,
      meta: { ...r.meta.global ?? {}, ...r.meta[t] ?? {} }
    }));
  }
  // validate 服务端 DTO
  parse(t) {
    try {
      return {
        success: !0,
        data: this.schema.parse(t)
      };
    } catch (n) {
      return {
        success: !1,
        issues: n instanceof FD ? n.issues : [{ code: "custom", input: t, path: [], message: n.message }]
      };
    }
  }
  safeParse(t) {
    const n = this.schema.safeParse(t);
    return n.success ? {
      success: !0,
      data: n.data
    } : {
      success: !1,
      issues: n.error.issues
    };
  }
  // 导出 JSON Schema 用于接口、校验
  // JSON Schema is a standard for describing the structure of JSON (with JSON).
  // It's widely used in OpenAPI definitions and defining structured outputs for AI.
  toJSONSchema(t) {
    return fD(this.schema, t);
  }
}
class N4 {
  context = new x4();
  constructor(t = []) {
    [...t, R4].forEach((n) => {
      this.context.install(n), n.scope in Dr.prototype || (Dr.prototype[n.scope] = function(r) {
        return this.use(n.scope, r);
      });
    });
  }
  field(t) {
    return new Dr(this.context, t);
  }
  entity(t) {
    return new k4(t);
  }
}
function _c(e = {}) {
  return new N4(e.plugins);
}
class I4 extends vc {
  label(t) {
    return this.meta.label = t, this;
  }
}
const Sc = {
  scope: "detail",
  builder: I4,
  defaults: {
    visible: !0
  }
}, fo = _c({
  plugins: [Sc]
}), P4 = fo.entity({
  tag: fo.field(
    () => Mi([wc(), an()]).transform((e) => String(e))
  )
}), z4 = "GOTO_RESULT", B4 = "GOTO_UNLOCKING", $4 = "CLOSE_DIALOG", L4 = "SHOW_DIALOG_LOADING", M4 = "SHOW_DIALOG_TOAST", j4 = "SHOW_DIALOG", U4 = "ENQUEUE_DIALOG", Z4 = "DIALOG_CLOSED", Ac = "SET_LOGIN_PHONE", Oc = "SET_LOGIN_CAPTCHA", q4 = "GET_CAPTCHA", Cc = "GET_CAPTCHA_START", W4 = "GET_CAPTCHA_SUCCESS", Tc = "GET_CAPTCHA_ERROR", Rc = "SET_CAPTCHA_COUNTDOWN", G4 = "LOGIN", V4 = "LOGIN_SUCCESS", K4 = "LOAD_LOT_ORDER", Q4 = "PAY_LOT_ORDER", J4 = "SET_DEMO", xc = "SET_COLOR_SCHEME", kc = "SET_PARK", Nc = "SET_LOT", Ic = "SET_BILL", Pc = "SET_ORDER", zc = "SET_PLATE", Bc = "SET_GROUP", $c = "SET_RESULT", Lc = "SET_USER", H4 = "SET_COUPON", X4 = "SET_POINT", Mc = "获取验证码";
function He(e, t = {}) {
  return e.phone = t.phone ?? e.phone ?? "", e.captcha = t.captcha ?? e.captcha ?? "", e.captchaText = t.captchaText ?? e.captchaText ?? Mc, e.disabledCaptcha = t.disabledCaptcha ?? !0, e.disabledLogin = !e.phone || !e.captcha, e;
}
function Y4(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  if (De(n))
    He(n, r);
  else
    switch (t.type) {
      case Ac:
        He(n, {
          phone: r.phone ?? "",
          disabledCaptcha: !r.phone
        });
        break;
      case Oc:
        He(n, {
          captcha: r.captcha ?? "",
          disabledCaptcha: e.disabledCaptcha
        });
        break;
      case Cc:
        He(n, {
          disabledCaptcha: !0
        });
        break;
      case Tc:
        He(n, {
          disabledCaptcha: !1
        });
        break;
      case Rc:
        He(n, {
          captchaText: r.count > 0 ? `${r.count}秒后可重发` : Mc,
          disabledCaptcha: r.count > 0
        });
        break;
    }
  return n;
}
const gr = {
  UNKNOWN: "UNKNOWN",
  // 未知，前端初始化状态
  IN_ROAD: "L",
  // 路内
  OUT_ROAD: "G"
  // 路外
}, yr = {
  UNKNOWN: "UNKNOWN",
  // 未知，前端初始化状态
  ROBOT: "robot",
  // 泊位机器人
  MANUAL: "manual",
  // 人工
  ELF: "elf"
  // 泊位精灵
};
function eg(e, t) {
  switch (e.tag = t.tag ? String(t.tag) : "", e.thirdno = t.thirdno || "", e.aitype = t.aitype || yr.UNKNOWN, e.isROBOT = e.aitype == yr.ROBOT, e.isMANUAL = e.aitype == yr.MANUAL, e.location = t.ctype || gr.UNKNOWN, e.locationFormatted = "", e.location) {
    case gr.IN_ROAD:
      e.locationFormatted = "路内";
      break;
    case gr.OUT_ROAD:
      e.locationFormatted = "路外";
      break;
  }
  return e.modules = t.modules || [], e.freetime = t.freetime || -1, e.freetimeIsValid = e.freetime >= 0, e.isInFreetime = (n, r) => !e.freetimeIsValid || !$(n) || !$(r) ? !1 : n.getTime() - r.getTime() < e.freetime * 60 * 1e3, e.name = t.cname || "", e.addr = t.addr || "", e.phone = t.phone || xi().HOTLINE, e.totallot = typeof t.totallot == "number" ? t.totallot : -1, e.freelot = typeof t.freelot == "number" ? t.freelot : -1, e.longitude = typeof t.longitude == "number" ? t.longitude : -1, e.latitude = typeof t.latitude == "number" ? t.latitude : -1, e.distance = typeof t.distance == "number" ? t.distance : -1, e.distanceFormatted = e.distance ? qf(e.distance) : "", e.chargeFeeStandard = (t.feedef || []).map((n) => ({
    startTime: Zi(n[0]),
    // 24小时制-开始时间
    endTime: Zi(n[1]),
    // 24小时制-结束时间
    chargeFee: n[2],
    // 电费(单位分)
    serviceFee: n[3]
    // 服务费(单位分)
  })), e.feebookurl = t.feebookurl || "", e.monthlyscopeurl = t.monthlyscopeurl || "", e.isShowMonthLotsPic = !!e.monthlyscopeurl, e.isShowMonthLotsGPS = !1, e.isShowMonthLots = e.isShowMonthLotsPic || e.isShowMonthLotsGPS, e;
}
function tg(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  return (t.type == kc || De(n)) && eg(n, r), n;
}
const vt = {
  UNKNOWN: "UNKNOWN",
  // 未知，前端初始化状态
  DESCENDING: "DESCENDING",
  // 降下中，实际后端没有这个状态
  DESCENDED: "DESCENDED",
  // 降下
  RISING: "RISING",
  // 升起中，实际后端没有这个状态
  RAISED: "RAISED"
  // 升起
};
function ng(e, t, n) {
  return e.tag = t.tag ? String(t.tag) : "", e.no = t.no || "", e.thirdno = t.thirdno || "", e.longitude = typeof t.longitude == "number" ? t.longitude : -1, e.latitude = typeof t.latitude == "number" ? t.latitude : -1, e.automode = typeof t.automode == "boolean" ? t.automode : !0, e.btname = t.btname || "", e.btcmd = t.btcmd || "", e.waitdown = typeof t.waitdown == "boolean" ? t.waitdown : !1, e.boardStatus = e.waitdown == !0 ? vt.RAISED : vt.DESCENDED, e.isBoardAsRaised = e.boardStatus == vt.UNKNOWN || e.boardStatus == vt.RAISED || e.boardStatus == vt.RISING, e;
}
function rg(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  return (t.type == Nc || De(n)) && ng(n, r), n;
}
const de = {
  UNKNOWN: "UNKNOWN",
  // 未知，前端初始化状态
  WX_MINI: "Y",
  // 微信小程序
  ALI_MINI: "B",
  // 支付宝小程序
  THIRD: "T",
  // 第三方系统支付
  CASH: "C",
  // 现金
  COUPON_HOUR: "P",
  // 小时券
  SEAMLESS: "N",
  // 无感支付 包括：支付宝-先离后付信用停车？
  WX_CREDIT: "?",
  // 微信支付分
  ALI_CREDIT: "??"
  // 支付宝芝麻先享
}, ig = {
  UNKNOWN: "UNKNOWN",
  // 未知，前端初始化状态
  DEPOSIT: "Y",
  // 押金
  CONSUME: "X",
  // 消费
  REFUND: "T"
  // 退费
};
function sg(e, t) {
  switch (e.sn = t.sn ? String(t.sn) : "", e.merchsn = t.merchs && t.merchs[0] ? String(t.merchs[0].sn) : "", e.type = t.paytype || de.UNKNOWN, e.typeFormatted = "", e.type) {
    case de.WX_MINI:
      e.typeFormatted = "微信小程序";
      break;
    case de.ALI_MINI:
      e.typeFormatted = "支付宝小程序";
      break;
    case de.THIRD:
      e.typeFormatted = "第三方系统支付";
      break;
    case de.CASH:
      e.typeFormatted = "现金";
      break;
    case de.COUPON_HOUR:
      e.typeFormatted = "小时券";
      break;
    case de.SEAMLESS:
      e.typeFormatted = "无感支付";
      break;
    case de.WX_CREDIT:
      e.typeFormatted = "微信支付分";
      break;
    case de.ALI_CREDIT:
      e.typeFormatted = "支付宝芝麻先享";
      break;
  }
  switch (e.ctype = t.ctype || ig.UNKNOWN, e.fee = t.fee || 0, e.type) {
    case de.COUPON_HOUR:
      if (e.fee >= 60) {
        let n = Math.floor(e.fee / 60);
        const r = e.fee % 60;
        r !== 0 && (n += Math.floor(r * 100 / 60) / 100), e.feeFormatted = n + "小时";
      } else
        e.feeFormatted = e.fee + "分钟";
      break;
    default:
      e.feeFormatted = wi(e.fee, 2);
      break;
  }
  return e.time = Le(t.time), e.timeIsValid = $(e.time), e.timeFormatted = _r(e.time), e;
}
function og(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  return (t.type == Ic || De(n)) && sg(n, r), n;
}
const br = {
  HOUR: "hour",
  // 时长优惠券，前端初始化状态
  CASH: "cash",
  // 金额优惠券
  DISCOUNT: "discount"
  // 折扣优惠券
};
function ug(e = 0, t) {
  let n = e <= 0 ? 0 : e;
  const r = {
    formattedValue: "",
    unit: ""
  };
  switch (t) {
    case br.DISCOUNT:
      n = n >= 100 ? 100 : n, n % 10 == 0 && n !== 100 ? r.formattedValue = "" + n / 10 : r.formattedValue = "" + n, r.unit = "折";
      break;
    case br.CASH:
      r.formattedValue = Wf(n, 2), r.unit = "元";
      break;
    case br.HOUR:
    default:
      n < 60 ? (r.formattedValue = String(H0(n)), r.unit = "分钟") : (r.formattedValue = J0(n / 60, 1), r.unit = "小时");
      break;
  }
  return r;
}
const ag = {
  UNKNOWN: "UNKNOWN",
  // 未知，前端初始化状态
  ROAD: "L",
  // 路边停车订单
  GATE: "B",
  // 道闸停车订单
  MONTH: "R",
  // 停车场包月订单
  CHARGE: "H"
  // 充电订单
}, _t = {
  UNKNOWN: "UNKNOWN",
  // 未知，前端初始化状态
  INIT: "I",
  // 初始化/预缴
  BEGIN: "B",
  // 开始/进行中/信用停进行中
  END: "E",
  // 正常结束
  CANCEL: "C",
  // 欠费/取消
  INVALID: "D",
  // 无效订单，后端反馈：后端内部状态，不用管
  WAIT: "W"
  // 待计算，后端反馈：后端内部状态，不用管
}, wr = {
  UNKNOWN: "UNKNOWN",
  // 未知
  IN: "IN",
  // 在场
  OUT: "OUT"
  // 离场
}, Fr = {
  NONE: "NONE",
  // 未开启
  INVALID: "INVALID",
  // 已失效
  VALID: "VALID",
  // 生效中(信鸽系统内)
  VALID_ON_EXTERNAL: "VALID_ON_EXTERNAL"
  // 生效中(第三方系统内)
};
function po(e, t) {
  switch (e.sn = t.sn ? String(t.sn) : "", e.type = e.ctype || ag.UNKNOWN, e.status = e.status || _t.UNKNOWN, e.fee = t.fee || 0, e.feeFormatted = wi(e.fee, 2), e.isInInitialFreePeriod = (r, i) => r.fee == 0 && i.fee == 0, e.starttime = Le(t.starttime), e.starttimeIsValid = $(e.starttime), e.starttimeFormatted = _r(e.starttime), e.endtime = Le(t.endtime), e.endtimeIsValid = $(e.endtime), e.endtimeFormatted = _r(e.endtime), e.duringtimeFormatted = e.starttimeIsValid ? hl(
    fl(e.starttime, /* @__PURE__ */ new Date(), !0),
    3
  ) : "", e.pics = (t.pics || []).map(
    (r) => typeof r == "string" ? r : r.url || ""
  ), e.carStatus = wr.UNKNOWN, e.status) {
    case _t.INIT:
    case _t.BEGIN:
      e.carStatus = wr.IN;
      break;
    case _t.END:
    case _t.CANCEL:
      e.carStatus = wr.OUT;
      break;
  }
  switch (e.nonsenseStatus = Fr.NONE, t.cred) {
    case "L":
    case "N":
    case "C":
    case "H":
      e.nonsenseStatus = Fr.NONE;
      break;
    case "D":
      e.nonsenseStatus = Fr.VALID;
      break;
  }
  const n = ug(e.m || 0);
  return e.mdesc = n.formattedValue + n.unit, e.sdesc = t.sdesc || [], e;
}
function cg(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  if (De(n))
    po(n, r);
  else
    switch (t.type) {
      case Pc:
        po(n, r);
        break;
    }
  return n;
}
const Pe = {
  UNKNOWN: "UNKNOWN",
  // 未知，前端初始化状态
  BLUE: "b",
  // 蓝牌
  GREEN: "g",
  // 绿牌
  YELLOW: "y",
  // 黄牌
  YELLOW_GREEM: "q",
  // 黄绿
  BLACK: "d",
  // 黑牌
  WHITE: "w"
  // 白牌
};
function lg(e, t = {}) {
  switch (e.color = t.color || Pe.UNKNOWN, e.colorFormatted = "", e.color) {
    case Pe.BLUE:
      e.colorFormatted = "蓝牌";
      break;
    case Pe.GREEN:
      e.colorFormatted = "绿牌";
      break;
    case Pe.YELLOW:
      e.colorFormatted = "黄牌";
      break;
    case Pe.YELLOW_GREEM:
      e.colorFormatted = "黄绿";
      break;
    case Pe.BLACK:
      e.colorFormatted = "黑牌";
      break;
    case Pe.WHITE:
      e.colorFormatted = "白牌";
      break;
  }
  return e.plate = t.plate || "", e;
}
function hg(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  return (t.type == zc || De(n)) && lg(n, r), n;
}
function fg(e, t) {
  return e.id = t.id ? String(t.id) : "", e.name = t.name || "", e.title = t.apptitle || "", e.nontax = typeof t.nontax == "boolean" ? t.nontax : !1, e.miniClassName = t.minicss?.classname || "", e.park_support_nonsense_ali = typeof t.credit_payalisn == "number" && t.credit_payalisn >= 0, e.park_support_nonsense_wx = typeof t.credit_paywxsn == "number" && t.credit_paywxsn >= 0, e;
}
function dg(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  return (t.type == Bc || De(n)) && fg(n, r), n;
}
function pg(e, t) {
  return e.openid = t.openid ?? e.openid ?? "", e.token = t.token ?? e.token ?? "", e.mobile = t.mobile ?? e.mobile ?? "", e.longitude = typeof t.longitude == "number" ? t.longitude : e.longitude ?? -1, e.latitude = typeof t.latitude == "number" ? t.latitude : e.latitude ?? -1, e;
}
function mg(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  return (t.type == Lc || De(n)) && pg(n, r), n;
}
function Dg(e, t) {
  return e.status = t.status || "", e.title = t.title || "", e.subtitle = t.subtitle || "", e;
}
function gg(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  return (t.type == $c || De(n)) && Dg(n, r), n;
}
function yg(e, t = "light", n = "xg-blue") {
  return e.scheme = t, e.theme = n, e;
}
function bg(e = {}, t) {
  const n = { ...e }, r = t.payload || {};
  return (t.type == xc || De(n)) && yg(
    n,
    r.scheme ?? n.scheme,
    r.theme ?? n.theme
  ), n;
}
const jc = td(), Xn = ba({
  initState: {},
  reducer: Y2({
    login: Y4,
    park: tg,
    lot: rg,
    bill: og,
    order: cg,
    plate: hg,
    group: dg,
    user: mg,
    result: gg,
    color: bg
  }),
  enhancer: ed(
    jc.middleware,
    nd,
    rd
    // executeTimeLoggerMiddleware
  )
}), Yn = new G2({
  baseURL: xi().baseURL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  },
  interceptors: {
    request: (e) => {
      const t = Xn.getState().user?.token;
      t && (e.headers = e.headers ?? {}, e.headers.Authentication = `Bearer ${t}`);
    }
  }
});
function wg(e) {
  return Yn.post("/api/v2/auth/genValidSN", {
    mobileno: e
  });
}
function Fg(e, t) {
  return Yn.post("/api/v2/auth/quickLogin", {
    mobileno: e,
    validsn: t,
    ufrom: "h5"
  });
}
const Eg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  genValidSN: wg,
  quickLogin: Fg
}, Symbol.toStringTag, { value: "Module" }));
function vg(e) {
  const t = Xn.getState();
  return Yn.post(
    // `/api/v6/lot/${lottag}/getwithorder6`
    `/api/v6/lot/${e}/genbill`,
    {
      openid: t.user?.openid ?? "",
      paytype: "U"
    }
  );
}
function _g(e, t) {
  const n = Xn.getState();
  return Yn.post(
    // `/api/v6/bill/${billsn}/pay`,
    `/api/v6/bill/${e}/paywithmerch`,
    {
      openid: n.user?.openid ?? "",
      merchsn: t ?? 0,
      type: "U"
    }
  );
}
const Sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get: vg,
  pay: _g
}, Symbol.toStringTag, { value: "Module" })), ME = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CLOSE_DIALOG: $4,
  DIALOG_CLOSED: Z4,
  ENQUEUE_DIALOG: U4,
  GET_CAPTCHA: q4,
  GET_CAPTCHA_ERROR: Tc,
  GET_CAPTCHA_START: Cc,
  GET_CAPTCHA_SUCCESS: W4,
  GOTO_RESULT: z4,
  GOTO_UNLOCKING: B4,
  LOAD_LOT_ORDER: K4,
  LOGIN: G4,
  LOGIN_SUCCESS: V4,
  LoginApi: Eg,
  Lot: P4,
  LotApi: Sg,
  PAY_LOT_ORDER: Q4,
  SET_BILL: Ic,
  SET_CAPTCHA_COUNTDOWN: Rc,
  SET_COLOR_SCHEME: xc,
  SET_COUPON: H4,
  SET_DEMO: J4,
  SET_GROUP: Bc,
  SET_LOGIN_CAPTCHA: Oc,
  SET_LOGIN_PHONE: Ac,
  SET_LOT: Nc,
  SET_ORDER: Pc,
  SET_PARK: kc,
  SET_PLATE: zc,
  SET_POINT: X4,
  SET_RESULT: $c,
  SET_USER: Lc,
  SHOW_DIALOG: j4,
  SHOW_DIALOG_LOADING: L4,
  SHOW_DIALOG_TOAST: M4,
  constants: Kd,
  epicMiddleware: jc,
  store: Xn
}, Symbol.toStringTag, { value: "Module" })), Ht = _c({
  plugins: [Sc]
}), Ag = Ht.entity({
  id: Ht.field(
    () => Mi([wc(), an()]).transform((e) => String(e))
  ),
  title: Ht.field(() => an()),
  comment: Ht.field(
    () => an().optional().transform((e) => String(e ?? ""))
  )
});
async function Uc(e) {
  return await (await fetch(`/movies/${e}`)).json();
}
const Zc = async () => await (await fetch("/movies")).json(), qc = async (e, t) => await (await fetch(`/movies/${e}`, {
  method: "POST",
  body: JSON.stringify({ comment: t }),
  headers: { "Content-Type": "application/json" }
})).json(), Og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fetchMovie: Uc,
  fetchMovies: Zc,
  updateMovie: qc
}, Symbol.toStringTag, { value: "Module" }));
function Cg(e) {
  const t = {
    all: () => ["movies"],
    list: () => [...t.all(), "list"],
    details: () => [...t.all(), "detail"],
    detail: (n) => [...t.details(), n]
  };
  return e.setMutationDefaults(t.all(), {
    mutationFn: async ({ id: n, comment: r }) => (await e.cancelQueries({ queryKey: t.detail(n) }), qc(n, r))
  }), {
    movieQueryOptions: (n) => ({
      queryKey: t.detail(n),
      queryFn: () => Uc(n)
    }),
    moviesQueryOptions: () => ({
      queryKey: t.list(),
      queryFn: Zc
    }),
    movieMutationOptions: (n, r, i) => {
      const s = t.detail(n);
      return {
        mutationKey: s,
        onMutate: async () => {
          await e.cancelQueries({ queryKey: s });
          const o = e.getQueryData(s);
          return i(void 0), e.setQueryData(s, {
            ...o,
            movie: {
              ...o.movie,
              comment: r
            }
          }), { previousData: o };
        },
        onError: (o, u, a) => {
          e.setQueryData(s, a.previousData);
        },
        onSettled: () => {
          e.invalidateQueries({ queryKey: s });
        }
      };
    }
  };
}
const jE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Movie: Ag,
  MovieApi: Og,
  createMovieQuery: Cg
}, Symbol.toStringTag, { value: "Module" }));
export {
  zn as ALGORITHM,
  kl as AbortControllerCache,
  xh as AbortError,
  Cw as AuthenticatableDecorator,
  Tw as AuthorizeDecorator,
  tt as BUFFER_ENCODING,
  Bn as BasicHeap,
  _E as BinarySearch,
  aw as BinarySearchTree,
  Ot as BinaryTreeNode,
  bE as BubbleSort,
  ve as BufferAttribute,
  zg as CIPHER,
  Bg as CSS_ANIMATION_NAME,
  Fw as CircularBuffer,
  Ye as Color,
  J2 as CommandInvoker,
  Mw as ConfigurableDecorator,
  zw as DebounceDecorator,
  iE as DeriveWorker,
  OE as DiffArray,
  pe as DomMatrix,
  Z as DomPoint,
  Tg as ENV,
  nb as EPSILON,
  _y as EndTruncatingAccumulator,
  jw as EnumerableDecorator,
  Jw as EventBus,
  gt as FETCH_RESPONSE_TYPE,
  xg as FRAME_INTERVAL,
  Rg as FRAME_INTERVAL_MS,
  G2 as FetchWithAxios,
  Yc as FileReaderResponseTypeInBrowser,
  Qy as Float16BufferAttribute,
  Jy as Float32BufferAttribute,
  Uo as FnScheduler,
  cw as Graph,
  fn as GraphEdge,
  oi as GraphNode,
  vw as HashCache,
  ww as HashObject,
  bw as HashTable,
  Wi as HashTableOverflow,
  vE as HeapSort,
  AF as HttpError,
  e0 as HttpStatusCode,
  Ll as IdleScheduler,
  FE as InsertSort,
  Wy as Int16BufferAttribute,
  Vy as Int32BufferAttribute,
  Uy as Int8BufferAttribute,
  gu as InvalidCharacterError,
  Pg as LINE_ENDING_TYPE,
  ai as LRUCache,
  dw as LinkedList,
  ui as ListNode,
  kw as LogExecuteResultDecorator,
  Nw as LogExecuteTimeDecorator,
  q0 as MAX_SAFE_INTEGER,
  W0 as MAX_SIGNED_INT,
  be as MIME,
  tb as MIN_SAFE_INTEGER,
  Kw as Mailbox,
  er as Map,
  Ol as MapCache,
  hw as MaxHeap,
  xw as MaxLengthDecorator,
  TE as MementoCaretaker,
  CE as MementoOriginator,
  $w as MemoizeDecorator,
  Cs as MergeSort,
  Os as MergeSort2,
  fw as MinHeap,
  Rw as MinLengthDecorator,
  Jr as NO_NUMBER,
  Er as NO_VALUE,
  Gw as NotifyScheduler,
  si as ONE_DAY_TIMESTAMP,
  Ig as PAGE_FROM_SCENE,
  ln as PRIORITIES,
  cn as PROCESS,
  AE as PrefixSumArray,
  lw as PriorityQueue,
  Iw as ProfileDecorator,
  Bt as Queue,
  me as QueueOverflow,
  SE as QuickSearch,
  Ts as QuickSort,
  Rs as QuickSort2,
  Q2 as QuickSort_partition,
  Lw as ReadonlyDecorator,
  Bw as RetryDecorator,
  Dt as SYMBOL_META,
  RE as SaveCommand,
  wE as SelectSort,
  _w as SetCache,
  CF as ShellError,
  EE as ShellSort,
  Ow as SingletonDecorator,
  ow as Stream,
  ci as TTLCache,
  xs as ThreeWayQuickSort,
  Pw as ThrottleDecorator,
  Gy as Uint16BufferAttribute,
  Ky as Uint32BufferAttribute,
  Zy as Uint8BufferAttribute,
  qy as Uint8ClampedBufferAttribute,
  xE as UndoCommand,
  _o as WeakMap,
  mo as YZ_PREFIX,
  Yt as ZeroArray,
  fs as __color,
  Hy as _instanceof,
  kg as action,
  ab as add,
  al as addMapEntry,
  cl as addSetEntry,
  X6 as all,
  f1 as angle,
  Rb as appendArrayItem,
  l1 as appendURL,
  eE as appendURLRecord,
  Kb as appendUniqueArray,
  x6 as apply,
  ed as applyMiddleware,
  zb as arrayCount,
  Bb as arrayEvery,
  kb as arrayHead,
  rl as arrayIncludes,
  Pb as arrayIterate,
  r6 as arrayNeedsUint32,
  il as arrayShift,
  $b as arraySome,
  Nb as arrayTail,
  N5 as assoc,
  Ut as assocIndexOf,
  Ph as atob,
  ob as average,
  zh as base58Encode,
  Nh as base64URLDecode,
  kh as base64URLEncode,
  Qf as bd09_to_gcj02,
  VF as bd09_to_wgs84,
  x5 as bind,
  k5 as bindObjectThis,
  Ih as btoa,
  Lo as cAF,
  Ww as cIC,
  yF as canUseBitmap,
  Th as canUseWorker,
  mE as cancelFetchWithFetch,
  ey as capitalize,
  o6 as changeTimeZone,
  Gg as charAt,
  N as clamp,
  S5 as classMixin,
  TF as classifyAxiosError,
  jb as clearArray,
  B5 as clearObject,
  Cb as clone2DArrayEmpty,
  Xr as cloneArrayBuffer,
  Ob as cloneArrayEmpty,
  C5 as cloneAsPrototype,
  xy as cloneDataView,
  i6 as cloneMap,
  n0 as cloneRegExp,
  s6 as cloneSet,
  i5 as cloneSymbol,
  h0 as cloneTypedArray,
  Nl as closeLog,
  IE as combineEpics,
  Y2 as combineReducers,
  rF as compareVersion,
  bl as compose,
  Ry as concateTypedArray,
  Ay as convertLeadingTabsToSpaces,
  d6 as copyTimeArray,
  by as countCharInString,
  el as create2DArray,
  vb as createArray,
  _b as createArrayIterate,
  fE as createAxiosGetWithMemoize,
  K2 as createAxiosGetWithRetry,
  dE as createAxiosGetWithRetryAndMemoize,
  pE as createBodyBuffer,
  Qw as createCapacityWake,
  K5 as createCommonDateValidator,
  J5 as createCommonDatetimeValidator,
  G5 as createCommonEmailValidator,
  Y5 as createCommonEnumValidator,
  X5 as createCommonLengthValidator,
  H5 as createCommonNumberValidator,
  V5 as createCommonPhoneValidator,
  Q5 as createCommonTimeValidator,
  Dw as createDroppingRingQueue,
  Eb as createEmptyArray,
  td as createEpicMiddleware,
  yw as createExpandingRingQueue,
  mw as createFixedRingQueue,
  zF as createId,
  Fb as createNextInt,
  pw as createNoneRingQueue,
  ba as createReduxStore,
  jo as createSignal,
  gw as createSlidingRingQueue,
  Hc as createSymbol,
  LE as createTanStackQueryCore,
  zE as createThunkMiddleware,
  kE as createTimestampValue,
  $l as createWorkerPool,
  Ct as curry,
  Xw as customDelay,
  F6 as dayOfYear,
  yl as debounce,
  mb as decimalNumber,
  f6 as decreaseTimeArray,
  LF as decrypt,
  Ne as deepClone,
  N0 as deepDiff,
  Ao as deepEqual,
  El as deferred,
  oE as deg,
  nl as deleteArrayItem,
  yt as denormalize,
  Sy as detectLineEndingsForString,
  qi as diffDays,
  t6 as differenceArray,
  n6 as differenceSet,
  Hw as discardOddDoubleEven,
  uE as distance,
  kF as djb2Hash,
  $F as encrypt,
  x0 as eq,
  Il as error,
  Rh as errorMessage,
  my as escapeRegExp,
  u0 as escapeXml,
  Dy as escapeXmlAttr,
  Q0 as euclideanModulo,
  rd as exceptionLoggerMiddleware,
  Sr as execNoThrow,
  Y6 as execToDone,
  BE as executeTimeLoggerMiddleware,
  X0 as extractAllNumbers,
  yb as extractNumber,
  Oi as fetchWithFetch,
  gE as fetchWithFetchMemoize,
  DE as fetchWithFetchRetry,
  yE as fetchWithFetchRetryAndMemoize,
  P5 as filterObject,
  yy as firstLineOf,
  Kg as fixChineseCompanyName,
  Vg as fixChineseTaxNo,
  Qg as fixEmail,
  xo as fixedDotNumberString,
  db as fixedNumberString,
  qb as flattenArray,
  ol as flattenArray2,
  ul as flattenArray3,
  Wb as flattenArray4,
  Gb as flattenArray5,
  sl as flushArray,
  iw as flushPromises,
  YF as flushURLRecord,
  c1 as flushURLSearch,
  rE as formDataToSearch,
  Pt as format,
  g6 as formatDate,
  _r as formatDateTime,
  qf as formatDistance,
  WF as formatFileSize,
  wi as formatMoney,
  Wf as formatMoneyMaxDot,
  Db as formatNumber,
  gb as formatNumberThousandSeparator,
  D6 as formatPreset,
  y6 as formatTime,
  b6 as formatTime2,
  c6 as formatTimeArray,
  hl as formatTimeArrayChinese,
  QF as formatUrl,
  T0 as freeze,
  _5 as functionMixin,
  KF as gb32100_2015,
  n1 as gbt11714,
  Kf as gcj02_to_bd09,
  Vf as gcj02_to_wgs84,
  V6 as generatorFromArray,
  K6 as generatorToArray,
  Ab as get2DArrayColumn,
  Sb as get2DArrayRow,
  a0 as getArrayBufferFromByteArray,
  Di as getBrowserClient,
  sF as getBrowserClientVersion,
  oF as getBrowserLanguage,
  p0 as getByteArrayFromArrayBuffer,
  Py as getByteArrayFromHexString,
  Iy as getByteArrayFromNumber,
  m0 as getByteArrayFromString,
  Ew as getCacheType,
  A6 as getCalendarPageItems,
  zy as getCodePointArrayFromString,
  h1 as getCrossOriginWorkerURL,
  Cy as getDataViewFromArrayBuffer,
  bt as getDateDetail,
  We as getDefinedRegExpPattern,
  ye as getDegree,
  lE as getDirection,
  Du as getErrnoCode,
  _F as getErrnoPath,
  jy as getFileExtension,
  My as getFileMimeFromArrayBuffer,
  ml as getFirstTimestampOfMonth,
  E6 as getFirstTimestampOfNextMonth,
  Gc as getGlobal,
  By as getHexNumberFromByteArray,
  D0 as getHexStringFromByteArray,
  Ah as getInternetExplorerVersion,
  dl as getLastDayOfMonth,
  pl as getLastTimestampOfMonth,
  v6 as getLastTimestampOfPrevMonth,
  ni as getNative,
  $5 as getNestedKey,
  L5 as getNestedValue,
  V0 as getNextPrime,
  qt as getNthDay,
  S6 as getNthMonth,
  _6 as getNthMonthNotGood,
  mi as getOperatingSystem,
  iF as getOperatingSystemVersion,
  F5 as getOwnPropertyDescriptors,
  h5 as getPrototype,
  t0 as getRegExpFlags,
  Fl as getRetryDelay,
  HF as getSearchParams,
  en as getSecondsFromTimeArray,
  k0 as getSortedObjectString,
  yo as getStringFromArrayBuffer,
  $y as getStringFromArrayBuffer2,
  g0 as getStringFromByteArray,
  ue as getTag,
  uF as getTimeZone,
  Xy as getType,
  Oy as getTypedArrayConstructorName,
  Ty as getTypedArrayFromArrayBuffer,
  Gu as getURL,
  Ny as getUint64BigIntFromDataView,
  ky as getUint64FromDataView,
  ei as getUint8ArrayFromString,
  No as getUintArray,
  qg as getUnicodeLengthES5,
  Gi as groupLog,
  wF as hasExactErrorMessage,
  E5 as hasProperty,
  O6 as idempotent,
  h6 as increaseTimeArray,
  $e as info,
  T5 as inheritPrototype,
  H0 as intNumber,
  Hb as intersectArray,
  Xb as intersectArrayUseMap,
  Yb as intersectSet,
  Zb as intersperseArray,
  hy as is32BitString,
  OF as isAbortError,
  Ch as isAliBrowser,
  gF as isAliMiniProgram,
  Sh as isAndroid,
  cF as isAppleDevice,
  Ge as isArray,
  c0 as isArrayBufferView,
  Mb as isArrayEqual,
  a5 as isArrayLike,
  Lb as isArrayNotEmpty,
  lF as isBadAndroid,
  t5 as isBoolean,
  vh as isBrowser,
  A5 as isCloneable,
  g5 as isDate,
  q5 as isDateExpired,
  Z5 as isDateNotStart,
  f5 as isDescriptor,
  EF as isENOENT,
  $0 as isEmail,
  De as isEmptyObject,
  bF as isErrorType,
  sb as isEven,
  vF as isFsInaccessible,
  Oe as isFunction,
  d5 as isGenerator,
  fF as isIE,
  pF as isIE10,
  mF as isIE11,
  dF as isIE9,
  mu as isIOS,
  W5 as isInDateRage,
  m6 as isInDays,
  Z0 as isInRange,
  p6 as isInTime,
  p5 as isIterable,
  C0 as isIterator,
  c5 as isKeyable,
  Yr as isLittleEndian,
  _h as isMacOS,
  m5 as isMap,
  Sl as isMapCacheContext,
  hF as isMobile,
  hn as isNative,
  o5 as isNativeFunction,
  j5 as isNestedValueChanged,
  nF as isNode,
  I0 as isNonNullable,
  e5 as isNull,
  r5 as isNumber,
  eb as isNumeric,
  ct as isObject,
  ri as isObjectLike,
  L0 as isPhone,
  Ee as isPlainObject,
  Ro as isPositive,
  we as isPositiveInt,
  tr as isPositiveIntOrInfinite,
  rb as isPositiveOrInfinite,
  To as isPositiveOrZero,
  ib as isPositiveOrZeroOrInfinite,
  G0 as isPrime,
  ti as isPrimitive,
  So as isPromise,
  l5 as isPrototype,
  Ng as isReduxStore,
  aF as isSafari,
  a1 as isSameOriginURL,
  tF as isServer,
  D5 as isSet,
  Al as isSetCacheContext,
  e6 as isSetIntersects,
  Co as isSettled,
  Ve as isSettledAndPrimitive,
  y5 as isStrictComparable,
  n5 as isString,
  s5 as isStringableFunction,
  A0 as isSymbol,
  Qc as isSymbolString,
  Io as isTimestampInMilliSeconds,
  ll as isTimestampInSeconds,
  V2 as isTransientNetworkError,
  l0 as isTypedArray,
  JF as isURL,
  Yy as isUndefined,
  $ as isValidDate,
  It as isValidNumber,
  w6 as isWeekend,
  Oh as isWxBrowser,
  DF as isWxMiniProgram,
  R6 as kDone,
  T6 as kFalse,
  C6 as kTrue,
  Po as konst,
  Q6 as lastX,
  xr as length,
  Xt as lerp,
  hb as lerpMap,
  lb as lerps,
  s0 as lowercaseFirst,
  $t as macrotask,
  Z6 as map,
  ji as mapToArray,
  Fe as maxDotNumber,
  pb as maxDotNumber2,
  J0 as maxDotNumberString,
  Ke as memoize,
  L6 as memoizeOne,
  Ml as mergeAbortSignals,
  At as mergeObjectDeep,
  Qr as meta,
  Pl as microtask,
  Zt as milliseconds,
  hE as moved,
  u5 as nativeCreate,
  R0 as newConstructor,
  Uw as nextTick,
  Dl as noop,
  Y as normalize,
  wy as normalizeFullWidthDigits,
  Fy as normalizeFullWidthSpace,
  cE as normalizePoint,
  M as now,
  Ib as numberArrayMiddle,
  f0 as numberToRadixString,
  w5 as objectEntries,
  U5 as objectGroupBy,
  ii as objectKeys,
  Mh as objectSignature,
  b5 as objectValues,
  PE as ofType,
  k6 as once,
  Sw as openLog,
  $E as operationParser,
  ju as out_of_china,
  wl as overArg,
  $6 as overRest,
  RF as pack,
  oy as padString,
  sw as parallelWithLimit,
  Le as parseDate,
  UF as parseJSONL,
  X as parseNumber,
  ub as parseRelativeNumber,
  l6 as parseTime,
  Zi as parseTimeFromArray,
  fl as parseTimeFromDateDiff,
  Yw as pausable$,
  z5 as pick,
  N6 as pipe,
  I6 as pipeMiddleware,
  gy as plural,
  aE as polar,
  Tb as popToArrayHead,
  Vi as profileLog,
  eF as prop$,
  pn as rAF,
  qw as rIC,
  sE as rad,
  d0 as radixStringToNumber,
  Bh as randomBytes,
  bb as randomDirection,
  Y0 as randomFloat,
  BF as randomId,
  wb as randomInt,
  Hg as randomLetter,
  Do as randomString,
  Jg as randomStringNumber,
  NF as randomUUID,
  Yg as raw,
  X2 as rawState,
  uw as readStream,
  a6 as readableTimestamp,
  Vu as recordToSearch,
  q6 as reduce,
  jg as regExec,
  Hr as regMatch,
  Mg as regMatchAll,
  $g as regSearchIndex,
  Lg as regSplit,
  Nt as regTest,
  uy as repeatString,
  Bl as requestAnimationFrameLoop,
  zt as retry,
  M6 as retryAndMemoize,
  J6 as returnValue,
  B6 as reverseArgs,
  ly as reverseString,
  _ as root,
  cb as round,
  nw as runAsyncFnsSequence,
  H6 as runGenerator,
  rw as runPromisesSequence,
  Te as runValidates,
  NE as rxState,
  Ey as safeJoinLines,
  Ji as scheduleIdle,
  Vw as scheduleIdleLoop,
  tE as searchToRecord,
  nE as searchToRecord2,
  Zw as setIntervalAccurate,
  Aw as setLogUploadFn,
  M5 as setNestedValue,
  R5 as setProtoOf,
  Ki as setTimeoutAccurate,
  Ui as setToArray,
  O5 as shallowClone,
  SF as shortErrorStack,
  Ub as shuffleArray,
  v5 as shuffleObject,
  MF as signEncrypt,
  Lh as signature,
  ew as sleep,
  tw as sleepSync,
  Wg as sliceByCodePoints,
  d1 as splitTransformString,
  nd as stateLoggerMiddleware,
  fb as stepMap,
  py as stringByteSize,
  at as stringLength,
  Ug as stringLength2,
  Zg as stringLength3,
  Xg as stringReplace,
  ZF as stringWidth,
  bu as stripBOM,
  I5 as subtractObject,
  tl as swapArrayValue,
  z6 as tco,
  jE as test,
  gl as throttle,
  G6 as thunkToPromise,
  W6 as thunkify,
  dn as timeLog,
  Ly as toBlob,
  ny as toCamel,
  oe as toDegree,
  FF as toError,
  Oo as toFunctionString,
  ty as toKebab,
  o0 as toPascal,
  Ku as toRadian,
  PF as toTaggedId,
  xb as toggleArrayItem,
  U6 as trace,
  P6 as trampoline,
  nr as treeify,
  ry as trim,
  XF as trimHash,
  sy as trimScopedCSS,
  iy as trimSpecial,
  ay as truncateString,
  cy as truncateStringInMiddle,
  vy as truncateToLines,
  j6 as tryEach,
  u6 as ttlInMilliseconds,
  Qb as unionArray,
  Jb as unionSet,
  Vb as uniqueArray,
  xF as unpack,
  u1 as urlQueryToSearchParams,
  fy as utf16to8,
  dy as utf8to16,
  IF as validateUUID,
  jF as verifyDecrypt,
  _e as warn,
  GF as wgs84_to_bd09,
  Gf as wgs84_to_gcj02,
  _l as withSignal,
  zo as withTimeout,
  K0 as withinErrorMarginNumber,
  qF as wrapAnsi,
  ME as xg,
  zl as yieldToMain
};
//# sourceMappingURL=zyzgroup_core_common.js.map
